
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    // Styles
var $3bcf9a3bdb62d21d$exports = {};
$3bcf9a3bdb62d21d$exports = new URL("hercules.851e22fa.png", import.meta.url).toString();


var $a0b4f895e1596b3b$exports = {};
!function(n) {
    "use strict";
    function e(n, e, t) {
        return t.a = n, t.f = e, t;
    }
    function F2(n) {
        return e(2, n, function(e) {
            return function(t) {
                return n(e, t);
            };
        });
    }
    function F3(n) {
        return e(3, n, function(e) {
            return function(t) {
                return function(r) {
                    return n(e, t, r);
                };
            };
        });
    }
    function F4(n) {
        return e(4, n, function(e) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return n(e, t, r, a);
                    };
                };
            };
        });
    }
    function F5(n) {
        return e(5, n, function(e) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return function(i) {
                            return n(e, t, r, a, i);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return e(6, n, function(e) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return function(i) {
                            return function(u) {
                                return n(e, t, r, a, i, u);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(n) {
        return e(7, n, function(e) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return function(i) {
                            return function(u) {
                                return function(c) {
                                    return n(e, t, r, a, i, u, c);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function F8(n) {
        return e(8, n, function(e) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return function(i) {
                            return function(u) {
                                return function(c) {
                                    return function(o) {
                                        return n(e, t, r, a, i, u, c, o);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, e, t) {
        return 2 === n.a ? n.f(e, t) : n(e)(t);
    }
    function A3(n, e, t, r) {
        return 3 === n.a ? n.f(e, t, r) : n(e)(t)(r);
    }
    function A4(n, e, t, r, a) {
        return 4 === n.a ? n.f(e, t, r, a) : n(e)(t)(r)(a);
    }
    function A5(n, e, t, r, a, i) {
        return 5 === n.a ? n.f(e, t, r, a, i) : n(e)(t)(r)(a)(i);
    }
    function A6(n, e, t, r, a, i, u) {
        return 6 === n.a ? n.f(e, t, r, a, i, u) : n(e)(t)(r)(a)(i)(u);
    }
    function A7(n, e, t, r, a, i, u, c) {
        return 7 === n.a ? n.f(e, t, r, a, i, u, c) : n(e)(t)(r)(a)(i)(u)(c);
    }
    var t = F3(function(n, e, t) {
        for(var r = Array(n), a = 0; n > a; a++)r[a] = t(e + a);
        return r;
    }), r = F2(function(n, e) {
        for(var t = Array(n), r = 0; n > r && e.b; r++)t[r] = e.a, e = e.b;
        return t.length = r, l(t, e);
    }), a = F3(function(n, e, t) {
        for(var r = t.length - 1; r >= 0; r--)e = A2(n, t[r], e);
        return e;
    });
    function i(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    function u(n, e) {
        for(var t, r = [], a = c(n, e, 0, r); a && (t = r.pop()); a = c(t.a, t.b, 0, r));
        return a;
    }
    function c(n, e, t, r) {
        if (t > 100) return r.push(l(n, e)), !0;
        if (n === e) return !0;
        if ("object" != typeof n || null === n || null === e) return "function" == typeof n && i(5), !1;
        for(var a in 0 > n.$ && (n = tt(n), e = tt(e)), n)if (!c(n[a], e[a], t + 1, r)) return !1;
        return !0;
    }
    var o = F2(u);
    function s(n, e, t) {
        if ("object" != typeof n) return n === e ? 0 : e > n ? -1 : 1;
        if (void 0 === n.$) return (t = s(n.a, e.a)) || (t = s(n.b, e.b)) ? t : s(n.c, e.c);
        for(; n.b && e.b && !(t = s(n.a, e.a)); n = n.b, e = e.b);
        return t || (n.b ? 1 : e.b ? -1 : 0);
    }
    var f = F2(function(n, e) {
        var t = s(n, e);
        return 0 > t ? ut : t ? it : at;
    });
    function l(n, e) {
        return {
            a: n,
            b: e
        };
    }
    function d(n, e, t) {
        return {
            a: n,
            b: e,
            c: t
        };
    }
    function b(n, e) {
        var t = {};
        for(var r in n)t[r] = n[r];
        for(var r in e)t[r] = e[r];
        return t;
    }
    function h(n, e) {
        if ("string" == typeof n) return n + e;
        if (!n.b) return e;
        var t = v(n.a, e);
        n = n.b;
        for(var r = t; n.b; n = n.b)r = r.b = v(n.a, e);
        return t;
    }
    var g = {
        $: 0
    };
    function v(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }
    var p = F2(v);
    function m(n) {
        for(var e = g, t = n.length; t--;)e = v(n[t], e);
        return e;
    }
    function $(n) {
        for(var e = []; n.b; n = n.b)e.push(n.a);
        return e;
    }
    var y = F3(function(n, e, t) {
        for(var r = []; e.b && t.b; e = e.b, t = t.b)r.push(A2(n, e.a, t.a));
        return m(r);
    }), w = F2(function(n, e) {
        return m($(e).sort(function(e, t) {
            return s(n(e), n(t));
        }));
    }), k = F2(function(n, e) {
        return m($(e).sort(function(e, t) {
            var r = A2(n, e, t);
            return r === at ? 0 : r === ut ? -1 : 1;
        }));
    }), x = F2(function(n, e) {
        return n + e;
    }), j = F2(function(n, e) {
        var t = e % n;
        return 0 === n ? i(11) : t > 0 && 0 > n || 0 > t && n > 0 ? t + n : t;
    }), A = Math.ceil, C = Math.floor, I = Math.round, T = Math.log, S = F2(function(n, e) {
        return n && e;
    }), D = F2(function(n, e) {
        return n + e;
    }), N = F2(function(n, e) {
        return n + e;
    }), E = F3(function(n, e, t) {
        for(var r = t.length; r--;){
            var a = t[r], i = t.charCodeAt(r);
            56320 > i || i > 57343 || (a = t[--r] + a), e = A2(n, a, e);
        }
        return e;
    }), L = F2(function(n, e) {
        return e.split(n);
    }), B = F2(function(n, e) {
        return e.join(n);
    }), O = F3(function(n, e, t) {
        return t.slice(n, e);
    }), P = F2(function(n, e) {
        for(var t = e.length; t--;){
            var r = e[t], a = e.charCodeAt(t);
            if (56320 > a || a > 57343 || (r = e[--t] + r), !n(r)) return !1;
        }
        return !0;
    }), G = F2(function(n, e) {
        return e.indexOf(n) > -1;
    }), R = F2(function(n, e) {
        return 0 === e.indexOf(n);
    }), z = F2(function(n, e) {
        return e.length >= n.length && e.lastIndexOf(n) === e.length - n.length;
    }), q = F2(function(n, e) {
        var t = n.length;
        if (1 > t) return g;
        for(var r = 0, a = []; (r = e.indexOf(n, r)) > -1;)a.push(r), r += t;
        return m(a);
    });
    function _(n) {
        return {
            $: 2,
            b: n
        };
    }
    var H = _(function(n) {
        return "number" != typeof n ? rn("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? lt(n) : !isFinite(n) || n % 1 ? rn("an INT", n) : lt(n);
    }), F = _(function(n) {
        return "boolean" == typeof n ? lt(n) : rn("a BOOL", n);
    }), U = (_(function(n) {
        return "number" == typeof n ? lt(n) : rn("a FLOAT", n);
    }), _(function(n) {
        return lt(n);
    })), V = _(function(n) {
        return "string" == typeof n ? lt(n) : n instanceof String ? lt(n + "") : rn("a STRING", n);
    }), W = F2(function(n, e) {
        return {
            $: 6,
            d: n,
            b: e
        };
    });
    function Y(n, e) {
        return {
            $: 9,
            f: n,
            g: e
        };
    }
    var M = F2(function(n, e) {
        return {
            $: 10,
            b: e,
            h: n
        };
    }), K = F2(function(n, e) {
        return Y(n, [
            e
        ]);
    }), J = F3(function(n, e, t) {
        return Y(n, [
            e,
            t
        ]);
    }), Q = F2(function(n, e) {
        try {
            return X(n, JSON.parse(e));
        } catch (n) {
            return ct(A2(ot, "This is not valid JSON! " + n.message, e));
        }
    }), Z = F2(function(n, e) {
        return X(n, e);
    });
    function X(n, e) {
        switch(n.$){
            case 2:
                return n.b(e);
            case 5:
                return null === e ? lt(n.c) : rn("null", e);
            case 3:
                return en(e) ? nn(n.b, e, m) : rn("a LIST", e);
            case 4:
                return en(e) ? nn(n.b, e, tn) : rn("an ARRAY", e);
            case 6:
                var t = n.d;
                if ("object" != typeof e || null === e || !(t in e)) return rn("an OBJECT with a field named `" + t + "`", e);
                var r = X(n.b, e[t]);
                return ir(r) ? r : ct(A2(st, t, r.a));
            case 7:
                var a = n.e;
                return en(e) ? e.length > a ? (r = X(n.b, e[a]), ir(r) ? r : ct(A2(ft, a, r.a))) : rn("a LONGER array. Need index " + a + " but only see " + e.length + " entries", e) : rn("an ARRAY", e);
            case 8:
                if ("object" != typeof e || null === e || en(e)) return rn("an OBJECT", e);
                var i = g;
                for(var u in e)if (e.hasOwnProperty(u)) {
                    if (r = X(n.b, e[u]), !ir(r)) return ct(A2(st, u, r.a));
                    i = v(l(u, r.a), i);
                }
                return lt(Bt(i));
            case 9:
                for(var c = n.f, o = n.g, s = 0; o.length > s; s++){
                    if (r = X(o[s], e), !ir(r)) return r;
                    c = c(r.a);
                }
                return lt(c);
            case 10:
                return r = X(n.b, e), ir(r) ? X(n.h(r.a), e) : r;
            case 11:
                for(var f = g, d = n.g; d.b; d = d.b){
                    if (r = X(d.a, e), ir(r)) return r;
                    f = v(r.a, f);
                }
                return ct(dt(Bt(f)));
            case 1:
                return ct(A2(ot, n.a, e));
            case 0:
                return lt(n.a);
        }
    }
    function nn(n, e, t) {
        for(var r = e.length, a = Array(r), i = 0; r > i; i++){
            var u = X(n, e[i]);
            if (!ir(u)) return ct(A2(ft, i, u.a));
            a[i] = u.a;
        }
        return lt(t(a));
    }
    function en(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function tn(n) {
        return A2(ar, n.length, function(e) {
            return n[e];
        });
    }
    function rn(n, e) {
        return ct(A2(ot, "Expecting " + n, e));
    }
    function an(n, e) {
        if (n === e) return !0;
        if (n.$ !== e.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === e.a;
            case 2:
                return n.b === e.b;
            case 5:
                return n.c === e.c;
            case 3:
            case 4:
            case 8:
                return an(n.b, e.b);
            case 6:
                return n.d === e.d && an(n.b, e.b);
            case 7:
                return n.e === e.e && an(n.b, e.b);
            case 9:
                return n.f === e.f && un(n.g, e.g);
            case 10:
                return n.h === e.h && an(n.b, e.b);
            case 11:
                return un(n.g, e.g);
        }
    }
    function un(n, e) {
        var t = n.length;
        if (t !== e.length) return !1;
        for(var r = 0; t > r; r++)if (!an(n[r], e[r])) return !1;
        return !0;
    }
    var cn = F2(function(n, e) {
        return JSON.stringify(e, null, n) + "";
    });
    function on(n) {
        return n;
    }
    var sn = F3(function(n, e, t) {
        return t[n] = e, t;
    });
    function fn(n) {
        return {
            $: 0,
            a: n
        };
    }
    function ln(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var dn = F2(function(n, e) {
        return {
            $: 3,
            b: n,
            d: e
        };
    }), bn = F2(function(n, e) {
        return {
            $: 4,
            b: n,
            d: e
        };
    }), hn = 0;
    function gn(n) {
        var e = {
            $: 0,
            e: hn++,
            f: n,
            g: null,
            h: []
        };
        return wn(e), e;
    }
    function vn(n) {
        return ln(function(e) {
            e(fn(gn(n)));
        });
    }
    function pn(n, e) {
        n.h.push(e), wn(n);
    }
    var mn = F2(function(n, e) {
        return ln(function(t) {
            pn(n, e), t(fn(0));
        });
    }), $n = !1, yn = [];
    function wn(n) {
        if (yn.push(n), !$n) {
            for($n = !0; n = yn.shift();)kn(n);
            $n = !1;
        }
    }
    function kn(n) {
        for(; n.f;){
            var e = n.f.$;
            if (0 === e || 1 === e) {
                for(; n.g && n.g.$ !== e;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === e) return void (n.f.c = n.f.b(function(e) {
                    n.f = e, wn(n);
                }));
                if (5 === e) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === e ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    var xn = {};
    function jn(n, e, t, r, a) {
        return {
            b: n,
            c: e,
            d: t,
            e: r,
            f: a
        };
    }
    function An(n, e) {
        var t = {
            g: e,
            h: void 0
        }, r = n.c, a = n.d, i = n.e, u = n.f;
        function c(n) {
            return A2(dn, c, {
                $: 5,
                b: function(e) {
                    var c = e.a;
                    return 0 === e.$ ? A3(a, t, c, n) : i && u ? A4(r, t, c.i, c.j, n) : A3(r, t, i ? c.i : c.j, n);
                }
            });
        }
        return t.h = gn(A2(dn, c, n.b));
    }
    var Cn = F2(function(n, e) {
        return ln(function(t) {
            n.g(e), t(fn(0));
        });
    }), In = F2(function(n, e) {
        return A2(mn, n.h, {
            $: 0,
            a: e
        });
    });
    function Tn(n) {
        return function(e) {
            return {
                $: 1,
                k: n,
                l: e
            };
        };
    }
    function Sn(n) {
        return {
            $: 2,
            m: n
        };
    }
    var Dn = F2(function(n, e) {
        return {
            $: 3,
            n: n,
            o: e
        };
    });
    function Nn(n, e, t) {
        var r = {};
        for(var a in En(!0, e, r, null), En(!1, t, r, null), n)pn(n[a], {
            $: "fx",
            a: r[a] || {
                i: g,
                j: g
            }
        });
    }
    function En(n, e, t, r) {
        switch(e.$){
            case 1:
                var a = e.k, i = function(n, e, t, r) {
                    function a(n) {
                        for(var e = t; e; e = e.q)n = e.p(n);
                        return n;
                    }
                    return A2(n ? xn[e].e : xn[e].f, a, r);
                }(n, a, r, e.l);
                return void (t[a] = function(n, e, t) {
                    return t = t || {
                        i: g,
                        j: g
                    }, n ? t.i = v(e, t.i) : t.j = v(e, t.j), t;
                }(n, i, t[a]));
            case 2:
                for(var u = e.m; u.b; u = u.b)En(n, u.a, t, r);
                return;
            case 3:
                return void En(n, e.o, t, {
                    p: e.n,
                    q: r
                });
        }
    }
    function Ln(n) {
        xn[n] && i(3);
    }
    var Bn = F2(function(n, e) {
        return e;
    });
    function On(n) {
        var e = [], t = xn[n].r, r = ln(function(n) {
            var e = setTimeout(function() {
                n(fn(0));
            }, 0);
            return function() {
                clearTimeout(e);
            };
        });
        return xn[n].b = r, xn[n].c = F3(function(n, a) {
            for(; a.b; a = a.b)for(var i = e, u = t(a.a), c = 0; i.length > c; c++)i[c](u);
            return r;
        }), {
            subscribe: function(n) {
                e.push(n);
            },
            unsubscribe: function(n) {
                var t = (e = e.slice()).indexOf(n);
                0 > t || e.splice(t, 1);
            }
        };
    }
    var Pn, Gn = F2(function(n, e) {
        return function(t) {
            return n(e(t));
        };
    });
    function Rn(n, e) {
        for(var t in e)t in n ? "init" == t ? i(6) : Rn(n[t], e[t]) : n[t] = e[t];
    }
    var zn = "undefined" != typeof document ? document : {};
    function qn(n, e) {
        n.appendChild(e);
    }
    function _n(n) {
        return {
            $: 0,
            a: n
        };
    }
    var Hn = F2(function(n, e) {
        return F2(function(t, r) {
            for(var a = [], i = 0; r.b; r = r.b){
                var u = r.a;
                i += u.b || 0, a.push(u);
            }
            return i += a.length, {
                $: 1,
                c: e,
                d: Qn(t),
                e: a,
                f: n,
                b: i
            };
        });
    }), Fn = Hn(void 0);
    F2(function(n, e) {
        return F2(function(t, r) {
            for(var a = [], i = 0; r.b; r = r.b){
                var u = r.a;
                i += u.b.b || 0, a.push(u);
            }
            return i += a.length, {
                $: 2,
                c: e,
                d: Qn(t),
                e: a,
                f: n,
                b: i
            };
        });
    })(void 0);
    var Un, Vn = F2(function(n, e) {
        return {
            $: 4,
            j: n,
            k: e,
            b: 1 + (e.b || 0)
        };
    }), Wn = F2(function(n, e) {
        return {
            $: "a0",
            n: n,
            o: e
        };
    }), Yn = F2(function(n, e) {
        return {
            $: "a1",
            n: n,
            o: e
        };
    }), Mn = F2(function(n, e) {
        return {
            $: "a2",
            n: n,
            o: e
        };
    }), Kn = F2(function(n, e) {
        return {
            $: "a3",
            n: n,
            o: e
        };
    });
    function Jn(n) {
        return /^\s*(javascript:|data:text\/html)/i.test(n) ? "" : n;
    }
    function Qn(n) {
        for(var e = {}; n.b; n = n.b){
            var t = n.a, r = t.$, a = t.n, i = t.o;
            if ("a2" !== r) {
                var u = e[r] || (e[r] = {});
                "a3" === r && "class" === a ? Zn(u, a, i) : u[a] = i;
            } else "className" === a ? Zn(e, a, i) : e[a] = i;
        }
        return e;
    }
    function Zn(n, e, t) {
        var r = n[e];
        n[e] = r ? r + " " + t : t;
    }
    function Xn(n, e) {
        var t = n.$;
        if (5 === t) return Xn(n.k || (n.k = n.m()), e);
        if (0 === t) return zn.createTextNode(n.a);
        if (4 === t) {
            for(var r = n.k, a = n.j; 4 === r.$;)"object" != typeof a ? a = [
                a,
                r.j
            ] : a.push(r.j), r = r.k;
            var i = {
                j: a,
                p: e
            };
            return (u = Xn(r, i)).elm_event_node_ref = i, u;
        }
        if (3 === t) return ne(u = n.h(n.g), e, n.d), u;
        var u = n.f ? zn.createElementNS(n.f, n.c) : zn.createElement(n.c);
        Pn && "a" == n.c && u.addEventListener("click", Pn(u)), ne(u, e, n.d);
        for(var c = n.e, o = 0; c.length > o; o++)qn(u, Xn(1 === t ? c[o] : c[o].b, e));
        return u;
    }
    function ne(n, e, t) {
        for(var r in t){
            var a = t[r];
            "a1" === r ? ee(n, a) : "a0" === r ? ae(n, e, a) : "a3" === r ? te(n, a) : "a4" === r ? re(n, a) : ("value" !== r && "checked" !== r || n[r] !== a) && (n[r] = a);
        }
    }
    function ee(n, e) {
        var t = n.style;
        for(var r in e)t[r] = e[r];
    }
    function te(n, e) {
        for(var t in e){
            var r = e[t];
            void 0 !== r ? n.setAttribute(t, r) : n.removeAttribute(t);
        }
    }
    function re(n, e) {
        for(var t in e){
            var r = e[t], a = r.f, i = r.o;
            void 0 !== i ? n.setAttributeNS(a, t, i) : n.removeAttributeNS(a, t);
        }
    }
    function ae(n, e, t) {
        var r = n.elmFs || (n.elmFs = {});
        for(var a in t){
            var i = t[a], u = r[a];
            if (i) {
                if (u) {
                    if (u.q.$ === i.$) {
                        u.q = i;
                        continue;
                    }
                    n.removeEventListener(a, u);
                }
                u = ie(e, i), n.addEventListener(a, u, Un && {
                    passive: 2 > fr(i)
                }), r[a] = u;
            } else n.removeEventListener(a, u), r[a] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                Un = !0;
            }
        }));
    } catch (n) {}
    function ie(n, e) {
        function t(e) {
            var r = t.q, a = X(r.a, e);
            if (ir(a)) {
                for(var i, u = fr(r), c = a.a, o = u ? 3 > u ? c.a : c.bl : c, s = 1 == u ? c.b : 3 == u && c.d8, f = (s && e.stopPropagation(), (2 == u ? c.b : 3 == u && c.d4) && e.preventDefault(), n); i = f.j;){
                    if ("function" == typeof i) o = i(o);
                    else for(var l = i.length; l--;)o = i[l](o);
                    f = f.p;
                }
                f(o, s);
            }
        }
        return t.q = e, t;
    }
    function ue(n, e) {
        return n.$ == e.$ && an(n.a, e.a);
    }
    function ce(n, e, t, r) {
        var a = {
            $: e,
            r: t,
            s: r,
            t: void 0,
            u: void 0
        };
        return n.push(a), a;
    }
    function oe(n, e, t, r) {
        if (n !== e) {
            var a = n.$, i = e.$;
            if (a !== i) {
                if (1 !== a || 2 !== i) return void ce(t, 0, r, e);
                e = function(n) {
                    for(var e = n.e, t = e.length, r = Array(t), a = 0; t > a; a++)r[a] = e[a].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: r,
                        f: n.f,
                        b: n.b
                    };
                }(e), i = 1;
            }
            switch(i){
                case 5:
                    for(var u = n.l, c = e.l, o = u.length, s = o === c.length; s && o--;)s = u[o] === c[o];
                    if (s) return void (e.k = n.k);
                    e.k = e.m();
                    var f = [];
                    return oe(n.k, e.k, f, 0), void (f.length > 0 && ce(t, 1, r, f));
                case 4:
                    for(var l = n.j, d = e.j, b = !1, h = n.k; 4 === h.$;)b = !0, "object" != typeof l ? l = [
                        l,
                        h.j
                    ] : l.push(h.j), h = h.k;
                    for(var g = e.k; 4 === g.$;)b = !0, "object" != typeof d ? d = [
                        d,
                        g.j
                    ] : d.push(g.j), g = g.k;
                    return b && l.length !== d.length ? void ce(t, 0, r, e) : ((b ? function(n, e) {
                        for(var t = 0; n.length > t; t++)if (n[t] !== e[t]) return !1;
                        return !0;
                    }(l, d) : l === d) || ce(t, 2, r, d), void oe(h, g, t, r + 1));
                case 0:
                    return void (n.a !== e.a && ce(t, 3, r, e.a));
                case 1:
                    return void se(n, e, t, r, le);
                case 2:
                    return void se(n, e, t, r, de);
                case 3:
                    if (n.h !== e.h) return void ce(t, 0, r, e);
                    var v = fe(n.d, e.d);
                    v && ce(t, 4, r, v);
                    var p = e.i(n.g, e.g);
                    return void (p && ce(t, 5, r, p));
            }
        }
    }
    function se(n, e, t, r, a) {
        if (n.c === e.c && n.f === e.f) {
            var i = fe(n.d, e.d);
            i && ce(t, 4, r, i), a(n, e, t, r);
        } else ce(t, 0, r, e);
    }
    function fe(n, e, t) {
        var r;
        for(var a in n)if ("a1" !== a && "a0" !== a && "a3" !== a && "a4" !== a) {
            if (a in e) {
                var i = n[a], u = e[a];
                i === u && "value" !== a && "checked" !== a || "a0" === t && ue(i, u) || ((r = r || {})[a] = u);
            } else (r = r || {})[a] = t ? "a1" === t ? "" : "a0" === t || "a3" === t ? void 0 : {
                f: n[a].f,
                o: void 0
            } : "string" == typeof n[a] ? "" : null;
        } else {
            var c = fe(n[a], e[a] || {}, a);
            c && ((r = r || {})[a] = c);
        }
        for(var o in e)o in n || ((r = r || {})[o] = e[o]);
        return r;
    }
    function le(n, e, t, r) {
        var a = n.e, i = e.e, u = a.length, c = i.length;
        u > c ? ce(t, 6, r, {
            v: c,
            i: u - c
        }) : c > u && ce(t, 7, r, {
            v: u,
            e: i
        });
        for(var o = c > u ? u : c, s = 0; o > s; s++){
            var f = a[s];
            oe(f, i[s], t, ++r), r += f.b || 0;
        }
    }
    function de(n, e, t, r) {
        for(var a = [], i = {}, u = [], c = n.e, o = e.e, s = c.length, f = o.length, l = 0, d = 0, b = r; s > l && f > d;){
            var h = (C = c[l]).a, g = (I = o[d]).a, v = C.b, p = I.b, m = void 0, $ = void 0;
            if (h !== g) {
                var y = c[l + 1], w = o[d + 1];
                if (y) {
                    var k = y.a, x = y.b;
                    $ = g === k;
                }
                if (w) {
                    var j = w.a, A = w.b;
                    m = h === j;
                }
                if (m && $) oe(v, A, a, ++b), he(i, a, h, p, d, u), b += v.b || 0, ge(i, a, h, x, ++b), b += x.b || 0, l += 2, d += 2;
                else if (m) b++, he(i, a, g, p, d, u), oe(v, A, a, b), b += v.b || 0, l += 1, d += 2;
                else if ($) ge(i, a, h, v, ++b), b += v.b || 0, oe(x, p, a, ++b), b += x.b || 0, l += 2, d += 1;
                else {
                    if (!y || k !== j) break;
                    ge(i, a, h, v, ++b), he(i, a, g, p, d, u), b += v.b || 0, oe(x, A, a, ++b), b += x.b || 0, l += 2, d += 2;
                }
            } else oe(v, p, a, ++b), b += v.b || 0, l++, d++;
        }
        for(; s > l;){
            var C;
            b++, ge(i, a, (C = c[l]).a, v = C.b, b), b += v.b || 0, l++;
        }
        for(; f > d;){
            var I, T = T || [];
            he(i, a, (I = o[d]).a, I.b, void 0, T), d++;
        }
        (a.length > 0 || u.length > 0 || T) && ce(t, 8, r, {
            w: a,
            x: u,
            y: T
        });
    }
    var be = "_elmW6BL";
    function he(n, e, t, r, a, i) {
        var u = n[t];
        if (!u) return i.push({
            r: a,
            A: u = {
                c: 0,
                z: r,
                r: a,
                s: void 0
            }
        }), void (n[t] = u);
        if (1 === u.c) {
            i.push({
                r: a,
                A: u
            }), u.c = 2;
            var c = [];
            return oe(u.z, r, c, u.r), u.r = a, void (u.s.s = {
                w: c,
                A: u
            });
        }
        he(n, e, t + be, r, a, i);
    }
    function ge(n, e, t, r, a) {
        var i = n[t];
        if (i) {
            if (0 === i.c) {
                i.c = 2;
                var u = [];
                return oe(r, i.z, u, a), void ce(e, 9, a, {
                    w: u,
                    A: i
                });
            }
            ge(n, e, t + be, r, a);
        } else {
            var c = ce(e, 9, a, void 0);
            n[t] = {
                c: 1,
                z: r,
                r: a,
                s: c
            };
        }
    }
    function ve(n, e, t, r) {
        pe(n, e, t, 0, 0, e.b, r);
    }
    function pe(n, e, t, r, a, i, u) {
        for(var c = t[r], o = c.r; o === a;){
            var s = c.$;
            if (1 === s) ve(n, e.k, c.s, u);
            else if (8 === s) c.t = n, c.u = u, (f = c.s.w).length > 0 && pe(n, e, f, 0, a, i, u);
            else if (9 === s) {
                c.t = n, c.u = u;
                var f, l = c.s;
                l && (l.A.s = n, (f = l.w).length > 0 && pe(n, e, f, 0, a, i, u));
            } else c.t = n, c.u = u;
            if (!(c = t[++r]) || (o = c.r) > i) return r;
        }
        var d = e.$;
        if (4 === d) {
            for(var b = e.k; 4 === b.$;)b = b.k;
            return pe(n, b, t, r, a + 1, i, n.elm_event_node_ref);
        }
        for(var h = e.e, g = n.childNodes, v = 0; h.length > v; v++){
            a++;
            var p = 1 === d ? h[v] : h[v].b, m = a + (p.b || 0);
            if (!(a > o || o > m || (c = t[r = pe(g[v], p, t, r, a, m, u)]) && (o = c.r) <= i)) return r;
            a = m;
        }
        return r;
    }
    function me(n, e) {
        for(var t = 0; e.length > t; t++){
            var r = e[t], a = r.t, i = $e(a, r);
            a === n && (n = i);
        }
        return n;
    }
    function $e(n, e) {
        switch(e.$){
            case 0:
                return function(n, e, t) {
                    var r = n.parentNode, a = Xn(e, t);
                    return a.elm_event_node_ref || (a.elm_event_node_ref = n.elm_event_node_ref), r && a !== n && r.replaceChild(a, n), a;
                }(n, e.s, e.u);
            case 4:
                return ne(n, e.u, e.s), n;
            case 3:
                return n.replaceData(0, n.length, e.s), n;
            case 1:
                return me(n, e.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = e.s : n.elm_event_node_ref = {
                    j: e.s,
                    p: e.u
                }, n;
            case 6:
                for(var t = e.s, r = 0; t.i > r; r++)n.removeChild(n.childNodes[t.v]);
                return n;
            case 7:
                for(var a = (t = e.s).e, u = n.childNodes[r = t.v]; a.length > r; r++)n.insertBefore(Xn(a[r], e.u), u);
                return n;
            case 9:
                if (!(t = e.s)) return n.parentNode.removeChild(n), n;
                var c = t.A;
                return void 0 !== c.r && n.parentNode.removeChild(n), c.s = me(n, t.w), n;
            case 8:
                return function(n, e) {
                    var t = e.s, r = function(n, e) {
                        if (n) {
                            for(var t = zn.createDocumentFragment(), r = 0; n.length > r; r++){
                                var a = n[r].A;
                                qn(t, 2 === a.c ? a.s : Xn(a.z, e.u));
                            }
                            return t;
                        }
                    }(t.y, e);
                    n = me(n, t.w);
                    for(var a = t.x, i = 0; a.length > i; i++){
                        var u = a[i], c = u.A, o = 2 === c.c ? c.s : Xn(c.z, e.u);
                        n.insertBefore(o, n.childNodes[u.r]);
                    }
                    return r && qn(n, r), n;
                }(n, e);
            case 5:
                return e.s(n);
            default:
                i(10);
        }
    }
    function ye(n) {
        if (3 === n.nodeType) return _n(n.textContent);
        if (1 !== n.nodeType) return _n("");
        for(var e = g, t = n.attributes, r = t.length; r--;){
            var a = t[r];
            e = v(A2(Kn, a.name, a.value), e);
        }
        var i = n.tagName.toLowerCase(), u = g, c = n.childNodes;
        for(r = c.length; r--;)u = v(ye(c[r]), u);
        return A3(Fn, i, e, u);
    }
    var we = F4(function(n, e, t, r) {
        return function(n, e, t, r, a, u) {
            var c = A2(Z, n, e ? e.flags : void 0);
            ir(c) || i(2);
            var o = {}, s = (c = t(c.a)).a, f = u(d, s), l = function(n, e) {
                var t;
                for(var r in xn){
                    var a = xn[r];
                    a.a && ((t = t || {})[r] = a.a(r, e)), n[r] = An(a, e);
                }
                return t;
            }(o, d);
            function d(n, e) {
                f(s = (c = A2(r, n, s)).a, e), Nn(o, c.b, a(s));
            }
            return Nn(o, c.b, a(s)), l ? {
                ports: l
            } : {};
        }(e, r, n.iE, n.jN, n.jH, function(e, t) {
            var r = n.d7 && n.d7(e), a = n.jQ, i = zn.title, u = zn.body, c = ye(u);
            return function(n, e) {
                e(n);
                var t = 0;
                function r() {
                    t = 1 === t ? 0 : (ke(r), e(n), 1);
                }
                return function(a, i) {
                    n = a, i ? (e(n), 2 === t && (t = 1)) : (0 === t && ke(r), t = 2);
                };
            }(t, function(n) {
                Pn = r;
                var t = a(n), o = Fn("body")(g)(t.aD), s = function(n, e) {
                    var t = [];
                    return oe(n, e, t, 0), t;
                }(c, o);
                u = function(n, e, t, r) {
                    return 0 === t.length ? n : (ve(n, e, t, r), me(n, t));
                }(u, c, s, e), c = o, Pn = 0, i !== t.e && (zn.title = i = t.e);
            });
        });
    }), ke = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    });
    function xe() {
        return Ir(zn.location.href).a || i(1);
    }
    var je = F2(function(n, e) {
        return A2(Fr, Tr, ln(function() {
            history.pushState({}, "", e), n();
        }));
    }), Ae = F2(function(n, e) {
        return A2(Fr, Tr, ln(function() {
            history.replaceState({}, "", e), n();
        }));
    }), Ce = ("undefined" != typeof document && document, "undefined" != typeof window ? window : {
        addEventListener: function() {},
        removeEventListener: function() {}
    });
    function Ie(n, e) {
        return ln(function(t) {
            ke(function() {
                var r = document.getElementById(n);
                t(r ? fn(e(r)) : {
                    $: 1,
                    a: dr(n)
                });
            });
        });
    }
    var Te = F3(function(n, e, t) {
        return Ie(n, function(n) {
            return n.scrollLeft = e, n.scrollTop = t, 0;
        });
    }), Se = F2(function(n, e) {
        var t = "g";
        n.iU && (t += "m"), n.h5 && (t += "i");
        try {
            return ht(RegExp(e, t));
        } catch (n) {
            return gt;
        }
    }), De = F2(function(n, e) {
        return null !== e.match(n);
    }), Ne = F5(function(n, e, t, r, a) {
        for(var i = n.length, u = a.length >= e + i, c = 0; u && i > c;){
            var o = a.charCodeAt(e);
            u = n[c++] === a[e++] && (10 === o ? (t++, r = 1) : (r++, 55296 == (63488 & o) ? n[c++] === a[e++] : 1));
        }
        return d(u ? e : -1, t, r);
    }), Ee = F3(function(n, e, t) {
        return t.length > e ? 55296 == (63488 & t.charCodeAt(e)) ? n(t.substr(e, 2)) ? e + 2 : -1 : n(t[e]) ? "\n" === t[e] ? -2 : e + 1 : -1 : -1;
    }), Le = F3(function(n, e, t) {
        return t.charCodeAt(e) === n;
    }), Be = F2(function(n, e) {
        for(; e.length > n; n++){
            var t = e.charCodeAt(n);
            if (48 > t || t > 57) return n;
        }
        return n;
    }), Oe = F3(function(n, e, t) {
        for(var r = 0; t.length > e; e++){
            var a = t.charCodeAt(e) - 48;
            if (0 > a || a >= n) break;
            r = n * r + a;
        }
        return l(e, r);
    }), Pe = F2(function(n, e) {
        for(var t = 0; e.length > n; n++){
            var r = e.charCodeAt(n);
            if (48 > r || r > 57) {
                if (65 > r || r > 70) {
                    if (97 > r || r > 102) break;
                    t = 16 * t + r - 87;
                } else t = 16 * t + r - 55;
            } else t = 16 * t + r - 48;
        }
        return l(n, t);
    }), Ge = F3(function(n, e, t) {
        return ln(function(r) {
            function a(n) {
                r(e(t.ip.a(n)));
            }
            var i = new XMLHttpRequest;
            i.addEventListener("error", function() {
                a(Yi);
            }), i.addEventListener("timeout", function() {
                a(Ji);
            }), i.addEventListener("load", function() {
                a(function(n, e) {
                    return A2(e.status >= 200 && 300 > e.status ? Wi : Ui, function(n) {
                        return {
                            hB: n.responseURL,
                            jD: n.status,
                            jE: n.statusText,
                            M: Re(n.getAllResponseHeaders())
                        };
                    }(e), n(e.response));
                }(t.ip.b, i));
            }), Qi(t.bz) && function(n, e, t) {
                e.upload.addEventListener("progress", function(r) {
                    e.c || gn(A2(Zi, n, l(t, Ki({
                        jx: r.loaded,
                        dC: r.total
                    }))));
                }), e.addEventListener("progress", function(r) {
                    e.c || gn(A2(Zi, n, l(t, Mi({
                        jk: r.loaded,
                        dC: r.lengthComputable ? ht(r.total) : gt
                    }))));
                });
            }(n, i, t.bz.a);
            try {
                i.open(t.aO, t.hB, !0);
            } catch (n) {
                return a(Vi(t.hB));
            }
            return function(n, e) {
                for(var t = e.M; t.b; t = t.b)n.setRequestHeader(t.a.a, t.a.b);
                n.timeout = e.ay.a || 0, n.responseType = e.ip.d, n.withCredentials = e.hY;
            }(i, t), t.aD.a && i.setRequestHeader("Content-Type", t.aD.a), i.send(t.aD.b), function() {
                i.c = !0, i.abort();
            };
        });
    });
    function Re(n) {
        if (!n) return da;
        for(var e = da, t = n.split("\r\n"), r = t.length; r--;){
            var a = t[r], i = a.indexOf(": ");
            if (i > 0) {
                var u = a.substring(0, i), c = a.substring(i + 2);
                e = A3(cu, u, function(n) {
                    return ht(Qi(n) ? c + ", " + n.a : c);
                }, e);
            }
        }
        return e;
    }
    var ze = F3(function(n, e, t) {
        return {
            $: 0,
            d: n,
            b: e,
            a: t
        };
    }), qe = F2(function(n, e) {
        return {
            $: 0,
            d: e.d,
            b: e.b,
            a: function(t) {
                return n(e.a(t));
            }
        };
    });
    function _e(n) {
        return new DataView(n);
    }
    var He = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), Fe = F2(function(n, e) {
        return ln(function() {
            var t = setInterval(function() {
                gn(e);
            }, n);
            return function() {
                clearInterval(t);
            };
        });
    }), Ue = _(function(n) {
        return "undefined" != typeof File && n instanceof File ? lt(n) : rn("a FILE", n);
    }), Ve = F3(function(n, e, t) {
        return function(n, e, t, r) {
            return {
                $: 3,
                d: Qn(n),
                g: e,
                h: t,
                i: r
            };
        }(e, {
            a: n,
            b: t
        }, We, Ye);
    });
    function We(n) {
        return A2(Je, n, zn.createElement("div"));
    }
    function Ye(n, e) {
        return (n.b !== e.b || n.a !== e.a) && Je(e);
    }
    var Me, Ke, Je = F2(function(n, e) {
        var t, r;
        return e.innerHTML = Qe(n.b, {
            highlight: function(n, e) {
                return !e && Qi(t.eX) && (e = t.eX.a), "undefined" != typeof hljs && e && hljs.listLanguages().indexOf(e) >= 0 ? hljs.highlight(e, n, !0).value : n;
            },
            gfm: r = (t = n.a).iv.a,
            tables: r && r.jI,
            breaks: r && r.h2,
            sanitize: t.ju,
            smartypants: t.jA
        }), e;
    }), Qe = (Ke = (Me = {}).exports = {}, (function() {
        var n = {
            newline: /^\n+/,
            code: /^( {4}[^\n]+\n*)+/,
            fences: o,
            hr: /^( *[-*_]){3,} *(?:\n+|$)/,
            heading: /^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,
            nptable: o,
            lheading: /^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,
            blockquote: /^( *>[^\n]+(\n(?!def)[^\n]+)*\n*)+/,
            list: /^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,
            html: /^ *(?:comment *(?:\n|\s*$)|closed *(?:\n{2,}|\s*$)|closing *(?:\n{2,}|\s*$))/,
            def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +["(]([^\n]+)[")])? *(?:\n+|$)/,
            table: o,
            paragraph: /^((?:[^\n]+\n?(?!hr|heading|lheading|blockquote|tag|def))+)\n*/,
            text: /^[^\n]+/
        };
        function e(e) {
            this.tokens = [], this.tokens.links = {}, this.options = e || f.defaults, this.rules = n.normal, this.options.gfm && (this.rules = this.options.tables ? n.tables : n.gfm);
        }
        n.bullet = /(?:[*+-]|\d+\.)/, n.item = /^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/, n.item = c(n.item, "gm")(/bull/g, n.bullet)(), n.list = c(n.list)(/bull/g, n.bullet)("hr", "\\n+(?=\\1?(?:[-*_] *){3,}(?:\\n+|$))")("def", "\\n+(?=" + n.def.source + ")")(), n.blockquote = c(n.blockquote)("def", n.def)(), n._tag = "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:/|[^\\w\\s@]*@)\\b", n.html = c(n.html)("comment", /<!--[\s\S]*?-->/)("closed", /<(tag)[\s\S]+?<\/\1>/)("closing", /<tag(?:"[^"]*"|'[^']*'|[^'">])*?>/)(/tag/g, n._tag)(), n.paragraph = c(n.paragraph)("hr", n.hr)("heading", n.heading)("lheading", n.lheading)("blockquote", n.blockquote)("tag", "<" + n._tag)("def", n.def)(), n.normal = s({}, n), n.gfm = s({}, n.normal, {
            fences: /^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\s*\1 *(?:\n+|$)/,
            paragraph: /^/,
            heading: /^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/
        }), n.gfm.paragraph = c(n.paragraph)("(?!", "(?!" + n.gfm.fences.source.replace("\\1", "\\2") + "|" + n.list.source.replace("\\1", "\\3") + "|")(), n.tables = s({}, n.gfm, {
            nptable: /^ *(\S.*\|.*)\n *([-:]+ *\|[-| :]*)\n((?:.*\|.*(?:\n|$))*)\n*/,
            table: /^ *\|(.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/
        }), e.rules = n, e.lex = function(n, t) {
            return new e(t).lex(n);
        }, e.prototype.lex = function(n) {
            return n = n.replace(/\r\n|\r/g, "\n").replace(/\t/g, "    ").replace(/\u00a0/g, " ").replace(/\u2424/g, "\n"), this.token(n, !0);
        }, e.prototype.token = function(e, t, r) {
            var a, i, u, c, o, s, f, l, d;
            for(e = e.replace(/^ +$/gm, ""); e;)if ((u = this.rules.newline.exec(e)) && (e = e.substring(u[0].length), u[0].length > 1 && this.tokens.push({
                type: "space"
            })), u = this.rules.code.exec(e)) e = e.substring(u[0].length), u = u[0].replace(/^ {4}/gm, ""), this.tokens.push({
                type: "code",
                text: this.options.pedantic ? u : u.replace(/\n+$/, "")
            });
            else if (u = this.rules.fences.exec(e)) e = e.substring(u[0].length), this.tokens.push({
                type: "code",
                lang: u[2],
                text: u[3] || ""
            });
            else if (u = this.rules.heading.exec(e)) e = e.substring(u[0].length), this.tokens.push({
                type: "heading",
                depth: u[1].length,
                text: u[2]
            });
            else if (t && (u = this.rules.nptable.exec(e))) {
                for(e = e.substring(u[0].length), s = {
                    type: "table",
                    header: u[1].replace(/^ *| *\| *$/g, "").split(/ *\| */),
                    align: u[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
                    cells: u[3].replace(/\n$/, "").split("\n")
                }, l = 0; s.align.length > l; l++)s.align[l] = /^ *-+: *$/.test(s.align[l]) ? "right" : /^ *:-+: *$/.test(s.align[l]) ? "center" : /^ *:-+ *$/.test(s.align[l]) ? "left" : null;
                for(l = 0; s.cells.length > l; l++)s.cells[l] = s.cells[l].split(/ *\| */);
                this.tokens.push(s);
            } else if (u = this.rules.lheading.exec(e)) e = e.substring(u[0].length), this.tokens.push({
                type: "heading",
                depth: "=" === u[2] ? 1 : 2,
                text: u[1]
            });
            else if (u = this.rules.hr.exec(e)) e = e.substring(u[0].length), this.tokens.push({
                type: "hr"
            });
            else if (u = this.rules.blockquote.exec(e)) e = e.substring(u[0].length), this.tokens.push({
                type: "blockquote_start"
            }), u = u[0].replace(/^ *> ?/gm, ""), this.token(u, t, !0), this.tokens.push({
                type: "blockquote_end"
            });
            else if (u = this.rules.list.exec(e)) {
                for(e = e.substring(u[0].length), this.tokens.push({
                    type: "list_start",
                    ordered: (c = u[2]).length > 1
                }), a = !1, d = (u = u[0].match(this.rules.item)).length, l = 0; d > l; l++)f = (s = u[l]).length, ~(s = s.replace(/^ *([*+-]|\d+\.) +/, "")).indexOf("\n ") && (f -= s.length, s = s.replace(this.options.pedantic ? /^ {1,4}/gm : RegExp("^ {1," + f + "}", "gm"), "")), this.options.smartLists && l !== d - 1 && (c === (o = n.bullet.exec(u[l + 1])[0]) || c.length > 1 && o.length > 1 || (e = u.slice(l + 1).join("\n") + e, l = d - 1)), i = a || /\n\n(?!\s*$)/.test(s), l !== d - 1 && (a = "\n" === s.charAt(s.length - 1), i || (i = a)), this.tokens.push({
                    type: i ? "loose_item_start" : "list_item_start"
                }), this.token(s, !1, r), this.tokens.push({
                    type: "list_item_end"
                });
                this.tokens.push({
                    type: "list_end"
                });
            } else if (u = this.rules.html.exec(e)) e = e.substring(u[0].length), this.tokens.push({
                type: this.options.sanitize ? "paragraph" : "html",
                pre: !this.options.sanitizer && ("pre" === u[1] || "script" === u[1] || "style" === u[1]),
                text: u[0]
            });
            else if (!r && t && (u = this.rules.def.exec(e))) e = e.substring(u[0].length), this.tokens.links[u[1].toLowerCase()] = {
                href: u[2],
                title: u[3]
            };
            else if (t && (u = this.rules.table.exec(e))) {
                for(e = e.substring(u[0].length), s = {
                    type: "table",
                    header: u[1].replace(/^ *| *\| *$/g, "").split(/ *\| */),
                    align: u[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
                    cells: u[3].replace(/(?: *\| *)?\n$/, "").split("\n")
                }, l = 0; s.align.length > l; l++)s.align[l] = /^ *-+: *$/.test(s.align[l]) ? "right" : /^ *:-+: *$/.test(s.align[l]) ? "center" : /^ *:-+ *$/.test(s.align[l]) ? "left" : null;
                for(l = 0; s.cells.length > l; l++)s.cells[l] = s.cells[l].replace(/^ *\| *| *\| *$/g, "").split(/ *\| */);
                this.tokens.push(s);
            } else if (t && (u = this.rules.paragraph.exec(e))) e = e.substring(u[0].length), this.tokens.push({
                type: "paragraph",
                text: "\n" === u[1].charAt(u[1].length - 1) ? u[1].slice(0, -1) : u[1]
            });
            else if (u = this.rules.text.exec(e)) e = e.substring(u[0].length), this.tokens.push({
                type: "text",
                text: u[0]
            });
            else if (e) throw Error("Infinite loop on byte: " + e.charCodeAt(0));
            return this.tokens;
        };
        var t = {
            escape: /^\\([\\`*{}\[\]()#+\-.!_>])/,
            autolink: /^<([^ >]+(@|:\/)[^ >]+)>/,
            url: o,
            tag: /^<!--[\s\S]*?-->|^<\/?\w+(?:"[^"]*"|'[^']*'|[^'">])*?>/,
            link: /^!?\[(inside)\]\(href\)/,
            reflink: /^!?\[(inside)\]\s*\[([^\]]*)\]/,
            nolink: /^!?\[((?:\[[^\]]*\]|[^\[\]])*)\]/,
            strong: /^_\_([\s\S]+?)_\_(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,
            em: /^\b_((?:[^_]|_\_)+?)_\b|^\*((?:\*\*|[\s\S])+?)\*(?!\*)/,
            code: /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,
            br: /^ {2,}\n(?!\s*$)/,
            del: o,
            text: /^[\s\S]+?(?=[\\<!\[_*`]| {2,}\n|$)/
        };
        function r(n, e) {
            if (this.options = e || f.defaults, this.links = n, this.rules = t.normal, this.renderer = this.options.renderer || new a, this.renderer.options = this.options, !this.links) throw Error("Tokens array requires a `links` property.");
            this.options.gfm ? this.rules = this.options.breaks ? t.breaks : t.gfm : this.options.pedantic && (this.rules = t.pedantic);
        }
        function a(n) {
            this.options = n || {};
        }
        function i(n) {
            this.tokens = [], this.token = null, this.options = n || f.defaults, this.options.renderer = this.options.renderer || new a, this.renderer = this.options.renderer, this.renderer.options = this.options;
        }
        function u(n, e) {
            return n.replace(e ? /&/g : /&(?!#?\w+;)/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
        }
        function c(n, e) {
            return n = n.source, e = e || "", function t(r, a) {
                return r ? (a = (a = a.source || a).replace(/(^|[^\[])\^/g, "$1"), n = n.replace(r, a), t) : RegExp(n, e);
            };
        }
        function o() {}
        function s(n) {
            for(var e, t, r = 1; arguments.length > r; r++)for(t in e = arguments[r])Object.prototype.hasOwnProperty.call(e, t) && (n[t] = e[t]);
            return n;
        }
        function f(n, t, r) {
            if (r || "function" == typeof t) {
                r || (r = t, t = null);
                var a, c, o = (t = s({}, f.defaults, t || {})).highlight, l = 0;
                try {
                    a = e.lex(n, t);
                } catch (n) {
                    return r(n);
                }
                c = a.length;
                var d = function(n) {
                    if (n) return t.highlight = o, r(n);
                    var e;
                    try {
                        e = i.parse(a, t);
                    } catch (e) {
                        n = e;
                    }
                    return t.highlight = o, n ? r(n) : r(null, e);
                };
                if (!o || 3 > o.length) return d();
                if (delete t.highlight, !c) return d();
                for(; a.length > l; l++)!function(n) {
                    "code" !== n.type ? --c || d() : o(n.text, n.lang, function(e, t) {
                        return e ? d(e) : null == t || t === n.text ? --c || d() : (n.text = t, n.escaped = !0, void (--c || d()));
                    });
                }(a[l]);
            } else try {
                return t && (t = s({}, f.defaults, t)), i.parse(e.lex(n, t), t);
            } catch (n) {
                if (n.message += "\nPlease report this to https://github.com/chjj/marked.", (t || f.defaults).silent) return "<p>An error occured:</p><pre>" + u(n.message + "", !0) + "</pre>";
                throw n;
            }
        }
        t._inside = /(?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*/, t._href = /\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/, t.link = c(t.link)("inside", t._inside)("href", t._href)(), t.reflink = c(t.reflink)("inside", t._inside)(), t.normal = s({}, t), t.pedantic = s({}, t.normal, {
            strong: /^_\_(?=\S)([\s\S]*?\S)_\_(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
            em: /^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/
        }), t.gfm = s({}, t.normal, {
            escape: c(t.escape)("])", "~|])")(),
            url: /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,
            del: /^~~(?=\S)([\s\S]*?\S)~~/,
            text: c(t.text)("]|", "~]|")("|", "|https?://|")()
        }), t.breaks = s({}, t.gfm, {
            br: c(t.br)("{2,}", "*")(),
            text: c(t.gfm.text)("{2,}", "*")()
        }), r.rules = t, r.output = function(n, e, t) {
            return new r(e, t).output(n);
        }, r.prototype.output = function(n) {
            for(var e, t, r, a, i = ""; n;)if (a = this.rules.escape.exec(n)) n = n.substring(a[0].length), i += a[1];
            else if (a = this.rules.autolink.exec(n)) n = n.substring(a[0].length), "@" === a[2] ? (t = ":" === a[1].charAt(6) ? this.mangle(a[1].substring(7)) : this.mangle(a[1]), r = this.mangle("mailto:") + t) : r = t = u(a[1]), i += this.renderer.link(r, null, t);
            else if (this.inLink || !(a = this.rules.url.exec(n))) {
                if (a = this.rules.tag.exec(n)) !this.inLink && /^<a /i.test(a[0]) ? this.inLink = !0 : this.inLink && /^<\/a>/i.test(a[0]) && (this.inLink = !1), n = n.substring(a[0].length), i += this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(a[0]) : u(a[0]) : a[0];
                else if (a = this.rules.link.exec(n)) n = n.substring(a[0].length), this.inLink = !0, i += this.outputLink(a, {
                    href: a[2],
                    title: a[3]
                }), this.inLink = !1;
                else if ((a = this.rules.reflink.exec(n)) || (a = this.rules.nolink.exec(n))) {
                    if (n = n.substring(a[0].length), e = (a[2] || a[1]).replace(/\s+/g, " "), !(e = this.links[e.toLowerCase()]) || !e.href) {
                        i += a[0].charAt(0), n = a[0].substring(1) + n;
                        continue;
                    }
                    this.inLink = !0, i += this.outputLink(a, e), this.inLink = !1;
                } else if (a = this.rules.strong.exec(n)) n = n.substring(a[0].length), i += this.renderer.strong(this.output(a[2] || a[1]));
                else if (a = this.rules.em.exec(n)) n = n.substring(a[0].length), i += this.renderer.em(this.output(a[2] || a[1]));
                else if (a = this.rules.code.exec(n)) n = n.substring(a[0].length), i += this.renderer.codespan(u(a[2], !0));
                else if (a = this.rules.br.exec(n)) n = n.substring(a[0].length), i += this.renderer.br();
                else if (a = this.rules.del.exec(n)) n = n.substring(a[0].length), i += this.renderer.del(this.output(a[1]));
                else if (a = this.rules.text.exec(n)) n = n.substring(a[0].length), i += this.renderer.text(u(this.smartypants(a[0])));
                else if (n) throw Error("Infinite loop on byte: " + n.charCodeAt(0));
            } else n = n.substring(a[0].length), t = u(a[1]), i += this.renderer.link(r = t, null, t);
            return i;
        }, r.prototype.outputLink = function(n, e) {
            var t = u(e.href), r = e.title ? u(e.title) : null;
            return "!" !== n[0].charAt(0) ? this.renderer.link(t, r, this.output(n[1])) : this.renderer.image(t, r, u(n[1]));
        }, r.prototype.smartypants = function(n) {
            return this.options.smartypants ? n.replace(/---/g, "\u2014").replace(/--/g, "\u2013").replace(/(^|[-\u2014\/(\[{"\s])'/g, "$1\u2018").replace(/'/g, "\u2019").replace(/(^|[-\u2014\/(\[{\u2018\s])"/g, "$1\u201C").replace(/"/g, "\u201D").replace(/\.{3}/g, "\u2026") : n;
        }, r.prototype.mangle = function(n) {
            if (!this.options.mangle) return n;
            for(var e, t = "", r = n.length, a = 0; r > a; a++)e = n.charCodeAt(a), Math.random() > .5 && (e = "x" + e.toString(16)), t += "&#" + e + ";";
            return t;
        }, a.prototype.code = function(n, e, t) {
            if (this.options.highlight) {
                var r = this.options.highlight(n, e);
                null != r && r !== n && (t = !0, n = r);
            }
            return e ? '<pre><code class="' + this.options.langPrefix + u(e, !0) + '">' + (t ? n : u(n, !0)) + "\n</code></pre>\n" : "<pre><code>" + (t ? n : u(n, !0)) + "\n</code></pre>";
        }, a.prototype.blockquote = function(n) {
            return "<blockquote>\n" + n + "</blockquote>\n";
        }, a.prototype.html = function(n) {
            return n;
        }, a.prototype.heading = function(n, e, t) {
            return "<h" + e + ' id="' + this.options.headerPrefix + t.toLowerCase().replace(/[^\w]+/g, "-") + '">' + n + "</h" + e + ">\n";
        }, a.prototype.hr = function() {
            return this.options.xhtml ? "<hr/>\n" : "<hr>\n";
        }, a.prototype.list = function(n, e) {
            var t = e ? "ol" : "ul";
            return "<" + t + ">\n" + n + "</" + t + ">\n";
        }, a.prototype.listitem = function(n) {
            return "<li>" + n + "</li>\n";
        }, a.prototype.paragraph = function(n) {
            return "<p>" + n + "</p>\n";
        }, a.prototype.table = function(n, e) {
            return "<table>\n<thead>\n" + n + "</thead>\n<tbody>\n" + e + "</tbody>\n</table>\n";
        }, a.prototype.tablerow = function(n) {
            return "<tr>\n" + n + "</tr>\n";
        }, a.prototype.tablecell = function(n, e) {
            var t = e.header ? "th" : "td";
            return (e.align ? "<" + t + ' style="text-align:' + e.align + '">' : "<" + t + ">") + n + "</" + t + ">\n";
        }, a.prototype.strong = function(n) {
            return "<strong>" + n + "</strong>";
        }, a.prototype.em = function(n) {
            return "<em>" + n + "</em>";
        }, a.prototype.codespan = function(n) {
            return "<code>" + n + "</code>";
        }, a.prototype.br = function() {
            return this.options.xhtml ? "<br/>" : "<br>";
        }, a.prototype.del = function(n) {
            return "<del>" + n + "</del>";
        }, a.prototype.link = function(n, e, t) {
            if (this.options.sanitize) {
                try {
                    var r = decodeURIComponent((a = n, a.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/g, function(n, e) {
                        return "colon" === (e = e.toLowerCase()) ? ":" : "#" === e.charAt(0) ? "x" === e.charAt(1) ? String.fromCharCode(parseInt(e.substring(2), 16)) : String.fromCharCode(+e.substring(1)) : "";
                    }))).replace(/[^\w:]/g, "").toLowerCase();
                } catch (n) {
                    return "";
                }
                if (0 === r.indexOf("javascript:") || 0 === r.indexOf("vbscript:") || 0 === r.indexOf("data:")) return "";
            }
            var a, i = '<a href="' + n + '"';
            return e && (i += ' title="' + e + '"'), i + ">" + t + "</a>";
        }, a.prototype.image = function(n, e, t) {
            var r = '<img src="' + n + '" alt="' + t + '"';
            return e && (r += ' title="' + e + '"'), r + (this.options.xhtml ? "/>" : ">");
        }, a.prototype.text = function(n) {
            return n;
        }, i.parse = function(n, e, t) {
            return new i(e, t).parse(n);
        }, i.prototype.parse = function(n) {
            this.inline = new r(n.links, this.options, this.renderer), this.tokens = n.reverse();
            for(var e = ""; this.next();)e += this.tok();
            return e;
        }, i.prototype.next = function() {
            return this.token = this.tokens.pop();
        }, i.prototype.peek = function() {
            return this.tokens[this.tokens.length - 1] || 0;
        }, i.prototype.parseText = function() {
            for(var n = this.token.text; "text" === this.peek().type;)n += "\n" + this.next().text;
            return this.inline.output(n);
        }, i.prototype.tok = function() {
            switch(this.token.type){
                case "space":
                    return "";
                case "hr":
                    return this.renderer.hr();
                case "heading":
                    return this.renderer.heading(this.inline.output(this.token.text), this.token.depth, this.token.text);
                case "code":
                    return this.renderer.code(this.token.text, this.token.lang, this.token.escaped);
                case "table":
                    var n, e, t, r, a = "", i = "";
                    for(t = "", n = 0; this.token.header.length > n; n++)t += this.renderer.tablecell(this.inline.output(this.token.header[n]), {
                        header: !0,
                        align: this.token.align[n]
                    });
                    for(a += this.renderer.tablerow(t), n = 0; this.token.cells.length > n; n++){
                        for(e = this.token.cells[n], t = "", r = 0; e.length > r; r++)t += this.renderer.tablecell(this.inline.output(e[r]), {
                            header: !1,
                            align: this.token.align[r]
                        });
                        i += this.renderer.tablerow(t);
                    }
                    return this.renderer.table(a, i);
                case "blockquote_start":
                    for(i = ""; "blockquote_end" !== this.next().type;)i += this.tok();
                    return this.renderer.blockquote(i);
                case "list_start":
                    i = "";
                    for(var u = this.token.ordered; "list_end" !== this.next().type;)i += this.tok();
                    return this.renderer.list(i, u);
                case "list_item_start":
                    for(i = ""; "list_item_end" !== this.next().type;)i += "text" === this.token.type ? this.parseText() : this.tok();
                    return this.renderer.listitem(i);
                case "loose_item_start":
                    for(i = ""; "list_item_end" !== this.next().type;)i += this.tok();
                    return this.renderer.listitem(i);
                case "html":
                    var c = this.token.pre || this.options.pedantic ? this.token.text : this.inline.output(this.token.text);
                    return this.renderer.html(c);
                case "paragraph":
                    return this.renderer.paragraph(this.inline.output(this.token.text));
                case "text":
                    return this.renderer.paragraph(this.parseText());
            }
        }, o.exec = o, f.options = f.setOptions = function(n) {
            return s(f.defaults, n), f;
        }, f.defaults = {
            gfm: !0,
            tables: !0,
            breaks: !1,
            pedantic: !1,
            sanitize: !1,
            sanitizer: null,
            mangle: !0,
            smartLists: !1,
            silent: !1,
            highlight: null,
            langPrefix: "lang-",
            smartypants: !1,
            headerPrefix: "",
            renderer: new a,
            xhtml: !1
        }, f.Parser = i, f.parser = i.parse, f.Renderer = a, f.Lexer = e, f.lexer = e.lex, f.InlineLexer = r, f.inlineLexer = r.output, f.parse = f, void 0 !== Me && "object" == typeof Ke ? Me.exports = f : "function" == typeof define && define.amd ? define(function() {
            return f;
        }) : this.marked = f;
    }).call(function() {
        return this || ("undefined" != typeof window ? window : $parcel$global);
    }()), Me.exports), Ze = p, Xe = a, nt = F3(function(n, e, t) {
        var r = t.c, a = t.d, i = F2(function(e, t) {
            return A3(Xe, e.$ ? n : i, t, e.a);
        });
        return A3(Xe, i, A3(Xe, n, e, a), r);
    }), et = F3(function(n, e, t) {
        for(;;){
            if (-2 === t.$) return e;
            var r = t.d, a = n, i = A3(n, t.b, t.c, A3(et, n, e, t.e));
            n = a, e = i, t = r;
        }
    }), tt = function(n) {
        return A3(et, F3(function(n, e, t) {
            return A2(Ze, l(n, e), t);
        }), g, n);
    }, rt = function(n) {
        return A3(et, F3(function(n, e, t) {
            return A2(Ze, n, t);
        }), g, n);
    }, at = 1, it = 2, ut = 0, ct = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ot = F2(function(n, e) {
        return {
            $: 3,
            a: n,
            b: e
        };
    }), st = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), ft = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), lt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, dt = function(n) {
        return {
            $: 2,
            a: n
        };
    }, bt = x, ht = function(n) {
        return {
            $: 0,
            a: n
        };
    }, gt = {
        $: 1
    }, vt = P, pt = S, mt = cn, $t = function(n) {
        return n + "";
    }, yt = F2(function(n, e) {
        return A2(B, n, $(e));
    }), wt = F2(function(n, e) {
        return m(A2(L, n, e));
    }), kt = function(n) {
        return A2(yt, "\n    ", A2(wt, "\n", n));
    }, xt = F3(function(n, e, t) {
        for(;;){
            if (!t.b) return e;
            var r = t.b, a = n, i = A2(n, t.a, e);
            n = a, e = i, t = r;
        }
    }), jt = function(n) {
        return A3(xt, F2(function(n, e) {
            return e + 1;
        }), 0, n);
    }, At = y, Ct = F3(function(n, e, t) {
        for(;;){
            if (s(n, e) >= 1) return t;
            var r = n, a = e - 1, i = A2(Ze, e, t);
            n = r, e = a, t = i;
        }
    }), It = F2(function(n, e) {
        return A3(Ct, n, e, g);
    }), Tt = F2(function(n, e) {
        return A3(At, n, A2(It, 0, jt(e) - 1), e);
    }), St = function(n) {
        var e = n.charCodeAt(0);
        return 55296 > e || e > 56319 ? e : 1024 * (e - 55296) + n.charCodeAt(1) - 56320 + 65536;
    }, Dt = function(n) {
        var e = St(n);
        return e >= 97 && 122 >= e;
    }, Nt = function(n) {
        var e = St(n);
        return 90 >= e && e >= 65;
    }, Et = function(n) {
        var e = St(n);
        return 57 >= e && e >= 48;
    }, Lt = function(n) {
        return Dt(n) || Nt(n) || Et(n);
    }, Bt = function(n) {
        return A3(xt, Ze, g, n);
    }, Ot = F2(function(n, e) {
        return "\n\n(" + $t(n + 1) + ") " + kt(Pt(e));
    }), Pt = function(n) {
        return A2(Gt, n, g);
    }, Gt = F2(function(n, e) {
        n: for(;;)switch(n.$){
            case 0:
                var t = n.a, r = n.b, a = function() {
                    var n, e, r = (e = (n = t).charCodeAt(0)) ? ht(55296 > e || e > 56319 ? l(n[0], n.slice(1)) : l(n[0] + n[1], n.slice(2))) : gt;
                    if (1 === r.$) return !1;
                    var a, i = r.a, u = i.b;
                    return (Dt(a = i.a) || Nt(a)) && A2(vt, Lt, u);
                }();
                n = r, e = A2(Ze, a ? "." + t : "['" + t + "']", e);
                continue n;
            case 1:
                r = n.b;
                var i = "[" + $t(n.a) + "]";
                n = r, e = A2(Ze, i, e);
                continue n;
            case 2:
                var u = n.a;
                if (u.b) {
                    if (u.b.b) {
                        var c = (e.b ? "The Json.Decode.oneOf at json" + A2(yt, "", Bt(e)) : "Json.Decode.oneOf") + " failed in the following " + $t(jt(u)) + " ways:";
                        return A2(yt, "\n\n", A2(Ze, c, A2(Tt, Ot, u)));
                    }
                    n = r = u.a;
                    continue n;
                }
                return "Ran into a Json.Decode.oneOf with no possibilities" + (e.b ? " at json" + A2(yt, "", Bt(e)) : "!");
            default:
                var o = n.a, s = n.b;
                return (c = e.b ? "Problem with the value at json" + A2(yt, "", Bt(e)) + ":\n\n    " : "Problem with the given value:\n\n") + kt(A2(mt, 4, s)) + "\n\n" + o;
        }
    }), Rt = 32, zt = F4(function(n, e, t, r) {
        return {
            $: 0,
            a: n,
            b: e,
            c: t,
            d: r
        };
    }), qt = [], _t = A, Ht = F2(function(n, e) {
        return T(e) / T(n);
    }), Ft = _t(A2(Ht, 2, Rt)), Ut = A4(zt, 0, Ft, qt, qt), Vt = t, Wt = F2(function(n, e) {
        return n(e);
    }), Yt = F2(function(n, e) {
        return e(n);
    }), Mt = o, Kt = C, Jt = function(n) {
        return n.length;
    }, Qt = F2(function(n, e) {
        return s(n, e) > 0 ? n : e;
    }), Zt = r, Xt = F2(function(n, e) {
        for(;;){
            var t = A2(Zt, Rt, n), r = t.b, a = A2(Ze, {
                $: 0,
                a: t.a
            }, e);
            if (!r.b) return Bt(a);
            n = r, e = a;
        }
    }), nr = function(n) {
        return n.a;
    }, er = F2(function(n, e) {
        for(;;){
            var t = _t(e / Rt);
            if (1 === t) return A2(Zt, Rt, n).a;
            n = A2(Xt, n, g), e = t;
        }
    }), tr = F2(function(n, e) {
        if (e.t) {
            var t = e.t * Rt, r = Kt(A2(Ht, Rt, t - 1)), a = n ? Bt(e.y) : e.y, i = A2(er, a, e.t);
            return A4(zt, Jt(e.w) + t, A2(Qt, 5, r * Ft), i, e.w);
        }
        return A4(zt, Jt(e.w), Ft, qt, e.w);
    }), rr = F5(function(n, e, t, r, a) {
        for(;;){
            if (0 > e) return A2(tr, !1, {
                y: r,
                t: t / Rt | 0,
                w: a
            });
            var i = {
                $: 1,
                a: A3(Vt, Rt, e, n)
            };
            e -= Rt, r = A2(Ze, i, r);
        }
    }), ar = F2(function(n, e) {
        if (n > 0) {
            var t = n % Rt;
            return A5(rr, e, n - t - Rt, n, g, A3(Vt, t, n - t, e));
        }
        return Ut;
    }), ir = function(n) {
        return !n.$;
    }, ur = M, cr = K, or = J, sr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, fr = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, lr = function(n) {
        return n;
    }, dr = lr, br = F6(function(n, e, t, r, a, i) {
        return {
            it: i,
            fJ: e,
            bp: r,
            gM: t,
            gU: n,
            jj: a
        };
    }), hr = G, gr = function(n) {
        return n.length;
    }, vr = O, pr = F2(function(n, e) {
        return 1 > n ? e : A3(vr, n, gr(e), e);
    }), mr = q, $r = function(n) {
        return "" === n;
    }, yr = F2(function(n, e) {
        return 1 > n ? "" : A3(vr, 0, n, e);
    }), wr = function(n) {
        for(var e = 0, t = n.charCodeAt(0), r = 43 == t || 45 == t ? 1 : 0, a = r; n.length > a; ++a){
            var i = n.charCodeAt(a);
            if (48 > i || i > 57) return gt;
            e = 10 * e + i - 48;
        }
        return a == r ? gt : ht(45 == t ? -e : e);
    }, kr = F5(function(n, e, t, r, a) {
        if ($r(a) || A2(hr, "@", a)) return gt;
        var i = A2(mr, ":", a);
        if (i.b) {
            if (i.b.b) return gt;
            var u = i.a, c = wr(A2(pr, u + 1, a));
            if (1 === c.$) return gt;
            var o = c;
            return ht(A6(br, n, A2(yr, u, a), o, e, t, r));
        }
        return ht(A6(br, n, a, gt, e, t, r));
    }), xr = F4(function(n, e, t, r) {
        if ($r(r)) return gt;
        var a = A2(mr, "/", r);
        if (a.b) {
            var i = a.a;
            return A5(kr, n, A2(pr, i, r), e, t, A2(yr, i, r));
        }
        return A5(kr, n, "/", e, t, r);
    }), jr = F3(function(n, e, t) {
        if ($r(t)) return gt;
        var r = A2(mr, "?", t);
        if (r.b) {
            var a = r.a;
            return A4(xr, n, ht(A2(pr, a + 1, t)), e, A2(yr, a, t));
        }
        return A4(xr, n, gt, e, t);
    }), Ar = F2(function(n, e) {
        if ($r(e)) return gt;
        var t = A2(mr, "#", e);
        if (t.b) {
            var r = t.a;
            return A3(jr, n, ht(A2(pr, r + 1, e)), A2(yr, r, e));
        }
        return A3(jr, n, gt, e);
    }), Cr = R, Ir = function(n) {
        return A2(Cr, "http://", n) ? A2(Ar, 0, A2(pr, 7, n)) : A2(Cr, "https://", n) ? A2(Ar, 1, A2(pr, 8, n)) : gt;
    }, Tr = function() {
        for(;;);
    }, Sr = fn, Dr = Sr(0), Nr = F4(function(n, e, t, r) {
        if (r.b) {
            var a = r.a, i = r.b;
            if (i.b) {
                var u = i.a, c = i.b;
                if (c.b) {
                    var o = c.a, s = c.b;
                    if (s.b) {
                        var f = s.b;
                        return A2(n, a, A2(n, u, A2(n, o, A2(n, s.a, t > 500 ? A3(xt, n, e, Bt(f)) : A4(Nr, n, e, t + 1, f)))));
                    }
                    return A2(n, a, A2(n, u, A2(n, o, e)));
                }
                return A2(n, a, A2(n, u, e));
            }
            return A2(n, a, e);
        }
        return e;
    }), Er = F3(function(n, e, t) {
        return A4(Nr, n, e, 0, t);
    }), Lr = F2(function(n, e) {
        return A3(Er, F2(function(e, t) {
            return A2(Ze, n(e), t);
        }), g, e);
    }), Br = dn, Or = F2(function(n, e) {
        return A2(Br, function(e) {
            return Sr(n(e));
        }, e);
    }), Pr = F3(function(n, e, t) {
        return A2(Br, function(e) {
            return A2(Br, function(t) {
                return Sr(A2(n, e, t));
            }, t);
        }, e);
    }), Gr = function(n) {
        return A3(Er, Pr(Ze), Sr(g), n);
    }, Rr = Cn, zr = F2(function(n, e) {
        var t = e;
        return vn(A2(Br, Rr(n), t));
    });
    xn.Task = jn(Dr, F3(function(n, e) {
        return A2(Or, function() {
            return 0;
        }, Gr(A2(Lr, zr(n), e)));
    }), F3(function() {
        return Sr(0);
    }), F2(function(n, e) {
        return A2(Or, n, e);
    }));
    var qr, _r, Hr = Tn("Task"), Fr = F2(function(n, e) {
        return Hr(A2(Or, n, e));
    }), Ur = W, Vr = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Wr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Yr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Mr = {
        $: 1
    }, Kr = {
        $: 0
    }, Jr = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Qr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Zr = V, Xr = A2(ur, function(n) {
        switch(n){
            case "User":
                return sr(0);
            case "Organization":
                return sr(1);
            default:
                return Qr("Unknown type: " + n);
        }
    }, Zr), na = F, ea = or(Yt), ta = F2(function(n, e) {
        return ea(A2(Ur, n, e));
    }), ra = De, aa = Se, ia = function(n) {
        return A2(aa, {
            h5: !1,
            iU: !1
        }, n);
    }, ua = /.^/, ca = F2(function(n, e) {
        return e.$ ? n : e.a;
    }), oa = A2(ca, ua, ia("^[0-9A-Fa-f]{8,8}-[0-9A-Fa-f]{4,4}-[1-5][0-9A-Fa-f]{3,3}-[8-9A-Ba-b][0-9A-Fa-f]{3,3}-[0-9A-Fa-f]{12,12}$")), sa = function(n) {
        return A2(ra, oa, n) ? ht(n.toLowerCase()) : gt;
    }, fa = A2(ur, function(n) {
        var e = sa(n);
        return e.$ ? Qr("Not a valid UUID") : sr(e.a);
    }, Zr), la = {
        $: -2
    }, da = la, ba = F5(function(n, e, t, r, a) {
        return {
            $: -1,
            a: n,
            b: e,
            c: t,
            d: r,
            e: a
        };
    }), ha = F5(function(n, e, t, r, a) {
        if (-1 !== a.$ || a.a) {
            if (-1 !== r.$ || r.a || -1 !== r.d.$ || r.d.a) return A5(ba, n, e, t, r, a);
            var i = r.d;
            return u = r.e, A5(ba, 0, r.b, r.c, A5(ba, 1, i.b, i.c, i.d, i.e), A5(ba, 1, e, t, u, a));
        }
        var u, c = a.b, o = a.c, s = a.d, f = a.e;
        return -1 !== r.$ || r.a ? A5(ba, n, c, o, A5(ba, 0, e, t, r, s), f) : A5(ba, 0, e, t, A5(ba, 1, r.b, r.c, r.d, u = r.e), A5(ba, 1, c, o, s, f));
    }), ga = f, va = F3(function(n, e, t) {
        if (-2 === t.$) return A5(ba, 0, n, e, la, la);
        var r = t.a, a = t.b, i = t.c, u = t.d, c = t.e;
        switch(A2(ga, n, a)){
            case 0:
                return A5(ha, r, a, i, A3(va, n, e, u), c);
            case 1:
                return A5(ba, r, a, e, u, c);
            default:
                return A5(ha, r, a, i, u, A3(va, n, e, c));
        }
    }), pa = F3(function(n, e, t) {
        var r = A3(va, n, e, t);
        return -1 !== r.$ || r.a ? r : A5(ba, 1, r.b, r.c, r.d, r.e);
    }), ma = function(n) {
        return A3(xt, F2(function(n, e) {
            return A3(pa, n.a, n.b, e);
        }), da, n);
    }, $a = function(n) {
        return A2(cr, ma, function(n) {
            return {
                $: 8,
                b: n
            };
        }(n));
    }, ya = F6(function(n, e, t, r, a, i) {
        return {
            ek: i,
            k: t,
            c: n,
            gm: a,
            ax: e,
            W: r
        };
    }), wa = Z, ka = function(n) {
        return {
            $: 11,
            g: n
        };
    }, xa = U, ja = F3(function(n, e, t) {
        var r, a = ka(m([
            A2(cr, ht, e),
            (r = t, {
                $: 5,
                c: r
            })
        ])), i = A2(Ur, n, xa);
        return A2(ur, function(n) {
            var e = A2(wa, i, n);
            if (e.$) return sr(t);
            var r = A2(wa, a, e.a);
            return r.$ ? Qr(Pt(r.a)) : sr(r.a);
        }, xa);
    }), Aa = F3(function(n, e, t) {
        return ea(A3(ja, n, e, t));
    }), Ca = A4(Aa, "adminPermission", na, gt, A4(Aa, "newInstallationURL", Zr, gt, A3(ta, "typ", Zr, A3(ta, "displayName", Zr, A3(ta, "slug", Zr, A3(ta, "id", fa, sr(ya))))))), Ia = A2(ur, function(n) {
        switch(n){
            case "Member":
                return sr(0);
            case "Admin":
                return sr(1);
            default:
                return Qr("Unknown type: " + n);
        }
    }, Zr), Ta = F8(function(n, e, t, r, a, i, u, c) {
        return {
            ew: t,
            k: e,
            c: n,
            hn: u,
            ho: i,
            hp: a,
            hq: c,
            hy: r
        };
    }), Sa = A2(ur, function(n) {
        switch(n){
            case "Community":
                return sr(0);
            case "Trial":
                return sr(1);
            case "Active":
                return sr(2);
            case "Cancelled":
                return sr(3);
            case "External":
                return sr(4);
            case "Enterprise":
                return sr(5);
            default:
                return Qr("Unknown type: " + n);
        }
    }, Zr), Da = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), Na = F3(function(n, e, t) {
        return {
            $: 0,
            a: n,
            b: e,
            c: t
        };
    }), Ea = F2(function(n, e) {
        var t = e;
        return function(e) {
            var r = t(e);
            if (1 === r.$) return A2(Da, r.a, r.b);
            var a = r.a, i = r.c, u = n(r.b)(i);
            if (1 === u.$) {
                var c = u.a;
                return A2(Da, a || c, u.b);
            }
            return c = u.a, A3(Na, a || c, u.b, u.c);
        };
    }), La = Ea, Ba = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), Oa = F4(function(n, e, t, r) {
        return {
            eL: e,
            id: r,
            gP: t,
            g8: n
        };
    }), Pa = {
        $: 0
    }, Ga = F2(function(n, e) {
        return A2(Ba, Pa, A4(Oa, n.g8, n.eL, e, n.h));
    }), Ra = (qr = {
        $: 10
    }, function(n) {
        return u(gr(n.b), n.d) ? A3(Na, !1, 0, n) : A2(Da, !1, A2(Ga, n, qr));
    }), za = Ee, qa = F5(function(n, e, t, r, a) {
        for(;;){
            var i = A3(za, n, e, a.b);
            if (u(i, -1)) return A3(Na, 0 > s(a.d, e), 0, {
                eL: r,
                h: a.h,
                i: a.i,
                d: e,
                g8: t,
                b: a.b
            });
            u(i, -2) ? (e += 1, t += 1, r = 1) : (e = i, r += 1);
        }
    }), _a = function(n) {
        return function(e) {
            return A5(qa, n, e.d, e.g8, e.eL, e);
        };
    }, Ha = F2(function(n) {
        return n;
    }), Fa = F2(function(n, e) {
        var t = e;
        return function(e) {
            var r = t(e);
            if (1 === r.$) return A2(Da, r.a, r.b);
            var a = r.b, i = r.c;
            return A3(Na, r.a, A2(n, A3(vr, e.d, i.d, e.b), a), i);
        };
    }), Ua = function(n) {
        return A2(Fa, Ha, n);
    }, Va = function(n) {
        return function(n) {
            return function(e) {
                return A2(Da, !1, A2(Ga, e, n));
            };
        }({
            $: 12,
            a: n
        });
    }, Wa = I, Ya = function(n) {
        return function(e) {
            return A3(Na, !1, n, e);
        };
    }, Ma = Ya, Ka = function(n) {
        if (0 === n.length || /[\sxbo]/.test(n)) return gt;
        var e = +n;
        return e == e ? ht(e) : gt;
    }, Ja = A2(La, function(n) {
        if (gr(n) > 9) return Va("Expected at most 9 digits, but got " + $t(gr(n)));
        var e = Ka("0." + n);
        return e.$ ? Va('Invalid float: "' + n + '"') : Ma(Wa(1e3 * e.a));
    }, Ua(_a(Et))), Qa = lr, Za = F6(function(n, e, t, r, a, i) {
        return Qa(n + 60 * e * 60000 + 60 * (t - i) * 1e3 + 1e3 * r + a);
    }), Xa = F3(function(n, e, t) {
        var r = e, a = t;
        return function(e) {
            var t = r(e);
            if (1 === t.$) return A2(Da, t.a, t.b);
            var i = t.a, u = t.b, c = a(t.c);
            if (1 === c.$) {
                var o = c.a;
                return A2(Da, i || o, c.b);
            }
            o = c.a;
            var s = c.c;
            return A3(Na, i || o, A2(n, u, c.b), s);
        };
    }), ni = F2(function(n, e) {
        return A3(Xa, Ha, n, e);
    }), ei = ni, ti = F2(function(n, e) {
        return A3(Xa, Wt, n, e);
    }), ri = F2(function(n, e) {
        return {
            $: 2,
            a: n,
            b: e
        };
    }), ai = F3(function(n, e, t) {
        n: for(;;){
            if (t.b) {
                var r = t.b, a = (0, t.a)(n);
                if (a.$) {
                    var i;
                    if ((i = a).a) return i;
                    e = A2(ri, e, i.b), t = r;
                    continue n;
                }
                return a;
            }
            return A2(Da, !1, e);
        }
    }), ii = function(n) {
        return function(e) {
            return A3(ai, e, Pa, n);
        };
    }, ui = ii, ci = function(n) {
        return {
            $: 1,
            a: n
        };
    }, oi = N, si = {
        $: 11
    }, fi = F2(function(n, e) {
        return function(t) {
            var r = A3(za, n, t.d, t.b);
            return u(r, -1) ? A2(Da, !1, A2(Ga, t, e)) : u(r, -2) ? A3(Na, !0, 0, {
                eL: 1,
                h: t.h,
                i: t.i,
                d: t.d + 1,
                g8: t.g8 + 1,
                b: t.b
            }) : A3(Na, !0, 0, {
                eL: t.eL + 1,
                h: t.h,
                i: t.i,
                d: r,
                g8: t.g8,
                b: t.b
            });
        };
    }), li = function(n) {
        return A2(fi, n, si);
    }, di = F4(function(n, e, t, r) {
        for(;;){
            var a = t(e)(r);
            if (a.$) return i = a.a, A2(Da, n || i, a.b);
            var i = a.a, u = a.b, c = a.c;
            if (u.$) return A3(Na, n || i, u.a, c);
            n = n || i, e = u.a, r = c;
        }
    }), bi = F2(function(n, e) {
        return function(t) {
            return A4(di, !1, n, e, t);
        };
    }), hi = F2(function(n, e) {
        var t = e;
        return function(e) {
            var r = t(e);
            if (r.$) return A2(Da, r.a, r.b);
            var a = r.c;
            return A3(Na, r.a, n(r.b), a);
        };
    }), gi = hi, vi = function(n) {
        return {
            $: 1,
            a: n
        };
    }, pi = function(n) {
        return {
            $: 0,
            a: n
        };
    }, mi = function(n) {
        return n.$ ? vi(n.a) : pi(n.a);
    }, $i = F2(function(n, e) {
        return A2(bi, n, function(n) {
            return A2(gi, mi, e(n));
        });
    }), yi = function(n) {
        return A2($i, "", function(e) {
            if (u(gr(e), n)) {
                var t = wr(e);
                return t.$ ? Va('Invalid integer: "' + e + '"') : A2(gi, ci, Ma(t.a));
            }
            return A2(gi, function(n) {
                return {
                    $: 0,
                    a: A2(oi, e, n)
                };
            }, Ua(li(Et)));
        });
    }, wi = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), ki = Ne, xi = function(n) {
        return !n;
    }, ji = function(n) {
        var e = n.a, t = n.b, r = !$r(e);
        return function(n) {
            var a = A5(ki, e, n.d, n.g8, n.eL, n.b), i = a.a, c = a.b, o = a.c;
            return u(i, -1) ? A2(Da, !1, A2(Ga, n, t)) : A3(Na, r, 0, {
                eL: o,
                h: n.h,
                i: n.i,
                d: i,
                g8: c,
                b: n.b
            });
        };
    }, Ai = ji, Ci = function(n) {
        return Ai(A2(wi, n, {
            $: 8,
            a: n
        }));
    }, Ii = function(n) {
        return Va("Invalid day: " + $t(n));
    }, Ti = j, Si = function(n) {
        return !(A2(Ti, 4, n) || !A2(Ti, 100, n) && A2(Ti, 400, n));
    }, Di = function(n) {
        var e = n - 1;
        return (e / 4 | 0) - (e / 100 | 0) + (e / 400 | 0);
    }, Ni = A2(La, function(n) {
        var e = n.a, t = n.b, r = n.c;
        if (0 > r) return Ii(r);
        var a = function(n) {
            var a = 31536e6 * (e - 1970), i = 864e5 * ((3 > t || !Si(e) ? r - 1 : r) + (Di(e) - Di(1970)));
            return Ma(n + a + i);
        };
        switch(t){
            case 1:
                return r > 31 ? Ii(r) : a(0);
            case 2:
                return r > 29 || 29 === r && !Si(e) ? Ii(r) : a(26784e5);
            case 3:
                return r > 31 ? Ii(r) : a(50976e5);
            case 4:
                return r > 30 ? Ii(r) : a(7776e6);
            case 5:
                return r > 31 ? Ii(r) : a(10368e6);
            case 6:
                return r > 30 ? Ii(r) : a(130464e5);
            case 7:
                return r > 31 ? Ii(r) : a(156384e5);
            case 8:
                return r > 31 ? Ii(r) : a(183168e5);
            case 9:
                return r > 30 ? Ii(r) : a(209952e5);
            case 10:
                return r > 31 ? Ii(r) : a(235872e5);
            case 11:
                return r > 30 ? Ii(r) : a(262656e5);
            case 12:
                return r > 31 ? Ii(r) : a(288576e5);
            default:
                return Va('Invalid month: "' + $t(t) + '"');
        }
    }, A2(ti, A2(ti, A2(ti, Ma(F3(function(n, e, t) {
        return d(n, e, t);
    })), yi(4)), ui(m([
        A2(ti, A2(ei, Ma(lr), Ci("-")), yi(2)),
        yi(2)
    ]))), ui(m([
        A2(ti, A2(ei, Ma(lr), Ci("-")), yi(2)),
        yi(2)
    ])))), Ei = (_r = F3(function(n, e, t) {
        return n * (60 * e) + t;
    }), A2(ti, Ma(lr), ui(m([
        A2(gi, function() {
            return 0;
        }, Ci("Z")),
        A2(ti, A2(ti, A2(ti, Ma(_r), ui(m([
            A2(gi, function() {
                return 1;
            }, Ci("+")),
            A2(gi, function() {
                return -1;
            }, Ci("-"))
        ]))), yi(2)), ui(m([
            A2(ti, A2(ei, Ma(lr), Ci(":")), yi(2)),
            yi(2),
            Ma(0)
        ]))),
        A2(ei, Ma(0), Ra)
    ])))), Li = A2(La, function(n) {
        return ui(m([
            A2(ti, A2(ti, A2(ti, A2(ti, A2(ti, A2(ei, Ma(Za(n)), Ci("T")), yi(2)), ui(m([
                A2(ti, A2(ei, Ma(lr), Ci(":")), yi(2)),
                yi(2)
            ]))), ui(m([
                A2(ti, A2(ei, Ma(lr), Ci(":")), yi(2)),
                yi(2)
            ]))), ui(m([
                A2(ti, A2(ei, Ma(lr), Ci(".")), Ja),
                Ma(0)
            ]))), A2(ei, Ei, Ra)),
            A2(ei, Ma(A6(Za, n, 0, 0, 0, 0, 0)), Ra)
        ]));
    }, Ni), Bi = F3(function(n, e, t) {
        return {
            eL: e,
            gP: t,
            g8: n
        };
    }), Oi = function(n) {
        return A3(Bi, n.g8, n.eL, n.gP);
    }, Pi = F2(function(n, e) {
        n: for(;;)switch(n.$){
            case 0:
                return e;
            case 1:
                var t = n.b;
                n = n.a, e = A2(Ze, t, e);
                continue n;
            default:
                var r = n.b;
                n = n.a, e = A2(Pi, r, e);
                continue n;
        }
    }), Gi = F2(function(n, e) {
        var t = n({
            eL: 1,
            h: g,
            i: 1,
            d: 0,
            g8: 1,
            b: e
        });
        return t.$ ? ct(A2(Pi, t.b, g)) : lt(t.b);
    }), Ri = F2(function(n, e) {
        var t = A2(Gi, n, e);
        return t.$ ? ct(A2(Lr, Oi, t.a)) : lt(t.a);
    }), zi = A2(ur, function(n) {
        var e = function(n) {
            return A2(Ri, Li, n);
        }(n);
        return e.$ ? Qr("Invalid ISO date: " + n) : sr(e.a);
    }, Zr), qi = A4(Aa, "subscriptionUpdateUrl", Zr, gt, A4(Aa, "subscriptionCancelUrl", Zr, gt, A4(Aa, "subscriptionCancelledOn", zi, gt, A4(Aa, "subscriptionStartedOn", zi, gt, A4(Aa, "trialStartedOn", zi, gt, A3(ta, "billingStatus", Sa, A3(ta, "displayName", Zr, A3(ta, "id", fa, sr(Ta))))))))), _i = A4(Aa, "installationIsSelection", na, gt, A4(Aa, "manageInstallationURL", Zr, gt, A4(Aa, "sourceHostingSites", $a(Ca), gt, A4(Aa, "membershipRole", Ia, gt, A3(ta, "isInstallable", na, A3(ta, "isInstalled", na, A4(Aa, "organization", qi, gt, A3(ta, "imageURL", Zr, A3(ta, "displayName", Zr, A3(ta, "typ", Xr, A3(ta, "slug", Zr, A3(ta, "sourceHostingSiteSlug", Zr, A3(ta, "id", fa, sr(function(n) {
        return function(e) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return function(i) {
                            return function(u) {
                                return function(c) {
                                    return function(o) {
                                        return function(s) {
                                            return function(f) {
                                                return function(l) {
                                                    return function(d) {
                                                        return {
                                                            k: a,
                                                            c: n,
                                                            T: i,
                                                            fT: d,
                                                            c9: o,
                                                            da: c,
                                                            gc: l,
                                                            gf: s,
                                                            gB: u,
                                                            ax: t,
                                                            hf: e,
                                                            hg: f,
                                                            W: r
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))), Hi = function(n) {
        return {
            $: 3,
            b: n
        };
    }, Fi = F2(function(n, e) {
        return e.$ ? gt : ht(n(e.a));
    }), Ui = F2(function(n, e) {
        return {
            $: 3,
            a: n,
            b: e
        };
    }), Vi = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Wi = F2(function(n, e) {
        return {
            $: 4,
            a: n,
            b: e
        };
    }), Yi = {
        $: 2
    }, Mi = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ki = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ji = {
        $: 1
    }, Qi = function(n) {
        return !n.$;
    }, Zi = In, Xi = F2(function(n, e) {
        n: for(;;){
            if (-2 === e.$) return gt;
            var t = e.c, r = e.d, a = e.e;
            switch(A2(ga, n, e.b)){
                case 0:
                    e = r;
                    continue n;
                case 1:
                    return ht(t);
                default:
                    e = a;
                    continue n;
            }
        }
    }), nu = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.e.d.$ || n.e.d.a) {
                var e = n.d, t = n.e;
                return u = t.b, c = t.c, r = t.d, f = t.e, A5(ba, 1, n.b, n.c, A5(ba, 0, e.b, e.c, e.d, e.e), A5(ba, 0, u, c, r, f));
            }
            var r, a = n.d, i = n.e, u = i.b, c = i.c, o = (r = i.d).d, s = r.e, f = i.e;
            return A5(ba, 0, r.b, r.c, A5(ba, 1, n.b, n.c, A5(ba, 0, a.b, a.c, a.d, a.e), o), A5(ba, 1, u, c, s, f));
        }
        return n;
    }, eu = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.d.d.$ || n.d.d.a) {
                var e = n.d, t = n.e;
                return s = t.b, f = t.c, l = t.d, d = t.e, A5(ba, 1, r = n.b, a = n.c, A5(ba, 0, e.b, e.c, e.d, c = e.e), A5(ba, 0, s, f, l, d));
            }
            var r = n.b, a = n.c, i = n.d, u = i.d, c = i.e, o = n.e, s = o.b, f = o.c, l = o.d, d = o.e;
            return A5(ba, 0, i.b, i.c, A5(ba, 1, u.b, u.c, u.d, u.e), A5(ba, 1, r, a, c, A5(ba, 0, s, f, l, d)));
        }
        return n;
    }, tu = F7(function(n, e, t, r, a, i, u) {
        if (-1 !== i.$ || i.a) {
            n: for(;;){
                if (-1 === u.$ && 1 === u.a) {
                    if (-1 === u.d.$) {
                        if (1 === u.d.a) return eu(e);
                        break n;
                    }
                    return eu(e);
                }
                break n;
            }
            return e;
        }
        return A5(ba, t, i.b, i.c, i.d, A5(ba, 0, r, a, i.e, u));
    }), ru = function(n) {
        if (-1 === n.$ && -1 === n.d.$) {
            var e = n.a, t = n.b, r = n.c, a = n.d, i = a.d, u = n.e;
            if (1 === a.a) {
                if (-1 !== i.$ || i.a) {
                    var c = nu(n);
                    if (-1 === c.$) {
                        var o = c.e;
                        return A5(ha, c.a, c.b, c.c, ru(c.d), o);
                    }
                    return la;
                }
                return A5(ba, e, t, r, ru(a), u);
            }
            return A5(ba, e, t, r, ru(a), u);
        }
        return la;
    }, au = F2(function(n, e) {
        if (-2 === e.$) return la;
        var t = e.a, r = e.b, a = e.c, i = e.d, u = e.e;
        if (0 > s(n, r)) {
            if (-1 === i.$ && 1 === i.a) {
                var c = i.d;
                if (-1 !== c.$ || c.a) {
                    var o = nu(e);
                    if (-1 === o.$) {
                        var f = o.e;
                        return A5(ha, o.a, o.b, o.c, A2(au, n, o.d), f);
                    }
                    return la;
                }
                return A5(ba, t, r, a, A2(au, n, i), u);
            }
            return A5(ba, t, r, a, A2(au, n, i), u);
        }
        return A2(iu, n, A7(tu, n, e, t, r, a, i, u));
    }), iu = F2(function(n, e) {
        if (-1 === e.$) {
            var t = e.a, r = e.b, a = e.c, i = e.d, c = e.e;
            if (u(n, r)) {
                var o = function(n) {
                    for(;;){
                        if (-1 !== n.$ || -1 !== n.d.$) return n;
                        n = n.d;
                    }
                }(c);
                return -1 === o.$ ? A5(ha, t, o.b, o.c, i, ru(c)) : la;
            }
            return A5(ha, t, r, a, i, A2(au, n, c));
        }
        return la;
    }), uu = F2(function(n, e) {
        var t = A2(au, n, e);
        return -1 !== t.$ || t.a ? t : A5(ba, 1, t.b, t.c, t.d, t.e);
    }), cu = F3(function(n, e, t) {
        var r = e(A2(Xi, n, t));
        return r.$ ? A2(uu, n, t) : A3(pa, n, r.a, t);
    }), ou = {
        $: 0
    }, su = F3(function(n, e, t) {
        var r = n(e);
        return r.$ ? t : A2(Ze, r.a, t);
    }), fu = F2(function(n, e) {
        return A3(Er, su(n), g, e);
    }), lu = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), du = fu(function(n) {
        var e = n.b;
        return A2(Fi, lu(n.a), e);
    }), bu = F2(function(n, e) {
        n: for(;;){
            if (n > 0) {
                if (e.b) {
                    n -= 1, e = e.b;
                    continue n;
                }
                return e;
            }
            return e;
        }
    }), hu = F3(function(n, e, t) {
        return A2(yt, e, A2(wt, n, t));
    }), gu = F2(function(n, e) {
        return A2(bu, 1, A2(wt, "/", A3(xt, F2(function(n, e) {
            return A3(hu, "{" + n.a + "}", n.b, e);
        }), n, e)));
    }), vu = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), pu = function(n) {
        return encodeURIComponent(n);
    }, mu = F2(function(n, e) {
        return A2(vu, pu(n), pu(e));
    }), $u = fu(function(n) {
        var e = n.b;
        return A2(Fi, mu(n.a), e);
    }), yu = F7(function(n, e, t, r, a, i, u) {
        return {
            a3: "http://localhost",
            aD: A2(ca, ou, i),
            bR: u,
            M: du(a),
            aO: n,
            cc: A2(gu, e, t),
            ce: $u(r),
            ay: gt,
            bz: gt
        };
    }), wu = F2(function(n, e) {
        return A7(yu, "GET", "/api/v1/accounts", g, m([
            l("site", A2(Fi, lr, n)),
            l("name", A2(Fi, lr, e))
        ]), g, gt, Hi(_i));
    }), ku = F5(function(n, e, t, r, a) {
        return {
            eo: n,
            fu: r,
            fv: e,
            f7: t,
            gJ: a
        };
    }), xu = A3(ta, "personalAccounts", Hi(_i), A3(ta, "forges", Hi(Ca), A3(ta, "licensedTo", Zr, A3(ta, "frontendBaseUrl", Zr, A3(ta, "apiBaseUrl", Zr, sr(ku)))))), ju = A7(yu, "GET", "/api/v1/client/info", g, g, g, gt, xu), Au = Sn, Cu = F5(function(n, e, t, r, a) {
        return {
            aJ: r,
            aP: t,
            az: e,
            bB: a,
            aX: n
        };
    }), Iu = function(n) {
        return n.b && ("" !== n.a || n.b.b) ? A2(Ze, n.a, Iu(n.b)) : g;
    }, Tu = F2(function(n, e) {
        return ht(1 === e.$ ? m([
            n
        ]) : A2(Ze, n, e.a));
    }), Su = function(n) {
        try {
            return ht(decodeURIComponent(n));
        } catch (n) {
            return gt;
        }
    }, Du = F2(function(n, e) {
        var t = A2(wt, "=", n);
        if (t.b && t.b.b && !t.b.b.b) {
            var r = t.b.a, a = Su(t.a);
            if (1 === a.$) return e;
            var i = a.a, u = Su(r);
            return 1 === u.$ ? e : A3(cu, i, Tu(u.a), e);
        }
        return e;
    }), Nu = F2(function(n, e) {
        var t;
        return function(n) {
            n: for(;;){
                if (n.b) {
                    var e = n.a, t = e.az;
                    if (t.b) {
                        if ("" !== t.a || t.b.b) {
                            n = n.b;
                            continue n;
                        }
                        return ht(e.bB);
                    }
                    return ht(e.bB);
                }
                return gt;
            }
        }(n(A5(Cu, g, function(n) {
            var e = A2(wt, "/", n);
            return Iu(e.b && "" === e.a ? e.b : e);
        }(e.bp), 1 === (t = e.jj).$ ? da : A3(Er, Du, da, A2(wt, "&", t.a)), e.it, lr)));
    }), Eu = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Lu = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Bu = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Ou = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Pu = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Gu = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Ru = function(n) {
        return {
            $: 8,
            a: n
        };
    }, zu = function(n) {
        return {
            $: 6,
            a: n
        };
    }, qu = function(n) {
        return {
            $: 17,
            a: n
        };
    }, _u = {
        $: 0
    }, Hu = function(n) {
        return {
            $: 21,
            a: n
        };
    }, Fu = function(n) {
        return {
            $: 20,
            a: n
        };
    }, Uu = function(n) {
        return {
            $: 13,
            a: n
        };
    }, Vu = function(n) {
        return {
            $: 15,
            a: n
        };
    }, Wu = function(n) {
        return {
            $: 16,
            a: n
        };
    }, Yu = function(n) {
        return {
            $: 14,
            a: n
        };
    }, Mu = {
        $: 19
    }, Ku = {
        $: 18
    }, Ju = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Qu = function(n) {
        return {
            $: 11,
            a: n
        };
    }, Zu = function(n) {
        return {
            $: 24,
            a: n
        };
    }, Xu = {
        $: 23
    }, nc = F2(function(n, e) {
        return e.$ ? gt : n(e.a);
    }), ec = D, tc = function(n) {
        for(var e = n.length, t = Array(e), r = 0; e > r;){
            var a = n.charCodeAt(r);
            55296 > a || a > 56319 ? (t[e - r] = n[r], r++) : (t[e - r] = n[r + 1], t[e - ++r] = n[r - 1], r++);
        }
        return t.join("");
    };
    function rc() {
        return F3(function(n, e, t) {
            n: for(;;){
                if (!t.b) return A2(Ze, tc(e), n);
                switch(t.a){
                    case '"':
                        var r = t.b;
                        return A3(ac(), n, e, r);
                    case "\\":
                        if (t.b.b) {
                            var a = t.b, i = a.a;
                            return r = a.b, A3(rc(), n, A2(ec, i, e), r);
                        }
                        break n;
                    default:
                        break n;
                }
            }
            return i = t.a, r = t.b, A3(rc(), n, A2(ec, i, e), r);
        });
    }
    function ac() {
        return F3(function(n, e, t) {
            if (!t.b) return "" !== e ? A2(Ze, tc(e), n) : n;
            switch(t.a){
                case ".":
                    var r = t.b;
                    return A3(ac(), A2(Ze, tc(e), n), "", r);
                case '"':
                    return r = t.b, A3(rc(), n, "", r);
                default:
                    var a = t.a;
                    return r = t.b, A3(ac(), n, A2(ec, a, e), r);
            }
        });
    }
    var ic = rc();
    rc = function() {
        return ic;
    };
    var uc = ac();
    ac = function() {
        return uc;
    };
    var cc = F3(function(n, e, t) {
        return e(n(t));
    }), oc = E, sc = function(n) {
        return A3(oc, Ze, g, n);
    }, fc = A2(cc, sc, A2(cc, A2(uc, g, ""), Bt)), lc = F2(function(n, e) {
        return A5(Cu, e.aX, e.az, e.aP, e.aJ, n(e.bB));
    }), dc = F2(function(n, e) {
        var t = e;
        return function(e) {
            var r = e.aX, a = e.az, i = e.aP, u = e.aJ;
            return A2(Lr, lc(e.bB), t(A5(Cu, r, a, i, u, n)));
        };
    }), bc = F2(function(n, e) {
        return function(n) {
            var t = n.aX, r = n.az, a = n.aP, i = n.aJ, u = n.bB;
            if (r.b) {
                var c = r.a, o = r.b, s = e(c);
                if (s.$) return g;
                var f = s.a;
                return m([
                    A5(Cu, A2(Ze, c, t), o, a, i, u(f))
                ]);
            }
            return g;
        };
    }), hc = A2(bc, "STRING", Su), gc = A2(dc, fc, hc), vc = A2(bc, "NUMBER", wr), pc = F2(function(n, e) {
        return function(t) {
            return e(A2(ca, g, A2(Xi, n, t)));
        };
    }), mc = function(n) {
        return A2(pc, n, function(n) {
            return n.b && !n.b.b ? wr(n.a) : gt;
        });
    }, $c = F2(function(n, e) {
        return e.b ? A3(Er, Ze, e, n) : n;
    }), yc = function(n) {
        return A3(Er, $c, g, n);
    }, wc = F2(function(n, e) {
        return yc(A2(Lr, n, e));
    }), kc = function(n) {
        return function(e) {
            return A2(wc, function(n) {
                return n(e);
            }, n);
        };
    }, xc = m([
        0,
        1,
        2,
        3
    ]), jc = function(n) {
        switch(n){
            case 0:
                return "config";
            case 1:
                return "legacy";
            case 2:
                return "onPush";
            default:
                return "onSchedule";
        }
    }, Ac = function(n) {
        return n.b ? ht(n.a) : gt;
    }, Cc = F3(function(n, e, t) {
        return Ac(A2(fu, function(e) {
            return u(n(e), t) ? ht(e) : gt;
        }, e));
    }), Ic = A2(Cc, jc, xc), Tc = function(n) {
        return A2(pc, n, function(n) {
            return n.b && !n.b.b ? sa(n.a) : gt;
        });
    }, Sc = F2(function(n, e) {
        var t = n, r = e;
        return function(n) {
            return A2(wc, r, t(n));
        };
    }), Dc = F2(function(n, e) {
        return A2(Sc, n, function(n) {
            var e = n;
            return function(n) {
                var t = n.aP;
                return m([
                    A5(Cu, n.aX, n.az, t, n.aJ, (0, n.bB)(e(t)))
                ]);
            };
        }(e));
    }), Nc = function(n) {
        return function(e) {
            var t = e.aX, r = e.az, a = e.aP, i = e.aJ, c = e.bB;
            if (r.b) {
                var o = r.a, s = r.b;
                return u(o, n) ? m([
                    A5(Cu, A2(Ze, o, t), s, a, i, c)
                ]) : g;
            }
            return g;
        };
    }, Ec = m([
        0,
        1,
        2,
        4,
        3
    ]), Lc = function(n) {
        switch(n){
            case 0:
                return "nix-darwin";
            case 1:
                return "nixops";
            case 2:
                return "terraform";
            case 3:
                return "manually";
            default:
                return "nixos";
        }
    }, Bc = A2(Cc, Lc, Ec), Oc = m([
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ]), Pc = function(n) {
        switch(n){
            case 0:
                return "pick-os";
            case 1:
                return "deploy";
            case 2:
                return "cachix";
            case 3:
                return "token";
            case 4:
                return "configure";
            case 5:
                return "target";
            default:
                return "test";
        }
    }, Gc = A2(Cc, Pc, Oc), Rc = function(n) {
        return A2(pc, n, function(n) {
            return n.b && !n.b.b ? ht(n.a) : gt;
        });
    }, zc = function(n) {
        return m([
            n
        ]);
    }, qc = kc(m([
        A2(dc, F2(function(n, e) {
            return {
                C: A2(nc, Bc, e),
                G: A2(ca, 0, A2(nc, Gc, n))
            };
        }), A2(Dc, A2(Dc, zc, Rc("step")), Rc("deployMethod"))),
        A2(dc, {
            C: gt,
            G: 0
        }, Nc("pick-os")),
        A2(dc, {
            C: ht(0),
            G: 1
        }, Nc("darwin")),
        A2(dc, {
            C: ht(0),
            G: 2
        }, Nc("darwin-cachix")),
        A2(dc, {
            C: ht(0),
            G: 6
        }, Nc("darwin-test")),
        A2(dc, {
            C: ht(1),
            G: 6
        }, Nc("linux-test")),
        A2(dc, {
            C: ht(1),
            G: 2
        }, Nc("linux-cachix")),
        A2(dc, {
            C: ht(1),
            G: 3
        }, Nc("generate-token")),
        A2(dc, {
            C: ht(1),
            G: 4
        }, Nc("bootstrap")),
        A2(dc, {
            C: ht(1),
            G: 5
        }, Nc("target")),
        A2(dc, {
            C: ht(1),
            G: 1
        }, Nc("deploy")),
        A2(dc, {
            C: ht(1),
            G: 6
        }, Nc("nixops-test"))
    ])), _c = A2(bc, "STRING", ht), Hc = _c, Fc = A2(bc, "UUID", sa), Uc = kc(m([
        A2(dc, _u, Nc("dashboard")),
        A2(dc, F3(function(n, e, t) {
            return function(n) {
                return {
                    $: 12,
                    a: n
                };
            }({
                fs: n,
                c6: e,
                hc: t
            });
        }), A2(Sc, Nc("dashboard"), A2(Sc, Nc("installation-return"), A2(Dc, A2(Dc, Fc, mc("installation_id")), Rc("setup_action"))))),
        A2(dc, F2(function(n, e) {
            return Ou({
                co: e,
                dA: n
            });
        }), A2(Sc, Nc("accounts"), A2(Sc, Hc, A2(Sc, _c, Nc("settings"))))),
        A2(dc, F4(function(n, e, t, r) {
            return Bu({
                co: e,
                eY: !1,
                a8: t,
                dA: n,
                d9: 0,
                dQ: r
            });
        }), A2(Sc, Nc("accounts"), A2(Sc, Hc, A2(Sc, _c, A2(Sc, Nc("derivations"), A2(Dc, hc, Tc("via-job"))))))),
        A2(dc, F4(function(n, e, t, r) {
            return Bu({
                co: e,
                eY: !1,
                a8: t,
                dA: n,
                d9: 1,
                dQ: r
            });
        }), A2(Sc, Nc("accounts"), A2(Sc, Hc, A2(Sc, _c, A2(Sc, Nc("derivations"), A2(Sc, hc, A2(Dc, Nc("log"), Tc("via-job")))))))),
        A2(dc, F4(function(n, e, t, r) {
            return Bu({
                co: e,
                eY: !0,
                a8: t,
                dA: n,
                d9: 0,
                dQ: r
            });
        }), A2(Sc, Nc("accounts"), A2(Sc, Hc, A2(Sc, _c, A2(Sc, Nc("dependencies"), A2(Dc, hc, Tc("via-job"))))))),
        A2(dc, F2(function(n, e) {
            return Lu({
                co: e,
                ia: 0,
                dA: n
            });
        }), A2(Sc, Nc("accounts"), A2(Sc, Hc, A2(Sc, _c, A2(Sc, Nc("default-cluster"), Nc("tasks")))))),
        A2(dc, F2(function(n, e) {
            return zu({
                co: e,
                dA: n
            });
        }), A2(Sc, Nc("agents"), A2(Sc, Hc, _c))),
        A2(dc, F3(function(n, e, t) {
            return Pu({
                co: e,
                fK: t,
                dA: n
            });
        }), A2(Sc, Nc("agents"), A2(Sc, Hc, A2(Sc, _c, A2(Sc, Nc("agent"), _c))))),
        A2(dc, F3(function(n, e, t) {
            return Ru({
                co: e,
                dA: n,
                bw: t
            });
        }), A2(Sc, Nc("agents"), A2(Sc, Hc, A2(Sc, _c, A2(Sc, Nc("setup"), qc))))),
        A2(dc, F2(function(n, e) {
            return Gu({
                co: e,
                dA: n
            });
        }), A2(Sc, Nc("agents"), A2(Sc, Hc, A2(Sc, _c, Nc("setup"))))),
        A2(dc, F2(function(n, e) {
            return qu({
                co: e,
                dA: n
            });
        }), A2(Dc, A2(Dc, Nc("billing"), Rc("site")), Rc("account"))),
        A2(dc, function(n) {
            return {
                $: 9,
                a: {
                    ga: A2(ca, "", n)
                }
            };
        }, A2(Sc, Nc("settings"), A2(Sc, Nc("cli"), A2(Dc, Nc("authorize"), Rc("token"))))),
        A2(dc, Ku, Nc("settings")),
        A2(dc, Mu, A2(Sc, Nc("settings"), Nc("notifications"))),
        A2(dc, Xu, Nc("terms")),
        A2(dc, Fu({}), A2(Sc, Nc("install"), Nc("gitlab"))),
        A2(dc, function(n) {
            return Hu({
                c6: n
            });
        }, A2(Sc, Nc("install"), A2(Sc, Nc("gitlab"), A2(Sc, Nc("continue"), Fc)))),
        A2(dc, function(n) {
            return Zu({
                gW: n
            });
        }, A2(Dc, Nc("signin"), Rc("redirect"))),
        A2(dc, F2(function(n, e) {
            return Eu({
                co: e,
                dA: n
            });
        }), A2(Sc, Hc, _c)),
        A2(dc, F3(function(n, e, t) {
            return Ju({
                co: e,
                gD: gt,
                br: t,
                dA: n
            });
        }), A2(Sc, Hc, A2(Sc, _c, _c))),
        A2(dc, F3(function(n, e, t) {
            return Qu({
                co: e,
                br: t,
                dA: n
            });
        }), A2(Sc, Hc, A2(Sc, _c, A2(Sc, _c, Nc("states"))))),
        A2(dc, F4(function(n, e, t, r) {
            return Ju({
                co: e,
                gD: r,
                br: t,
                dA: n
            });
        }), A2(Sc, Hc, A2(Sc, _c, A2(Sc, _c, A2(Dc, Nc("jobs"), mc("page")))))),
        A2(dc, F4(function(n, e, t, r) {
            return Uu({
                co: e,
                ab: r,
                br: t,
                dA: n
            });
        }), A2(Sc, Hc, A2(Sc, _c, A2(Sc, _c, A2(Sc, Nc("jobs"), vc))))),
        A2(dc, F5(function(n, e, t, r, a) {
            return Vu({
                co: e,
                eu: a,
                ab: r,
                br: t,
                dA: n
            });
        }), A2(Sc, Hc, A2(Sc, _c, A2(Sc, _c, A2(Sc, Nc("jobs"), A2(Sc, vc, A2(Dc, Nc("compare"), Tc("baseId")))))))),
        A2(dc, F5(function(n, e, t, r, a) {
            return Wu({
                co: e,
                a2: a,
                ab: r,
                br: t,
                dA: n,
                d9: 0
            });
        }), A2(Sc, Hc, A2(Sc, _c, A2(Sc, _c, A2(Sc, Nc("jobs"), A2(Sc, vc, A2(Sc, Nc("effects"), gc))))))),
        A2(dc, F5(function(n, e, t, r, a) {
            return Wu({
                co: e,
                a2: a,
                ab: r,
                br: t,
                dA: n,
                d9: 1
            });
        }), A2(Sc, Hc, A2(Sc, _c, A2(Sc, _c, A2(Sc, Nc("jobs"), A2(Sc, vc, A2(Sc, Nc("effects"), A2(Sc, gc, Nc("log"))))))))),
        A2(dc, F5(function(n, e, t, r, a) {
            return Yu({
                co: e,
                n: a,
                br: t,
                dA: n,
                W: A2(nc, Ic, r)
            });
        }), A2(Sc, Hc, A2(Sc, _c, A2(Sc, _c, A2(Sc, Nc("jobs"), A2(Dc, A2(Dc, Nc("latest"), Rc("type")), Rc("name"))))))),
        A2(dc, F3(function(n, e, t) {
            return Yu({
                co: e,
                n: gt,
                br: t,
                dA: n,
                W: gt
            });
        }), A2(Sc, Hc, A2(Sc, _c, A2(Sc, _c, Nc("status")))))
    ])), Vc = function(n) {
        return A2(ca, {
            $: 22,
            a: {
                hB: n
            }
        }, A2(Nu, Uc, n));
    }, Wc = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), Yc = Wc, Mc = ln(function(n) {
        n(fn(A2(Yc, -(new Date).getTimezoneOffset(), g)));
    }), Kc = Au(g), Jc = l({
        cO: 0
    }, Kc), Qc = Dn, Zc = F3(function(n, e, t) {
        return n(e(t));
    }), Xc = function(n) {
        return {
            $: 3,
            a: n
        };
    }, no = function(n) {
        return {
            $: 0,
            a: n
        };
    }, eo = {
        $: 2
    }, to = {
        $: 1
    }, ro = function(n) {
        return {
            $: 4,
            a: n
        };
    }, ao = Q, io = F2(function(n, e) {
        var t = A2(ao, n, e);
        return t.$ ? ct(ro(Pt(t.a))) : lt(t.a);
    }), uo = F2(function(n, e) {
        switch(e.$){
            case 0:
                return ct(no(e.a));
            case 1:
                return ct(to);
            case 2:
                return ct(eo);
            case 3:
                return ct(Xc(e.a.jD));
            default:
                var t = e.b;
                if ($r(t)) {
                    var r = A2(ao, n, "{}");
                    return r.$ ? A2(io, n, t) : lt(r.a);
                }
                return A2(io, n, t);
        }
    }), co = F2(function(n, e) {
        return A3(ze, "", lr, A2(cc, e, n));
    }), oo = F2(function(n, e) {
        return e.$ ? ct(n(e.a)) : lt(e.a);
    }), so = F3(function(n, e, t) {
        return A2(co, e, A2(Zc, oo(n), uo(t)));
    }), fo = function(n) {
        return n.a + "=" + n.b;
    }, lo = function(n) {
        return n.b ? "?" + A2(yt, "&", A2(Lr, fo, n)) : "";
    }, bo = F3(function(n, e, t) {
        return n + "/" + (A2(yt, "/", e) + lo(t));
    }), ho = function(n) {
        return {
            $: 1,
            a: n
        };
    }, go = F2(function(n, e) {
        return {
            g_: n,
            hm: e
        };
    }), vo = Sr(A2(go, da, g)), po = function(n) {
        return ln(function(e) {
            var t = n.f;
            2 === t.$ && t.c && t.c(), n.f = null, e(fn(0));
        });
    }, mo = vn, $o = F3(function(n, e, t) {
        n: for(;;){
            if (e.b) {
                var r = e.a, a = e.b;
                if (r.$) {
                    var i = r.a;
                    return A2(Br, function(e) {
                        var r = i.bz;
                        return A3($o, n, a, 1 === r.$ ? t : A3(pa, r.a, e, t));
                    }, mo(A3(Ge, n, Rr(n), i)));
                }
                var u = r.a, c = A2(Xi, u, t);
                if (1 === c.$) {
                    e = a;
                    continue n;
                }
                return A2(Br, function() {
                    return A3($o, n, a, A2(uu, u, t));
                }, po(c.a));
            }
            return Sr(t);
        }
    }), yo = F4(function(n, e, t, r) {
        return A2(Br, function(n) {
            return Sr(A2(go, n, t));
        }, A3($o, n, e, r.g_));
    }), wo = F4(function(n, e, t, r) {
        var a = r.b;
        return u(e, r.a) ? ht(A2(Rr, n, a(t))) : gt;
    }), ko = F3(function(n, e, t) {
        return A2(Br, function() {
            return Sr(t);
        }, Gr(A2(fu, A3(wo, n, e.a, e.b), t.hm)));
    }), xo = F2(function(n, e) {
        if (e.$) {
            var t = e.a;
            return ho({
                hY: t.hY,
                aD: t.aD,
                ip: A2(qe, n, t.ip),
                M: t.M,
                aO: t.aO,
                ay: t.ay,
                bz: t.bz,
                hB: t.hB
            });
        }
        return {
            $: 0,
            a: e.a
        };
    }), jo = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    });
    xn.Http = jn(vo, yo, ko, xo, F2(function(n, e) {
        return A2(jo, e.a, A2(cc, e.b, n));
    }));
    var Ao, Co = Tn("Http"), Io = Tn("Http"), To = function(n) {
        return Co(ho({
            hY: !1,
            aD: n.aD,
            ip: n.ip,
            M: n.M,
            aO: n.aO,
            ay: n.ay,
            bz: n.bz,
            hB: n.hB
        }));
    }, So = F2(function(n, e) {
        var t = e;
        return To({
            aD: t.aD,
            ip: n(t.bR),
            M: t.M,
            aO: t.aO,
            ay: t.ay,
            bz: t.bz,
            hB: A3(bo, t.a3, t.cc, t.ce)
        });
    }), Do = F3(function(n, e, t) {
        return A2(So, A2(so, n, e), t);
    }), No = F2(function(n, e) {
        return A3(Do, lr, n, e);
    }), Eo = F2(function(n, e) {
        return b(e, {
            a3: n
        });
    }), Lo = F3(function(n, e, t) {
        return A2(No, t, A2(Eo, n, e));
    }), Bo = F3(function(n, e, t) {
        var r = Vc(e), a = Jc.b;
        return l({
            aZ: 0,
            hV: Mr,
            bH: 0,
            q: Kr,
            bL: Jc.a,
            h9: Mr,
            cY: n,
            iI: t,
            ch: r,
            jK: gt,
            hB: e,
            hD: Mr
        }, Au(m([
            A3(Lo, n.hZ, A2(wu, gt, gt), Wr),
            A3(Lo, n.hZ, ju, Yr),
            A2(Qc, Vr, a),
            A2(Fr, Jr, Mc)
        ])));
    }), Oo = H, Po = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Go = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Ro = Sn, zo = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), qo = F2(function(n, e) {
        return {
            gR: e,
            hu: n
        };
    }), _o = Sr(A2(qo, da, da)), Ho = F2(function(n, e) {
        var t = n.a, r = n.b, a = A2(Xi, t, e);
        return A3(pa, t, 1 === a.$ ? m([
            r
        ]) : A2(Ze, r, a.a), e);
    }), Fo = F3(function(n, e, t) {
        for(;;){
            if (-2 === t.$) return e;
            var r = t.e, a = n, i = A3(n, t.b, t.c, A3(Fo, n, e, t.d));
            n = a, e = i, t = r;
        }
    }), Uo = F6(function(n, e, t, r, a, i) {
        var u = A3(Fo, F3(function(r, a, i) {
            n: for(;;){
                var u = i.a, c = i.b;
                if (u.b) {
                    var o = u.a, f = o.a, d = o.b, b = u.b;
                    if (0 > s(f, r)) {
                        i = l(b, A3(n, f, d, c));
                        continue n;
                    }
                    return s(f, r) > 0 ? l(u, A3(t, r, a, c)) : l(b, A4(e, f, d, a, c));
                }
                return l(u, A3(t, r, a, c));
            }
        }), l(tt(r), i), a), c = u.a, o = u.b;
        return A3(xt, F2(function(e, t) {
            return A3(n, e.a, e.b, t);
        }), o, c);
    }), Vo = Fe, Wo = F3(function(n, e, t) {
        if (e.b) {
            var r = e.a, a = e.b, i = mo(A2(Vo, r, A2(Zi, n, r)));
            return A2(Br, function(e) {
                return A3(Wo, n, a, A3(pa, r, e, t));
            }, i);
        }
        return Sr(t);
    }), Yo = F3(function(n, e, t) {
        var r = t.gR, a = F3(function(n, e, t) {
            var r = t.c;
            return d(t.a, t.b, A2(Br, function() {
                return r;
            }, po(e)));
        }), i = A3(xt, Ho, da, e), u = A6(Uo, F3(function(n, e, t) {
            var r = t.b, a = t.c;
            return d(A2(Ze, n, t.a), r, a);
        }), F4(function(n, e, t, r) {
            var a = r.c;
            return d(r.a, A3(pa, n, t, r.b), a);
        }), a, i, r, d(g, da, Sr(0))), c = u.a, o = u.b;
        return A2(Br, function(n) {
            return Sr(A2(qo, i, n));
        }, A2(Br, function() {
            return A3(Wo, n, c, o);
        }, u.c));
    }), Mo = (Ao = Qa, ln(function(n) {
        n(fn(Ao(Date.now())));
    }));
    xn.Time = jn(_o, Yo, F3(function(n, e, t) {
        var r = A2(Xi, e, t.hu);
        if (1 === r.$) return Sr(t);
        var a = r.a;
        return A2(Br, function() {
            return Sr(t);
        }, A2(Br, function(e) {
            return Gr(A2(Lr, function(t) {
                return A2(Rr, n, t(e));
            }, a));
        }, Mo));
    }), 0, F2(function(n, e) {
        return A2(zo, e.a, A2(Zc, n, e.b));
    }));
    var Ko, Jo, Qo, Zo, Xo, ns, es, ts, rs, as, is, us, cs, os, ss, fs, ls, ds = Tn("Time"), bs = F2(function(n, e) {
        return ds(A2(zo, n, e));
    }), hs = Dn, gs = Ro(g), vs = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ps = function(n) {
        return {
            $: 3,
            a: n
        };
    }, ms = function(n) {
        return {
            $: 12,
            a: n
        };
    }, $s = function(n) {
        return {
            $: 4,
            a: n
        };
    }, ys = function(n) {
        return {
            $: 5,
            a: n
        };
    }, ws = function(n) {
        return {
            $: 18,
            a: n
        };
    }, ks = function(n) {
        return {
            $: 17,
            a: n
        };
    }, xs = function(n) {
        return {
            $: 16,
            a: n
        };
    }, js = function(n) {
        return {
            $: 9,
            a: n
        };
    }, As = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Cs = function(n) {
        return {
            $: 11,
            a: n
        };
    }, Is = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Ts = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Ss = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Ds = {
        $: 7
    }, Ns = {
        $: 8
    }, Es = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Ls = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Bs = {
        $: 0
    }, Os = F2(function(n, e) {
        switch(e.$){
            case 3:
                return n(e.a);
            case 2:
                return Ls(e.a);
            case 0:
                return Bs;
            default:
                return Mr;
        }
    }), Ps = F2(function(n, e) {
        return A2(Os, function(n) {
            return A2(Os, function(e) {
                return Es({
                    co: n,
                    ig: e
                });
            }, e.ig.ie);
        }, e.co);
    }), Gs = F2(function(n, e) {
        var t = A2(Ps, n, e);
        return 3 === t.$ ? 5 === t.a.ig.V ? gs : Ro(m([
            A2(bs, 5e3, function() {
                return Ds;
            }),
            A2(bs, 1e3, function() {
                return Ns;
            })
        ])) : gs;
    }), Rs = function(n) {
        return {
            $: 2,
            a: n
        };
    }, zs = F2(function() {
        return A2(bs, 5e3, Rs);
    }), qs = function(n) {
        return {
            $: 7,
            a: n
        };
    }, _s = (Ko = "paddleSubscriptionSucceeded", Jo = xa, Ln(Ko), xn[Ko] = {
        f: Gn,
        r: Jo,
        a: function(n, e) {
            var t = g, r = xn[n].r, a = fn(null);
            return xn[n].b = a, xn[n].c = F3(function(n, e) {
                return t = e, a;
            }), {
                send: function(n) {
                    var a = A2(Z, r, n);
                    ir(a) || i(4);
                    for(var u = a.a, c = t; c.b; c = c.b)e(c.a(u));
                }
            };
        }
    }, Tn(Ko)), Hs = F2(function() {
        return gs;
    }), Fs = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Us = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Vs = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ws = function() {
        return A2(bs, 3e3, Vs);
    }, Ys = A2(cc, tt, wc(function(n) {
        var e = n.b, t = sa(n.a);
        return t.$ ? g : m([
            l(t.a, e)
        ]);
    })), Ms = F2(function() {
        return gs;
    }), Ks = F2(function() {
        return gs;
    }), Js = {
        $: 1
    }, Qs = {
        $: 2
    }, Zs = F2(function() {
        return Ro(m([
            A2(bs, 1e3, function() {
                return Js;
            }),
            A2(bs, 3e4, function() {
                return Qs;
            })
        ]));
    }), Xs = function(n) {
        return {
            $: 10,
            a: n
        };
    }, nf = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ef = {
        $: 8
    }, tf = {
        $: 9
    }, rf = F2(function(n, e) {
        return A2(Os, function(n) {
            return A2(Os, function(t) {
                return A2(Os, function(e) {
                    return Es({
                        co: n,
                        j: t,
                        as: e.b
                    });
                }, e.aN);
            }, e.j.ie);
        }, e.co);
    }), af = F2(function(n, e) {
        var t = A2(rf, n, e);
        return 3 === t.$ ? 4 === t.a.j.V ? gs : Ro(m([
            A2(bs, 5e3, function() {
                return ef;
            }),
            A2(bs, 1e3, function() {
                return tf;
            })
        ])) : gs;
    }), uf = F2(function() {
        return gs;
    }), cf = function(n) {
        return {
            $: 4,
            a: n
        };
    }, of = function(n) {
        return {
            $: 3,
            a: n
        };
    }, sf = A2(cc, tt, wc(function(n) {
        var e = n.b, t = sa(n.a);
        return t.$ ? g : m([
            l(t.a, e)
        ]);
    })), ff = F2(function(n, e) {
        return {
            $: 7,
            a: n,
            b: e
        };
    }), lf = function(n) {
        return {
            $: 1,
            a: n
        };
    }, df = F2(function(n, e) {
        return Io(A2(jo, n, e));
    }), bf = F2(function(n, e) {
        var t = e.gD;
        switch(t.$){
            case 10:
                return A2(hs, vs, A2(Gs, n, t.a));
            case 2:
                return A2(hs, ps, A2(zs, n, t.a));
            case 6:
                return A2(hs, As, A2(af, n, t.a));
            case 7:
                return A2(hs, Cs, A2(uf, n, t.a));
            case 9:
            case 13:
            case 15:
            case 14:
            case 12:
            case 16:
            case 17:
                return gs;
            case 11:
                return A2(hs, $s, A2(Hs, n, t.a));
            case 0:
                return A2(hs, ys, function(n) {
                    var e = A2(Lr, function(n) {
                        var e = n.a;
                        return A2(hs, function(n) {
                            return Fs({
                                bE: e,
                                bF: n
                            });
                        }, Ws());
                    }, Ys(n.hV));
                    return Ro(A2(Ze, A2(bs, 3e3, Us), e));
                }(t.a));
            case 1:
                return A2(hs, Ts, function(n) {
                    var e = A2(Lr, function(n) {
                        var e = n.a;
                        return A2(hs, function(n) {
                            return cf({
                                bE: e,
                                bF: n
                            });
                        }, Ws());
                    }, sf(n.hV));
                    return Ro(A2(Ze, A2(bs, 3e3, of), e));
                }(t.a));
            case 3:
                return A2(hs, Ss, function(n) {
                    var e;
                    return Ro(A2(Ze, A2(bs, 1e4, lf), 2 === (e = n.z).$ ? A2(Lr, function(n) {
                        return A2(df, n, ff(n));
                    }, rt(e.a)) : g));
                }(t.a));
            case 4:
                return A2(hs, Is, A2(bs, 5e3, Xs));
            case 5:
                return A2(hs, js, A2(bs, 3e4, nf));
            case 8:
                return A2(hs, ms, _s(qs));
            case 18:
                return A2(hs, xs, A2(Zs, n, t.a));
            case 19:
                return A2(hs, ks, A2(Ks, n, t.a));
            default:
                return A2(hs, ws, A2(Ms, n, t.a));
        }
    }), hf = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), gf = function(n) {
        return {
            $: 10,
            a: n
        };
    }, vf = function(n) {
        return {
            $: 7,
            a: n
        };
    }, pf = F2(function(n, e) {
        return A3(ze, "arraybuffer", _e, A2(cc, e, n));
    }), mf = F2(function(n, e) {
        switch(e.$){
            case 0:
                return ct(no(e.a));
            case 1:
                return ct(to);
            case 2:
                return ct(eo);
            case 3:
                return ct(Xc(e.a.jD));
            default:
                return A2(oo, ro, n(e.b));
        }
    }), $f = function(n) {
        return A2(pf, n, mf(function() {
            return lt(0);
        }));
    }, yf = function(n) {
        return 1 === n.$ ? Ls(n.a) : Es(n.a);
    }, wf = function(n) {
        return A2(Fr, Tr, ln(function() {
            try {
                Ce.location = n;
            } catch (n) {
                zn.location.reload(!1);
            }
        }));
    }, kf = F2(function(n, e) {
        switch(e.$){
            case 3:
                return Es(n(e.a));
            case 1:
                return Mr;
            case 0:
                return Bs;
            default:
                return Ls(e.a);
        }
    }), xf = je, jf = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Af = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Cf = function(n) {
        return {
            $: 9,
            a: n
        };
    }, If = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Tf = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Sf = function(n) {
        return {
            $: 11,
            a: n
        };
    }, Df = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Nf = function(n) {
        return {
            $: 20,
            a: n
        };
    }, Ef = function(n) {
        return {
            $: 19,
            a: n
        };
    }, Lf = function(n) {
        return {
            $: 18,
            a: n
        };
    }, Bf = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Of = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Pf = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Gf = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Rf = function(n) {
        return {
            $: 15,
            a: n
        };
    }, zf = function(n) {
        return {
            $: 17,
            a: n
        };
    }, qf = function(n) {
        return {
            $: 14,
            a: n
        };
    }, _f = function(n) {
        return {
            $: 16,
            a: n
        };
    }, Hf = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ff = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Uf = F2(function(n, e) {
        return A3(Er, F2(function(e, t) {
            return n(e) ? A2(Ze, e, t) : t;
        }), g, e);
    }), Vf = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), Wf = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Yf = {
        $: 1
    }, Mf = {
        $: 0
    }, Kf = {
        $: 13
    }, Jf = {
        $: 0
    }, Qf = function(n) {
        return {
            $: 14,
            a: n
        };
    }, Zf = {
        $: 3
    }, Xf = {
        $: 15
    }, nl = {
        C: gt,
        G: 0
    }, el = Wf(nl), tl = F2(function(n, e) {
        for(;;){
            if (!e.b) return gt;
            var t = e.a, r = e.b;
            if (n(t)) return ht(t);
            e = r;
        }
    }), rl = F2(function(n, e) {
        return A2(tl, function(n) {
            return u(n.ax, e);
        }, n.hV);
    }), al = function(n) {
        return {
            $: 0,
            a: n
        };
    }, il = F2(function(n, e) {
        var t = e.b, r = n(e.a);
        return l(r.a, Au(m([
            t,
            r.b
        ])));
    }), ul = da, cl = F2(function(n, e) {
        return Ac(A2(Uf, function(n) {
            return u(n.hf, e.dA) && u(n.ax, e.co);
        }, n.hV));
    }), ol = {
        ie: Mr,
        ao: Mr
    }, sl = function(n) {
        return l(n, Kc);
    }, fl = F3(function(n, e, t) {
        return A2(No, t, A2(Eo, n.cY.hZ, e));
    }), ll = F3(function(n, e, t) {
        return A3(fl, n, A2(wu, ht(e.dA), ht(e.co)), A2(Zc, t, yf));
    }), dl = function(n) {
        return {
            $: 6,
            a: n
        };
    }, bl = F2(function(n, e) {
        return {
            $: 9,
            a: n,
            b: e
        };
    }), hl = function(n) {
        return {
            $: 4,
            a: n
        };
    }, gl = function(n) {
        return n;
    }, vl = F2(function(n, e) {
        return A7(yu, "POST", "/api/v1/accounts/{accountId}/derivations/{derivationPath}/cancel", m([
            l("accountId", n),
            l("derivationPath", e)
        ]), g, g, gt, sr(0));
    }), pl = F3(function(n, e, t) {
        return {
            e5: t,
            c: n,
            f8: e
        };
    }), ml = F3(function(n, e, t) {
        return {
            fM: n,
            gl: e,
            ht: t
        };
    }), $l = A3(ta, "t", Zr, A3(ta, "ms", Oo, A3(ta, "i", Oo, sr(ml)))), yl = A3(ta, "done", na, A3(ta, "lines", Hi($l), A3(ta, "id", fa, sr(pl)))), wl = function(n) {
        switch(n){
            case 0:
                return "Error";
            case 1:
                return "Warn";
            case 2:
                return "Notice";
            case 3:
                return "Info";
            case 4:
                return "Talkative";
            case 5:
                return "Chatty";
            case 6:
                return "Debug";
            default:
                return "Vomit";
        }
    }, kl = F5(function(n, e, t, r, a) {
        return A7(yu, "GET", "/api/v1/accounts/{accountId}/derivations/{derivationPath}/log/lines", m([
            l("accountId", n),
            l("derivationPath", e)
        ]), m([
            l("logId", ht(t)),
            l("iMin", A2(Fi, $t, r)),
            l("verbosity", A2(Fi, wl, a))
        ]), g, gt, yl);
    }), xl = F2(function(n, e) {
        return A7(yu, "POST", "/api/v1/accounts/{accountId}/derivations/{derivationPath}/retry", m([
            l("accountId", n),
            l("derivationPath", e)
        ]), g, g, gt, sr(0));
    }), jl = F2(function(n, e) {
        return "/" + (A2(yt, "/", n) + lo(e));
    }), Al = F2(function(n, e) {
        return A2(jl, A2(Lr, pu, n), e);
    }), Cl = ia("^[a-zA-Z_][a-zA-Z0-9_'-]*$"), Il = 1 === Cl.$ ? function() {
        return !1;
    } : ra(Cl.a), Tl = A2(cc, Lr(function(n) {
        return Il(n) ? n : function(n) {
            return '"' + A3(hu, '"', '\\"', A3(hu, "\\", "\\\\", n)) + '"';
        }(n);
    }), yt(".")), Sl = F2(function(n, e) {
        return A2(vu, pu(n), $t(e));
    }), Dl = function(n) {
        return 1 === n.$ ? g : m([
            n.a
        ]);
    }, Nl = F2(function(n, e) {
        return A2(Lr, n, Dl(e));
    }), El = function(n) {
        var e, t, r, a = function(n) {
            return m([
                "accounts",
                n.dA,
                n.co
            ]);
        };
        switch(n.$){
            case 0:
                return A2(jl, m([
                    "dashboard"
                ]), g);
            case 1:
                return A2(jl, m([
                    (u = n.a).dA,
                    u.co
                ]), g);
            case 2:
                return A2(jl, h(a(u = n.a), m([
                    "settings"
                ])), g);
            case 3:
                if ((u = n.a).eY) return A2(Al, h(a(u), m([
                    "dependencies",
                    u.a8
                ])), A2(Nl, A2(Zc, mu("via-job"), gl), u.dQ));
                var i = u.d9;
                return A2(Al, h(a(u), m(i ? [
                    "derivations",
                    u.a8,
                    "log"
                ] : [
                    "derivations",
                    u.a8
                ])), A2(Nl, A2(Zc, mu("via-job"), gl), u.dQ));
            case 6:
                return A2(jl, m([
                    "agents",
                    (u = n.a).dA,
                    u.co
                ]), g);
            case 4:
                return A2(jl, h(a(u = n.a), m([
                    "default-cluster",
                    "tasks"
                ])), g);
            case 5:
                return A2(jl, m([
                    "agents",
                    (u = n.a).dA,
                    u.co,
                    "agent",
                    u.fK
                ]), g);
            case 7:
                return A2(jl, m([
                    "agents",
                    (u = n.a).dA,
                    u.co,
                    "setup"
                ]), g);
            case 8:
                return A2(jl, m([
                    "agents",
                    (u = n.a).dA,
                    u.co,
                    "setup"
                ]), (r = u.bw, h(A2(Nl, A2(Zc, mu("deployMethod"), Lc), r.C), m([
                    A2(mu, "step", Pc(r.G))
                ]))));
            case 9:
                var u = n.a;
                return A2(jl, m([
                    "settings",
                    "cli",
                    "authorize"
                ]), m([
                    A2(mu, "token", u.ga)
                ]));
            case 10:
                var c = (u = n.a).gD;
                if (1 === c.$) return A2(jl, m([
                    u.dA,
                    u.co,
                    u.br
                ]), g);
                var o = c.a;
                return A2(jl, m([
                    u.dA,
                    u.co,
                    u.br,
                    "jobs"
                ]), m([
                    A2(Sl, "page", o)
                ]));
            case 11:
                return A2(jl, m([
                    (u = n.a).dA,
                    u.co,
                    u.br,
                    "states"
                ]), g);
            case 13:
                return A2(jl, m([
                    (u = n.a).dA,
                    u.co,
                    u.br,
                    "jobs",
                    $t(u.ab)
                ]), g);
            case 15:
                return A2(jl, m([
                    (u = n.a).dA,
                    u.co,
                    u.br,
                    "jobs",
                    $t(u.ab),
                    "compare"
                ]), (t = u.eu).$ ? g : m([
                    A2(mu, "baseId", t.a)
                ]));
            case 16:
                return A2(jl, m((u = n.a).d9 ? [
                    u.dA,
                    u.co,
                    u.br,
                    "jobs",
                    $t(u.ab),
                    "effects",
                    pu(Tl(u.a2)),
                    "log"
                ] : [
                    u.dA,
                    u.co,
                    u.br,
                    "jobs",
                    $t(u.ab),
                    "effects",
                    pu(Tl(u.a2))
                ]), g);
            case 14:
                return A2(jl, m([
                    (u = n.a).dA,
                    u.co,
                    u.br,
                    "jobs",
                    "latest"
                ]), h(A2(Nl, A2(Zc, mu("type"), jc), u.W), A2(Nl, mu("name"), u.n)));
            case 17:
                return u = n.a, A2(jl, m([
                    "billing"
                ]), h(A2(Nl, mu("site"), u.dA), A2(Nl, mu("account"), u.co)));
            case 18:
                return A2(jl, m([
                    "settings"
                ]), g);
            case 19:
                return A2(jl, m([
                    "settings",
                    "notifications"
                ]), g);
            case 22:
                return A2(jl, g, g);
            case 23:
                return A2(jl, m([
                    "terms"
                ]), g);
            case 12:
                return A2(jl, m([
                    "dashboard",
                    "installation-return",
                    (u = n.a).fs
                ]), m([
                    A2(Sl, "installation_id", A2(ca, 0, u.c6)),
                    A2(mu, "setup_action", A2(ca, "", u.hc))
                ]));
            case 20:
                return A2(jl, m([
                    "install",
                    "gitlab"
                ]), g);
            case 21:
                return A2(jl, m([
                    "install",
                    "gitlab",
                    "continue",
                    n.a.c6
                ]), g);
            default:
                return u = n.a, A2(jl, m([
                    "signin"
                ]), (e = u.gW).$ ? g : m([
                    A2(mu, "redirect", e.a)
                ]));
        }
    }, Ll = F2(function(n, e) {
        return A2(xf, n, El(e));
    }), Bl = F2(function(n, e) {
        return A3(Fo, F3(function(n, e, t) {
            return A2(uu, n, t);
        }), n, e);
    }), Ol = F2(function(n, e) {
        return A2(Bl, n, e);
    }), Pl = A2(cc, Lr(function(n) {
        var e = n.a;
        return l(e, l(e, n.b));
    }), A2(cc, ma, lr)), Gl = function(n) {
        return n.b;
    }, Rl = F2(function(n, e) {
        return A2(Fi, Gl, A2(Xi, n, e));
    }), zl = function(n) {
        return function(e) {
            var t = e.b;
            return l(n(e.a), t);
        };
    }, ql = {
        $: 12
    }, _l = bn, Hl = F2(function(n, e) {
        return Hr(A2(_l, A2(Zc, A2(Zc, Sr, n), ct), A2(Br, A2(Zc, A2(Zc, Sr, n), lt), e)));
    }), Fl = Te, Ul = F2(function(n, e) {
        return A2(Hl, function() {
            return e;
        }, A2(Br, function(e) {
            return A3(Fl, n, 0, e.jv.ix);
        }, function(n) {
            return Ie(n, function(n) {
                return {
                    jv: {
                        hR: n.scrollWidth,
                        ix: n.scrollHeight
                    },
                    hK: {
                        hS: n.scrollLeft,
                        hT: n.scrollTop,
                        hR: n.clientWidth,
                        ix: n.clientHeight
                    }
                };
            });
        }(n)));
    }), Vl = F3(function(n, e, t) {
        return n ? A2(Ul, e, t) : Kc;
    }), Wl = F2(function(n, e) {
        return A3(Vl, A2(ca, !0, A2(Xi, e, n.aT)), e, ql);
    }), Yl = F2(function(n, e) {
        if (3 !== n.ie.$) return b(n, {
            ie: e,
            ao: Bs
        });
        switch(e.$){
            case 3:
                return b(n, {
                    ie: e,
                    ao: Bs
                });
            case 1:
                return b(n, {
                    ao: Mr
                });
            default:
                return b(n, {
                    ao: Bs
                });
        }
    }), Ml = function(n) {
        n: for(;;){
            if (n.b) {
                if (n.b.b) {
                    n = n.b;
                    continue n;
                }
                return ht(n.a);
            }
            return gt;
        }
    }, Kl = F2(function(n, e) {
        var t = function() {
            var e = Ml(n.f8);
            if (e.$) return function() {
                return !0;
            };
            var t = e.a;
            return function(n) {
                return s(n.fM, t.fM) > 0;
            };
        }();
        return {
            e5: n.e5 || e.e5,
            c: n.c,
            f8: h(n.f8, A2(Uf, t, e.f8))
        };
    }), Jl = F2(function(n, e) {
        if (3 === n.$) {
            var t = n.a;
            return ht(Es(e.$ || 3 !== e.a.$ ? t : A2(Kl, e.a.a, t)));
        }
        return 1 === e.$ || 1 === e.a.$ ? ht(n) : e;
    }), Ql = function(n) {
        return A3(et, F3(function(n, e, t) {
            return A2(Ze, e, t);
        }), g, n);
    }, Zl = function(n) {
        return Ql(n);
    }, Xl = F2(function(n, e) {
        return 3 === e.$ ? e.a : n;
    }), nd = A2(cc, kf(ht), Xl(gt)), ed = F3(function(n, e, t) {
        var r = t, a = A2(cc, Fi(Gl), A2(cc, e, Fi(function(e) {
            return l(n, e);
        })));
        return A3(cu, n, a, r);
    }), td = F3(function(n, e, t) {
        var r = A3(xt, F2(function(e, t) {
            var r = t.b, a = A2(n, t.a, e);
            return l(a.a, A2(Ze, a.b, r));
        }), l(e, g), t);
        return l(r.a, Bt(r.b));
    }), rd = F3(function(n, e, t) {
        var r = A3(td, F2(function(e, t) {
            var r, a = t.a;
            return l((r = A3(n, e, a, t.b)).a, l(a, r.b));
        }), e, Zl(t));
        return l(r.a, Pl(r.b));
    }), ad = F2(function(n, e) {
        var t = A3(rd, F3(function(e, t, r) {
            var a = A2(n, t, r), i = a.a;
            return l(A2(Ze, a.b, e), i);
        }), g, e);
        return l(t.b, Au(t.a));
    }), id = F2(function(n, e) {
        return 3 === n.$ ? n.a.e5 ? Kc : e(A2(Fi, function(n) {
            return n.fM;
        }, Ml(n.a.f8))) : Kc;
    }), ud = F3(function(n, e, t) {
        var r = A2(ad, F2(function(r, a) {
            return l(a, A2(id, a, function(a) {
                return A3(fl, n, A5(kl, e.c, pu(t.a8), r, a, gt), A2(Zc, bl(r), yf));
            }));
        }), t.al);
        return l(t, r.b);
    }), cd = function(n) {
        return {
            $: 1,
            a: n
        };
    }, od = F2(function(n, e) {
        return {
            $7: e,
            f: n
        };
    }), sd = F5(function(n, e, t, r, a) {
        return {
            fG: t,
            af: n,
            bm: e,
            gX: a,
            dC: r
        };
    }), fd = A4(Aa, "references", Hi(Zr), gt, A3(ta, "size", Oo, A3(ta, "hash", Zr, A3(ta, "outputPath", Zr, A3(ta, "outputName", Zr, sr(sd)))))), ld = function(n) {
        return ka(m([
            A2(cr, ht, n),
            sr(gt)
        ]));
    }, dd = A3(ta, "outputs", ld(Hi(fd)), A3(ta, "time", zi, sr(od))), bd = A3(ta, "time", zi, sr(function(n) {
        return {
            f: n
        };
    })), hd = A3(ta, "time", zi, sr(function(n) {
        return {
            f: n
        };
    })), gd = F2(function(n, e) {
        return {
            dM: e,
            f: n
        };
    }), vd = A4(Aa, "technicalError", Zr, gt, A3(ta, "time", zi, sr(gd))), pd = F2(function(n, e) {
        return {
            eE: e,
            f: n
        };
    }), md = F6(function(n, e, t, r, a, i) {
        return {
            k: t,
            c: n,
            T: a,
            n: e,
            dA: i,
            W: r
        };
    }), $d = F3(function(n, e, t) {
        return {
            k: t,
            c: n,
            n: e
        };
    }), yd = A3(ta, "displayName", Zr, A3(ta, "name", Zr, A3(ta, "id", fa, sr($d)))), wd = A3(ta, "site", yd, A3(ta, "imageURL", Zr, A3(ta, "typ", Xr, A3(ta, "displayName", Zr, A3(ta, "name", Zr, A3(ta, "id", fa, sr(md))))))), kd = A4(Aa, "byUser", wd, gt, A3(ta, "time", zi, sr(pd))), xd = A3(ta, "time", zi, sr(function(n) {
        return {
            f: n
        };
    })), jd = A3(ta, "time", zi, sr(function(n) {
        return {
            f: n
        };
    })), Ad = F3(function(n, e, t) {
        return {
            g$: t,
            g0: e,
            f: n
        };
    }), Cd = F5(function(n, e, t, r, a) {
        return {
            c: n,
            ab: t,
            dr: a,
            br: e,
            V: r
        };
    }), Id = A2(ur, function(n) {
        switch(n){
            case "Queued":
                return sr(0);
            case "Evaluating":
                return sr(1);
            case "Building":
                return sr(2);
            case "Effects":
                return sr(3);
            case "Done":
                return sr(4);
            default:
                return Qr("Unknown type: " + n);
        }
    }, Zr), Td = A2(ur, function(n) {
        switch(n){
            case "Pending":
                return sr(0);
            case "Failure":
                return sr(1);
            case "Success":
                return sr(2);
            default:
                return Qr("Unknown type: " + n);
        }
    }, Zr), Sd = F6(function(n, e, t, r, a, i) {
        return {
            k: r,
            c: n,
            T: a,
            ar: i,
            n: e,
            bn: t
        };
    }), Dd = A3(ta, "isPublic", na, A4(Aa, "imageURL", Zr, gt, A3(ta, "displayName", Zr, A3(ta, "owner", wd, A3(ta, "name", Zr, A3(ta, "id", fa, sr(Sd))))))), Nd = A3(ta, "phase", Id, A3(ta, "status", Td, A3(ta, "index", Oo, A3(ta, "project", Dd, A3(ta, "id", fa, sr(Cd)))))), Ed = A4(Aa, "requeuedForAgent", Zr, gt, A4(Aa, "requeuedForEvalOfJob", Nd, gt, A3(ta, "time", zi, sr(Ad)))), Ld = A3(ta, "time", zi, sr(function(n) {
        return {
            f: n
        };
    })), Bd = F4(function(n, e, t, r) {
        return {
            a_: t,
            dg: e,
            hj: r,
            f: n
        };
    }), Od = A3(ta, "streamable", na, A4(Aa, "agentHostname", Zr, gt, A3(ta, "logId", fa, A3(ta, "time", zi, sr(Bd))))), Pd = A3(ta, "time", zi, sr(function(n) {
        return {
            f: n
        };
    })), Gd = A4(Aa, "HasCancelledForReset", jd, gt, A4(Aa, "HasCancelled", xd, gt, A4(Aa, "Built", dd, gt, A4(Aa, "ForceCancelled", kd, gt, A4(Aa, "Cancelled", bd, gt, A4(Aa, "Succeeded", Pd, gt, A4(Aa, "Failed", vd, gt, A4(Aa, "Reset", Ld, gt, A4(Aa, "Started", Od, gt, A4(Aa, "DependencyFailed", hd, gt, A4(Aa, "Queued", Ed, gt, sr(function(n) {
        return function(e) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return function(i) {
                            return function(u) {
                                return function(c) {
                                    return function(o) {
                                        return function(s) {
                                            return function(f) {
                                                return {
                                                    eD: o,
                                                    cy: u,
                                                    cK: e,
                                                    cX: a,
                                                    fq: c,
                                                    fD: s,
                                                    fE: f,
                                                    dt: n,
                                                    g4: r,
                                                    dG: t,
                                                    dI: i
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))), Rd = F4(function(n, e, t, r) {
        return {
            a8: e,
            cL: n,
            af: t,
            bm: r
        };
    }), zd = A2(ur, function(n) {
        switch(n){
            case "NotPlanned":
                return sr(0);
            case "Waiting":
                return sr(1);
            case "Building":
                return sr(2);
            case "BuildFailure":
                return sr(3);
            case "DependencyFailure":
                return sr(4);
            case "BuildSuccess":
                return sr(5);
            case "Cancelled":
                return sr(6);
            default:
                return Qr("Unknown type: " + n);
        }
    }, Zr), qd = A3(ta, "outputPath", Zr, A3(ta, "outputName", Zr, A3(ta, "derivationPath", Zr, A3(ta, "derivationStatus", zd, sr(Rd))))), _d = F2(function(n, e) {
        return {
            af: n,
            bm: e
        };
    }), Hd = A4(Aa, "outputPath", Zr, gt, A3(ta, "outputName", Zr, sr(_d))), Fd = F6(function(n, e, t, r, a, i) {
        return {
            eO: a,
            fx: r,
            f9: i,
            bl: t,
            du: e,
            g6: n
        };
    }), Ud = A3(ta, "link", Zr, A4(Aa, "committer", _i, gt, A3(ta, "gitCommitterName", Zr, A3(ta, "message", Zr, A3(ta, "ref", Zr, A3(ta, "revision", Zr, sr(Fd))))))), Vd = F2(function(n, e) {
        return {
            fy: n,
            fQ: e
        };
    }), Wd = F7(function(n, e, t, r, a, i, u) {
        return {
            fI: u,
            c1: r,
            dc: i,
            du: e,
            gZ: a,
            g5: n,
            dE: t
        };
    }), Yd = F6(function(n, e, t, r, a, i) {
        return {
            k: r,
            c: n,
            T: a,
            ar: i,
            n: e,
            bn: t
        };
    }), Md = A3(ta, "isPublic", na, A4(Aa, "imageURL", Zr, gt, A3(ta, "displayName", Zr, A3(ta, "owner", wd, A3(ta, "name", Zr, A3(ta, "id", fa, sr(Yd))))))), Kd = A4(Aa, "historyURL", Zr, gt, A4(Aa, "jobs", Hi(Nd), gt, A4(Aa, "repo", Md, gt, A3(ta, "httpURL", Zr, A3(ta, "sshURL", Zr, A3(ta, "ref", Zr, A3(ta, "rev", Zr, sr(Wd)))))))), Jd = A4(Aa, "IgnoreMe", sr(g), gt, A4(Aa, "GitInput", Kd, gt, sr(Vd))), Qd = A2(ur, function(n) {
        switch(n){
            case "Config":
                return sr(0);
            case "Legacy":
                return sr(1);
            case "OnPush":
                return sr(2);
            case "OnSchedule":
                return sr(3);
            default:
                return Qr("Unknown type: " + n);
        }
    }, Zr), Zd = A3(ta, "mayRerun", na, A3(ta, "mayCancel", na, A4(Aa, "cancelledBy", fa, gt, A4(Aa, "startedBy", fa, gt, A4(Aa, "rerunOfIndex", Oo, gt, A4(Aa, "rerunOf", fa, gt, A4(Aa, "jobName", Zr, gt, A3(ta, "jobType", Qd, A3(ta, "extraInputs", $a(Jd), A3(ta, "source", Ud, A3(ta, "evaluationId", fa, A3(ta, "effectsStatus", Td, A3(ta, "derivationStatus", Td, A3(ta, "evaluationStatus", Td, A3(ta, "jobStatus", Td, A3(ta, "isCancelled", na, A3(ta, "jobPhase", Id, A4(Aa, "endTime", zi, gt, A3(ta, "startTime", zi, A3(ta, "repoId", fa, A3(ta, "forgeName", Zr, A3(ta, "ownerName", Zr, A3(ta, "repoName", Zr, A3(ta, "index", Oo, A3(ta, "projectId", fa, A3(ta, "id", fa, sr(function(n) {
        return function(e) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return function(i) {
                            return function(u) {
                                return function(c) {
                                    return function(o) {
                                        return function(s) {
                                            return function(f) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(h) {
                                                                return function(g) {
                                                                    return function(v) {
                                                                        return function(p) {
                                                                            return function(m) {
                                                                                return function($) {
                                                                                    return function(y) {
                                                                                        return function(w) {
                                                                                            return function(k) {
                                                                                                return function(x) {
                                                                                                    return function(j) {
                                                                                                        return function(A) {
                                                                                                            return {
                                                                                                                eG: x,
                                                                                                                cL: b,
                                                                                                                e7: h,
                                                                                                                e8: o,
                                                                                                                fh: g,
                                                                                                                fj: d,
                                                                                                                fn: p,
                                                                                                                ft: i,
                                                                                                                c: n,
                                                                                                                ab: t,
                                                                                                                fV: f,
                                                                                                                f_: $,
                                                                                                                f$: s,
                                                                                                                f0: l,
                                                                                                                f1: m,
                                                                                                                bk: j,
                                                                                                                gd: A,
                                                                                                                dp: a,
                                                                                                                U: e,
                                                                                                                dv: u,
                                                                                                                dw: r,
                                                                                                                g1: y,
                                                                                                                g2: w,
                                                                                                                dD: v,
                                                                                                                dF: c,
                                                                                                                hh: k
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))))))))))))), Xd = A3(ta, "isPublic", na, A4(Aa, "imageURL", Zr, gt, A3(ta, "displayName", Zr, A3(ta, "slug", Zr, A3(ta, "name", Zr, A3(ta, "ownerSlug", Zr, A3(ta, "siteSlug", Zr, A3(ta, "enabled", na, A3(ta, "repoId", fa, A3(ta, "ownerId", fa, A3(ta, "owner", wd, A3(ta, "id", fa, sr(function(n) {
        return function(e) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return function(i) {
                            return function(u) {
                                return function(c) {
                                    return function(o) {
                                        return function(s) {
                                            return function(f) {
                                                return function(l) {
                                                    return {
                                                        k: s,
                                                        be: a,
                                                        c: n,
                                                        T: f,
                                                        ar: l,
                                                        n: c,
                                                        bn: e,
                                                        bo: t,
                                                        gC: u,
                                                        dv: r,
                                                        dB: i,
                                                        ax: o
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))), nb = A4(Aa, "dummy", Gd, gt, A3(ta, "mayCancel", na, A3(ta, "mayRestart", na, A3(ta, "events", Hi(Hi(Gd)), A3(ta, "usedInProjects", Hi(Xd), A3(ta, "outputs", Hi(Hd), A3(ta, "inputDerivations", Hi(qd), A3(ta, "requiredSystemFeatures", Hi(Zr), A3(ta, "platform", Zr, A4(Aa, "viaProject", Xd, gt, A4(Aa, "viaJob", Zd, gt, A3(ta, "status", zd, sr(function(n) {
        return function(e) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return function(i) {
                            return function(u) {
                                return function(c) {
                                    return function(o) {
                                        return function(s) {
                                            return function(f) {
                                                return function(l) {
                                                    return {
                                                        cP: l,
                                                        cT: o,
                                                        c3: i,
                                                        bk: f,
                                                        ge: s,
                                                        $7: u,
                                                        bq: r,
                                                        bs: a,
                                                        V: n,
                                                        hC: c,
                                                        hI: e,
                                                        hJ: t
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))), eb = F3(function(n, e, t) {
        return A7(yu, "GET", "/api/v1/accounts/{accountId}/derivations/{derivationPath}", m([
            l("accountId", n),
            l("derivationPath", e)
        ]), m([
            l("via-job", A2(Fi, gl, t))
        ]), g, gt, nb);
    }), tb = F3(function(n, e, t) {
        var r = n(t);
        return 3 === r.$ ? e(r.a) : sl(t);
    }), rb = F2(function(n, e) {
        return A3(tb, function(n) {
            return n.co;
        }, function(t) {
            return l(b(e, {
                ig: A2(Yl, e.ig, Mr)
            }), A3(fl, n, A3(eb, t.c, pu(e.a8), e.ch.dQ), A2(Zc, cd, yf)));
        }, e);
    }), ab = F2(function(n, e) {
        return A2(cc, sl, function() {
            switch(e.$){
                case 12:
                    return zl(function(n) {
                        return n;
                    });
                case 0:
                    var t = A2(Os, function(n) {
                        return n.b && !n.b.b ? Es(n.a) : Ls(ro("Could not load account"));
                    }, r = e.a);
                    return A2(cc, zl(function(n) {
                        return b(n, {
                            co: t
                        });
                    }), il(rb(n)));
                case 7:
                    return il(rb(n));
                case 8:
                    return il(function(e) {
                        return A3(tb, function(n) {
                            return n.co;
                        }, function(t) {
                            return A3(ud, n, t, e);
                        }, e);
                    });
                case 1:
                    var r = e.a;
                    return A2(cc, zl(function(n) {
                        return b(n, {
                            ig: A2(Yl, n.ig, r)
                        });
                    }), il(function(e) {
                        return A3(tb, Ps(n), function(t) {
                            var a, i = 1 === (a = nd(r)).$ ? ul : Pl(A2(wc, function(n) {
                                return A2(Lr, function(n) {
                                    return l(n.dg, n.dg);
                                }, Dl(n.dG));
                            }, yc(a.a.cT))), u = Zl(A2(Ol, i, e.al)), c = A2(Lr, function(r) {
                                var a = r.b;
                                return A3(fl, n, A5(kl, t.co.c, pu(e.a8), a, gt, gt), A2(Zc, bl(a), yf));
                            }, u);
                            return l(e, Au(c));
                        }, e);
                    }));
                case 2:
                    var a = e.a;
                    return il(function(e) {
                        var t = b(e.ch, {
                            d9: a
                        });
                        return l(b(e, {
                            ch: t
                        }), A2(Ll, n.iI, Bu(t)));
                    });
                case 3:
                    return il(function(e) {
                        return A2(il, rb(n), A3(tb, Ps(n), function(t) {
                            return l(b(e, {
                                cg: Mr
                            }), A3(fl, n, A2(xl, t.co.c, pu(e.a8)), A2(Zc, hl, yf)));
                        }, e));
                    });
                case 4:
                    var i = e.a;
                    return zl(function(n) {
                        return b(n, {
                            cg: i
                        });
                    });
                case 5:
                    return il(function(e) {
                        return A2(il, rb(n), A3(tb, Ps(n), function(t) {
                            return l(b(e, {
                                bN: Mr
                            }), A3(fl, n, A2(vl, t.co.c, pu(e.a8)), A2(Zc, dl, yf)));
                        }, e));
                    });
                case 6:
                    return i = e.a, zl(function(n) {
                        return b(n, {
                            bN: i
                        });
                    });
                case 9:
                    var c = e.a;
                    return i = e.b, il(function(n) {
                        var e = b(n, {
                            al: A3(ed, c, Jl(i), n.al)
                        });
                        return l(e, u(A2(Fi, kf(A2(Zc, jt, function(n) {
                            return n.f8;
                        })), A2(Rl, c, n.al)), A2(Fi, kf(A2(Zc, jt, function(n) {
                            return n.f8;
                        })), A2(Rl, c, e.al))) ? Kc : A2(Wl, n, c));
                    });
                case 10:
                    c = e.a;
                    var o = e.b;
                    return A2(cc, zl(function(n) {
                        return b(n, {
                            aT: A3(pa, c, o, n.aT)
                        });
                    }), il(function(n) {
                        return l(n, A2(Wl, n, c));
                    }));
                default:
                    c = e.a;
                    var s = e.b;
                    return A2(cc, zl(function(n) {
                        return b(n, {
                            b9: A3(cu, c, function(n) {
                                return u(n, ht(s)) ? gt : ht(s);
                            }, n.b9)
                        });
                    }), il(function(n) {
                        return l(n, Kc);
                    }));
            }
        }());
    }), ib = F2(function(n, e) {
        return A2(il, function(t) {
            var r = A2(cl, n, e);
            return r.$ ? l(t, A3(ll, n, e, al)) : A3(ab, n, al(Es(m([
                r.a
            ]))), t);
        }, sl({
            co: Mr,
            dR: e.co,
            bN: Bs,
            ig: ol,
            a8: e.a8,
            al: ul,
            b9: da,
            cg: Bs,
            ch: e,
            aT: da,
            dA: e.dA
        }));
    }), ub = function(n) {
        return {
            $: 0,
            a: n
        };
    }, cb = function(n) {
        return {
            $: 6,
            a: n
        };
    }, ob = F3(function(n, e, t) {
        return {
            cp: t,
            es: n,
            cJ: e
        };
    }), sb = F3(function(n, e, t) {
        return {
            ej: n,
            fX: e,
            dD: t
        };
    }), fb = A4(Aa, "source", yd, gt, A3(ta, "isPrimary", na, A3(ta, "address", Zr, sr(sb)))), lb = F2(function(n, e) {
        return {
            co: n,
            hb: e
        };
    }), db = F2(function(n, e) {
        return {
            gu: e,
            gv: n
        };
    }), bb = A2(ur, function(n) {
        switch(n){
            case "Ignore":
                return sr(0);
            case "All":
                return sr(1);
            default:
                return Qr("Unknown type: " + n);
        }
    }, Zr), hb = A4(Aa, "notificationEmail", Zr, gt, A4(Aa, "notificationLevel", bb, gt, sr(db))), gb = A3(ta, "setting", hb, A3(ta, "account", wd, sr(lb))), vb = A3(ta, "accountOverrides", Hi(gb), A4(Aa, "defaultSetting", hb, gt, A3(ta, "authorizedEmails", Hi(fb), sr(ob)))), pb = A7(yu, "GET", "/api/v1/accounts/me/settings/notifications", g, g, g, gt, vb), mb = function(n) {
        return {
            $: 1,
            a: n
        };
    }, $b = function(n) {
        return {
            $: 5,
            a: n
        };
    }, yb = function(n) {
        return {
            $: 14,
            a: n
        };
    }, wb = function(n) {
        return {
            $: 9,
            a: n
        };
    }, kb = function(n) {
        return {
            $: 12,
            a: n
        };
    }, xb = function(n) {
        return {
            $: 2,
            a: n
        };
    }, jb = function(n) {
        return A7(yu, "POST", "/api/v1/accounts/{accountId}/gitlab/deinstall", m([
            l("accountId", n)
        ]), g, g, gt, sr(0));
    }, Ab = A3(ta, "enableNewRepos", na, sr(function(n) {
        return {
            cS: n
        };
    })), Cb = on, Ib = F2(function(n, e) {
        return l(n, e);
    }), Tb = F2(function(n, e) {
        return Fi(A2(Zc, Ib(n), e));
    }), Sb = function(n) {
        return m([
            A3(Tb, "enableNewRepos", Cb, n.cS)
        ]);
    }, Db = function(n) {
        return A3(xt, F2(function(n, e) {
            return A3(sn, n.a, n.b, e);
        }), {}, n);
    }, Nb = A2(Zc, Db, fu(lr)), Eb = A2(Zc, Nb, Sb), Lb = function(n) {
        return A2(He, "application/json", A2(mt, 0, n));
    }, Bb = F2(function(n, e) {
        return A7(yu, "PATCH", "/api/v1/accounts/{accountId}/settings", m([
            l("accountId", n)
        ]), g, g, A2(Fi, Lb, ht(Eb(e))), Ab);
    }), Ob = F3(function(n, e, t) {
        return A3(Fo, F3(function(t, r, a) {
            return A3(sn, n(t), e(r), a);
        }), {}, t);
    }), Pb = F3(function(n, e, t) {
        return ht(l(n, e(t)));
    }), Gb = on, Rb = function(n) {
        return n ? "All" : "Ignore";
    }, zb = A2(Zc, Gb, Rb), qb = function(n) {
        return m([
            A3(Tb, "notificationLevel", zb, n.gv),
            A3(Tb, "notificationEmail", Gb, n.gu)
        ]);
    }, _b = A2(Zc, Nb, qb), Hb = function(n) {
        return m([
            A3(Tb, "defaultSetting", _b, n.cJ),
            A3(Pb, "accountOverrides", A2(Ob, lr, _b), n.cp)
        ]);
    }, Fb = A2(Zc, Nb, Hb), Ub = function(n) {
        return A7(yu, "PATCH", "/api/v1/accounts/me/settings/notifications", g, g, g, A2(Fi, Lb, ht(Fb(n))), vb);
    }, Vb = {
        cp: da,
        cJ: gt
    }, Wb = F2(function(n, e) {
        return A2(Fi, function(n) {
            return n.hb;
        }, A2(nc, A2(cc, function(n) {
            return n.cp;
        }, tl(function(n) {
            return u(n.co.c, e.c);
        })), nd(n.Z)));
    }), Yb = F2(function(n, e) {
        return 1 === e.$ ? Ls(n) : Es(e.a);
    }), Mb = F2(function(n, e) {
        return A2(Yb, ro("Could not match account forge name"), A2(tl, function(e) {
            return u(e.ax, n);
        }, e));
    }), Kb = F2(function(n, e) {
        return A2(Os, function(t) {
            return A2(Os, function(e) {
                return A2(Os, function(n) {
                    return Es({
                        co: t,
                        ai: e,
                        fr: n
                    });
                }, A2(Mb, t.hf, n.h9.fu));
            }, e.ai);
        }, e.co);
    }), Jb = F2(function(n, e) {
        var t = l(n, e);
        return 3 === t.b.$ ? Es(t.b.a) : 3 === t.a.$ ? Es(t.a.a) : t.b;
    }), Qb = function(n) {
        return 3 === n.$;
    }, Zb = F2(function(n, e) {
        return 1 === e.$ ? n : e;
    }), Xb = A2(Fr, Tr, ln(function() {
        zn.location.reload(false);
    })), nh = F2(function(n, e) {
        return A5(ba, 1, n, e, la, la);
    }), eh = F2(function(n, e) {
        switch(e.$){
            case 3:
                var t = n(e.a), r = t.b;
                return l(Es(t.a), r);
            case 0:
                return l(Bs, Kc);
            case 1:
                return l(Mr, Kc);
            default:
                return l(Ls(e.a), Kc);
        }
    }), th = F3(function(n, e, t) {
        var r = l(t, Kc), a = l(nd(A2(Kb, n, t)), e);
        n: for(;;)switch(a.b.$){
            case 0:
                var i = A2(eh, function(e) {
                    return l(e, A3(fl, n, A7(yu, "GET", "/api/v1/accounts/{accountId}/settings", m([
                        l("accountId", e.c)
                    ]), g, g, gt, Ab), A2(Zc, mb, yf)));
                }, A2(Os, function(n) {
                    return n.b && !n.b.b ? Es(n.a) : Ls(ro("Could not load account"));
                }, a.b.a)), u = i.b;
                return l(b(t, {
                    co: i.a
                }), u);
            case 1:
                return l(b(t, {
                    ai: a.b.a
                }), Kc);
            case 3:
                if (a.a.$) break n;
                var c = a.a.a, o = a.b.a;
                return l(b(t, {
                    b_: Mr
                }), A3(fl, n, A2(Bb, c.co.c, {
                    cS: ht(o)
                }), A2(Zc, xb, yf)));
            case 2:
                return l(b(t, {
                    ai: A2(Jb, t.ai, p = a.b.a),
                    b_: A2(kf, function() {
                        return 0;
                    }, p)
                }), Kc);
            case 4:
                if (a.a.$) break n;
                return c = a.a.a, l(b(t, {
                    bW: Mr
                }), A3(fl, n, A7(yu, "POST", "/api/v1/accounts/{accountId}/disable-all-projects", m([
                    l("accountId", c.co.c)
                ]), g, g, gt, Oo), A2(Zc, $b, yf)));
            case 5:
                return l(b(t, {
                    bW: p = a.b.a
                }), Kc);
            case 6:
                return l(b(t, {
                    Z: p = a.b.a
                }), Kc);
            case 8:
                return l(b(t, {
                    dk: a.b.a
                }), Kc);
            case 7:
                var s = a.b.a, f = t.co;
                if (3 === f.$) {
                    var d = f.a;
                    return l(b(t, {
                        dl: s,
                        b7: Mr
                    }), A3(fl, n, Ub(b(Vb, {
                        cp: A2(nh, d.c, {
                            gu: s,
                            gv: A2(Zb, A2(nc, function(n) {
                                return n.gv;
                            }, A2(Wb, t, d)), t.dn)
                        })
                    })), A2(Zc, wb, yf)));
                }
                return r;
            case 9:
                return l(b(t, {
                    b7: v = a.b.a,
                    Z: A2(Jb, t.Z, v)
                }), Kc);
            case 11:
                return l(b(t, {
                    dm: a.b.a
                }), Kc);
            case 10:
                s = a.b.a;
                var h = t.co;
                return 3 === h.$ ? (d = h.a, l(b(t, {
                    dn: s,
                    b8: Mr
                }), A3(fl, n, Ub(b(Vb, {
                    cp: A2(nh, d.c, {
                        gu: A2(Zb, A2(nc, function(n) {
                            return n.gu;
                        }, A2(Wb, t, d)), t.dl),
                        gv: s
                    })
                })), A2(Zc, kb, yf)))) : r;
            case 12:
                var v;
                return l(b(t, {
                    b8: v = a.b.a,
                    Z: A2(Jb, t.Z, v)
                }), Kc);
            case 13:
                if (a.a.$) break n;
                return c = a.a.a, l(t, A3(fl, n, a.b.a ? A7(yu, "POST", "/api/v1/accounts/{accountId}/gitlab/install", m([
                    l("accountId", c.co.c)
                ]), g, g, gt, sr(0)) : jb(c.co.c), A2(Zc, yb, yf)));
            default:
                if (a.a.$) break n;
                var p;
                return l(b(t, {
                    c4: p = a.b.a
                }), Qb(p) ? Xb : Kc);
        }
        return r;
    }), rh = F2(function(n, e) {
        var t, r = {
            co: Mr,
            ai: Mr,
            bW: Bs,
            b_: Bs,
            c4: Bs,
            dk: 0,
            dl: gt,
            b7: Bs,
            dm: 0,
            dn: gt,
            b8: Bs,
            Z: Mr
        }, a = (t = A2(cl, n, e)).$ ? l(r, A3(fl, n, A2(wu, ht(e.dA), ht(e.co)), A2(Zc, ub, yf))) : A3(th, n, ub(Es(m([
            t.a
        ]))), r);
        return l(a.a, Au(m([
            a.b,
            A3(fl, n, pb, A2(Zc, cb, yf))
        ])));
    }), ah = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ih = F2(function(n, e) {
        var t = e.b, r = n(e.a);
        return l(r.a, Au(m([
            t,
            r.b
        ])));
    }), uh = function(n) {
        return l(n, Kc);
    }, ch = function(n) {
        return {
            $: 1,
            a: n
        };
    }, oh = A3(ta, "labels", $a(xa), A3(ta, "concurrentTasks", Oo, A3(ta, "available", na, A4(Aa, "revocation", zi, gt, A4(Aa, "lastSeen", zi, gt, A3(ta, "creation", zi, A3(ta, "substituters", Hi(Zr), A3(ta, "pushCaches", Hi(Zr), A3(ta, "cachixPushCaches", Hi(Zr), A3(ta, "systemFeatures", Hi(Zr), A3(ta, "platforms", Hi(Zr), A3(ta, "nixVersion", Zr, A3(ta, "agentVersion", Zr, A3(ta, "hostname", Zr, A3(ta, "description", Zr, A3(ta, "clusterJoinTokenId", fa, A3(ta, "id", fa, sr(function(n) {
        return function(e) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return function(i) {
                            return function(u) {
                                return function(c) {
                                    return function(o) {
                                        return function(s) {
                                            return function(f) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(h) {
                                                                return function(g) {
                                                                    return function(v) {
                                                                        return {
                                                                            a0: a,
                                                                            et: h,
                                                                            eF: o,
                                                                            eK: e,
                                                                            eP: g,
                                                                            eR: l,
                                                                            v: t,
                                                                            fK: r,
                                                                            c: n,
                                                                            f4: v,
                                                                            f5: d,
                                                                            gr: i,
                                                                            gL: u,
                                                                            gV: s,
                                                                            g7: b,
                                                                            hr: f,
                                                                            hs: c
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))))))), sh = function(n) {
        return A7(yu, "GET", "/api/v1/accounts/{accountId}/agentSessions", m([
            l("accountId", n)
        ]), g, g, gt, Hi(oh));
    }, fh = F3(function(n, e, t) {
        return l(b(e, {
            aB: A2(Jb, e.aB, Mr)
        }), A3(fl, n, sh(t.c), A2(Zc, ch, yf)));
    }), lh = F2(function(n, e) {
        var t = nd(e.co);
        return t.$ ? uh(e) : A3(fh, n, e, t.a);
    }), dh = F3(function(n, e, t) {
        switch(e.$){
            case 0:
                return uh(b(t, {
                    co: A2(Os, function(n) {
                        return n.b && !n.b.b ? Es(n.a) : Ls(ro("Could not load account"));
                    }, e.a)
                }));
            case 1:
                var r = A2(eh, function(n) {
                    return l(A2(Uf, function(n) {
                        return u(n.fK, t.ch.fK);
                    }, n), Kc);
                }, e.a), a = r.b;
                return l(b(t, {
                    aB: r.a
                }), a);
            default:
                return A2(lh, n, t);
        }
    }), bh = F2(function(n, e) {
        var t = function(t) {
            var r = A2(cl, n, e);
            return r.$ ? l(t, A3(ll, n, e, ah)) : A3(dh, n, ah(Es(m([
                r.a
            ]))), t);
        }, r = {
            co: Mr,
            aB: Mr,
            ch: e
        };
        return A2(ih, lh(n), A2(ih, t, uh(r)));
    }), hh = function(n) {
        return {
            $: 9,
            a: n
        };
    }, gh = function(n) {
        return {
            $: 0,
            a: n
        };
    }, vh = A7(yu, "GET", "/api/v1/api/organizations", g, g, g, gt, Hi(qi)), ph = F2(function(n, e) {
        return {
            eh: e,
            gq: n
        };
    }), mh = A3(ta, "activeUsers", Hi(_i), A4(Aa, "nextPayment", zi, gt, sr(ph))), $h = F2(function(n, e) {
        return l({
            co: e,
            cx: Bs,
            cD: Bs,
            bP: Bs,
            n: "",
            ca: Mr,
            gH: Bs,
            dH: !1
        }, Au(A2(Ze, A3(fl, n, vh, A2(cc, yf, gh)), A2(Lr, function(e) {
            return A3(fl, n, A7(yu, "GET", "/api/v1/api/organizations/{organizationId}/billing", m([
                l("organizationId", e.c)
            ]), g, g, gt, mh), A2(cc, yf, hh));
        }, Dl(e.gB)))));
    }), yh = function(n) {
        return {
            $: 3,
            a: n
        };
    }, wh = F2(function(n, e) {
        return {
            I: e,
            v: n
        };
    }), kh = A3(ta, "creationTime", zi, A3(ta, "description", Zr, sr(wh))), xh = F2(function(n, e) {
        var t = {
            cu: Mr,
            bO: !1,
            a6: Bs,
            ch: e
        }, r = A3(fl, n, A7(yu, "GET", "/api/v1/auth/cli/authorization/request/{browserToken}", m([
            l("browserToken", e.ga)
        ]), g, g, gt, kh), A2(Zc, yh, yf));
        return l(t, r);
    }), jh = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), Ah = F2(function(n, e) {
        return {
            dc: e,
            br: n
        };
    }), Ch = A3(ta, "jobs", Hi(Zd), A3(ta, "project", Xd, sr(Ah))), Ih = F5(function(n, e, t, r, a) {
        return A7(yu, "GET", "/api/v1/jobs", g, m([
            l("site", A2(Fi, lr, n)),
            l("account", A2(Fi, lr, e)),
            l("project", A2(Fi, lr, t)),
            l("index", A2(Fi, $t, r)),
            l("latest", A2(Fi, $t, a))
        ]), g, gt, Hi(Ch));
    }), Th = F2(function(n, e) {
        var t = e.bC;
        if (1 === t.$) {
            var r = t.a;
            return A3(fl, n, A5(Ih, ht(r.hf), ht(r.ax), gt, gt, ht(1)), A2(cc, yf, jh(n.ch)));
        }
        return A3(fl, n, A5(Ih, gt, gt, gt, gt, ht(1)), A2(cc, yf, jh(n.ch)));
    }), Sh = F2(function(n, e) {
        var t = {
            hV: da,
            aR: Mr,
            bC: e
        };
        return l(t, A2(Th, n, t));
    }), Dh = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Nh = F6(function(n, e, t, r, a, i) {
        return {
            k: r,
            fe: i,
            fr: a,
            c$: e,
            c: n,
            n: t
        };
    }), Eh = F2(function(n, e) {
        return {
            fc: n,
            bl: e
        };
    }), Lh = A3(ta, "message", Zr, A3(ta, "errorTags", Hi(Zr), sr(Eh))), Bh = A3(ta, "errors", Hi(Lh), A4(Aa, "forge", yd, gt, A3(ta, "displayName", Zr, A3(ta, "name", Zr, A3(ta, "gitlabURL", Zr, A3(ta, "id", fa, sr(Nh))))))), Oh = F2(function(n, e) {
        return l({
            bU: Bs,
            k: "",
            ac: Mr,
            aq: Bs,
            n: "",
            ch: e
        }, A3(fl, n, A7(yu, "GET", "/api/v1/gitlab/installation/{installationId}", m([
            l("installationId", e.c6)
        ]), g, g, gt, Bh), A2(Zc, Dh, yf)));
    }), Ph = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Gh = A3(ta, "items", Hi(Bh), sr(function(n) {
        return {
            bh: n
        };
    })), Rh = A7(yu, "GET", "/api/v1/gitlab/installations", g, g, g, gt, Gh), zh = F2(function(n) {
        return l({
            c$: "https://",
            c4: Bs,
            c5: Mr,
            aQ: "",
            aW: "",
            aA: !1
        }, A3(fl, n, Rh, A2(Zc, Ph, yf)));
    }), qh = function(n) {
        return {
            $: 0,
            a: n
        };
    }, _h = F4(function(n, e, t, r) {
        return {
            co: e,
            fY: t,
            g9: r,
            dA: n
        };
    }), Hh = A4(Aa, "secondsSinceInstallationWebHookComplete", Oo, gt, A3(ta, "isProcessingInstallationWebHook", na, A4(Aa, "account", _i, gt, A3(ta, "site", Ca, sr(_h))))), Fh = F2(function(n, e) {
        return A7(yu, "GET", "/api/v1/sites/{forgeId}/installation/{installationId}/status", m([
            l("forgeId", n),
            l("installationId", $t(e))
        ]), g, g, gt, Hh);
    }), Uh = F2(function(n, e) {
        return A3(fl, n, A2(Fh, e.ch.fs, A2(ca, 0, e.ch.c6)), A2(Zc, qh, yf));
    }), Vh = F2(function(n, e) {
        var t = {
            ch: e,
            aU: ol
        };
        return l(t, A2(Uh, n, t));
    }), Wh = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Yh = F2(function(n, e) {
        return {
            ie: n,
            ao: e
        };
    }), Mh = da, Kh = F3(function(n, e, t) {
        return A3(fl, n, sh(e.c), A2(cc, yf, t));
    }), Jh = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Qh = F2(function(n, e) {
        return A3(fl, n, A5(Ih, ht(e.dB), ht(e.H), ht(e.br), ht(e.au), gt), Jh);
    }), Zh = F2(function(n, e) {
        var t, r = {
            H: e.co,
            a1: Mr,
            bM: Bs,
            a5: A2(rl, n, e.co),
            ak: Mr,
            aF: !1,
            b$: gt,
            b0: !0,
            aG: 3,
            aH: A2(Yh, Mr, Bs),
            as: A2(Yh, Mr, Bs),
            at: Bs,
            au: e.ab,
            br: e.br,
            bt: Bs,
            ch: e,
            bu: Bs,
            aa: Mh,
            dB: e.dA
        }, a = 1 === (t = r.a5).$ ? Kc : A3(Kh, n, t.a, Wh);
        return l(r, Au(m([
            A2(Qh, n, r),
            a
        ])));
    }), Xh = F3(function(n, e, t) {
        return e.$ ? l(t, Kc) : A2(n, e.a, t);
    }), ng = F2(function(n, e) {
        var t = e.b, r = n(e.a);
        return l(r.a, Au(m([
            t,
            r.b
        ])));
    }), eg = function(n) {
        return {
            $: 3,
            a: n
        };
    }, tg = function(n) {
        return !n.$;
    }, rg = F3(function(n, e, t) {
        return l(b(t, {
            aj: tg(t.aj) ? Mr : t.aj
        }), A3(fl, n, A7(yu, "GET", "/api/v1/jobs/{jobId}", m([
            l("jobId", e)
        ]), g, g, gt, Zd), A2(Zc, eg, yf)));
    }), ag = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ig = function(n) {
        if (n.b) {
            var e = n.a.dc;
            return e.b ? Es(e.a) : Ls(Xc(404));
        }
        return Ls(Xc(404));
    }, ug = F2(function(n, e) {
        var t = e.ch;
        return l(b(e, {
            am: tg(e.am) ? Mr : e.am
        }), A3(fl, n, A5(Ih, ht(t.dA), ht(t.co), ht(t.br), ht(t.ab), ht(1)), A2(Zc, A2(Zc, ag, Os(ig)), yf)));
    }), cg = F2(function(n, e) {
        var t = {
            ep: da,
            aj: Bs,
            a4: Bs,
            bV: Bs,
            bg: gt,
            am: Bs,
            ch: e
        };
        return A2(ng, A2(Xh, rg(n), e.eu), A2(ug, n, t));
    }), og = function(n) {
        return {
            $: 0,
            a: n
        };
    }, sg = function(n) {
        return {
            $: 1,
            a: n
        };
    }, fg = F2(function(n, e) {
        var t = e.b, r = n(e.a);
        return l(r.a, Au(m([
            t,
            r.b
        ])));
    }), lg = function(n) {
        return l(n, Kc);
    }, dg = function(n) {
        return {
            $: 7,
            a: n
        };
    }, bg = F2(function(n, e) {
        return {
            $: 10,
            a: n,
            b: e
        };
    }), hg = F2(function(n, e) {
        return A7(yu, "POST", "/api/v1/jobs/{jobId}/effects/{attribute}/cancel", m([
            l("jobId", n),
            l("attribute", e)
        ]), g, g, gt, sr(0));
    }), gg = function(n) {
        switch(n){
            case 0:
                return "Error";
            case 1:
                return "Warn";
            case 2:
                return "Notice";
            case 3:
                return "Info";
            case 4:
                return "Talkative";
            case 5:
                return "Chatty";
            case 6:
                return "Debug";
            default:
                return "Vomit";
        }
    }, vg = F5(function(n, e, t, r, a) {
        return A7(yu, "GET", "/api/v1/jobs/{jobId}/effects/{attribute}/log/lines", m([
            l("jobId", n),
            l("attribute", e)
        ]), m([
            l("logId", ht(t)),
            l("iMin", A2(Fi, $t, r)),
            l("verbosity", A2(Fi, gg, a))
        ]), g, gt, yl);
    }), pg = function(n) {
        return function(e) {
            var t = e.b;
            return l(n(e.a), t);
        };
    }, mg = {
        $: 13
    }, $g = F2(function(n, e) {
        return A3(Vl, A2(ca, !0, A2(Xi, e, n.aT)), e, mg);
    }), yg = F2(function(n, e) {
        var t = A3(rd, F3(function(e, t, r) {
            var a = A2(n, t, r), i = a.a;
            return l(A2(Ze, a.b, e), i);
        }), g, e);
        return l(t.b, Au(t.a));
    }), wg = F3(function(n, e, t) {
        var r = n(t);
        return 3 === r.$ ? e(r.a) : lg(t);
    }), kg = F2(function(n, e) {
        var t = A3(wg, function(n) {
            return n.aN;
        }, function(t) {
            var r = t.b, a = A2(yg, F2(function(t, a) {
                return l(a, A2(id, a, function(a) {
                    return A3(fl, n, A5(vg, r.c, pu(Tl(e.ch.a2)), t, a, gt), A2(Zc, bg(t), yf));
                }));
            }), e.al);
            return l(e, a.b);
        }, e);
        return l(e, t.b);
    }), xg = function(n) {
        return {
            $: 2,
            a: n
        };
    }, jg = F6(function(n, e, t, r, a, i) {
        return {
            cy: i,
            cK: e,
            cX: r,
            dt: n,
            dG: t,
            dI: a
        };
    }), Ag = A3(ta, "time", zi, sr(function(n) {
        return {
            f: n
        };
    })), Cg = A3(ta, "time", zi, sr(function(n) {
        return {
            f: n
        };
    })), Ig = F2(function(n, e) {
        return {
            dM: e,
            f: n
        };
    }), Tg = A4(Aa, "technicalError", Zr, gt, A3(ta, "time", zi, sr(Ig))), Sg = A3(ta, "time", zi, sr(function(n) {
        return {
            f: n
        };
    })), Dg = F4(function(n, e, t, r) {
        return {
            a_: t,
            a0: r,
            dg: e,
            f: n
        };
    }), Ng = A3(ta, "agentVersion", Zr, A3(ta, "agentHostname", Zr, A3(ta, "logId", fa, A3(ta, "time", zi, sr(Dg))))), Eg = A3(ta, "time", zi, sr(function(n) {
        return {
            f: n
        };
    })), Lg = A4(Aa, "Cancelled", Ag, gt, A4(Aa, "Succeeded", Eg, gt, A4(Aa, "Failed", Tg, gt, A4(Aa, "Started", Ng, gt, A4(Aa, "DependencyFailed", Cg, gt, A4(Aa, "Queued", Sg, gt, sr(jg))))))), Bg = F2(function(n, e) {
        return {
            er: e,
            as: n
        };
    }), Og = A3(ta, "attributePath", Hi(Zr), A3(ta, "job", Nd, sr(Bg))), Pg = A2(ur, function(n) {
        switch(n){
            case "Waiting":
                return sr(0);
            case "Running":
                return sr(1);
            case "Failed":
                return sr(2);
            case "DependencyFailed":
                return sr(3);
            case "Successful":
                return sr(4);
            case "Cancelled":
                return sr(5);
            default:
                return Qr("Unknown type: " + n);
        }
    }, Zr), Gg = A4(Aa, "dummy", Lg, gt, A3(ta, "mayCancel", na, A3(ta, "waitingForJobs", Hi(Nd), A3(ta, "waitingForEffects", Hi(Og), A3(ta, "events", Hi(Hi(Lg)), A3(ta, "inputDerivations", Hi(qd), A3(ta, "requiredSystemFeatures", Hi(Zr), A3(ta, "platform", Zr, A3(ta, "projectId", fa, A3(ta, "jobId", fa, A3(ta, "status", Pg, sr(function(n) {
        return function(e) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return function(i) {
                            return function(u) {
                                return function(c) {
                                    return function(o) {
                                        return function(s) {
                                            return function(f) {
                                                return {
                                                    cP: f,
                                                    cT: u,
                                                    c3: i,
                                                    db: e,
                                                    bk: s,
                                                    bq: r,
                                                    U: t,
                                                    bs: a,
                                                    V: n,
                                                    hL: c,
                                                    hM: o
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))), Rg = F2(function(n, e) {
        return A7(yu, "GET", "/api/v1/jobs/{jobId}/effects/{attribute}", m([
            l("jobId", n),
            l("attribute", e)
        ]), g, g, gt, Gg);
    }), zg = F2(function(n, e) {
        return A3(wg, function(n) {
            return n.aN;
        }, function(t) {
            var r = t.b;
            return l(b(e, {
                j: A2(Yl, e.j, Mr)
            }), A3(fl, n, A2(Rg, r.c, pu(Tl(e.ch.a2))), A2(Zc, xg, yf)));
        }, e);
    }), qg = F2(function(n, e) {
        return A2(cc, lg, function() {
            switch(e.$){
                case 13:
                case 4:
                    return pg(function(n) {
                        return n;
                    });
                case 0:
                    var t = A2(Os, function(n) {
                        return n.b && !n.b.b ? Es(n.a) : Ls(ro("Could not load account"));
                    }, a = e.a);
                    return A2(cc, pg(function(n) {
                        return b(n, {
                            co: t
                        });
                    }), fg(zg(n)));
                case 1:
                    var r = A2(Os, function(n) {
                        if (n.b && !n.b.b) {
                            var e = n.a, t = e.dc;
                            return t.b && !t.b.b ? Es(l(e.br, t.a)) : Ls(ro("Could not load job"));
                        }
                        return Ls(ro("Could not load project"));
                    }, a = e.a);
                    return A2(cc, pg(function(n) {
                        return b(n, {
                            aN: r
                        });
                    }), fg(zg(n)));
                case 8:
                    return fg(zg(n));
                case 9:
                    return fg(kg(n));
                case 2:
                    var a = e.a;
                    return A2(cc, pg(function(n) {
                        return b(n, {
                            j: A2(Yl, n.j, a)
                        });
                    }), fg(function(e) {
                        return A3(wg, rf(n), function(t) {
                            var r, i = 1 === (r = nd(a)).$ ? ul : Pl(A2(wc, function(n) {
                                return A2(Lr, function(n) {
                                    return l(n.dg, n.dg);
                                }, Dl(n.dG));
                            }, yc(r.a.cT))), u = Zl(A2(Ol, i, e.al)), c = A2(Lr, function(r) {
                                var a = r.b;
                                return A3(fl, n, A5(vg, t.as.c, pu(Tl(e.ch.a2)), a, gt, gt), A2(Zc, bg(a), yf));
                            }, u);
                            return l(e, Au(c));
                        }, e);
                    }));
                case 3:
                    var i = e.a;
                    return fg(function(e) {
                        var t = b(e.ch, {
                            d9: i
                        });
                        return l(b(e, {
                            ch: t
                        }), A2(Ll, n.iI, Wu(t)));
                    });
                case 5:
                    var c = e.a;
                    return pg(function(n) {
                        return b(n, {
                            cg: c
                        });
                    });
                case 6:
                    return fg(function(e) {
                        return A2(fg, zg(n), A3(wg, rf(n), function(t) {
                            return l(b(e, {
                                cg: Mr
                            }), A3(fl, n, A2(hg, t.as.c, pu(Tl(e.ch.a2))), A2(Zc, dg, yf)));
                        }, e));
                    });
                case 7:
                    return c = e.a, pg(function(n) {
                        return b(n, {
                            bN: c
                        });
                    });
                case 10:
                    var o = e.a;
                    return c = e.b, fg(function(n) {
                        var e = b(n, {
                            al: A3(ed, o, Jl(c), n.al)
                        });
                        return l(e, u(A2(Fi, kf(A2(Zc, jt, function(n) {
                            return n.f8;
                        })), A2(Rl, o, n.al)), A2(Fi, kf(A2(Zc, jt, function(n) {
                            return n.f8;
                        })), A2(Rl, o, e.al))) ? Kc : A2($g, n, o));
                    });
                case 11:
                    o = e.a;
                    var s = e.b;
                    return A2(cc, pg(function(n) {
                        return b(n, {
                            aT: A3(pa, o, s, n.aT)
                        });
                    }), fg(function(n) {
                        return l(n, A2($g, n, o));
                    }));
                default:
                    o = e.a;
                    var f = e.b;
                    return A2(cc, pg(function(n) {
                        return b(n, {
                            b9: A3(cu, o, function(n) {
                                return u(n, ht(f)) ? gt : ht(f);
                            }, n.b9)
                        });
                    }), fg(function(n) {
                        return l(n, Kc);
                    }));
            }
        }());
    }), _g = F2(function(n, e) {
        return A2(fg, function(e) {
            return l(e, A3(fl, n, A5(Ih, ht(e.dA), ht(e.dR), ht(e.ch.br), ht(e.ch.ab), gt), A2(Zc, sg, yf)));
        }, A2(fg, function(t) {
            var r = A2(cl, n, e);
            return r.$ ? l(t, A3(ll, n, e, og)) : A3(qg, n, og(Es(m([
                r.a
            ]))), t);
        }, lg({
            co: Mr,
            dR: e.co,
            bN: Bs,
            j: ol,
            aN: Mr,
            al: ul,
            b9: da,
            cg: Bs,
            ch: e,
            aT: da,
            dA: e.dA
        })));
    }), Hg = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Fg = F2(function(n, e) {
        return {
            bh: n,
            dj: e
        };
    }), Ug = A3(ta, "more", na, A3(ta, "items", Hi(Zd), sr(Fg))), Vg = function(n) {
        return function(e) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return function(i) {
                            return function(u) {
                                return function(c) {
                                    return function(o) {
                                        return function(s) {
                                            return function(f) {
                                                return A7(yu, "GET", "/api/v1/site/{site}/account/{account}/project/{project}/jobs", m([
                                                    l("site", n),
                                                    l("account", e),
                                                    l("project", t)
                                                ]), h(m([
                                                    l("ref", A2(Fi, lr, r)),
                                                    l("rev", A2(Fi, lr, a)),
                                                    l("name", A2(Fi, lr, u)),
                                                    l("success", A2(Fi, function(n) {
                                                        return n ? "true" : "false";
                                                    }, c)),
                                                    l("offsetId", A2(Fi, gl, o)),
                                                    l("offsetIndex", A2(Fi, $t, s)),
                                                    l("limit", A2(Fi, $t, f))
                                                ]), A2(Lr, function(n) {
                                                    return l("handler", ht(function(n) {
                                                        switch(n){
                                                            case 0:
                                                                return "Config";
                                                            case 1:
                                                                return "Legacy";
                                                            case 2:
                                                                return "OnPush";
                                                            default:
                                                                return "OnSchedule";
                                                        }
                                                    }(n)));
                                                }, i)), g, gt, Ug);
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }, Wg = F2(function(n, e) {
        var t;
        return A3(fl, n, Vg(e.dA)(e.co)(e.br)(ht("HEAD"))(gt)(m(1 === (t = e.W).$ ? [
            1,
            0
        ] : [
            t.a
        ]))(e.n)(gt)(gt)(gt)(ht(1)), A2(Zc, Hg, yf));
    }), Yg = F2(function(n, e) {
        return l({
            d5: Mr,
            ch: e
        }, A2(Wg, n, e));
    }), Mg = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Kg = F2(function(n) {
        return l({
            bG: da,
            ef: da,
            cF: 0,
            cG: gt,
            bS: Bs,
            cH: 0,
            cI: gt,
            bT: Bs,
            Z: Mr
        }, function(n) {
            return A3(fl, n, pb, A2(Zc, Mg, yf));
        }(n));
    }), Jg = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Qg = F4(function(n, e, t, r) {
        return {
            I: t,
            v: e,
            c: n,
            hE: r
        };
    }), Zg = A3(ta, "userId", fa, A3(ta, "creationTime", zi, A3(ta, "description", Zr, A3(ta, "id", fa, sr(Qg))))), Xg = A3(ta, "cliTokens", Hi(Zg), sr(function(n) {
        return {
            eJ: n
        };
    })), nv = A7(yu, "GET", "/api/v1/auth/cli/tokens", g, g, g, gt, Xg), ev = function(n) {
        return A3(fl, n, nv, A2(Zc, Jg, yf));
    }, tv = F2(function(n) {
        return l({
            cA: Mr,
            aE: da
        }, ev(n));
    }), rv = function(n) {
        return {
            $: 0,
            a: n
        };
    }, av = F2(function(n, e) {
        var t = e.b, r = n(e.a);
        return l(r.a, Au(m([
            t,
            r.b
        ])));
    }), iv = F2(function(n, e) {
        return {
            $: 2,
            a: n,
            b: e
        };
    }), uv = F2(function(n, e) {
        var t = A2(Fi, function(n) {
            return 25 * n + 1;
        }, e.ch.gD);
        return A3(fl, n, Vg(e.ch.dA)(e.ch.co)(e.ch.br)(gt)(gt)(g)(gt)(gt)(gt)(t)(ht(25)), A2(cc, yf, iv(t)));
    }), cv = F2(function(n, e) {
        return A3(fl, n, Vg(e.ch.dA)(e.ch.co)(e.ch.br)(gt)(gt)(g)(gt)(gt)(gt)(gt)(ht(25)), A2(cc, yf, iv(gt)));
    }), ov = function(n) {
        return {
            $: 1,
            a: n
        };
    }, sv = F3(function(n, e, t) {
        return A7(yu, "GET", "/api/v1/site/{site}/account/{account}/project/{project}", m([
            l("site", n),
            l("account", e),
            l("project", t)
        ]), g, g, gt, Xd);
    }), fv = F2(function(n, e) {
        return A3(fl, n, A3(sv, e.ch.dA, e.ch.co, e.ch.br), A2(cc, yf, ov));
    }), lv = function(n) {
        return {
            $: 6,
            a: n
        };
    }, dv = function(n) {
        return m([
            A3(Tb, "enabled", Cb, n.be)
        ]);
    }, bv = A2(Zc, Nb, dv), hv = F2(function(n, e) {
        return A7(yu, "PATCH", "/api/v1/projects/{projectId}", m([
            l("projectId", n)
        ]), g, g, A2(Fi, Lb, ht(bv(e))), Xd);
    }), gv = function(n) {
        return 1 !== n.$;
    }, vv = function(n) {
        return {
            $: 0,
            a: n
        };
    }, pv = function(n) {
        return {
            $: 4,
            a: n
        };
    }, mv = function(n) {
        return m([
            A3(Pb, "description", Gb, n.v)
        ]);
    }, $v = A2(Zc, Nb, mv), yv = F2(function(n, e) {
        return {
            gi: n,
            by: e
        };
    }), wv = F4(function(n, e, t, r) {
        return {
            I: t,
            v: r,
            c: n,
            bo: e
        };
    }), kv = A3(ta, "description", Zr, A3(ta, "creationTime", zi, A3(ta, "ownerId", fa, A3(ta, "id", fa, sr(wv))))), xv = A3(ta, "token", Zr, A3(ta, "metadata", kv, sr(yv))), jv = F2(function(n, e) {
        return A7(yu, "POST", "/api/v1/accounts/{accountId}/clusterJoinTokens", m([
            l("accountId", n)
        ]), g, g, A2(Fi, Lb, ht($v(e))), xv);
    }), Av = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Cv = F2(function(n, e) {
        return {
            bh: n,
            dj: e
        };
    }), Iv = F3(function(n, e, t) {
        return {
            eC: e,
            cQ: t,
            ff: n
        };
    }), Tv = F6(function(n, e, t, r, a, i) {
        return {
            a$: i,
            I: t,
            a8: r,
            c: n,
            bw: e,
            dJ: a
        };
    }), Sv = A2(ur, function(n) {
        switch(n){
            case "Ready":
                return sr(0);
            case "Dispatched":
                return sr(1);
            case "Cancelling":
                return sr(2);
            case "Resetting":
                return sr(3);
            default:
                return Qr("Unknown type: " + n);
        }
    }, Zr), Dv = A4(Aa, "agentName", Zr, gt, A3(ta, "system", Zr, A4(Aa, "derivationPath", Zr, gt, A3(ta, "creationTime", zi, A3(ta, "state", Sv, A3(ta, "id", fa, sr(Tv))))))), Nv = F6(function(n, e, t, r, a, i) {
        return {
            a$: i,
            I: t,
            cQ: r,
            c: n,
            bw: e,
            dJ: a
        };
    }), Ev = A4(Aa, "agentName", Zr, gt, A3(ta, "system", Zr, A4(Aa, "effect", Og, gt, A3(ta, "creationTime", zi, A3(ta, "state", Sv, A3(ta, "id", fa, sr(Nv))))))), Lv = F5(function(n, e, t, r, a) {
        return {
            a$: a,
            I: t,
            c: n,
            as: r,
            bw: e
        };
    }), Bv = A4(Aa, "agentName", Zr, gt, A4(Aa, "job", Nd, gt, A3(ta, "creationTime", zi, A3(ta, "state", Sv, A3(ta, "id", fa, sr(Lv)))))), Ov = A4(Aa, "Effect", Ev, gt, A4(Aa, "Build", Dv, gt, A4(Aa, "Evaluation", Bv, gt, sr(Iv)))), Pv = A3(ta, "more", na, A3(ta, "items", Hi(Ov), sr(Cv))), Gv = function(n) {
        switch(n){
            case 0:
                return "Ready";
            case 1:
                return "Dispatched";
            case 2:
                return "Cancelling";
            default:
                return "Resetting";
        }
    }, Rv = F3(function(n, e, t) {
        return A7(yu, "GET", "/api/v1/accounts/{accountId}/default-cluster/tasks", m([
            l("accountId", n)
        ]), m([
            l("state", A2(Fi, Gv, e)),
            l("limit", A2(Fi, $t, t))
        ]), g, gt, Pv);
    }), zv = F2(function(n, e) {
        return A3(fl, n, A3(Rv, e.c, gt, gt), A2(cc, yf, Av));
    }), qv = F3(function(n, e, t) {
        switch(e.$){
            case 0:
                return l(b(t, {
                    a1: e.a
                }), Kc);
            case 1:
                return l(t, Au(A2(Ze, A3(Kh, n, t.co, vv), u(t.d9, Zf) ? m([
                    A2(zv, n, t.co)
                ]) : g)));
            case 2:
            case 6:
                return l(t, A2(Ll, n.iI, r = e.a));
            case 5:
                var r = e.b;
                return l(b(t, {
                    d9: e.a
                }), A2(Ll, n.iI, r));
            case 3:
                return l(t, A3(fl, n, A2(jv, t.co.c, {
                    v: "Generated for getting started"
                }), A2(cc, yf, pv)));
            case 4:
                return l(b(t, {
                    cs: e.a
                }), Kc);
            default:
                return l(b(t, {
                    dL: e.a
                }), Kc);
        }
    }), _v = F3(function(n, e, t) {
        switch(e.$){
            case 7:
                return l(t, A2(Ll, n.iI, e.a));
            case 0:
                return l(b(t, {
                    bn: A2(Os, function(n) {
                        return n.b && !n.b.b ? Es(n.a) : Ls(ro("Could not load account"));
                    }, e.a)
                }), Kc);
            case 1:
                return l(b(t, {
                    br: a = e.a
                }), Kc);
            case 2:
                var r = e.a, a = e.b;
                return l(b(t, {
                    dc: u(gv(r), gv(t.ch.gD)) ? a : t.dc,
                    bi: 1 === r.$ ? A2(Zb, t.bi, nd(a)) : t.bi
                }), Kc);
            case 3:
                return l(t, Au(m([
                    A2(uv, n, t)
                ])));
            case 4:
                var i = e.a.bE, c = e.a.bF, o = A2(Xi, i, t.hV);
                if (1 === o.$) return l(t, Kc);
                var s = A3(qv, n, c, o.a), f = s.a, d = s.b;
                return l(b(t, {
                    hV: A3(cu, i, function() {
                        return ht(f);
                    }, t.hV)
                }), A2(Qc, function(n) {
                    return cf({
                        bE: i,
                        bF: n
                    });
                }, d));
            case 5:
                var h = e.a.c, g = e.a.gG;
                return l(b(t, {
                    cb: Mr
                }), A3(fl, n, A2(hv, h, g), A2(Zc, lv, yf)));
            case 6:
                var v = e.a;
                return l(b(t, {
                    cb: A2(kf, function() {
                        return 0;
                    }, v),
                    br: Qb(v) ? v : t.br
                }), function(n) {
                    return A2(Fr, lr, Sr(n));
                }(of(Qa(0))));
            default:
                return l(b(t, {
                    bA: !t.bA
                }), Kc);
        }
    }), Hv = F2(function(n, e) {
        return A2(av, function(e) {
            return l(e, Au(h(m([
                A2(uv, n, e),
                A2(fv, n, e)
            ]), e.ch.gD.$ ? g : m([
                A2(cv, n, e)
            ]))));
        }, A2(av, function(t) {
            var r = A2(cl, n, e);
            return r.$ ? l(t, A3(ll, n, e, rv)) : A3(_v, n, rv(Es(m([
                r.a
            ]))), t);
        }, l({
            hV: da,
            dc: Mr,
            bi: gt,
            bn: Mr,
            cb: Bs,
            br: Mr,
            ch: e,
            bA: !1
        }, Kc)));
    }), Fv = {
        $: 0
    }, Uv = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Vv = F3(function(n, e, t) {
        return A7(yu, "GET", "/api/v1/projects", g, m([
            l("site", A2(Fi, lr, n)),
            l("account", A2(Fi, lr, e)),
            l("project", A2(Fi, lr, t))
        ]), g, gt, Hi(Xd));
    }), Wv = F2(function(n, e) {
        return A3(fl, n, A3(Vv, ht(e.ch.dA), ht(e.ch.co), ht(e.ch.br)), A2(Zc, Uv, yf));
    }), Yv = F2(function(n, e) {
        var t = {
            cd: Mr,
            ch: e,
            bx: A2(Yh, Mr, Bs),
            z: Fv
        };
        return l(t, Au(m([
            A2(Wv, n, t)
        ])));
    }), Mv = F2(function(n, e) {
        return {
            $: 12,
            a: n,
            b: e
        };
    }), Kv = function(n) {
        return {
            $: 13,
            a: n
        };
    }, Jv = F3(function(n, e, t) {
        var r = function(e) {
            var r = A2(Sh, n, t(e)), a = r.b;
            return l(Df(r.a), A2(Qc, ys, a));
        }, a = A2(rl, n, e.co);
        return 1 === a.$ ? l(A2(Mv, e.co, r), A3(fl, n, A2(wu, ht(e.dA), ht(e.co)), A2(cc, yf, Kv))) : r(a.a);
    }), Qv = F2(function(n, e) {
        var t, r, a = n.hD;
        if (a.$) {
            var i = a.a;
            switch(e.$){
                case 22:
                    return l(Kf, Kc);
                case 0:
                    var u = A2(Sh, n, Mf);
                    return $ = u.b, l(Df(u.a), A2(Qc, ys, $));
                case 11:
                    return function(n) {
                        var e = n.b;
                        return l(Ff(n.a), A2(Qc, Ss, e));
                    }(A2(Yv, n, y = e.a));
                case 1:
                    return A3(Jv, n, y = e.a, function(n) {
                        return A2(Vf, n, Jf);
                    });
                case 2:
                    return function(n) {
                        var e = n.b;
                        return l(Cf(n.a), A2(Qc, Af, e));
                    }(A2(rh, n, y = e.a));
                case 3:
                    return function(n) {
                        var e = n.b;
                        return l(jf(n.a), A2(Qc, vs, e));
                    }(A2(ib, n, y = e.a));
                case 4:
                    return A3(Jv, n, y = e.a, function(n) {
                        return A2(Vf, n, Zf);
                    });
                case 5:
                    return function(n) {
                        var e = n.b;
                        return l(If(n.a), A2(Qc, ps, e));
                    }(A2(bh, n, y = e.a));
                case 10:
                    return function(n) {
                        var e = n.b;
                        return l(Hf(n.a), A2(Qc, Ts, e));
                    }(A2(Hv, n, y = e.a));
                case 6:
                    return A3(Jv, n, y = e.a, function(n) {
                        return A2(Vf, n, Yf);
                    });
                case 7:
                    return A3(Jv, n, y = e.a, function(n) {
                        return A2(Vf, n, el);
                    });
                case 8:
                    return A3(Jv, n, y = e.a, function(n) {
                        return A2(Vf, n, Wf(y.bw));
                    });
                case 9:
                    var c = A2(xh, n, y = e.a);
                    return $ = c.b, l(Sf(c.a), A2(Qc, $s, $));
                case 13:
                    var o = A2(Zh, n, y = e.a);
                    return $ = o.b, l(Gf(o.a), A2(Qc, Is, $));
                case 15:
                    var s = A2(cg, n, y = e.a);
                    return $ = s.b, l(Bf(s.a), A2(Qc, js, $));
                case 16:
                    var f = A2(_g, n, y = e.a);
                    return $ = f.b, l(Of(f.a), A2(Qc, As, $));
                case 14:
                    var d = A2(Yg, n, y = e.a);
                    return $ = d.b, l(Pf(d.a), A2(Qc, Cs, $));
                case 17:
                    y = e.a;
                    var b = A2(nc, rl(n), y.co);
                    if (1 === b.$) return l(Kf, Kc);
                    var h = A2($h, n, b.a);
                    return $ = h.b, l(Tf(h.a), A2(Qc, ms, $));
                case 23:
                    return l(Xf, Kc);
                case 18:
                    var g = A2(tv, n, i);
                    return $ = g.b, l(_f(g.a), A2(Qc, qf, $));
                case 19:
                    var v = A2(Kg, n, i);
                    return $ = v.b, l(zf(v.a), A2(Qc, Rf, $));
                case 12:
                    var p = A2(Vh, n, y = e.a);
                    return $ = p.b, l(Lf(p.a), A2(Qc, xs, $));
                case 20:
                    return function(n) {
                        var e = n.b;
                        return l(Ef(n.a), A2(Qc, ks, e));
                    }(A2(zh, n, y = e.a));
                case 21:
                    return function(n) {
                        var e = n.b;
                        return l(Nf(n.a), A2(Qc, ws, e));
                    }(A2(Oh, n, y = e.a));
                default:
                    return l(Qf(y = e.a), Kc);
            }
        } else switch(e.$){
            case 22:
                return l(Kf, Kc);
            case 23:
                return l(Xf, Kc);
            case 1:
                return A3(Jv, n, y = e.a, function(n) {
                    return A2(Vf, n, Jf);
                });
            case 3:
                return r = (t = A2(ib, n, y = e.a)).b, l(jf(t.a), A2(Qc, vs, r));
            case 10:
                return function(n) {
                    var e = n.b;
                    return l(Hf(n.a), A2(Qc, Ts, e));
                }(A2(Hv, n, y = e.a));
            case 11:
                return function(n) {
                    var e = n.b;
                    return l(Ff(n.a), A2(Qc, Ss, e));
                }(A2(Yv, n, y = e.a));
            case 13:
                var m = A2(Zh, n, y = e.a), $ = m.b;
                return l(Gf(m.a), A2(Qc, Is, $));
            case 14:
                return function(n) {
                    var e = n.b;
                    return l(Pf(n.a), A2(Qc, Cs, e));
                }(A2(Yg, n, y = e.a));
            case 16:
                return function(n) {
                    var e = n.b;
                    return l(Of(n.a), A2(Qc, As, e));
                }(A2(_g, n, y = e.a));
            case 20:
                return function(n) {
                    var e = n.b;
                    return l(Ef(n.a), A2(Qc, ks, e));
                }(A2(zh, n, y = e.a));
            case 21:
                return function(n) {
                    var e = n.b;
                    return l(Nf(n.a), A2(Qc, ws, e));
                }(A2(Oh, n, y = e.a));
            case 24:
                var y;
                return l(Qf(y = e.a), Kc);
            default:
                return l(Qf({
                    gW: ht(El(e))
                }), Kc);
        }
    }), Zv = F2(function(n, e) {
        var t = l(n, e);
        n: for(;;)switch(t.a.$){
            case 6:
                switch(t.b.$){
                    case 7:
                    case 1:
                        return u((r = t.a.a).dA, (a = t.b.a).dA) && u(r.co, a.co);
                    default:
                        break n;
                }
            case 7:
                switch(t.b.$){
                    case 6:
                    case 1:
                        return u((r = t.a.a).dA, (a = t.b.a).dA) && u(r.co, a.co);
                    default:
                        break n;
                }
            case 8:
                switch(t.b.$){
                    case 8:
                    case 1:
                    case 6:
                        return u((r = t.a.a).dA, (a = t.b.a).dA) && u(r.co, a.co);
                    default:
                        break n;
                }
            case 1:
                if (6 === t.b.$) return u((r = t.a.a).dA, (a = t.b.a).dA) && u(r.co, a.co);
                break n;
            case 3:
                var r, a;
                if (3 === t.b.$) return u((r = t.a.a).dA, (a = t.b.a).dA) && u(r.co, a.co) && u(r.a8, a.a8) && u(r.dQ, a.dQ) && u(r.eY, a.eY);
                break n;
            default:
                break n;
        }
        return !1;
    }), Xv = function(n) {
        return {
            $: 2,
            a: n
        };
    }, np = function(n) {
        return {
            $: 4,
            a: n
        };
    }, ep = F2(function(n, e) {
        return {
            $: 6,
            a: n,
            b: e
        };
    }), tp = F2(function(n, e) {
        return A7(yu, "POST", "/api/v1/api/organizations/{organizationId}/accounts/{accountId}", m([
            l("organizationId", n),
            l("accountId", e)
        ]), g, g, gt, sr(0));
    }), rp = F2(function(n, e) {
        return {
            gT: e,
            hB: n
        };
    }), ap = A3(ta, "productId", Oo, A3(ta, "url", Zr, sr(rp))), ip = A2(cc, gl, Gb), up = function(n) {
        return m([
            A3(Pb, "displayName", Gb, n.k),
            A3(Pb, "primaryAccountId", ip, n.gN)
        ]);
    }, cp = A2(Zc, Nb, up), op = on, sp = function(n) {
        return Ln(n), xn[n] = {
            e: Bn,
            r: function(n) {
                return Db(m([
                    l("passthrough", Gb(n.gF)),
                    l("paymentLink", Gb(n.gH)),
                    l("product", op(n.gS))
                ]));
            },
            a: On
        }, Tn(n);
    }("paddleSubscribe"), fp = F3(function(n, e, t) {
        switch(e.$){
            case 0:
                return l(b(t, {
                    ca: a = e.a
                }), Kc);
            case 8:
                return l(b(t, {
                    n: e.a
                }), Kc);
            case 1:
                var r = e.a;
                return 3 > gr(r.k) ? l(b(t, {
                    bP: A2(Yb, ro("Name should have at least 3 characters"), gt)
                }), Kc) : l(t, A3(fl, n, A7(yu, "POST", "/api/v1/api/organizations", g, g, g, A2(Fi, Lb, ht(cp(r))), qi), A2(cc, yf, Xv)));
            case 3:
                return l(t, A3(fl, n, A2(tp, e.a, e.b), A2(cc, yf, np)));
            case 2:
                return l(b(t, {
                    bP: a = e.a
                }), Qb(a) ? Xb : Kc);
            case 4:
                var a;
                return l(b(t, {
                    cD: a = e.a
                }), Qb(a) ? Xb : Kc);
            case 5:
                var i = e.a;
                return l(b(t, {
                    gH: Mr
                }), A3(fl, n, A7(yu, "POST", "/api/v1/api/organizations/{organizationId}/paymentLink", m([
                    l("organizationId", i.c)
                ]), g, g, gt, ap), A2(cc, yf, ep(i))));
            case 6:
                i = e.a;
                var u = e.b, c = function() {
                    if (3 === u.$) {
                        var n = u.a;
                        return sp({
                            gF: i.c,
                            gH: n.hB,
                            gS: n.gT
                        });
                    }
                    return Kc;
                }();
                return l(b(t, {
                    gH: u
                }), c);
            case 7:
                return l(b(t, {
                    dH: !0
                }), Kc);
            default:
                return l(b(t, {
                    cx: e.a
                }), Kc);
        }
    }), lp = function(n) {
        return {
            $: 4,
            a: n
        };
    }, dp = F3(function(n, e, t) {
        switch(e.$){
            case 0:
                return l(b(t, {
                    bO: !t.bO
                }), Kc);
            case 2:
                return l(b(t, {
                    a6: Mr
                }), A3(fl, n, A7(yu, "POST", "/api/v1/auth/cli/authorization/request/{browserToken}/confirm", m([
                    l("browserToken", t.ch.ga)
                ]), g, g, gt, sr(0)), A2(Zc, lp, yf)));
            case 1:
                return l(t, A2(Ll, n.iI, _u));
            case 3:
                return l(b(t, {
                    cu: e.a
                }), Kc);
            default:
                return l(b(t, {
                    a6: e.a
                }), Kc);
        }
    }), bp = F4(function(n, e, t, r) {
        return l({
            co: e,
            cs: Bs,
            a1: Mr,
            dA: e.hf,
            d9: t,
            dL: Bs,
            ed: r
        }, Au(A2(Ze, A3(Kh, n, e, vv), u(t, Zf) ? m([
            A2(zv, n, e)
        ]) : g)));
    }), hp = F3(function(n, e, t) {
        switch(e.$){
            case 3:
                return l(t, A2(Ll, n.iI, e.a));
            case 0:
                var r = e.b;
                if (!u(e.a, n.ch)) return l(t, Kc);
                switch(r.$){
                    case 3:
                        var a = r.a, i = function(e) {
                            var r = function() {
                                var r = A2(Xi, e.c, t.hV);
                                if (1 === r.$) {
                                    var a = t.bC;
                                    return a.$ ? A4(bp, n, e, a.b, 0) : A4(bp, n, e, Jf, 1);
                                }
                                return l(r.a, Kc);
                            }();
                            return d(e.c, r.a, r.b);
                        }, c = ma(A2(Lr, function(n) {
                            return l(n.c, g);
                        }, n.hV)), o = A3(Er, F2(function(n, e) {
                            var t, r = (t = A2(Xi, n.br.bo, e)).$ ? g : t.a;
                            return A3(pa, n.br.bo, A2(Ze, n, r), e);
                        }), c, a), s = (k = t.bC).$ ? m([
                            k.a
                        ]) : n.hV;
                        return l(b(t, {
                            hV: A3(Er, function(n) {
                                return A2(pa, n.a, n.b);
                            }, da, w = A2(Lr, i, s)),
                            aR: Es(o)
                        }), Au(A2(Lr, function(n) {
                            var e = n.a;
                            return A2(Qc, function(n) {
                                return Fs({
                                    bE: e,
                                    bF: n
                                });
                            }, n.c);
                        }, w)));
                    case 2:
                        return l(b(t, {
                            aR: Ls(r.a)
                        }), Kc);
                    case 0:
                        return l(b(t, {
                            aR: Bs
                        }), Kc);
                    default:
                        return l(b(t, {
                            aR: Mr
                        }), Kc);
                }
            case 1:
                return l(t, A2(Th, n, t));
            default:
                var f = e.a.bE, h = e.a.bF, v = A2(Xi, f, t.hV);
                if (1 === v.$) return l(t, Kc);
                var p = A3(qv, n, h, v.a), $ = p.a, y = p.b;
                return l(b(t, {
                    hV: A3(cu, f, function() {
                        return ht($);
                    }, t.hV)
                }), A2(Qc, function(n) {
                    return Fs({
                        bE: f,
                        bF: n
                    });
                }, y));
        }
        var w, k;
    }), gp = function(n) {
        return {
            $: 3,
            a: n
        };
    }, vp = function(n) {
        return {
            $: 1,
            a: n
        };
    }, pp = function(n) {
        return m([
            A3(Tb, "name", Gb, n.n),
            A3(Tb, "displayName", Gb, n.k)
        ]);
    }, mp = A2(Zc, Nb, pp), $p = F2(function(n, e) {
        return A7(yu, "PATCH", "/api/v1/gitlab/installation/{installationId}", m([
            l("installationId", n)
        ]), g, g, A2(Fi, Lb, ht(mp(e))), Bh);
    }), yp = F2(function(n, e) {
        return A3(fl, n, A2($p, e.ch.c6, {
            k: ht(e.k),
            n: ht(e.n)
        }), A2(Zc, vp, yf));
    }), wp = F2(function(n, e) {
        return u(e.n, n.n) && u(e.k, n.k);
    }), kp = F2(function(n, e) {
        return function(n) {
            var e = n.aq;
            switch(e.$){
                case 3:
                    return !A2(wp, n, e.a);
                case 2:
                default:
                    return !1;
                case 0:
                    var t = n.ac;
                    return 3 === t.$ && !A2(wp, n, t.a);
            }
        }(e) ? l(b(e, {
            aq: Mr
        }), A2(yp, n, e)) : l(e, Kc);
    }), xp = F3(function(n, e, t) {
        switch(e.$){
            case 0:
                return l(b(t, 3 === e.a.$ ? {
                    k: (a = e.a.a).k,
                    ac: Es(a),
                    n: a.n
                } : {
                    ac: a = e.a
                }), Kc);
            case 1:
                if (3 === e.a.$) {
                    var r = b(t, {
                        ac: Es(a = e.a.a),
                        aq: Es(a)
                    });
                    return A2(kp, n, r);
                }
                return r = b(t, {
                    aq: a = e.a
                }), A2(kp, n, r);
            case 2:
                return l(b(t, {
                    bU: Mr
                }), A3(fl, n, A7(yu, "DELETE", "/api/v1/gitlab/installation/{installationId}", m([
                    l("installationId", t.ch.c6)
                ]), g, g, gt, sr(0)), A2(Zc, gp, yf)));
            case 4:
                if (e.a) return r = b(t, {
                    k: e.b
                }), A2(kp, n, r);
                r = b(t, {
                    n: e.b
                });
                return A2(kp, n, r);
            case 3:
                var a;
                return l(b(t, {
                    bU: a = e.a
                }), Kc);
            default:
                return l(b(t, {
                    aq: Mr
                }), A2(yp, n, t));
        }
    }), jp = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Ap = function(n) {
        return m([
            A3(Pb, "gitlabURL", Gb, n.c$),
            A3(Pb, "gitlabAdminUsername", Gb, n.fA),
            A3(Pb, "gitlabAdminPassword", Gb, n.fz)
        ]);
    }, Cp = A2(Zc, Nb, Ap), Ip = F2(function(n, e) {
        var t = A2(ao, n, e);
        return t.$ ? ct(ro(Pt(t.a))) : lt(t.a);
    }), Tp = F2(function(n, e) {
        if ($r(e)) {
            var t = A2(ao, n, "{}");
            return t.$ ? A2(Ip, n, e) : lt(t.a);
        }
        return A2(Ip, n, e);
    }), Sp = F2(function(n, e) {
        return e.$ ? ct(e.a) : lt(n(e.a));
    }), Dp = F2(function(n, e) {
        switch(e.$){
            case 0:
                return ct(no(e.a));
            case 1:
                return ct(to);
            case 2:
                return ct(eo);
            case 3:
                return ct(Xc(e.a.jD));
            default:
                return A2(n, e.a, e.b);
        }
    }), Np = A2(co, function(n) {
        return n.a;
    }, lt), Ep = F2(function(n, e) {
        var t, r, a, i, u, c, o;
        return A2(Qc, A2(Zc, jp, yf), (t = {
            i7: function(n) {
                if (3 === n.$) {
                    var e = n.b;
                    return 400 === n.a.jD ? ht(A2(Sp, ct, A2(Tp, A2(Ur, "message", Zr), e))) : gt;
                }
                return gt;
            },
            ja: function(n) {
                return lt(n);
            },
            jo: (o = {
                fz: e.aQ,
                fA: e.aW,
                c$: e.c$
            }, A7(yu, "POST", "/api/v1/gitlab/installation", g, g, g, A2(Fi, Lb, ht(Cp(o))), Bh)),
            jz: n
        }, i = t.i7, u = t.ja, c = a = t.jo, A2(Qc, function(n) {
            var e = i(n);
            return e.$ ? A2(Sp, u, A2(Dp, F2(function(n, e) {
                return A2(Tp, c.bR, e);
            }), n)) : e.a;
        }, To({
            aD: (r = A2(Eo, t.jz.cY.hZ, a)).aD,
            ip: Np,
            M: r.M,
            aO: r.aO,
            ay: r.ay,
            bz: r.bz,
            hB: A3(bo, r.a3, r.cc, r.ce)
        }))));
    }), Lp = F3(function(n, e, t) {
        return {
            c$: n,
            aQ: t,
            aW: e
        };
    }), Bp = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), Op = Bp, Pp = F2(function(n, e) {
        var t = e.b;
        return A2(Op, n(e.a), A2(Lr, n, t));
    }), Gp = F4(function(n, e, t, r) {
        return A2(Zc, A2(Zc, A2(Zc, oo(Pp(e)), Sp(t)), r), n);
    }), Rp = function(n) {
        return A2(Gp, n, lr);
    }, zp = function(n) {
        return A2(Rp, n, lr);
    }, qp = function(n) {
        return A2(Ze, n.a, n.b);
    }, _p = F2(function(n, e) {
        return A2(cc, qp, A2(Er, n, e));
    }), Hp = F2(function(n, e) {
        var t = F2(function(n, e) {
            return A2(Op, n, qp(e));
        });
        return A3(_p, t, e, n);
    }), Fp = F4(function(n, e, t, r) {
        var a = e(r);
        if (1 === a.$) {
            var i = a.a, u = t(r);
            return ct(1 === u.$ ? A2(Hp, i, u.a) : i);
        }
        var c = a.a, o = t(r);
        return 1 === o.$ ? ct(o.a) : lt(A2(n, c, o.a));
    }), Up = F2(function(n, e) {
        return A2(Fp, Yt, A2(zp, n, e));
    }), Vp = function(n) {
        return A3(Gp, lr, n, lr);
    }, Wp = function(n) {
        return A2(Op, n, g);
    }, Yp = A2(Zc, ct, Wp), Mp = lt, Kp = F4(function(n, e, t, r) {
        return n(r) ? Mp(t(r)) : Yp(e);
    }), Jp = A3(Kp, A2(Zc, xi, $r), 0, lr), Qp = A2(Zc, Ha, lt), Zp = (Qo = function(n) {
        return Vp(function(e) {
            return l(n, e);
        });
    }, Zo = function(n) {
        return "https://" === n || "http://" === n ? ct(Wp("please enter a valid URL")) : A2(Cr, "https://", n) || A2(Cr, "http://", n) ? lt(n) : ct(Wp("please enter a URL that starts with http:// or https://"));
    }, Xo = A2(Vp, function() {
        return "must not be empty";
    }, Jp), A3(Up, function(n) {
        return n.aQ;
    }, A2(Qo, "GitLab Admin Password", Xo), A3(Up, function(n) {
        return n.aW;
    }, A2(Qo, "GitLab Admin Username", Xo), A3(Up, function(n) {
        return n.c$;
    }, A2(Qo, "GitLab URL", Zo), Qp(Lp))))), Xp = F3(function(n, e, t) {
        switch(e.$){
            case 0:
                return l(t, Kc);
            case 1:
                switch(e.a){
                    case 0:
                        return l(b(t, {
                            c$: e.b
                        }), Kc);
                    case 1:
                        return l(b(t, {
                            aW: e.b
                        }), Kc);
                    default:
                        return l(b(t, {
                            aQ: e.b
                        }), Kc);
                }
            case 2:
                var r = Zp(t);
                if (r.$) return l(b(t, {
                    aA: !0
                }), Kc);
                var a = r.a;
                return l(b(t, {
                    c4: Mr,
                    aA: !1
                }), A2(Ep, n, a));
            case 3:
                return l(b(t, {
                    c4: i = e.a
                }), 3 !== i.$ || i.a.$ ? Kc : A2(Ll, n.iI, Hu({
                    c6: i.a.a.c
                })));
            default:
                var i;
                return l(b(t, {
                    c5: i = e.a
                }), Kc);
        }
    }), nm = function(n) {
        var e;
        return n.fY || !(e = n.g9).$ && e.a >= 120;
    }, em = Ae, tm = F2(function(n, e) {
        return A2(em, n, El(e));
    }), rm = function(n) {
        return Eu({
            co: n.ax,
            dA: n.hf
        });
    }, am = F3(function(n, e, t) {
        switch(e.$){
            case 0:
                var r = e.a;
                return l(b(t, {
                    aU: A2(Yl, t.aU, r)
                }), function() {
                    if (3 === r.$) {
                        var e = r.a;
                        if (nm(e)) return Kc;
                        var t = e.co;
                        return t.$ ? Kc : A2(tm, n.iI, rm(t.a));
                    }
                    return Kc;
                }());
            case 1:
                return l(t, A2(Uh, n, t));
            default:
                var a = t.aU.ie;
                return 3 === a.$ && nm(a.a) ? l(t, Kc) : l(t, A2(Ll, n.iI, _u));
        }
    }), im = function(n) {
        return {
            $: 14,
            a: n
        };
    }, um = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), cm = function(n) {
        return {
            $: 5,
            a: n
        };
    }, om = function(n) {
        return {
            $: 2,
            a: n
        };
    }, sm = {
        $: 20
    }, fm = function(n) {
        return {
            $: 12,
            a: n
        };
    }, lm = function(n) {
        return {
            $: 9,
            a: n
        };
    }, dm = F2(function(n, e) {
        var t = e.b, r = n(e.a);
        return l(r.a, Au(m([
            t,
            r.b
        ])));
    }), bm = F2(function(n, e) {
        return {
            a7: n,
            fo: e
        };
    }), hm = F2(function(n, e) {
        return {
            a8: e,
            V: n
        };
    }), gm = A3(ta, "derivationPath", Zr, A3(ta, "status", zd, sr(hm))), vm = A3(ta, "failedDependencies", Hi(Zr), A3(ta, "derivation", gm, sr(bm))), pm = A3(ta, "nodes", Hi(vm), sr(function(n) {
        return {
            gt: n
        };
    })), mm = F2(function(n, e) {
        return {
            bq: n,
            bs: e
        };
    }), $m = A3(ta, "requiredSystemFeatures", Hi(Zr), A3(ta, "platform", Zr, sr(mm))), ym = F3(function(n, e, t) {
        return {
            bp: n,
            W: t,
            bB: e
        };
    }), wm = A2(ur, function(n) {
        switch(n){
            case "Regular":
                return sr(0);
            case "MustFail":
                return sr(1);
            case "MayFail":
                return sr(2);
            case "DependenciesOnly":
                return sr(3);
            case "Effect":
                return sr(4);
            default:
                return Qr("Unknown type: " + n);
        }
    }, Zr), km = F2(function(n, e) {
        return {
            e9: e,
            gx: n
        };
    }), xm = F4(function(n, e, t, r) {
        return {
            fa: t,
            fb: n,
            fd: e,
            hx: r
        };
    }), jm = A4(Aa, "trace", Zr, gt, A4(Aa, "errorDerivation", Zr, gt, A4(Aa, "errorType", Zr, gt, A3(ta, "errorMessage", Zr, sr(xm))))), Am = A4(Aa, "Error", jm, gt, A4(Aa, "Ok", gm, gt, sr(km))), Cm = A3(ta, "typ", wm, A3(ta, "value", Am, A3(ta, "path", Hi(Zr), sr(ym)))), Im = F3(function(n, e, t) {
        return {
            a7: e,
            ab: n,
            af: t
        };
    }), Tm = A3(ta, "outputName", Zr, A3(ta, "derivation", gm, A3(ta, "index", Oo, sr(Im)))), Sm = F3(function(n, e, t) {
        return {
            bp: n,
            W: t,
            bB: e
        };
    }), Dm = A3(ta, "typ", wm, A3(ta, "value", gm, A3(ta, "path", Hi(Zr), sr(Sm)))), Nm = F3(function(n, e, t) {
        return {
            ab: n,
            bl: t,
            W: e
        };
    }), Em = A2(ur, function(n) {
        switch(n){
            case "Error":
                return sr(0);
            case "Trace":
                return sr(1);
            default:
                return Qr("Unknown type: " + n);
        }
    }, Zr), Lm = A3(ta, "message", Zr, A3(ta, "typ", Em, A3(ta, "index", Oo, sr(Nm)))), Bm = A3(ta, "unmetAgentRequirements", Hi($m), A3(ta, "derivationsCancelledCount", Oo, A3(ta, "derivationsBuildSuccessCount", Oo, A3(ta, "derivationsDependencyFailureCount", Oo, A3(ta, "derivationsBuildFailureCount", Oo, A3(ta, "derivationsBuildingCount", Oo, A3(ta, "derivationsWaitingCount", Oo, A3(ta, "derivations", $a(zd), A4(Aa, "evaluationLog", fa, gt, A3(ta, "evaluationDependencies", Hi(Tm), A3(ta, "ifdAttributes", Hi(Dm), A3(ta, "attributes", Hi(Cm), A3(ta, "messages", Hi(Lm), A3(ta, "agentVersion", Zr, A3(ta, "agentHostname", Zr, A3(ta, "id", fa, sr(function(n) {
        return function(e) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return function(i) {
                            return function(u) {
                                return function(c) {
                                    return function(o) {
                                        return function(s) {
                                            return function(f) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(h) {
                                                                return function(g) {
                                                                    return {
                                                                        a_: e,
                                                                        a0: t,
                                                                        ct: a,
                                                                        eZ: o,
                                                                        e_: l,
                                                                        e$: b,
                                                                        e0: f,
                                                                        e1: h,
                                                                        e2: d,
                                                                        e3: s,
                                                                        fg: u,
                                                                        fi: c,
                                                                        c: n,
                                                                        fO: i,
                                                                        gh: r,
                                                                        hz: g
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))), Om = F3(function(n, e, t) {
        return {
            db: n,
            gy: e,
            gz: t
        };
    }), Pm = F2(function(n, e) {
        return {
            c8: e,
            n: n
        };
    }), Gm = A3(ta, "isFlake", na, A3(ta, "name", Zr, sr(Pm))), Rm = F4(function(n, e, t, r) {
        return {
            c8: e,
            gb: r,
            n: n,
            hP: t
        };
    }), zm = F4(function(n, e, t, r) {
        return {
            eU: r,
            eV: t,
            fL: e,
            gj: n
        };
    }), qm = A2(ur, function(n) {
        switch(n){
            case "Mon":
                return sr(0);
            case "Tue":
                return sr(1);
            case "Wed":
                return sr(2);
            case "Thu":
                return sr(3);
            case "Fri":
                return sr(4);
            case "Sat":
                return sr(5);
            case "Sun":
                return sr(6);
            default:
                return Qr("Unknown type: " + n);
        }
    }, Zr), _m = A4(Aa, "dayOfMonth", Hi(Oo), gt, A4(Aa, "dayOfWeek", Hi(qm), gt, A3(ta, "hour", Hi(Oo), A3(ta, "minute", Oo, sr(zm))))), Hm = A3(ta, "mainExists", na, A3(ta, "when", _m, A3(ta, "isFlake", na, A3(ta, "name", Zr, sr(Rm))))), Fm = A3(ta, "onSchedule", $a(Hm), A3(ta, "onPush", $a(Gm), A3(ta, "jobId", fa, sr(Om)))), Um = F2(function(n, e) {
        return A7(yu, "POST", "/api/v1/jobs/{jobId}/on-schedule/{jobName}/run", m([
            l("jobId", n),
            l("jobName", e)
        ]), g, g, gt, Zd);
    }), Vm = F2(function(n, e) {
        return A7(yu, "POST", "/api/v1/jobs/{jobId}/rerun", m([
            l("jobId", n)
        ]), m([
            l("rebuildFailures", A2(Fi, function(n) {
                return n ? "true" : "false";
            }, e))
        ]), g, gt, Zd);
    }), Wm = F2(function(n, e) {
        var t = A2(Fi, n, e);
        return !t.$ && t.a ? e : gt;
    }), Ym = F2(function(n, e) {
        return A3(pa, n, 0, e);
    }), Mm = function(n) {
        return A2(Fi, function(n) {
            return n.b;
        }, nd(n.as.ie));
    }, Km = function(n) {
        return 1 === n.$;
    }, Jm = F2(function(n, e) {
        return function(n) {
            return !Km(n.ao);
        }(n) ? l(b(n, {
            ao: Mr
        }), e) : l(n, Kc);
    }), Qm = F2(function(n, e) {
        return A2(uu, n, e);
    }), Zm = F2(function(n, e) {
        return {
            $: 19,
            a: n,
            b: e
        };
    }), Xm = function(n) {
        switch(n){
            case 0:
                return "Error";
            case 1:
                return "Warn";
            case 2:
                return "Notice";
            case 3:
                return "Info";
            case 4:
                return "Talkative";
            case 5:
                return "Chatty";
            case 6:
                return "Debug";
            default:
                return "Vomit";
        }
    }, n$ = F4(function(n, e, t, r) {
        return A7(yu, "GET", "/api/v1/jobs/{jobId}/evaluation/log/lines", m([
            l("jobId", n)
        ]), m([
            l("logId", ht(e)),
            l("iMin", A2(Fi, $t, t)),
            l("verbosity", A2(Fi, Xm, r))
        ]), g, gt, yl);
    }), e$ = F2(function(n, e) {
        var t = e.as.ie;
        if (3 === t.$) {
            var r = t.a, a = r.b;
            return l(e, Au(A2(Lr, function(t) {
                return A3(fl, n, A4(n$, a.c, t, e.aF ? function(n) {
                    return 3 === n.$ ? A2(Fi, function(n) {
                        return n.fM;
                    }, Ml(n.a.f8)) : gt;
                }(e.ak) : gt, ht(e.aG)), A2(cc, yf, Zm(e.aG)));
            }, Dl(r.c.fi))));
        }
        return l(e, Kc);
    }), t$ = F2(function(n, e) {
        if (3 === n.$) {
            var t = n.a;
            return Es(3 === e.$ ? A2(Kl, e.a, t) : t);
        }
        return 1 === e.$ ? n : e;
    }), r$ = F3(function(n, e, t) {
        switch(e.$){
            case 0:
                return l(t, A2(Ll, n.iI, e.a));
            case 1:
                var r = e.b, a = (s = e.a).dc;
                if (a.b) {
                    var i = a.a;
                    return A2(dm, function(e) {
                        return i.f1 ? l(b(e, {
                            at: Bs
                        }), Kc) : l(b(e, {
                            at: e.at.$ ? e.at : Mr
                        }), A3(fl, n, A7(yu, "GET", "/api/v1/jobs/{jobId}/handlers", m([
                            l("jobId", i.c)
                        ]), g, g, gt, Fm), A2(cc, yf, om)));
                    }, A2(dm, function(e) {
                        return function(n) {
                            return 3 === n.$ && n.a.e5;
                        }(e.ak) ? l(e, Kc) : A2(e$, n, e);
                    }, l(b(t, {
                        as: A2(Yl, t.as, A2(kf, function(n) {
                            return d(s.br, i, n);
                        }, yf(r)))
                    }), Kc)));
                }
                return l(t, Kc);
            case 2:
                return l(b(t, {
                    at: e.a
                }), Kc);
            case 5:
                var c = function(n) {
                    return ma(A2(Lr, function(n) {
                        return l(n.a7.a8, l(n.a7, n.fo));
                    }, n.gt));
                };
                return l(b(t, {
                    aH: A2(Yl, t.aH, A2(kf, c, e.a))
                }), Kc);
            case 8:
                return l(t, A3(fl, n, A2(xl, e.a.bE, pu(e.a.a8)), lm));
            case 6:
                return l(b(t, {
                    aa: A2(Ym, e.a.bp, t.aa)
                }), Kc);
            case 7:
                return l(b(t, {
                    aa: A2(Qm, e.a.bp, t.aa)
                }), Kc);
            case 9:
            default:
                return l(t, Kc);
            case 4:
                var o = A2(Xl, g, yf(r = e.a));
                if (o.b) {
                    var s, f = (s = o.a).dc;
                    if (f.b) {
                        var h = f.a, v = A2(Jm, t.as, A3(fl, n, A7(yu, "GET", "/api/v1/jobs/{jobId}/evaluation", m([
                            l("jobId", h.c)
                        ]), g, g, gt, Bm), um(s))), p = (i = v.a, v.b), $ = A2(Jm, t.aH, A3(fl, n, A7(yu, "GET", "/api/v1/jobs/{jobId}/derivations/failed", m([
                            l("jobId", h.c)
                        ]), g, g, gt, pm), A2(cc, yf, cm))), y = $.b;
                        return l(b(t, {
                            aH: $.a,
                            as: i
                        }), Au(m([
                            p,
                            y
                        ])));
                    }
                    return l(b(t, {
                        as: A2(Yl, t.as, Ls(no("No such job number exists")))
                    }), Kc);
                }
                return l(b(t, {
                    as: A2(Yl, t.as, Ls(no("No such repository exists")))
                }), Kc);
            case 3:
                return l(b(t, {
                    a1: e.a
                }), Kc);
            case 10:
                return l(t, A2(Qh, n, t));
            case 11:
                var w = Mm(t);
                return w.$ ? l(t, Kc) : (i = w.a, l(b(t, {
                    bt: Mr
                }), A3(fl, n, A2(Vm, i.c, ht(!0)), A2(cc, yf, fm))));
            case 12:
                var k = l(b(t, {
                    bt: D = e.a
                }), Kc);
                if (3 === D.$) {
                    var x = D.a, j = t.as.ie;
                    if (3 === j.$) {
                        var A = j.a.a;
                        return l(b(t, {
                            as: ol,
                            bt: D
                        }), A2(Ll, n.iI, Uu({
                            co: t.H,
                            ab: x.ab,
                            br: A.ax,
                            dA: t.dB
                        })));
                    }
                    return k;
                }
                return k;
            case 15:
                var C = e.a, I = Mm(t);
                return I.$ ? l(t, Kc) : (i = I.a, l(b(t, {
                    bu: Mr
                }), A3(fl, n, A2(Um, i.c, C), A2(cc, yf, fm))));
            case 16:
                if (k = l(b(t, {
                    bu: D = e.a
                }), Kc), 3 === D.$) {
                    x = D.a;
                    var T = t.as.ie;
                    return 3 === T.$ ? (A = T.a.a, l(b(t, {
                        bu: D
                    }), A2(Ll, n.iI, Uu({
                        co: t.H,
                        ab: x.ab,
                        br: A.ax,
                        dA: t.dB
                    })))) : k;
                }
                return k;
            case 13:
                var S = Mm(t);
                return S.$ ? l(t, Kc) : (i = S.a, l(b(t, {
                    bM: Mr
                }), A3(fl, n, function(n) {
                    return A7(yu, "POST", "/api/v1/jobs/{jobId}/cancel", m([
                        l("jobId", n)
                    ]), g, g, gt, sr(0));
                }(i.c), A2(cc, yf, im))));
            case 14:
                var D;
                return l(b(t, {
                    bM: D = e.a
                }), Kc);
            case 17:
                return l(b(t, {
                    b0: B = e.a
                }), Kc);
            case 18:
                var N = e.a;
                return l(b(t, {
                    b$: u(t.b$, ht(N)) ? gt : ht(N)
                }), Kc);
            case 21:
                var E = e.a;
                return A2(dm, e$(n), l(b(t, {
                    aF: !1,
                    aG: E
                }), Kc));
            case 19:
                E = e.a;
                var L = e.b, B = t.aF ? A2(t$, L, t.ak) : L, O = !u(A2(kf, A2(Zc, jt, function(n) {
                    return n.f8;
                }), t.ak), A2(kf, A2(Zc, jt, function(n) {
                    return n.f8;
                }), B)), P = A2(Wm, function() {
                    return O;
                }, A2(Fi, function(n) {
                    return n.c;
                }, nd(B)));
                return u(E, t.aG) ? l(b(t, {
                    ak: B,
                    aF: !0
                }), P.$ ? Kc : A3(Vl, t.b0, "evaluation_log", sm)) : l(t, Kc);
        }
    }), a$ = function(n) {
        return {
            $: 1,
            a: n
        };
    }, i$ = F4(function(n, e, t, r) {
        return {
            el: e,
            ct: t,
            ev: n,
            fP: r
        };
    }), u$ = F2(function(n, e) {
        return {
            bp: n,
            bB: e
        };
    }), c$ = F2(function(n, e) {
        return {
            cr: e,
            cw: n
        };
    }), o$ = A4(Aa, "after", Cm, gt, A4(Aa, "before", Cm, gt, sr(c$))), s$ = A3(ta, "value", o$, A3(ta, "path", Hi(Zr), sr(u$))), f$ = F2(function(n, e) {
        return {
            cr: e,
            cw: n
        };
    }), l$ = F2(function(n, e) {
        return {
            a7: n,
            af: e
        };
    }), d$ = A3(ta, "outputName", Zr, A3(ta, "derivation", gm, sr(l$))), b$ = A4(Aa, "after", d$, gt, A4(Aa, "before", d$, gt, sr(f$))), h$ = A3(ta, "ifds", Hi(b$), A3(ta, "attributes", Hi(s$), A3(ta, "afterId", fa, A3(ta, "beforeId", fa, sr(i$))))), g$ = F2(function(n, e) {
        return A7(yu, "GET", "/api/v1/jobs/{jobId}/evaluation/compare/{baseJobId}", m([
            l("jobId", n),
            l("baseJobId", e)
        ]), g, g, gt, h$);
    }), v$ = F2(function(n, e) {
        var t = l(e.ch.eu, e.am);
        if (t.a.$ || 3 !== t.b.$) return l(e, Kc);
        var r = t.a.a, a = t.b.a;
        return l(b(e, {
            bV: Mr
        }), A3(fl, n, A2(g$, a.c, r), A2(Zc, a$, yf)));
    }), p$ = function(n) {
        return {
            $: 6,
            a: n
        };
    }, m$ = F3(function(n, e, t) {
        var r = t.ch;
        return l(b(t, {
            a4: Mr
        }), A3(fl, n, A5(Ih, ht(r.dA), ht(r.co), ht(r.br), ht(e), ht(1)), A2(Zc, A2(Zc, p$, Os(ig)), yf)));
    }), $$ = F3(function(n, e, t) {
        switch(e.$){
            case 7:
            case 0:
                return l(t, Kc);
            case 1:
                return l(b(t, {
                    bV: r = e.a
                }), Kc);
            case 2:
                var r = e.a;
                return A2(ng, v$(n), l(b(t, {
                    am: r
                }), Kc));
            case 3:
                return l(b(t, {
                    aj: r = e.a
                }), Kc);
            case 4:
                return l(b(t, {
                    bg: e.a
                }), Kc);
            case 5:
                return A2(ng, A2(m$, n, e.a), l(t, Kc));
            default:
                var a = e.a;
                if (3 === a.$) {
                    var i = a.a, u = t.ch;
                    return A2(ng, v$(n), l(b(t, {
                        aj: a,
                        a4: Bs,
                        ch: b(u, {
                            eu: ht(i.c)
                        })
                    }), A2(Ll, n.iI, Vu(b(u, {
                        eu: ht(i.c)
                    })))));
                }
                return l(b(t, {
                    a4: a
                }), Kc);
        }
    }), y$ = F3(function(n, e, t) {
        if (e.$) {
            if (3 === e.a.$) {
                var r = e.a.a.bh;
                return l(t, A2(tm, n.iI, r.b ? Uu({
                    co: t.ch.co,
                    ab: r.a.ab,
                    br: t.ch.br,
                    dA: t.ch.dA
                }) : Ju({
                    co: t.ch.co,
                    gD: gt,
                    br: t.ch.br,
                    dA: t.ch.dA
                })));
            }
            return l(b(t, {
                d5: e.a
            }), Kc);
        }
        return l(t, Kc);
    }), w$ = F2(function(n, e) {
        return {
            $: 5,
            a: n,
            b: e
        };
    }), k$ = F2(function(n, e) {
        return {
            $: 6,
            a: n,
            b: e
        };
    }), x$ = function(n) {
        return {
            $: 9,
            a: n
        };
    }, j$ = function(n) {
        return {
            $: 12,
            a: n
        };
    }, A$ = {
        gu: gt,
        gv: gt
    }, C$ = function(n) {
        var e;
        return b(n, {
            cJ: (e = A2(ca, A$, n.cJ), ht(1 === e.gv.$ ? b(e, {
                gv: ht(1)
            }) : e))
        });
    }, I$ = F2(function(n, e) {
        return A2(ca, {
            gu: gt,
            gv: gt
        }, A2(nc, function(n) {
            return A2(Fi, function(n) {
                return n.hb;
            }, Ac(A2(Uf, function(n) {
                return u(n.co.c, e);
            }, n.cp)));
        }, nd(n.Z)));
    }), T$ = F2(function(n, e) {
        return A2(ca, {
            cR: 0,
            bZ: gt,
            bc: Bs,
            dd: 0,
            b3: gt,
            bj: Bs
        }, A2(Xi, e, n.bG));
    }), S$ = F3(function(n, e, t) {
        return b(t, {
            bG: A3(pa, n, e, t.bG)
        });
    }), D$ = F3(function(n, e, t) {
        return A3(S$, n, e(A2(T$, t, n)), t);
    }), N$ = F3(function(n, e, t) {
        switch(e.$){
            case 0:
                return l(b(t, {
                    Z: A2(kf, C$, e.a)
                }), Kc);
            case 1:
                var r = e.b;
                return l(A3(D$, c = e.a.bE, function(n) {
                    return b(n, {
                        cR: r
                    });
                }, t), Kc);
            case 2:
                return r = e.b, l(A3(D$, c = e.a.bE, function(n) {
                    return b(n, {
                        dd: r
                    });
                }, t), Kc);
            case 3:
                var a = e.b;
                return l(i = A3(D$, c = e.a.bE, function(n) {
                    return b(n, {
                        bZ: ht(a),
                        bc: Mr
                    });
                }, t), A3(fl, n, Ub(b(Vb, {
                    cp: A2(nh, c, function(n) {
                        return {
                            gu: a,
                            gv: A2(ca, A2(I$, i, c).gv, n.b3)
                        };
                    }(A2(T$, i, c)))
                })), A2(Zc, w$({
                    bE: c
                }), yf)));
            case 5:
                return l(A3(D$, c = e.a.bE, function(n) {
                    return b(n, {
                        bZ: gt,
                        bc: A2(kf, function() {
                            return 0;
                        }, s)
                    });
                }, b(t, {
                    Z: A2(Jb, t.Z, s = e.b)
                })), Kc);
            case 4:
                var i, u = e.b;
                return l(i = A3(D$, c = e.a.bE, function(n) {
                    return b(n, {
                        b3: ht(u),
                        bj: Mr
                    });
                }, t), A3(fl, n, Ub(b(Vb, {
                    cp: A2(nh, c, function(n) {
                        return {
                            gu: A2(ca, A2(I$, i, c).gu, n.bZ),
                            gv: u
                        };
                    }(A2(T$, i, c)))
                })), A2(Zc, k$({
                    bE: c
                }), yf)));
            case 6:
                var c;
                return l(A3(D$, c = e.a.bE, function(n) {
                    return b(n, {
                        b3: gt,
                        bj: A2(kf, function() {
                            return 0;
                        }, s)
                    });
                }, b(t, {
                    Z: A2(Jb, t.Z, s = e.b)
                })), Kc);
            case 8:
                return l(b(t, {
                    cF: r = e.a
                }), Kc);
            case 7:
                return l(b(t, {
                    cG: o = e.a,
                    bS: Mr
                }), A3(fl, n, Ub(b(Vb, {
                    cJ: ht({
                        gu: o,
                        gv: A2(Zb, A2(nc, function(n) {
                            return n.gv;
                        }, A2(nc, function(n) {
                            return n.cJ;
                        }, nd(t.Z))), t.cI)
                    })
                })), A2(Zc, x$, yf)));
            case 9:
                return l(b(t, {
                    bS: s = e.a,
                    Z: A2(Jb, t.Z, s)
                }), Kc);
            case 11:
                return l(b(t, {
                    cH: r = e.a
                }), Kc);
            case 10:
                var o;
                return l(b(t, {
                    cI: o = e.a,
                    bT: Mr
                }), A3(fl, n, Ub(b(Vb, {
                    cJ: ht({
                        gu: A2(Zb, A2(nc, function(n) {
                            return n.gu;
                        }, A2(nc, function(n) {
                            return n.cJ;
                        }, nd(t.Z))), t.cG),
                        gv: o
                    })
                })), A2(Zc, j$, yf)));
            default:
                var s;
                return l(b(t, {
                    bT: s = e.a,
                    Z: A2(Jb, t.Z, s)
                }), Kc);
        }
    }), E$ = F2(function(n, e) {
        return {
            $: 2,
            a: n,
            b: e
        };
    }), L$ = F3(function(n, e, t) {
        switch(e.$){
            case 0:
                return l(b(t, {
                    cA: e.a
                }), Kc);
            case 1:
                return l(b(t, {
                    aE: A3(pa, r = e.a, Mr, t.aE)
                }), A3(fl, n, A7(yu, "POST", "/api/v1/auth/cli/tokens/{cliTokenId}/revoke", m([
                    l("cliTokenId", r)
                ]), g, g, gt, sr(0)), A2(Zc, E$(r), yf)));
            default:
                var r;
                return l(b(t, {
                    aE: A3(pa, r = e.a, e.b, t.aE)
                }), ev(n));
        }
    }), B$ = function(n) {
        return {
            $: 1,
            a: n
        };
    }, O$ = {
        $: 1
    }, P$ = {
        $: 2
    }, G$ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, R$ = F2(function(n, e) {
        return {
            $: 8,
            a: n,
            b: e
        };
    }), z$ = function(n) {
        return {
            $: 2,
            a: n
        };
    }, q$ = F2(function(n, e) {
        var t = e.b, r = n(e.a);
        return l(r.a, Au(m([
            t,
            r.b
        ])));
    }), _$ = He(""), H$ = F3(function(n, e, t) {
        return 0 > s(t, n) ? n : s(t, e) > 0 ? e : t;
    }), F$ = function(n) {
        return {
            $: 3,
            a: n
        };
    }, U$ = F2(function(n, e) {
        return {
            U: n,
            hi: e
        };
    }), V$ = F3(function(n, e, t) {
        return {
            n: e,
            U: n,
            hH: t
        };
    }), W$ = F8(function(n, e, t, r, a, i, u, c) {
        return {
            I: r,
            as: a,
            n: e,
            U: n,
            hd: u,
            dC: c,
            hA: i,
            hG: t
        };
    }), Y$ = A4(Aa, "size", Oo, gt, A4(Aa, "sha256", Zr, gt, A4(Aa, "uploader", _i, gt, A4(Aa, "job", Zd, gt, A3(ta, "creationTime", zi, A3(ta, "version", Oo, A3(ta, "name", Zr, A3(ta, "projectId", fa, sr(W$))))))))), M$ = A3(ta, "versions", Hi(Y$), A3(ta, "name", Zr, A3(ta, "projectId", fa, sr(V$)))), K$ = A3(ta, "stateFiles", $a(M$), A3(ta, "projectId", fa, sr(U$))), J$ = A2(cc, function(n) {
        return n.cd;
    }, Os(function(n) {
        return n.b && !n.b.b ? Es(n.a) : Ls(ro("Project not found"));
    })), Q$ = F3(function(n, e, t) {
        var r = n(t);
        return 3 === r.$ ? e(r.a) : l(t, Kc);
    }), Z$ = F2(function(n, e) {
        return A3(Q$, J$, function(t) {
            return l(e, A3(fl, n, A7(yu, "GET", "/api/v1/projects/{projectId}/states", m([
                l("projectId", t.c)
            ]), g, g, gt, K$), A2(Zc, F$, yf)));
        }, e);
    }), X$ = F2(function(n, e) {
        if (-2 === e.$) return la;
        var t = e.b, r = e.d, a = e.e;
        return A5(ba, e.a, t, A2(n, t, e.c), A2(X$, n, r), A2(X$, n, a));
    }), ny = function(n) {
        return n.name;
    }, ey = F3(function(n, e, t) {
        n: for(;;){
            if (n > 0) {
                if (e.b) {
                    var r = e.a;
                    n -= 1, e = e.b, t = A2(Ze, r, t);
                    continue n;
                }
                return t;
            }
            return t;
        }
    }), ty = F2(function(n, e) {
        return Bt(A3(ey, n, e, g));
    }), ry = F3(function(n, e, t) {
        if (e > 0) {
            var r = l(e, t);
            n: for(;;){
                e: for(;;){
                    if (!r.b.b) return t;
                    if (!r.b.b.b) {
                        if (1 === r.a) break n;
                        break e;
                    }
                    switch(r.a){
                        case 1:
                            break n;
                        case 2:
                            var a = r.b;
                            return m([
                                a.a,
                                a.b.a
                            ]);
                        case 3:
                            if (r.b.b.b.b) {
                                var i = r.b, u = i.b;
                                return m([
                                    i.a,
                                    u.a,
                                    u.b.a
                                ]);
                            }
                            break e;
                        default:
                            if (r.b.b.b.b && r.b.b.b.b.b) {
                                var c = r.b, o = c.b, s = o.b, f = s.b, d = f.b;
                                return A2(Ze, c.a, A2(Ze, o.a, A2(Ze, s.a, A2(Ze, f.a, n > 1e3 ? A2(ty, e - 4, d) : A3(ry, n + 1, e - 4, d)))));
                            }
                            break e;
                    }
                }
                return t;
            }
            return m([
                r.b.a
            ]);
        }
        return g;
    }), ay = F2(function(n, e) {
        return A3(ry, 0, n, e);
    }), iy = F2(function(n, e) {
        return A3(Er, F2(function(e, t) {
            return A3(cu, n(e), A2(cc, Fi(Ze(e)), A2(cc, ca(m([
                e
            ])), ht)), t);
        }), da, e);
    }), uy = function(n) {
        return -2 === n.$;
    }, cy = At(Ib), oy = function(n) {
        var e = function(n) {
            return n.b.$ ? g : m([
                l(n.a, n.b.a)
            ]);
        }, t = function(n) {
            return 1 === n.b.$ ? m([
                l(n.a, n.b.a)
            ]) : g;
        }, r = A2(X$, F2(function(n, e) {
            return e.b && !e.b.b ? "" === e.a.a ? ct("Name must not be empty") : lt(e.a) : ct("Duplicate name");
        }), A2(iy, function(n) {
            return n.a;
        }, A2(cy, n.Y, n.aI))), a = ma(A2(wc, e, tt(r))), i = ma(A2(wc, t, tt(r)));
        return uy(i) ? lt(A2(X$, F2(function(n, e) {
            return e.b;
        }), a)) : ct(i);
    }, sy = F3(function(n, e, t) {
        switch(e.$){
            case 0:
                return l(t, A2(Ll, n.iI, e.a));
            case 1:
                return A2(Z$, n, t);
            case 2:
                var r = e.a;
                return A2(q$, Z$(n), l(b(t, {
                    cd: r
                }), Kc));
            case 3:
                return l(b(t, {
                    bx: A2(Yl, t.bx, r = e.a)
                }), Kc);
            case 6:
                var a = e.a;
                return l(b(t, {
                    z: B$({
                        aI: a,
                        Y: A2(Lr, ny, a)
                    })
                }), Kc);
            case 9:
                var i = e.a, u = e.b;
                return l(b(t, {
                    z: function() {
                        var n = t.z;
                        if (1 === n.$) {
                            var e = n.a;
                            return B$(b(e, {
                                Y: h(A2(ay, i, e.Y), A2(Ze, u, A2(bu, i + 1, e.Y)))
                            }));
                        }
                        return n;
                    }()
                }), Kc);
            case 10:
                return i = e.a, l(b(t, {
                    z: function() {
                        var n = t.z;
                        if (1 === n.$) {
                            var e = n.a;
                            return 1 === jt(e.Y) ? Fv : B$(b(e, {
                                aI: h(A2(ay, i, e.aI), A2(bu, i + 1, e.aI)),
                                Y: h(A2(ay, i, e.Y), A2(bu, i + 1, e.Y))
                            }));
                        }
                        return n;
                    }()
                }), Kc);
            case 5:
            case 11:
                return l(b(t, {
                    z: Fv
                }), Kc);
            case 4:
                return A3(Q$, J$, function(e) {
                    var r = t.z;
                    if (1 === r.$) {
                        var a = oy(r.a);
                        if (a.$) return l(t, Kc);
                        var i = a.a;
                        return l(b(t, {
                            z: z$(A2(X$, F2(function() {
                                return G$(0);
                            }), i))
                        }), Au(A2(Lr, function(t) {
                            var r, a = t.a;
                            return r = {
                                a3: n.cY.hZ,
                                aD: _$(t.b),
                                i9: R$(a),
                                U: e.c,
                                ci: a
                            }, To({
                                aD: r.aD,
                                ip: $f(r.i9),
                                M: A2(fu, lr, g),
                                aO: "PUT",
                                ay: ht(3e4),
                                bz: ht(r.ci),
                                hB: A3(bo, r.a3, m([
                                    "api",
                                    "v1",
                                    "projects",
                                    r.U,
                                    "state",
                                    r.ci,
                                    "data"
                                ]), A2(fu, lr, g))
                            });
                        }, tt(i))));
                    }
                    return l(t, Kc);
                }, t);
            case 7:
                var c = e.a, o = e.b;
                if (o.$) return l(t, Kc);
                var s = o.a, f = t.z;
                if (2 === f.$) {
                    var d = f.a;
                    return l(b(t, {
                        z: z$(A3(cu, c, Fi(function(n) {
                            return n.$ ? n : G$(function(n) {
                                return n.dC ? A3(H$, 0, 1, n.jx / n.dC) : 1;
                            }(s));
                        }), d))
                    }), Kc);
                }
                return l(t, Kc);
            case 8:
                var v = e.b, p = t.z;
                return 2 === p.$ ? A2(q$, function(e) {
                    return v.$ ? l(e, Kc) : A2(Z$, n, e);
                }, l(b(t, {
                    z: z$(A3(pa, e.a, v.$ ? P$ : O$, d = p.a))
                }), Kc)) : l(t, Kc);
            default:
                return l(t, Kc);
        }
    }), fy = F3(function(n, e, t) {
        var r = l(t, Kc);
        switch(e.$){
            case 0:
                var a = e.a, i = A2(Qv, n, a), c = i.a, o = i.b;
                return A2(Zv, t.ch, a) ? l(b(t, {
                    ch: a
                }), Kc) : l(b(t, {
                    gD: c,
                    ch: a
                }), o);
            case 2:
                var s = e.a, f = t.gD;
                if (10 === f.$) {
                    var d = A3(ab, n, s, f.a);
                    return o = d.b, l(b(t, {
                        gD: jf(d.a)
                    }), A2(Qc, vs, o));
                }
                return l(t, Kc);
            case 3:
                var h = t.gD;
                if (2 === h.$) {
                    var g = A3(dh, n, e.a, h.a), v = g.b;
                    return l(b(t, {
                        gD: If(g.a)
                    }), A2(Qc, ps, v));
                }
                return l(t, Kc);
            case 10:
                s = e.a;
                var p = t.gD;
                if (6 === p.$) {
                    var m = A3(qg, n, s, p.a);
                    return o = m.b, l(b(t, {
                        gD: Of(m.a)
                    }), A2(Qc, As, o));
                }
                return l(t, Kc);
            case 11:
                s = e.a;
                var $ = t.gD;
                if (7 === $.$) {
                    var y = A3(y$, n, s, $.a);
                    return o = y.b, l(b(t, {
                        gD: Pf(y.a)
                    }), A2(Qc, Cs, o));
                }
                return r;
            case 1:
                var w = e.a, k = t.gD;
                if (9 === k.$) {
                    var x = A3(th, n, w, k.a);
                    return o = x.b, l(b(t, {
                        gD: Cf(x.a)
                    }), A2(Qc, Af, o));
                }
                return r;
            case 12:
                s = e.a;
                var j = t.gD;
                if (8 === j.$) {
                    var A = A3(fp, n, s, j.a);
                    return o = A.b, l(b(t, {
                        gD: Tf(A.a)
                    }), A2(Qc, ms, o));
                }
                return l(t, Kc);
            case 4:
                w = e.a;
                var C = t.gD;
                if (11 === C.$) {
                    var I = A3(dp, n, w, C.a);
                    return o = I.b, l(b(t, {
                        gD: Sf(I.a)
                    }), A2(Qc, $s, o));
                }
                return l(t, Kc);
            case 5:
                s = e.a;
                var T = t.gD;
                if (T.$) return l(t, Kc);
                var S = A3(hp, n, s, T.a);
                return o = S.b, l(b(t, {
                    gD: Df(S.a)
                }), A2(Qc, ys, o));
            case 6:
                s = e.a;
                var D = t.gD;
                if (1 === D.$) {
                    var N = A3(_v, n, s, D.a);
                    return o = N.b, l(b(t, {
                        gD: Hf(N.a)
                    }), A2(Qc, Ts, o));
                }
                return l(t, Kc);
            case 7:
                s = e.a;
                var E = t.gD;
                if (3 === E.$) {
                    var L = A3(sy, n, s, E.a);
                    return o = L.b, l(b(t, {
                        gD: Ff(L.a)
                    }), A2(Qc, Ss, o));
                }
                return l(t, Kc);
            case 8:
                s = e.a;
                var B = t.gD;
                if (4 === B.$) {
                    var O = A3(r$, n, s, B.a);
                    return o = O.b, l(b(t, {
                        gD: Gf(O.a)
                    }), A2(Qc, Is, o));
                }
                return l(t, Kc);
            case 9:
                var P = t.gD;
                if (5 === P.$) {
                    var G = A3($$, n, e.a, P.a);
                    return v = G.b, l(b(t, {
                        gD: Bf(G.a)
                    }), A2(Qc, js, v));
                }
                return l(t, Kc);
            case 13:
                var R = e.a, z = t.gD;
                if (12 === z.$) {
                    var q = z.a, _ = z.b;
                    if (3 === R.$) {
                        var H = A2(Uf, function(n) {
                            return u(n.ax, q);
                        }, R.a);
                        if (H.b) {
                            var F = _(H.a), U = F.b;
                            return l(b(t, {
                                gD: F.a
                            }), U);
                        }
                        return r;
                    }
                    return r;
                }
                return r;
            case 14:
                s = e.a;
                var V = t.gD;
                if (16 === V.$) {
                    var W = A3(L$, n, s, V.a);
                    return o = W.b, l(b(t, {
                        gD: _f(W.a)
                    }), A2(Qc, qf, o));
                }
                return l(t, Kc);
            case 15:
                s = e.a;
                var Y = t.gD;
                if (17 === Y.$) {
                    var M = A3(N$, n, s, Y.a);
                    return o = M.b, l(b(t, {
                        gD: zf(M.a)
                    }), A2(Qc, Rf, o));
                }
                return l(t, Kc);
            case 16:
                s = e.a;
                var K = t.gD;
                if (18 === K.$) {
                    var J = A3(am, n, s, K.a);
                    return o = J.b, l(b(t, {
                        gD: Lf(J.a)
                    }), A2(Qc, xs, o));
                }
                return l(t, Kc);
            case 17:
                s = e.a;
                var Q = t.gD;
                if (19 === Q.$) {
                    var Z = A3(Xp, n, s, Q.a);
                    return o = Z.b, l(b(t, {
                        gD: Ef(Z.a)
                    }), A2(Qc, ks, o));
                }
                return l(t, Kc);
            default:
                s = e.a;
                var X = t.gD;
                if (20 === X.$) {
                    var nn = A3(xp, n, s, X.a);
                    return o = nn.b, l(b(t, {
                        gD: Nf(nn.a)
                    }), A2(Qc, ws, o));
                }
                return l(t, Kc);
        }
    }), ly = F2(function(n, e) {
        switch(e.$){
            case 0:
                return b(n, {
                    eS: e.a
                });
            case 1:
                return b(n, {
                    ch: e.a
                });
            default:
                return b(n, {
                    hV: e.a
                });
        }
    }), dy = F2(function(n, e) {
        var t = n.q;
        if (1 === t.$) {
            var r = t.b, a = A2(ly, t.a, {
                $: 1,
                a: n.ch
            }), i = A3(fy, a, e, r), u = i.b;
            return l(b(n, {
                q: A2(hf, a, i.a)
            }), A2(Qc, Po, u));
        }
        return l(n, Kc);
    }), by = function(n) {
        return {
            $: 2,
            a: n
        };
    }, hy = {
        $: 0
    }, gy = F2(function(n, e) {
        return 3 === e.$ && u(e.a, n);
    }), vy = gy(401), py = F2(function(n, e) {
        var t = A2(Qv, n, e);
        return l({
            gD: t.a,
            ch: e
        }, t.b);
    }), my = F5(function(n, e, t, r, a) {
        var i = {
            hV: a,
            h9: r,
            eS: Qa(n.cY.eS),
            cY: n.cY,
            iI: n.iI,
            ch: n.ch,
            jK: e,
            hD: t
        }, u = A2(py, i, n.ch), c = u.b;
        return l(b(n, {
            q: A2(hf, i, u.a)
        }), A2(Qc, Po, c));
    }), $y = function(n) {
        var e = n.jK;
        if (1 === e.$) return l(n, Kc);
        var t = e.a, r = n.h9;
        switch(r.$){
            case 3:
                var a = r.a, i = n.hV;
                switch(i.$){
                    case 3:
                        var u = a.gJ;
                        return u.b ? A5(my, n, t, {
                            $: 1,
                            a: u.a
                        }, a, i.a) : A5(my, n, t, hy, a, g);
                    case 2:
                        return vy(c = i.a) ? A5(my, n, t, hy, a, g) : l(b(n, {
                            q: by(c)
                        }), Kc);
                    default:
                        return l(n, Kc);
                }
            case 2:
                var c;
                return l(b(n, {
                    q: by(c = r.a)
                }), Kc);
            default:
                return l(n, Kc);
        }
    }, yy = F2(function(n, e) {
        return 1 === n.$ ? e : e + ":" + $t(n.a);
    }), wy = F3(function(n, e, t) {
        return 1 === e.$ ? t : h(t, h(n, e.a));
    }), ky = function(n) {
        return A3(wy, "#", n.it, A3(wy, "?", n.jj, h(A2(yy, n.gM, h(n.gU ? "https://" : "http://", n.fJ)), n.bp)));
    }, xy = F3(function(n, e, t) {
        return 1 === e.$ ? l(b(t, {
            cO: e.a
        }), Kc) : l(t, 1 === n.$ ? A2(Ll, n.a.iI, Eu(e.a)) : Kc);
    }), jy = F2(function(n, e) {
        switch(n.$){
            case 0:
                var t = n.a;
                return t.$ ? l(e, "" === t.a ? Kc : wf(r = t.a)) : 22 === Vc(r = t.a).$ ? l(e, wf(ky(r))) : l(b(e, {
                    aZ: (w = e.aZ, 2 === w ? 3 : w)
                }), A2(xf, e.iI, ky(r)));
            case 1:
                var r, a = Vc(r = n.a);
                return A2(dy, b(e, {
                    ch: a,
                    hB: r
                }), {
                    $: 0,
                    a: a
                });
            case 10:
                return l(e, wf("/"));
            case 4:
                return A2(dy, e, n.a);
            case 3:
                return $y(b(e, {
                    hV: ($ = yf(c = n.a), p = $, y = 2 === p.$ && function(n) {
                        return 24 === n.$;
                    }(e.ch) ? Es(g) : $, y)
                }));
            case 2:
                return $y(b(e, {
                    h9: yf(c = n.a),
                    hD: A2(Os, function(n) {
                        return n.$ ? Ls(ro("Not logged in")) : Es(n.a);
                    }, A2(kf, function(n) {
                        return Ac(n.gJ);
                    }, yf(c)))
                }));
            case 5:
                var i = A3(xy, e.q, n.a, e.bL), u = i.b;
                return l(b(e, {
                    bL: i.a
                }), A2(Qc, Vr, u));
            case 7:
                var c = n.a, o = e.q;
                if (1 === o.$) {
                    var s = o.a, f = o.b;
                    if (3 === c.$) {
                        var d = A2(ly, s, {
                            $: 2,
                            a: c.a
                        });
                        return l(b(e, {
                            q: A2(hf, d, f)
                        }), Kc);
                    }
                    return l(e, Kc);
                }
                return l(e, Kc);
            case 6:
                var h = e.q;
                return 1 === h.$ ? (f = h.b, d = A2(ly, s = h.a, function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                }(n.a)), l(b(e, {
                    bH: e.bH + 1,
                    q: A2(hf, d, f)
                }), 4 > e.bH ? A3(fl, s, A2(wu, gt, gt), A2(cc, yf, vf)) : Kc)) : l(e, Kc);
            case 8:
                return l(b(e, {
                    jK: ht(n.a)
                }), Kc);
            case 9:
                return l(e, To({
                    aD: ou,
                    ip: $f((v = {
                        a3: e.cY.hZ,
                        i9: A2(cc, yf, gf)
                    }).i9),
                    M: A2(fu, lr, g),
                    aO: "POST",
                    ay: ht(3e4),
                    bz: gt,
                    hB: A3(bo, v.a3, m([
                        "api",
                        "auth",
                        "sign-out"
                    ]), A2(fu, lr, g))
                }));
            default:
                return l(b(e, {
                    aZ: n.a
                }), Kc);
        }
        var v, p, $, y, w;
    }), Ay = F2(function(n, e) {
        return A2(Mn, n, Gb(e));
    }), Cy = Ay("className"), Iy = Fn("div"), Ty = Ay("id"), Sy = Vn, Dy = Sy, Ny = Fn("nav"), Ey = Yn, Ly = Ey, By = _n, Oy = By, Py = Fn("a"), Gy = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ry = function(n) {
        return {
            $: 0,
            a: n
        };
    }, zy = Fn("i"), qy = function(n) {
        return {
            h8: n.h8,
            iC: n.iC,
            aM: !1,
            b5: function(n) {
                return A3(n, zy, m([
                    Cy("dropdown icon")
                ]), g);
            },
            i8: n.i8,
            jb: n.jb,
            cf: !1,
            dO: 0
        };
    }, _y = F2(function(n, e) {
        return b(e, {
            aM: n
        });
    }), Hy = F2(function(n, e) {
        return b(e, {
            b5: n
        });
    }), Fy = function(n) {
        return n.b;
    }, Uy = function(n) {
        return Cy(A2(yt, " ", A2(Lr, nr, A2(Uf, Fy, n))));
    }, Vy = A2(Ly, "position", "absolute"), Wy = A2(Ly, "visibility", "hidden"), Yy = A2(Ly, "visibility", "visible"), My = F5(function(n, e, t, r, a) {
        return A2(n, r ? A2(Ze, a.il, h(m([
            Yy,
            Vy
        ]), e)) : h(m([
            Wy,
            Vy
        ]), e), t);
    }), Ky = Wn, Jy = F2(function(n, e) {
        return A2(Ky, n, {
            $: 0,
            a: e
        });
    }), Qy = F2(function(n, e) {
        var t = 1 === e || 3 === e, r = t ? 1 === e ? 2 : 0 : e, a = 1 === e || 2 === e, i = a || t, u = {
            h4: A2(Zc, n.jb, function(n) {
                return n ? a ? e : 1 : a ? 3 : e;
            }),
            il: Uy(g),
            iC: n.iC,
            dO: function() {
                switch(n.dO){
                    case 0:
                        return 0;
                    case 1:
                        return 1;
                    default:
                        return 2;
                }
            }()
        };
        return {
            bX: a,
            a9: t,
            ba: i,
            dX: r,
            bY: u
        };
    }), Zy = F5(function(n, e, t, r, a) {
        var i = A2(Qy, n, e);
        return n.cf ? A2(t, A2(Ze, Uy(m([
            l("menu", !0)
        ])), r), a) : A5(My, t, h(A2(Ze, Uy(m([
            l("menu", !0),
            l("active", !0),
            l("visible", i.ba),
            l("hiden", !i.ba),
            l("animating", i.a9),
            l("transition", !0),
            l("slide", i.a9),
            l("down", i.a9),
            l("in", 1 === e),
            l("out", 3 === e)
        ])), i.a9 ? m([
            A2(Jy, "animationend", sr(n.jb(i.dX)))
        ]) : g), r), a, i.bX, i.bY);
    }), Xy = F3(function(n, e, t) {
        return A2(n, A2(Ze, Cy("item"), e), t);
    }), nw = F2(function(n, e) {
        return A2(Mn, function(n) {
            return "innerHTML" == n || "formAction" == n ? "data-" + n : n;
        }(n), Jn(e));
    }), ew = nw, tw = A2(Ly, "display", "inline-block"), rw = F2(function(n, e) {
        return {
            fW: n,
            gE: e
        };
    }), aw = F2(function(n, e) {
        return sr(u(n, e));
    }), iw = F2(function(n, e) {
        return A2(cr, ca(n), ld(e));
    }), uw = function(n) {
        return A3(or, rw, A2(iw, !1, A2(ur, aw(n), A2(Ur, "dropdownId", Zr))), A2(Ur, "parentElement", ld(A2(cr, lr, A2(ur, function() {
            return uw(n);
        }, sr(0))))));
    }, cw = function(n) {
        for(;;){
            if (n.fW) return sr(!0);
            var e = n.gE;
            if (1 === e.$) return sr(!1);
            n = e.a;
        }
    }, ow = F2(function(n, e) {
        return A2(cr, e.h4, A2(iw, !1, A2(ur, cw, A2(Ur, "relatedTarget", uw(e.iC)))));
    }), sw = A2(Ur, "keyCode", Oo), fw = F2(function(n, e) {
        return A2(cr, e.h4, A2(ur, A2(Zc, A2(Zc, A2(Zc, sr, pt(n)), xi), Mt(27)), sw));
    }), lw = A2(Ly, "outline", "none"), dw = A2(Ly, "position", "relative"), bw = F5(function(n, e, t, r, a) {
        var i, u = m(1 === a.dO ? [
            A2(Jy, "mouseout", A2(ow, r, a)),
            A2(Jy, "focusout", A2(ow, r, a))
        ] : [
            A2(Jy, "focusout", A2(ow, r, a))
        ]);
        return A2(n, h(m([
            A2(Jy, "keydown", A2(fw, r, a))
        ]), h(u, h(m([
            (i = a.iC, A2(ew, "dropdownId", Gb(i))),
            A2(Kn, "tabIndex", $t(-1)),
            dw,
            tw,
            lw
        ]), e))), A2(Lr, function(n) {
            return A2(n, r, a);
        }, t));
    }), hw = F2(function(n, e) {
        return A2(Ky, n, {
            $: 3,
            a: e
        });
    }), gw = function(n) {
        return A2(Jy, "focus", sr(n));
    }, vw = F5(function(n, e, t, r, a) {
        return A2(n, h(function() {
            var n;
            switch(a.dO){
                case 0:
                    return m([
                        A2(hw, "click", sr({
                            bl: a.h4(!r),
                            d4: !0,
                            d8: !0
                        }))
                    ]);
                case 1:
                    return m([
                        (n = a.h4(!0), A2(Jy, "mouseenter", sr(n))),
                        gw(a.h4(!0))
                    ]);
                default:
                    return m([
                        gw(a.h4(!0))
                    ]);
            }
        }(), e), t);
    }), pw = F5(function(n, e, t, r, a) {
        var i = A2(Qy, n, e);
        return n.cf ? A2(t, r, a) : A5(vw, t, r, a, i.bX, i.bY);
    }), mw = F5(function(n, e, t, r, a) {
        var i = A2(Qy, n, e), u = A2(Ze, Uy(m([
            l("ui", !0),
            l("dropdown", !0),
            l("active", i.ba),
            l("visible", i.ba),
            l("disabled", n.cf)
        ])), A2(Ze, A2(Ly, "position", "relative"), r));
        return A5(bw, t, u, A2(Lr, function(n) {
            return F2(function() {
                return n;
            });
        }, A2(Ze, A5(pw, n, e, Iy, m([
            A2(Ly, "position", "absolute"),
            A2(Ly, "width", "100%"),
            A2(Ly, "height", "100%"),
            A2(Ly, "left", "0%"),
            A2(Ly, "top", "0%")
        ]), g), a)), i.bX, i.bY);
    }), $w = F3(function(n, e, t) {
        return t({
            iM: A2(Zy, n, e),
            iN: A2(mw, n, e),
            iO: Xy,
            iP: A2(pw, n, e)
        });
    }), yw = Fn("input"), ww = function(n) {
        return A2(Jy, "click", sr(n));
    }, kw = Ay("type"), xw = F5(function(n, e, t, r, a) {
        return A3($w, {
            iC: n.iC,
            jb: n.jb,
            cf: n.cf,
            dO: n.dO
        }, e.im, function(i) {
            var u = i.iP, c = i.iM, o = i.iO;
            return A3(i.iN, t, A2(Ze, Uy(m([
                l("selection", !n.aM),
                l("inline", n.aM)
            ])), r), m([
                A3(u, yw, m([
                    kw("hidden")
                ]), g),
                A3(a, F3(function(e, t, r) {
                    return A3(u, e, A2(Ze, Uy(m([
                        l("text", n.aM)
                    ])), t), r);
                }), !1, e.jw),
                n.b5(u),
                A3(c, Iy, m([
                    ww(n.jb(3))
                ]), A2(Lr, function(e) {
                    return A3(a, A2(Zc, o, F3(function(t, r, a) {
                        return A2(t, A2(Ze, ww(n.i8(e)), r), a);
                    })), !0, e);
                }, n.h8))
            ]));
        });
    }), jw = function(n) {
        var e;
        return A2(Ay, "href", /^javascript:/i.test((e = n).replace(/\s/g, "")) ? "" : e);
    }, Aw = function(n) {
        return jw(A3(hu, "\\", "%5C", El(n)));
    }, Cw = F2(function(n, e) {
        return A2(hr, "?", n) ? n + "&" + e : n + "?" + e;
    }), Iw = Fn("img"), Tw = function(n) {
        return A2(Ay, "src", Jn(n));
    }, Sw = function(n) {
        return A2(Kn, "width", $t(n));
    }, Dw = F2(function(n, e) {
        var t = 3 * e;
        return "" === n.T ? function(n) {
            var e = n.dC, t = n.W;
            return A2(zy, m([
                Cy("ui icon middle aligned"),
                A2(Ly, "margin-right", "10px"),
                Uy(m([
                    l("user", !t),
                    l("group", 1 === t)
                ])),
                A2(Ly, "width", $t(e))
            ]), g);
        }({
            dC: e,
            W: n.W
        }) : A2(Iw, m([
            Tw(A2(Cw, n.T, "size=" + $t(t))),
            Sw(e),
            Cy("ui image middle aligned rounded"),
            A2(Ly, "margin-right", "10px")
        ]), g);
    }), Nw = F3(function(n, e, t) {
        var r = F4(function(n, e, t, r) {
            var a = function() {
                var e = A2(rl, n, r.co);
                if (1 === e.$) return m([
                    Oy(r.co)
                ]);
                var t = e.a;
                return m([
                    A2(Dw, t, 30),
                    Oy(t.k)
                ]);
            }(), i = t ? a : g;
            return A3(e, Iy, m([
                Cy("text")
            ]), i);
        });
        switch(n.$){
            case 0:
                return A2(Iy, m([
                    Cy("ui loader inline active")
                ]), g);
            case 2:
                return A2(Iy, g, g);
            default:
                var a = n.a;
                return A2(Iy, g, m([
                    function(n) {
                        return A2(Py, m([
                            Aw(Eu({
                                co: t.co,
                                dA: t.dA
                            })),
                            A2(Ly, "margin-right", "15px")
                        ]), h(function(n) {
                            return A2(Lr, function(n) {
                                return A2(Dw, n, 30);
                            }, Dl(A2(cl, n, {
                                co: t.co,
                                dA: t.dA
                            })));
                        }(n), m([
                            Oy(t.co)
                        ])));
                    }(a),
                    A5(xw, function(n) {
                        return A2(Hy, function(n) {
                            return A3(n, zy, m([
                                Cy("caret square down outline large icon")
                            ]), g);
                        }, A2(_y, !0, qy({
                            h8: A2(fu, function(n) {
                                return u(n.ax, t.co) && u(n.hf, t.dA) ? gt : ht({
                                    co: n.ax,
                                    dA: n.hf
                                });
                            }, n.hV),
                            iC: "selectAccount",
                            i8: Ry,
                            jb: Gy
                        })));
                    }(a), {
                        im: e.cO,
                        jw: {
                            co: t.co,
                            dA: t.dA
                        }
                    }, Iy, g, r(a))
                ]));
        }
    }), Ew = function(n) {
        return A2(ca, n, Ac(Bt(A2(Uf, A2(Zc, xi, $r), A2(wt, "/", n)))));
    }, Lw = F2(function(n, e) {
        return {
            u: e,
            c7: n
        };
    }), Bw = F2(function(n, e) {
        if (e.b) {
            var t = e.a, r = e.b, a = F2(function(e, t) {
                return A2(Ze, n, A2(Ze, e, t));
            });
            return A2(Ze, t, A3(Er, a, g, r));
        }
        return g;
    }), Ow = function(n) {
        return Uy(m([
            l("mini", !n),
            l("tiny", 1 === n),
            l("small", 2 === n),
            l("medium", 3 === n),
            l("large", 4 === n),
            l("big", 5 === n),
            l("huge", 7 === n),
            l("massive", 6 === n)
        ]));
    }, Pw = Fn("span"), Gw = F2(function(n, e) {
        var t = function(n) {
            return A2(Iy, m([
                Uy(m([
                    l("section", !0),
                    l("active", n.c7)
                ]))
            ]), m([
                n.u
            ]));
        }, r = A2(Pw, m([
            Cy("divider")
        ]), m([
            n.cN
        ]));
        return A2(Iy, m([
            Cy("ui breadcrumb"),
            Ow(n.dC)
        ]), A2(Bw, r, A2(Lr, t, e)));
    }), Rw = F2(function(n, e) {
        return A2(Gw, n, A2(Lr, function(n) {
            return A2(Lw, !1, n);
        }, e));
    }), zw = F2(function(n, e) {
        return b(e, {
            cN: n
        });
    }), qw = {
        cN: Oy("/"),
        dC: 3
    }, _w = F2(function(n, e) {
        return b(e, {
            dC: n
        });
    }), Hw = A2(zw, A2(zy, m([
        Cy("right angle icon divider")
    ]), g), A2(_w, 4, qw)), Fw = F3(function(n, e, t) {
        var r = function(n) {
            return A2(Py, m([
                Aw(Ju({
                    co: n.co,
                    gD: gt,
                    br: n.br,
                    dA: n.dA
                }))
            ]), m([
                Oy(n.br)
            ]));
        }, a = function(n) {
            return A2(Py, m([
                Aw(Vu(n))
            ]), m([
                Oy("Compare")
            ]));
        }, i = function(n) {
            return A2(Py, m([
                Aw(Uu({
                    co: n.co,
                    ab: n.ab,
                    br: n.br,
                    dA: n.dA
                }))
            ]), m([
                Oy("Job #" + $t(n.ab))
            ]));
        }, u = function(n) {
            return A2(Py, m([
                Aw(Wu(n))
            ]), m([
                Oy("Effect " + Tl(n.a2))
            ]));
        }, c = function(n) {
            return A2(Py, m([
                Aw(Bu(n))
            ]), m([
                Oy("Derivation " + Ew(n.a8))
            ]));
        }, o = function(e) {
            return A3(Nw, n, t, e);
        }, s = m([
            A2(Py, m([
                Aw(Ku)
            ]), m([
                Oy("Personal Settings")
            ]))
        ]), f = h(s, m([
            A2(Py, m([
                Aw(Mu)
            ]), m([
                Oy("Notifications")
            ]))
        ])), d = function(n) {
            return m([
                o({
                    co: n.co,
                    dA: n.dA
                })
            ]);
        }, b = function(n) {
            return h(d(n), m([
                r(n)
            ]));
        }, v = function(n) {
            return h(b(n), m([
                i(n)
            ]));
        }, p = function() {
            switch(e.$){
                case 1:
                case 6:
                    return d(t = e.a);
                case 3:
                    return h(function(e) {
                        if (1 === n.$) {
                            var t = n.b.gD;
                            if (10 === t.$) {
                                var r = t.a.ig.ie;
                                if (3 === r.$) {
                                    var a = r.a, i = l(a.hI, a.hJ);
                                    return i.a.$ || i.b.$ ? d(e) : v({
                                        co: e.co,
                                        ab: i.a.a.ab,
                                        br: i.b.a.ax,
                                        dA: e.dA
                                    });
                                }
                                return d(e);
                            }
                            return d(e);
                        }
                        return d(e);
                    }(t = e.a), m([
                        c(t)
                    ]));
                case 2:
                    return h(d(t = e.a), m([
                        Oy("Settings")
                    ]));
                case 4:
                    return h(d(t = e.a), m([
                        Oy("Tasks")
                    ]));
                case 5:
                    return function(n) {
                        return h(function(n) {
                            return h(d(n), m([
                                A2(Py, m([
                                    Aw(zu({
                                        co: n.co,
                                        dA: n.dA
                                    }))
                                ]), m([
                                    Oy("Agents")
                                ]))
                            ]));
                        }(n), m([
                            A2(Py, m([
                                Aw(Pu({
                                    co: n.co,
                                    fK: n.fK,
                                    dA: n.dA
                                }))
                            ]), m([
                                Oy(n.fK)
                            ]))
                        ]));
                    }(t = e.a);
                case 10:
                case 14:
                    return b(t = e.a);
                case 11:
                    return h(b(t = e.a), m([
                        Oy("State files")
                    ]));
                case 13:
                    return v(t = e.a);
                case 15:
                    return function(n) {
                        return h(v(n), m([
                            a(n)
                        ]));
                    }(t = e.a);
                case 16:
                    return h(v(t = e.a), m([
                        u(t)
                    ]));
                case 7:
                case 8:
                    return h(d(t = e.a), m([
                        Oy("Agent setup")
                    ]));
                case 17:
                    var t;
                    return h(A2(Nl, o, A2(nc, function(n) {
                        return A2(Fi, function(e) {
                            return {
                                co: n,
                                dA: e
                            };
                        }, t.dA);
                    }, (t = e.a).co)), m([
                        Oy("Billing")
                    ]));
                case 9:
                    return m([
                        Oy("Personal Settings"),
                        Oy("CLI Authorization Request")
                    ]);
                case 0:
                case 23:
                case 22:
                case 12:
                default:
                    return g;
                case 18:
                    return s;
                case 19:
                    return f;
                case 20:
                case 21:
                    return m([
                        Oy("Install"),
                        Oy("GitLab")
                    ]);
            }
        }();
        return p.b ? A2(Rw, Hw, p) : A2(Pw, g, g);
    }), Uw = function(n) {
        switch(n){
            case "github":
                return Cy("black");
            case "gitlab":
                return Cy("orange");
            default:
                return Uy(g);
        }
    }, Vw = F2(function(n, e) {
        return A2(zy, h(m([
            Cy("ui icon"),
            Cy(n)
        ]), e), g);
    }), Ww = Fn("p"), Yw = F2(function(n, e) {
        return u(n.fu, g) ? A2(Iy, g, m([
            A2(Ww, g, m([
                Oy("No Forges have been installed yet.")
            ])),
            A2(Py, m([
                Cy("ui button primary"),
                Aw(Fu({}))
            ]), m([
                A2(Vw, "gitlab", g),
                Oy("Install GitLab")
            ]))
        ])) : A2(Iy, g, A2(Lr, function(n) {
            return A2(Py, m([
                Cy("ui button"),
                Uw(n.W),
                jw("/api/auth/" + n.W + "/start/" + n.c + (e.$ ? "" : "?redirect=" + pu(e.a)))
            ]), m([
                A2(Vw, n.W, g),
                Oy(n.k)
            ]));
        }, n.fu));
    }), Mw = Fn("h1"), Kw = function(n) {
        return Ew(n.a8);
    }, Jw = function(n) {
        return 1 === n.hD.$;
    }, Qw = F2(function(n, e) {
        return b(e, {
            ct: n
        });
    }), Zw = function(n) {
        return Cy(function() {
            switch(n){
                case 0:
                    return "blue";
                case 1:
                    return "teal";
                case 2:
                    return "yellow";
                case 3:
                    return "red";
                case 4:
                    return "green";
                case 5:
                    return "orange";
                default:
                    return "grey";
            }
        }());
    }, Xw = function(n) {
        switch(n){
            case 0:
                return Cy("mini");
            case 1:
                return Cy("tiny");
            case 2:
                return Cy("small");
            case 3:
                return Cy("");
            case 4:
                return Cy("large");
            case 5:
                return Cy("big");
            case 7:
                return Cy("huge");
            default:
                return Cy("massive");
        }
    }, nk = F2(function(n, e) {
        return A2(zy, yc(m([
            n.ct,
            m([
                Uy(m([
                    l("link", n.f9),
                    l("icon", !0)
                ])),
                Xw(n.dC),
                Cy(function() {
                    switch(e){
                        case 14:
                            return "dropbox";
                        case 46:
                            return "warning";
                        case 47:
                            return "warning sign";
                        case 3:
                            return "arrow right";
                        case 2:
                            return "left arrow";
                        case 34:
                            return "search";
                        case 29:
                            return "plus";
                        case 24:
                            return "info";
                        case 45:
                            return "user";
                        case 8:
                            return "check circle outline";
                        case 20:
                            return "help";
                        case 9:
                            return "chevron up";
                        case 43:
                            return "trash";
                        case 44:
                            return "upload";
                        case 13:
                            return "download";
                        case 18:
                            return "fork";
                        case 39:
                            return "star";
                        case 19:
                            return "github";
                        case 25:
                            return "legal";
                        case 21:
                            return "hide";
                        case 0:
                            return "alarm";
                        case 1:
                            return "align justify";
                        case 35:
                            return "settings";
                        case 11:
                            return "close";
                        case 32:
                            return "remove";
                        case 33:
                            return "retweet";
                        case 30:
                            return "print";
                        case 16:
                            return "file outline";
                        case 7:
                            return "caret down";
                        case 15:
                            return "dropdown";
                        case 38:
                            return "sort up";
                        case 37:
                            return "sort down";
                        case 36:
                            return "sort";
                        case 27:
                            return "pencil alternative";
                        case 17:
                            return "filter";
                        case 22:
                            return "image outline";
                        case 12:
                            return "dot circle outline";
                        case 26:
                            return "pause circle outline";
                        case 42:
                            return "times circle outline";
                        case 10:
                            return "circle outline";
                        case 6:
                            return "camera";
                        case 4:
                            return "arrows alternate";
                        case 31:
                            return "question circle outline";
                        case 5:
                            return "calendar";
                        case 28:
                            return "play";
                        case 40:
                            return "stop";
                        case 41:
                            return "stopwatch";
                        default:
                            return "industry";
                    }
                }())
            ])
        ])), g);
    }), ek = {
        ct: g,
        f9: !1,
        dC: 3
    }, tk = F3(function(n, e, t) {
        var r, a, i, c = function() {
            var n = e.iw;
            if (1 === n.$) return g;
            var t = n.a;
            return m([
                A2(Iy, m([
                    Cy("header")
                ]), m([
                    Oy(t)
                ]))
            ]);
        }(), o = 1 === (r = e.cB).$ ? g : m([
            A2(nk, A2(Qw, m([
                ww(r.a)
            ]), ek), 11)
        ]), s = h(c, t);
        return A2(Iy, yc(m([
            m([
                Cy("ui message"),
                Uy(m([
                    l("icon", !u(e.iB, gt))
                ]))
            ]),
            (i = e.cC, i.$ ? g : m([
                Zw(i.a)
            ])),
            n
        ])), h(o, 1 === (a = e.iB).$ ? s : h(o, m([
            A2(nk, ek, a.a),
            A2(Iy, m([
                Cy("contents")
            ]), s)
        ]))));
    }), rk = tk(m([
        Cy("error")
    ])), ak = {
        cB: gt,
        cC: gt,
        iw: gt,
        iB: gt
    }, ik = F3(function(n, e, t) {
        var r = m([
            Oy("sign in")
        ]);
        return function() {
            switch(e.$){
                case 0:
                    return A2(Ze, Oy("A request could not be made due to a bad url (" + e.a + ")"), t);
                case 1:
                    return A2(Ze, Oy("We made a request but it timed out."), t);
                case 2:
                    return A2(Ze, Oy("A network error occurred. Are you connected to the Internet?"), t);
                case 3:
                    switch(e.a){
                        case 401:
                            return n ? A2(Ze, Oy("Authentication error."), t) : A2(Ze, Oy("You need to "), h(r, A2(Ze, Oy("."), t)));
                        case 403:
                            return n ? A2(Ze, Oy("Permission denied."), t) : A2(Ze, Oy("Permission denied. You may want to "), h(r, A2(Ze, Oy("."), t)));
                        case 404:
                            return n ? A2(Ze, Oy("Not found."), t) : A2(Ze, Oy("Not found. If you're looking for something private, please "), h(r, A2(Ze, Oy("."), t)));
                        case 500:
                            return A2(Ze, Oy("We made a request but the service encountered an error. (500)"), t);
                        case 502:
                            return A2(Ze, Oy("We're having trouble reaching the service. (502)"), t);
                        default:
                            return A2(Ze, Oy("Unexpected error. (" + $t(e.a) + ")"), t);
                    }
                default:
                    return A2(Ze, Oy("We got a response we don't understand. Sometimes this can be fixed by refreshing the page."), t);
            }
        }();
    }), uk = F2(function(n, e) {
        return A2(rk, ak, A3(ik, n, e, g));
    }), ck = Ay("title"), ok = F2(function(n, e) {
        return A2(zy, m([
            Cy("ui icon big " + n),
            ck(e)
        ]), g);
    }), sk = F2(function(n, e) {
        return A2(zy, h(m([
            Cy("icons"),
            A2(Ly, "margin", "0 0.35rem 0 0"),
            A2(Ly, "padding", "0 0.2rem 0 0.2rem")
        ]), e), m([
            A2(zy, A2(Ze, Cy("icon circle outline"), n), g),
            A2(zy, A2(Ze, Cy("icon small minus"), n), g)
        ]));
    }), fk = sk(m([
        Cy("grey")
    ])), lk = function(n) {
        switch(n){
            case 0:
                return "Not Planned";
            case 1:
                return "Queued";
            case 2:
                return "Building";
            case 5:
                return "Build succeeded";
            case 3:
                return "Build failed";
            case 4:
                return "Build failed due to dependencies";
            default:
                return "Cancelled";
        }
    }, dk = function(n) {
        var e = lk(n);
        switch(n){
            case 0:
                return A2(ok, "grey minus", e);
            case 1:
                return A2(ok, "spinner loading", e);
            case 2:
                return A2(ok, "sun outline loading", e);
            case 5:
                return A2(ok, "check green circle", e);
            case 3:
                return A2(ok, "times red circle", e);
            case 4:
                return A2(ok, "times red circle outline", e);
            default:
                return fk(m([
                    Cy("big"),
                    ck(e)
                ]));
        }
    }, bk = function(n) {
        return n.cT.b ? lk(n.V) : "No build planned";
    }, hk = F2(function(n, e) {
        return 1 > n ? e : A3(vr, 0, -n, e);
    }), gk = z, vk = function(n) {
        var e;
        return function(n) {
            return A2(gk, ".drv", n) ? A2(hk, 4, n) : n;
        }((e = Ew(n.a8), "-" === A3(vr, 32, 33, e) && A2(vt, Lt, A3(vr, 0, 32, e)) ? A2(pr, 33, e) : e));
    }, pk = function(n) {
        switch(n.$){
            case 0:
            case 1:
                return l(gt, Bs);
            case 2:
                return l(ht(n.a), Ls(0));
            default:
                return l(gt, Es(n.a));
        }
    }, mk = F2(function(n, e) {
        return 1 === n.$ ? e : A2(Ze, n.a, e);
    }), $k = A2(Er, mk, g), yk = Fn("h3"), wk = Fn("table"), kk = Fn("tbody"), xk = Fn("td"), jk = Fn("th"), Ak = Fn("thead"), Ck = Fn("tr"), Ik = function(n) {
        switch(n){
            case 0:
            case 4:
            case 5:
                return 0;
            default:
                return 1;
        }
    }, Tk = F3(function(n, e, t) {
        return Bu({
            co: n.dR,
            eY: !1,
            a8: e,
            dA: n.ch.dA,
            d9: A2(ca, 0, A2(Fi, Ik, t)),
            dQ: n.ch.dQ
        });
    }), Sk = F3(function(n, e, t) {
        return A2(Py, m([
            Aw(A3(Tk, n, e, t))
        ]), m([
            Oy(e)
        ]));
    }), Dk = function(n) {
        return "out" === n ? A2(Pw, m([
            Cy("ui text grey")
        ]), m([
            Oy(n)
        ])) : Oy(n);
    }, Nk = F2(function(n, e) {
        var t = A2(Lr, function(e) {
            return A2(Ck, g, m([
                A2(xk, m([
                    Cy("center aligned")
                ]), m([
                    dk(e.cL)
                ])),
                A2(xk, g, m([
                    A3(Sk, n, e.a8, ht(e.cL))
                ])),
                A2(xk, g, m([
                    Dk(e.af)
                ])),
                A2(xk, g, m([
                    Oy(e.bm)
                ]))
            ]));
        }, e.ig.c3);
        return A2(wk, m([
            Cy("ui unstackable table")
        ]), m([
            A2(Ak, g, m([
                A2(Ck, m([
                    Cy("center aligned")
                ]), m([
                    A2(jk, m([
                        Cy("one wide")
                    ]), m([
                        Oy("Status")
                    ])),
                    A2(jk, m([
                        Cy("six wide")
                    ]), m([
                        Oy("Derivation")
                    ])),
                    A2(jk, m([
                        Cy("one wide")
                    ]), m([
                        Oy("Output")
                    ])),
                    A2(jk, m([
                        Cy("six wide")
                    ]), m([
                        Oy("Output path")
                    ]))
                ]))
            ])),
            A2(kk, g, t)
        ]));
    }), Ek = Fn("code"), Lk = function(n) {
        return A2(Kn, "colspan", $t(n));
    }, Bk = Fn("strong"), Ok = F2(function(n, e) {
        var t, r = jt(e.ig.$7), a = 1 === r ? "Output" : "Outputs", i = A2(Lr, function(n) {
            var e, t, i = n.b;
            return A2(Ck, g, h(1 === n.a ? m([
                A2(xk, m([
                    (t = r, A2(Kn, "rowspan", $t(t)))
                ]), m([
                    A2(Bk, g, m([
                        Oy(a)
                    ]))
                ]))
            ]) : g, m([
                A2(xk, g, m([
                    A2(Bk, g, m([
                        A2(Ek, g, m([
                            Oy(i.af)
                        ]))
                    ]))
                ])),
                A2(xk, g, (e = i.bm, m(1 === e.$ ? [
                    Oy("floating")
                ] : [
                    A2(Ek, g, m([
                        Oy(e.a)
                    ]))
                ])))
            ])));
        }, A2(cy, A2(It, 1, r), e.ig.$7));
        return A2(wk, m([
            Cy("ui structured collapsing table")
        ]), m([
            A2(kk, g, h(m([
                A2(Ck, g, m([
                    A2(xk, m([
                        Lk(2)
                    ]), m([
                        A2(Bk, g, m([
                            Oy("Derivation path")
                        ]))
                    ])),
                    A2(xk, g, m([
                        A2(Ek, g, m([
                            Oy(n.a8)
                        ]))
                    ]))
                ])),
                A2(Ck, g, m([
                    A2(xk, m([
                        Lk(2)
                    ]), m([
                        A2(Bk, g, m([
                            Oy("Platform")
                        ]))
                    ])),
                    A2(xk, g, m([
                        A2(Ek, g, m([
                            Oy(e.ig.bq)
                        ]))
                    ]))
                ])),
                A2(Ck, g, m([
                    A2(xk, m([
                        Lk(2)
                    ]), m([
                        A2(Bk, g, m([
                            Oy("Required system features")
                        ]))
                    ])),
                    A2(xk, g, (t = e.ig.bs, t.b ? A2(Bw, Oy(", "), A2(Lr, function(n) {
                        return A2(Ek, g, m([
                            Oy(n)
                        ]));
                    }, t)) : m([
                        A2(zy, g, m([
                            Oy("(none)")
                        ]))
                    ])))
                ]))
            ]), i))
        ]));
    }), Pk = F2(function(n, e) {
        for(;;){
            if (!e.b) return !1;
            var t = e.b;
            if (n(e.a)) return !0;
            e = t;
        }
    }), Gk = function(n) {
        var e, t, r, a, i = n.$7;
        return i.$ ? g : (t = A2(wc, function(n) {
            var e, t;
            return A2(Ze, A2(Ck, g, m([
                A2(xk, g, m([
                    A2(Ek, g, m([
                        Oy(n.af)
                    ]))
                ])),
                A2(xk, g, m([
                    Oy($t(n.dC))
                ])),
                A2(xk, g, (t = n.gX, t.$ || t.a.b ? g : m([
                    A2(zy, g, m([
                        Oy("(none)")
                    ]))
                ])))
            ])), 1 === (e = n.gX).$ ? g : A2(Lr, function(n) {
                return A2(Ck, g, m([
                    A2(xk, g, g),
                    A2(xk, g, g),
                    A2(xk, g, m([
                        Oy(n)
                    ]))
                ]));
            }, e.a));
        }, e = i.a), r = A2(Pk, A2(cc, function(n) {
            return n.gX;
        }, gv), e) ? "References" : "", a = A2(Ck, g, m([
            A2(xk, m([
                Lk(3)
            ]), m([
                A2(zy, g, m([
                    Oy("(none)")
                ]))
            ]))
        ])), m([
            A2(yk, g, m([
                Oy("Outputs")
            ])),
            A2(wk, m([
                Cy("ui unstackable table")
            ]), m([
                A2(Ak, g, m([
                    A2(Ck, g, m([
                        A2(jk, m([
                            Cy("two wide")
                        ]), m([
                            Oy("Output")
                        ])),
                        A2(jk, m([
                            Cy("one wide")
                        ]), m([
                            Oy("Size")
                        ])),
                        A2(jk, m([
                            Cy("nine wide")
                        ]), m([
                            Oy(r)
                        ]))
                    ]))
                ])),
                A2(kk, g, u(e, g) ? m([
                    a
                ]) : t)
            ]))
        ]));
    }, Rk = F2(function(n, e) {
        var t = A2(nc, function(n) {
            return n.eD;
        }, A2(tl, function(n) {
            return gv(n.eD);
        }, yc(Bt(e.ig.cT))));
        return A2(wc, Gk, Dl(t));
    }), zk = Fn("li"), qk = Fn("ul"), _k = F2(function(n, e) {
        return m([
            A2(yk, g, m([
                Oy("Usage")
            ])),
            A2(Ww, g, m([
                Oy("This exact derivation is part of the following projects:")
            ])),
            A2(qk, g, A2(Lr, function(e) {
                return A2(zk, g, m([
                    A2(Py, m([
                        Aw(Ju({
                            co: n.ch.co,
                            gD: gt,
                            br: e.ax,
                            dA: e.dB
                        }))
                    ]), m([
                        Oy(e.k)
                    ]))
                ]));
            }, e.ig.hC))
        ]);
    }), Hk = F2(function(n, e) {
        return h(m([
            A2(Ok, n, e),
            A2(yk, g, m([
                Oy("Inputs")
            ])),
            A2(Nk, n, e)
        ]), h(A2(Rk, n, e), A2(_k, n, e)));
    }), Fk = sk(m([
        Cy("red")
    ])), Uk = F2(function(n, e) {
        return u(n.dA, e.dA) && u(n.co, ht(e.co)) ? u(n.br, ht(e.br)) ? A2(Py, m([
            Aw(Uu(e))
        ]), m([
            Oy("#" + $t(e.ab))
        ])) : A2(Py, m([
            Aw(Uu(e))
        ]), m([
            Oy(e.br + "#" + $t(e.ab))
        ])) : A2(Py, m([
            Aw(Uu(e))
        ]), m([
            Oy(e.co + "/" + e.br + "#" + $t(e.ab))
        ]));
    }), Vk = function(n) {
        return A2(Iy, m([
            Cy("event")
        ]), m([
            A2(Iy, m([
                Cy("label")
            ]), n.N),
            A2(Iy, m([
                Cy("content")
            ]), A2(Ze, A2(Iy, m([
                Cy("summary")
            ]), n.Q), A2(Ze, A2(Iy, m([
                Cy("meta")
            ]), n.O), Dl(A2(Fi, Iy(m([
                Cy("extra")
            ])), n.K)))))
        ]));
    }, Wk = F3(function(n, e, t) {
        return n > 0 ? A3(Wk, n >> 1, h(e, e), 1 & n ? h(t, e) : t) : t;
    }), Yk = F2(function(n, e) {
        return A3(Wk, n, e, "");
    }), Mk = F3(function(n, e, t) {
        return h(A2(Yk, n - gr(t), function(n) {
            return A2(ec, n, "");
        }(e)), t);
    }), Kk = F2(function(n, e) {
        return Kt(n / e);
    }), Jk = function(n) {
        return n;
    }, Qk = F3(function(n, e, t) {
        for(;;){
            if (!t.b) return e + n;
            var r = t.a, a = t.b;
            if (0 > s(r.jC, e)) return e + r.d;
            t = a;
        }
    }), Zk = F2(function(n, e) {
        var t = n.b;
        return A3(Qk, n.a, A2(Kk, e, 6e4), t);
    }), Xk = function(n) {
        var e = A2(Kk, n, 1440) + 719468, t = (0 > e ? e - 146096 : e) / 146097 | 0, r = e - 146097 * t, a = (r - (r / 1460 | 0) + (r / 36524 | 0) - (r / 146096 | 0)) / 365 | 0, i = r - (365 * a + (a / 4 | 0) - (a / 100 | 0)), u = (5 * i + 2) / 153 | 0, c = u + (10 > u ? 3 : -9);
        return {
            eT: i - ((153 * u + 2) / 5 | 0) + 1,
            gk: c,
            hU: a + 400 * t + (c > 2 ? 0 : 1)
        };
    }, nx = F2(function(n, e) {
        return Xk(A2(Zk, n, e)).eT;
    }), ex = F2(function(n, e) {
        return A2(Ti, 24, A2(Kk, A2(Zk, n, e), 60));
    }), tx = F2(function(n, e) {
        return A2(Ti, 60, A2(Zk, n, e));
    }), rx = F2(function(n, e) {
        switch(Xk(A2(Zk, n, e)).gk){
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            case 7:
                return 6;
            case 8:
                return 7;
            case 9:
                return 8;
            case 10:
                return 9;
            case 11:
                return 10;
            default:
                return 11;
        }
    }), ax = F2(function(n, e) {
        return A2(Ti, 60, A2(Kk, e, 1e3));
    }), ix = F2(function(n, e) {
        return Xk(A2(Zk, n, e)).hU;
    }), ux = F2(function(n, e) {
        return $t(A2(ix, n, e)) + "-" + A3(Mk, 2, "0", $t(function(n) {
            switch(n){
                case 0:
                    return 1;
                case 1:
                    return 2;
                case 2:
                    return 3;
                case 3:
                    return 4;
                case 4:
                    return 5;
                case 5:
                    return 6;
                case 6:
                    return 7;
                case 7:
                    return 8;
                case 8:
                    return 9;
                case 9:
                    return 10;
                case 10:
                    return 11;
                default:
                    return 12;
            }
        }(A2(rx, n, e)))) + "-" + A3(Mk, 2, "0", $t(A2(nx, n, e))) + " " + A3(Mk, 2, "0", $t(A2(ex, n, e))) + ":" + A3(Mk, 2, "0", $t(A2(tx, n, e))) + ":" + A3(Mk, 2, "0", $t(A2(ax, n, e)));
    }), cx = A2(Wc, 0, g), ox = F2(function(n, e) {
        return A2(Pw, m([
            ck(A2(ux, cx, e) + " UTC")
        ]), m([
            Oy(A2(ux, n, e))
        ]));
    }), sx = F2(function(n, e) {
        var t = e.dM;
        if (1 === t.$) return Vk({
            K: gt,
            N: m([
                A2(zy, m([
                    Cy("ui icon red circle times")
                ]), g)
            ]),
            O: m([
                A2(ox, n.jK, e.f)
            ]),
            Q: m([
                Oy("Failed")
            ])
        });
        var r = t.a;
        return Vk({
            K: ht(m([
                A2(Iy, m([
                    Cy("ui message error")
                ]), m([
                    A2(Ww, g, m([
                        Oy(r)
                    ]))
                ]))
            ])),
            N: m([
                A2(zy, m([
                    Cy("ui icon red circle bolt")
                ]), g)
            ]),
            O: m([
                A2(ox, n.jK, e.f)
            ]),
            Q: m([
                Oy("Technical error")
            ])
        });
    }), fx = F2(function(n, e) {
        return {
            $: 11,
            a: n,
            b: e
        };
    }), lx = F2(function(n, e) {
        return {
            $: 10,
            a: n,
            b: e
        };
    }), dx = F5(function(n, e, t, r, a) {
        return A7(yu, "GET", "/api/v1/accounts/{accountId}/derivations/{derivationPath}/log/raw", m([
            l("accountId", n),
            l("derivationPath", e)
        ]), m([
            l("logId", ht(t)),
            l("iMin", A2(Fi, $t, r)),
            l("verbosity", A2(Fi, wl, a))
        ]), g, gt, Zr);
    }), bx = Fn("iframe"), hx = F3(function(n, e, t) {
        return A2(jl, m([
            "api",
            "v1",
            "accounts",
            n,
            "derivations",
            pu(e),
            "log"
        ]), m([
            A2(mu, "logId", t)
        ]));
    }), gx = F2(function(n, e) {
        var t;
        return A3(bo, (t = A2(Eo, n.cY.hZ, e)).a3, t.cc, t.ce);
    }), vx = Fn("button"), px = function(n) {
        switch(n){
            case 0:
            case 1:
                return 0;
            case 2:
            case 3:
                return 1;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            default:
                return 6;
        }
    }, mx = {
        o: 0,
        p: 0,
        bD: 0
    }, $x = function(n) {
        switch(n){
            case 0:
                return "default";
            case 1:
                return "black";
            case 2:
                return "red";
            case 3:
                return "green";
            case 4:
                return "yellow";
            case 5:
                return "blue";
            case 6:
                return "magenta";
            case 7:
                return "cyan";
            case 8:
                return "white";
            case 9:
                return "b-black";
            case 10:
                return "b-red";
            case 11:
                return "b-green";
            case 12:
                return "b-yellow";
            case 13:
                return "b-blue";
            case 14:
                return "b-magenta";
            case 15:
                return "b-cyan";
            default:
                return "b-white";
        }
    }, yx = function(n) {
        return function(n) {
            switch(n){
                case 0:
                    return "";
                case 1:
                    return "bold ";
                default:
                    return "faint ";
            }
        }(n.bD) + "fg-" + $x(n.p) + " bg-" + $x(n.o);
    }, wx = l(yx(mx), mx), kx = function(n) {
        switch(n){
            case 0:
                return 1;
            case 1:
            case 2:
                return 3;
            case 3:
                return 4;
            case 4:
                return 5;
            case 5:
                return 6;
            default:
                return 7;
        }
    }, xx = m([
        A2(Iy, m([
            Cy("ui placeholder fluid")
        ]), m([
            A2(Iy, m([
                Cy("line")
            ]), g),
            A2(Iy, m([
                Cy("line")
            ]), g),
            A2(Iy, m([
                Cy("line")
            ]), g),
            A2(Iy, m([
                Cy("line")
            ]), g),
            A2(Iy, m([
                Cy("line")
            ]), g)
        ]))
    ]), jx = F3(function(n, e, t) {
        var r = A2(Ri, n, t);
        return r.$ ? e(r.a) : Ma(r.a);
    }), Ax = {
        $: 1
    }, Cx = Oe, Ix = Pe, Tx = F2(function(n, e) {
        return {
            eL: e.eL + (n - e.d),
            h: e.h,
            i: e.i,
            d: n,
            g8: e.g8,
            b: e.b
        };
    }), Sx = Be, Dx = Le, Nx = F2(function(n, e) {
        if (A3(Dx, 101, n, e) || A3(Dx, 69, n, e)) {
            var t = n + 1, r = A3(Dx, 43, t, e) || A3(Dx, 45, t, e) ? t + 1 : t, a = A2(Sx, r, e);
            return u(r, a) ? -a : a;
        }
        return n;
    }), Ex = F2(function(n, e) {
        return A2(Nx, A3(Dx, 46, n, e) ? A2(Sx, n + 1, e) : n, e);
    }), Lx = F5(function(n, e, t, r, a) {
        var i = r.a, c = r.b;
        if (1 === e.$) return A2(Da, !0, A2(Ga, a, e.a));
        var o = e.a;
        return u(t, i) ? A2(Da, 0 > s(a.d, t), A2(Ga, a, n)) : A3(Na, !0, o(c), A2(Tx, i, a));
    }), Bx = F4(function(n, e, t, r) {
        return A2(Ba, Pa, A4(Oa, n, e, t, r));
    }), Ox = F6(function(n, e, t, r, a, i) {
        var c = a.a, o = A2(Ex, c, i.b);
        if (0 > o) return A2(Da, !0, A4(Bx, i.g8, i.eL - (o + i.d), n, i.h));
        if (u(i.d, o)) return A2(Da, !1, A2(Ga, i, e));
        if (u(c, o)) return A5(Lx, n, t, i.d, a, i);
        if (1 === r.$) return A2(Da, !0, A2(Ga, i, n));
        var s = r.a, f = Ka(A3(vr, i.d, o, i.b));
        return 1 === f.$ ? A2(Da, !0, A2(Ga, i, n)) : A3(Na, !0, s(f.a), A2(Tx, o, i));
    }), Px = F2(function(n, e) {
        var t;
        return t = {
            ex: ct(e),
            fm: n,
            fp: ct(e),
            fH: ct(e),
            fU: lt(lr),
            iF: e,
            gw: ct(e)
        }, function(n) {
            if (A3(Dx, 48, n.d, n.b)) {
                var e = n.d + 1, r = e + 1;
                return A3(Dx, 120, e, n.b) ? A5(Lx, t.iF, t.fH, r, A2(Ix, r, n.b), n) : A3(Dx, 111, e, n.b) ? A5(Lx, t.iF, t.gw, r, A3(Cx, 8, r, n.b), n) : A3(Dx, 98, e, n.b) ? A5(Lx, t.iF, t.ex, r, A3(Cx, 2, r, n.b), n) : A6(Ox, t.iF, t.fm, t.fU, t.fp, l(e, 0), n);
            }
            return A6(Ox, t.iF, t.fm, t.fU, t.fp, A3(Cx, 10, n.d, n.b), n);
        };
    }), Gx = A2(Px, Ax, Ax), Rx = F2(function(n, e) {
        return e;
    }), zx = F2(function(n, e) {
        return A3(Xa, Rx, n, e);
    }), qx = F5(function(n, e, t, r, a) {
        return A2(zx, e, ii(m([
            A2(zx, r, A2(zx, e, A2(hi, function(n) {
                return pi(A2(Ze, n, a));
            }, t))),
            A2(hi, function() {
                return vi(Bt(a));
            }, n)
        ])));
    }), _x = F4(function(n, e, t, r) {
        return ii(m([
            A2(hi, function(n) {
                return pi(A2(Ze, n, r));
            }, A2(ni, e, A2(ni, n, A2(ni, t, n)))),
            A2(hi, function() {
                return vi(Bt(r));
            }, Ya(0))
        ]));
    }), Hx = F5(function(n, e, t, r, a) {
        var i = A2(hi, function() {
            return vi(Bt(a));
        }, n);
        return A2(zx, e, ii(m([
            A2(zx, r, A2(zx, e, ii(m([
                A2(hi, function(n) {
                    return pi(A2(Ze, n, a));
                }, t),
                i
            ])))),
            i
        ])));
    }), Fx = F5(function(n, e, t, r, a) {
        var i = function(i) {
            switch(a){
                case 0:
                    return A2(bi, m([
                        i
                    ]), A4(qx, n, e, t, r));
                case 1:
                    return A2(bi, m([
                        i
                    ]), A4(Hx, n, e, t, r));
                default:
                    return A2(ni, A2(zx, e, A2(zx, r, A2(zx, e, A2(bi, m([
                        i
                    ]), A3(_x, e, t, r))))), n);
            }
        };
        return ii(m([
            A2(Ea, i, t),
            A2(hi, function() {
                return g;
            }, n)
        ]));
    }), Ux = function(n) {
        switch(n){
            case 0:
                return 0;
            case 1:
                return 1;
            default:
                return 2;
        }
    }, Vx = function(n) {
        return A2(wi, n, {
            $: 0,
            a: n
        });
    }, Wx = (ns = Ua(_a(function() {
        return !0;
    })), es = ui(m([
        (is = A2(gi, F2(function(n, e) {
            return l(yc(n), e);
        }), (cs = {
            io: "m",
            iH: ui(m([
                A2(gi, function(n) {
                    return m([
                        n
                    ]);
                }, Gx),
                Ma(g)
            ])),
            jy: ";",
            jB: Ma(0),
            jC: "[",
            jL: 0
        }, function(n) {
            return A2(zx, ji(n.jC), A2(zx, n.jB, A5(Fx, ji(n.io), n.jB, n.iH, ji(n.jy), n.jL)));
        }({
            io: Vx(cs.io),
            iH: cs.iH,
            jy: Vx(cs.jy),
            jB: cs.jB,
            jC: Vx(cs.jC),
            jL: Ux(cs.jL)
        }))), us = is, function(n) {
            var e = us(n);
            return 1 === e.$ ? A2(Da, !1, e.b) : A3(Na, !1, e.b, e.c);
        }),
        A2(gi, F2(function(n, e) {
            return l(g, "\u2B11" + e);
        }), (as = "[1G", function(n) {
            var e = n.a, t = n.b, r = !$r(e);
            return function(n) {
                var a = A5(ki, e, n.d, n.g8, n.eL, n.b), i = a.a, c = a.b, o = a.c;
                return u(i, -1) || A3(za, function(n) {
                    return Lt(n) || "_" === n;
                }, i, n.b) >= 0 ? A2(Da, !1, A2(Ga, n, t)) : A3(Na, r, 0, {
                    eL: o,
                    h: n.h,
                    i: n.i,
                    d: i,
                    g8: c,
                    b: n.b
                });
            };
        }(A2(wi, as, {
            $: 9,
            a: as
        })))),
        A2(ei, Ma(function(n) {
            return l(g, n);
        }), ns)
    ])), ts = A2(La, A2(jx, es, function() {
        return Ma(function(n) {
            return l(g, n);
        });
    }), Ua(A2(ei, A2(ei, A2(ei, li(function(n) {
        return "[" === n;
    }), _a(function(n) {
        return n >= "0" && "?" >= n;
    })), _a(function(n) {
        return n >= "!" && "/" >= n;
    })), li(function(n) {
        return n >= "@" && "~" >= n;
    })))), A2(ti, ts, ns)), Yx = F2(function(n, e) {
        var t = e.b, r = function() {
            switch(n){
                case 0:
                    return {
                        o: 0,
                        p: 0,
                        bD: 0
                    };
                case 1:
                    return b(t, {
                        bD: 1
                    });
                case 2:
                    return b(t, {
                        bD: 2
                    });
                case 30:
                    return b(t, {
                        p: 1
                    });
                case 40:
                    return b(t, {
                        o: 1
                    });
                case 31:
                    return b(t, {
                        p: 2
                    });
                case 41:
                    return b(t, {
                        o: 2
                    });
                case 32:
                    return b(t, {
                        p: 3
                    });
                case 42:
                    return b(t, {
                        o: 3
                    });
                case 33:
                    return b(t, {
                        p: 4
                    });
                case 43:
                    return b(t, {
                        o: 4
                    });
                case 34:
                    return b(t, {
                        p: 5
                    });
                case 44:
                    return b(t, {
                        o: 5
                    });
                case 35:
                    return b(t, {
                        p: 6
                    });
                case 45:
                    return b(t, {
                        o: 6
                    });
                case 36:
                    return b(t, {
                        p: 7
                    });
                case 46:
                    return b(t, {
                        o: 7
                    });
                case 37:
                    return b(t, {
                        p: 8
                    });
                case 47:
                    return b(t, {
                        o: 8
                    });
                case 39:
                    return b(t, {
                        p: 0
                    });
                case 49:
                    return b(t, {
                        o: 0
                    });
                case 90:
                    return b(t, {
                        p: 9
                    });
                case 100:
                    return b(t, {
                        o: 9
                    });
                case 91:
                    return b(t, {
                        p: 10
                    });
                case 101:
                    return b(t, {
                        o: 10
                    });
                case 92:
                    return b(t, {
                        p: 11
                    });
                case 102:
                    return b(t, {
                        o: 11
                    });
                case 93:
                    return b(t, {
                        p: 12
                    });
                case 103:
                    return b(t, {
                        o: 12
                    });
                case 94:
                    return b(t, {
                        p: 13
                    });
                case 104:
                    return b(t, {
                        o: 13
                    });
                case 95:
                    return b(t, {
                        p: 14
                    });
                case 105:
                    return b(t, {
                        o: 14
                    });
                case 96:
                    return b(t, {
                        p: 15
                    });
                case 106:
                    return b(t, {
                        o: 15
                    });
                case 97:
                    return b(t, {
                        p: 16
                    });
                case 107:
                    return b(t, {
                        o: 16
                    });
                default:
                    return t;
            }
        }();
        return l(yx(r), r);
    }), Mx = F2(function(n, e) {
        return n.b ? A3(xt, Yx, e, n) : wx;
    }), Kx = F2(function(n, e) {
        return A2(Pw, m([
            Cy(n.a)
        ]), m([
            Oy(e)
        ]));
    }), Jx = F2(function(n, e) {
        var t = A2(Ri, Wx, n);
        if (1 === t.$) return {
            eI: A2(Ze, A2(Kx, e.an, n), e.eI),
            an: e.an
        };
        var r = t.a, a = r.b, i = A2(Mx, r.a, e.an);
        return {
            eI: A2(Ze, A2(Kx, i, a), e.eI),
            an: i
        };
    }), Qx = F2(function(n, e) {
        var t;
        return b(t = A3(xt, Jx, {
            eI: g,
            an: e
        }, n), {
            eI: Bt(t.eI)
        });
    }), Zx = F2(function(n, e) {
        var t = A2(wt, "\x1b", e);
        if (t.b) {
            var r = t.a, a = t.b;
            if (A2(Cr, "\x1b", e)) return A2(Qx, A2(Ze, r, a), n);
            var i = A2(Qx, a, n);
            return {
                eI: A2(Ze, A2(Kx, n, r), i.eI),
                an: i.an
            };
        }
        return {
            eI: g,
            an: n
        };
    }), Xx = function(n) {
        return m([
            Cy("clickable"),
            ww(n)
        ]);
    }, nj = function(n) {
        var e = A2(Ti, 1e3, n);
        return A3(Mk, 4, " ", $t(n / 1e3 | 0)) + "." + A3(Mk, 3, "0", $t(e)) + " ";
    }, ej = F5(function(n, e, t, r, a) {
        return 1 === t.$ ? A2(Iy, m([
            Cy("line")
        ]), A2(Ze, A2(Pw, m([
            Cy("time")
        ]), m([
            Oy(nj(r.gl))
        ])), a)) : t.a ? A2(Iy, A2(Ze, Cy("line"), Xx(e(r.fM))), A2(Ze, A2(Pw, m([
            Cy("time"),
            A2(Ly, "color", "blue")
        ]), m([
            Oy(nj(r.gl))
        ])), A2(Ze, A2(Pw, m([
            A2(Ly, "color", "blue")
        ]), m([
            u(n, ht(r.fM)) ? Oy("\u21F2  ") : Oy("\u21F1 ")
        ])), a))) : A2(Iy, A2(Ze, Cy("line"), u(n, ht(r.fM)) ? g : m([
            Cy("log-collapsed")
        ])), A2(Ze, A2(Pw, m([
            Cy("time"),
            A2(Ly, "visibility", "hidden")
        ]), m([
            Oy(nj(r.gl))
        ])), a));
    }), tj = F4(function(n, e, t, r) {
        if (t.b) {
            if (t.b.b) return A3(xt, F2(function(t, r) {
                var a = t.a, i = t.b, u = A2(Zx, r.an, i.ht);
                return {
                    f8: A2(Ze, A5(ej, n, e, ht(a), i, u.eI), r.f8),
                    an: u.an
                };
            }), r, A2(Tt, F2(function(n, e) {
                return l(u(n, jt(t) - 1), e);
            }), t));
            var a = t.a;
            if (A2(hr, "\x1b", a.ht)) {
                var i = A2(Zx, r.an, a.ht);
                return {
                    f8: A2(Ze, A5(ej, n, e, gt, a, i.eI), r.f8),
                    an: i.an
                };
            }
            return {
                f8: A2(Ze, A5(ej, n, e, gt, a, m([
                    Oy(a.ht)
                ])), r.f8),
                an: r.an
            };
        }
        return r;
    }), rj = F3(function(n, e, t) {
        return m([
            A2(Iy, h(m([
                A2(Ly, "padding", "1em 0 1em 0"),
                Ty(e)
            ]), A2(Uf, function() {
                return n;
            }, m([
                A2(Ly, "overflow-y", "scroll"),
                A2(Ly, "scroll-behavior", "smooth"),
                A2(Ly, "height", "50vh")
            ]))), t)
        ]);
    }), aj = function(n) {
        return A2(hr, "\r", n.ht) ? A2(Lr, function(e) {
            return b(n, {
                ht: e
            });
        }, A2(Uf, function(n) {
            return "" !== n;
        }, A2(wt, "\r", n.ht))) : m([
            n
        ]);
    }, ij = Ay("target"), uj = function(n) {
        switch(n){
            case 0:
                return "Error";
            case 1:
                return "Warn";
            case 2:
                return "Notice";
            case 3:
                return "Info";
            case 4:
                return "Talkative";
            case 5:
                return "Chatty";
            case 6:
                return "Debug";
            default:
                return "Vomit";
        }
    }, cj = F2(function(n, e) {
        return A2(Mn, n, Cb(e));
    }), oj = cj("checked"), sj = cj("disabled"), fj = Ay("htmlFor"), lj = Fn("label"), dj = F2(function(n, e) {
        return A3(Er, Ur, e, n);
    }), bj = A2(dj, m([
        "target",
        "checked"
    ]), na), hj = function(n) {
        var e, t = Km(n.iT.eN);
        return A2(Ze, A2(Iy, m([
            Cy("ui toggle checkbox")
        ]), m([
            A2(yw, m([
                kw("checkbox"),
                Cy("hidden"),
                (e = n.ib, A2(Jy, "change", A2(cr, e, bj))),
                oj(n.iT.jm),
                Ty(n.iz),
                sj(t)
            ]), g),
            A2(lj, m([
                fj(n.iz)
            ]), A2(Ze, A2(zy, m([
                Cy("ui icon loading spinner"),
                A2(Ly, "visibility", t ? "visible" : "hidden")
            ]), g), n.jS))
        ])), function() {
            var e = n.iT.eN;
            switch(e.$){
                case 1:
                case 0:
                default:
                    return g;
                case 2:
                    return m([
                        A2(uk, !0, e.a)
                    ]);
            }
        }());
    }, gj = F3(function(n, e, t) {
        return A2(rk, b(ak, {
            iw: ht(e)
        }), A3(ik, n, t, g));
    }), vj = F2(function(n, e) {
        var t, r, a, i = A2(ca, 3, e.jO), c = gv(e.jO), o = 3 === (t = e.df).$ && !t.a.e5, s = A2(Uf, function() {
            return o;
        }, m([
            A2(Iy, m([
                Cy("ui basic segment")
            ]), hj({
                ib: n.gA,
                iz: "scroll-to-bottom-" + n.c,
                iT: (r = e.aT, {
                    eN: Es(0),
                    jm: r
                }),
                jS: m([
                    Oy("Auto scroll")
                ])
            }))
        ])), f = m([
            A2(Iy, m([
                Cy("ui basic segment")
            ]), m([
                A2(Py, m([
                    Cy("ui labeled icon button fluid"),
                    jw(e.e6(i)),
                    ij("_blank"),
                    A2(Ay, "download", "")
                ]), m([
                    A2(zy, m([
                        Cy("download icon")
                    ]), g),
                    Oy("Download log")
                ]))
            ]))
        ]), d = function(e) {
            return u(e, i) ? Cy("disabled") : ww(n.i4(e));
        }, b = A2(Uf, function() {
            return c;
        }, m([
            A2(Iy, m([
                Cy("ui basic segment")
            ]), m([
                A2(Iy, m([
                    Cy("ui labeled stackable buttons")
                ]), m([
                    A2(vx, m([
                        Cy("ui left attached icon button"),
                        Uy(m([
                            l("disabled", !i)
                        ]))
                    ]), m([
                        A2(zy, m([
                            Cy("minus icon"),
                            d(px(i))
                        ]), g)
                    ])),
                    A2(vx, m([
                        Cy("ui label"),
                        A2(Ly, "border-radius", "0px"),
                        A2(Ly, "margin-left", "0"),
                        A2(Ly, "margin-right", "0"),
                        A2(Ly, "width", "7rem")
                    ]), m([
                        Oy(uj(i))
                    ])),
                    A2(vx, m([
                        Cy("ui right attached icon button"),
                        Uy(m([
                            l("disabled", 7 === i)
                        ]))
                    ]), m([
                        A2(zy, m([
                            Cy("plus icon"),
                            d(kx(i))
                        ]), g)
                    ]))
                ]))
            ]))
        ]));
        return A3(rj, 3 !== (a = e.df).$ || function(n) {
            return !(n.e5 && 20 > jt(n.f8));
        }(a.a), n.c, m([
            A2(Iy, m([
                Cy("log")
            ]), m([
                A2(Iy, m([
                    Cy("sticky-controls ui compact segments")
                ]), h(b, h(s, f))),
                A2(Iy, e.iG ? g : m([
                    A2(Ly, "opacity", "50%")
                ]), function() {
                    var t = e.df;
                    switch(t.$){
                        case 3:
                            var r = t.a, a = r.f8;
                            if (a.b) {
                                var c = a;
                                return Bt(A3(xt, A2(tj, e.jg, n.i6), {
                                    f8: g,
                                    an: wx
                                }, A2(Lr, aj, c)).f8);
                            }
                            return r.e5 ? u(e.jO, gt) ? m([
                                A2(zy, g, m([
                                    Oy("(did not produce log output)")
                                ]))
                            ]) : m(e.iG ? [
                                A2(zy, g, m([
                                    Oy("(did not produce log output at " + uj(i) + " level)")
                                ]))
                            ] : [
                                A2(Iy, m([
                                    Cy("ui placeholder")
                                ]), m([
                                    A2(Iy, m([
                                        Cy("line")
                                    ]), g)
                                ]))
                            ]) : g;
                        case 1:
                            return xx;
                        case 0:
                            return g;
                        default:
                            return m([
                                A3(gj, e.fZ, "Could not retrieve log", t.a)
                            ]);
                    }
                }())
            ]))
        ]));
    }), pj = F2(function(n, e) {
        return A2(vj, {
            c: e.jR,
            i4: e.i4,
            i6: e.i6,
            gA: e.jc
        }, {
            e6: function(t) {
                return A2(gx, n, e.ik(t));
            },
            fZ: Jw(n),
            iG: e.iG,
            df: e.iT,
            jg: e.jg,
            aT: e.aT,
            jO: e.jO
        });
    }), mj = F5(function(n, e, t, r, a) {
        return r.hj ? A2(pj, n, {
            ik: function() {
                return A5(dx, t.co.c, pu(e.a8), r.dg, gt, gt);
            },
            iG: !0,
            iT: A2(ca, Mr, A2(Rl, r.dg, e.al)),
            i4: function() {
                return ql;
            },
            i6: fx(r.dg),
            jc: lx(r.dg),
            jg: A2(Xi, r.dg, e.b9),
            aT: A2(ca, !0, A2(Xi, r.dg, e.aT)),
            jO: gt,
            jR: r.dg
        }) : m([
            A2(bx, m([
                Tw(A3(hx, t.co.c, e.a8, r.dg) + "&v=" + $t(a)),
                Cy("log")
            ]), m([
                Oy("Loading log...")
            ]))
        ]);
    }), $j = F5(function(n, e, t, r, a) {
        return h(A2(Lr, function(e) {
            return Vk({
                K: gt,
                N: m([
                    A2(zy, m([
                        Cy("ui icon green circle check")
                    ]), g)
                ]),
                O: m([
                    A2(ox, n.jK, e.f)
                ]),
                Q: m([
                    Oy("Succeeded")
                ])
            });
        }, Dl(a.dI)), h(A2(Lr, function(t) {
            return Vk({
                K: A2(Fi, function(n) {
                    return m([
                        A2(Ww, g, h(m([
                            Oy("A rebuild was necessary because the output was missing from the cache when demanded by the evaluation of "),
                            A2(Uk, {
                                co: ht(e.ch.co),
                                br: gt,
                                dA: e.dA
                            }, {
                                co: e.ch.co,
                                ab: n.ab,
                                br: n.br.n,
                                dA: e.dA
                            })
                        ]), yc(Dl(A2(Fi, function(n) {
                            return m([
                                Oy(" on agent "),
                                A2(Ek, g, m([
                                    Oy(n)
                                ])),
                                Oy(".")
                            ]);
                        }, t.g$)))))
                    ]);
                }, t.g0),
                N: m([
                    A2(zy, m([
                        Cy("ui icon ellipsis horizontal")
                    ]), g)
                ]),
                O: m([
                    A2(ox, n.jK, t.f)
                ]),
                Q: m([
                    Oy("Queued")
                ])
            });
        }, Dl(a.dt)), h(A2(Lr, function(e) {
            return Vk({
                K: gt,
                N: m([
                    A2(zy, m([
                        Cy("ui icon orange ellipsis horizontal")
                    ]), g)
                ]),
                O: m([
                    A2(ox, n.jK, e.f)
                ]),
                Q: m([
                    Oy("Reset")
                ])
            });
        }, Dl(a.g4)), h(A2(Lr, function(a) {
            return Vk({
                K: ht(h(A2(Lr, function(n) {
                    return A2(Ww, g, m([
                        Oy("Agent: "),
                        A2(Ek, g, m([
                            Oy(n)
                        ]))
                    ]));
                }, Dl(a.a_)), A5(mj, n, e, t, a, r))),
                N: m([
                    A2(zy, m([
                        Cy("ui icon sun outline")
                    ]), g)
                ]),
                O: m([
                    A2(ox, n.jK, a.f)
                ]),
                Q: m([
                    Oy("Created")
                ])
            });
        }, Dl(a.dG)), h(A2(Lr, function(e) {
            return A2(sx, n, e);
        }, Dl(a.cX)), h(A2(Lr, function(e) {
            return Vk({
                K: gt,
                N: m([
                    A2(zy, m([
                        Cy("ui icon times red circle outline")
                    ]), g)
                ]),
                O: m([
                    A2(ox, n.jK, e.f)
                ]),
                Q: m([
                    Oy("Dependency failed")
                ])
            });
        }, Dl(a.cK)), h(A2(Lr, function(e) {
            return Vk({
                K: gt,
                N: m([
                    fk(m([
                        A2(Ly, "margin-left", "0.4rem")
                    ]))
                ]),
                O: m([
                    A2(ox, n.jK, e.f)
                ]),
                Q: m([
                    Oy("Cancelled")
                ])
            });
        }, Dl(a.cy)), h(A2(Lr, function(e) {
            return Vk({
                K: A2(Fi, function(n) {
                    return m([
                        Oy("Requested by @" + n.dA.n + "/" + n.n)
                    ]);
                }, e.eE),
                N: m([
                    Fk(m([
                        A2(Ly, "margin-left", "0.4rem")
                    ]))
                ]),
                O: m([
                    A2(ox, n.jK, e.f)
                ]),
                Q: m([
                    Oy("Cancelled by user")
                ])
            });
        }, Dl(a.fq)), h(A2(Lr, function(e) {
            return Vk({
                K: function() {
                    var n = A2(ca, g, e.$7);
                    if (n.b) {
                        var t = A3(xt, bt, 0, A2(Lr, function(n) {
                            return n.dC;
                        }, n));
                        return ht(m([
                            Oy("Size before compression: "),
                            Oy($t(t)),
                            Oy(" bytes")
                        ]));
                    }
                    return gt;
                }(),
                N: m([
                    A2(zy, m([
                        Cy("ui icon green circle")
                    ]), g)
                ]),
                O: m([
                    A2(ox, n.jK, e.f)
                ]),
                Q: m([
                    Oy("Built on agent")
                ])
            });
        }, Dl(a.eD)), h(A2(Lr, function(e) {
            return Vk({
                K: gt,
                N: m([
                    fk(m([
                        A2(Ly, "margin-left", "0.4rem")
                    ]))
                ]),
                O: m([
                    A2(ox, n.jK, e.f)
                ]),
                Q: m([
                    Oy("Cancellation complete")
                ])
            });
        }, Dl(a.fD)), A2(Lr, function(e) {
            return Vk({
                K: gt,
                N: m([
                    fk(m([
                        A2(Ly, "margin-left", "0.4rem")
                    ]))
                ]),
                O: m([
                    A2(ox, n.jK, e.f)
                ]),
                Q: m([
                    Oy("Cancellation for reset complete")
                ])
            });
        }, Dl(a.fE))))))))))));
    }), yj = F4(function(n, e, t, r) {
        return A2(Iy, m([
            Cy("ui feed")
        ]), A2(wc, A4($j, n, e, t, jt(r)), r));
    }), wj = F3(function(n, e, t) {
        var r = Bt(t.ig.cT);
        if (r.b) {
            if (r.b.b) {
                var a = r.a, i = r.b;
                return A2(Ze, A2(Iy, m([
                    Cy("ui vertical segment")
                ]), m([
                    A4(yj, n, e, t, a)
                ])), A2(Lr, function(r) {
                    return A2(Iy, m([
                        Cy("ui vertical segment")
                    ]), m([
                        A2(yk, g, m([
                            Oy("Previous attempt")
                        ])),
                        A4(yj, n, e, t, r)
                    ]));
                }, i));
            }
            return m([
                A4(yj, n, e, t, r.a)
            ]);
        }
        return m([
            Oy("No events / No events yet")
        ]);
    }), kj = {
        $: 5
    }, xj = {
        $: 3
    }, jj = function(n) {
        return vx(A2(Ze, Cy("ui button"), h(Km(n.eN) ? m([
            Cy("loading")
        ]) : m([
            ww(n.eM)
        ]), n.ct)));
    }, Aj = F3(function(n, e, t) {
        return h(A2(Lr, function(n) {
            return A2(jj, {
                ct: m([
                    Cy("primary fluid")
                ]),
                eM: xj,
                eN: e
            }, m([
                A2(zy, m([
                    Cy("ui icon redo alternative")
                ]), g),
                Oy(n)
            ]));
        }, function(n) {
            if (!n.ig.ge) return g;
            switch(n.ig.V){
                case 3:
                    return m([
                        "Restart build"
                    ]);
                case 4:
                    return m([
                        "Restart recursively"
                    ]);
                case 2:
                    return m([
                        "Reset build"
                    ]);
                default:
                    return g;
            }
        }(n)), n.ig.bk ? m([
            A2(jj, {
                ct: m([
                    Cy("red basic fluid"),
                    ck("Kill and do not rebuild until explicitly requested")
                ]),
                eM: kj,
                eN: t
            }, m([
                A2(zy, m([
                    Cy("ui icon times")
                ]), g),
                Oy("Cancel")
            ]))
        ]) : g);
    }), Cj = F4(function(n, e, t, r) {
        var a, i = Bu(b(n.ch, {
            d9: e
        }));
        return A2(Iy, A2(Ze, ww({
            $: 2,
            a: e
        }), h((a = u(n.ch.d9, e), A2(Uf, function() {
            return a;
        }, m([
            Cy("active")
        ]))), t)), m([
            A2(Py, m([
                Aw(i)
            ]), r)
        ]));
    }), Ij = F3(function(n, e, t) {
        var r, a = pk(e.cg), i = a.a, u = a.b, c = pk(e.bN), o = c.a, s = c.b, f = A2(Lr, uk(Jw(n)), $k(m([
            i,
            o
        ])));
        return A2(Iy, g, h(m(e.ch.eY ? [
            A2(Mw, m([
                Cy("ui large header")
            ]), m([
                Oy("Dependencies of " + vk(e))
            ]))
        ] : [
            A2(Iy, m([
                A2(Ly, "float", "right"),
                A2(Ly, "width", "14em")
            ]), A3(Aj, t, u, s)),
            A2(Mw, m([
                Cy("ui large header")
            ]), m([
                (r = t.ig, r.cT.b ? dk(r.V) : A2(ok, "", "")),
                Oy(bk(t.ig))
            ]))
        ]), A2(Ze, A2(Iy, g, f), h(e.ch.eY ? g : m([
            A2(Iy, m([
                Cy("ui big top attached tabular small menu")
            ]), h(m([
                A4(Cj, e, 0, m([
                    Cy("item right")
                ]), m([
                    A2(zy, m([
                        Cy("ui icon info circle black")
                    ]), g),
                    Oy("Info")
                ]))
            ]), A2(Uf, function() {
                return !!t.ig.V;
            }, m([
                A4(Cj, e, 1, m([
                    Cy("item ")
                ]), m([
                    A2(zy, m([
                        Cy("ui icon clipboard list black")
                    ]), g),
                    Oy("Log")
                ]))
            ]))))
        ]), m([
            A2(Iy, m([
                Cy("ui bottom attached active tab segment")
            ]), e.ch.d9 ? A3(wj, n, e, t) : A2(Hk, e, t))
        ])))));
    }), Tj = F2(function(n, e) {
        return {
            u: function() {
                var t = A2(Ps, n, e);
                switch(t.$){
                    case 3:
                        return A3(Ij, n, e, t.a);
                    case 2:
                        var r = t.a;
                        return A2(uk, Jw(n), r);
                    default:
                        return function(n) {
                            return Oy("Loading " + n.a8);
                        }(e);
                }
            }(),
            e: Kw(e)
        };
    }), Sj = function(n) {
        return Aw(qu({
            co: ht(n.ax),
            dA: ht(n.hf)
        }));
    }, Dj = function(n) {
        var e = A2(ix, cx, n), t = function() {
            switch(A2(rx, cx, n)){
                case 0:
                    return "01";
                case 1:
                    return "02";
                case 2:
                    return "03";
                case 3:
                    return "04";
                case 4:
                    return "05";
                case 5:
                    return "06";
                case 6:
                    return "07";
                case 7:
                    return "08";
                case 8:
                    return "09";
                case 9:
                    return "10";
                case 10:
                    return "11";
                default:
                    return "12";
            }
        }(), r = A2(nx, cx, n), a = 10 > r ? "0" + $t(r) : $t(r);
        return $t(e) + "-" + t + "-" + a;
    }, Nj = function(n) {
        return n.$ ? "unknown" : Dj(n.a);
    }, Ej = function(n) {
        switch(n.ew){
            case 0:
                return A2(Ww, g, m([
                    Oy("You are on the free community plan.")
                ]));
            case 1:
                return A2(Ww, g, m([
                    Oy("Your free trial is active since " + Nj(n.hy) + ".")
                ]));
            case 2:
                return A2(Ww, g, m([
                    Oy("Your subscription is active since " + Nj(n.hp) + ".")
                ]));
            case 3:
                return A2(Ww, g, m([
                    Oy("Your subscription is cancelled since " + Nj(n.ho) + ".")
                ]));
            case 4:
                return A2(Ww, g, m([
                    Oy("Your subscription is active but not managed via the dashboard. For questions, contact support@hercules-ci.com.")
                ]));
            default:
                return A2(Ww, g, m([
                    Oy("You are using Hercules CI Enterprise, which is billed at the instance level. For questions, contact support@hercules-ci.com.")
                ]));
        }
    }, Lj = {
        $: 4
    }, Bj = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Oj = F3(function(n, e, t) {
        switch(t.$){
            case 0:
                return A2(Iy, g, g);
            case 1:
                return A2(Iy, m([
                    Cy("ui icon message")
                ]), m([
                    A2(zy, m([
                        Cy("notched circle loading icon")
                    ]), g),
                    A2(Iy, m([
                        Cy("content")
                    ]), m([
                        A2(Iy, m([
                            Cy("header")
                        ]), m([
                            Oy("Loading")
                        ])),
                        A2(Ww, g, m([
                            Oy("We are disabling all repos for this account.")
                        ]))
                    ]))
                ]));
            case 3:
                var r = t.a;
                return A2(Iy, m([
                    Cy("ui icon positive message")
                ]), m([
                    A2(zy, m([
                        Cy("notched check icon")
                    ]), g),
                    A2(Iy, m([
                        Cy("content")
                    ]), m([
                        A2(Iy, m([
                            Cy("header")
                        ]), m([
                            Oy("Done")
                        ])),
                        A2(Ww, g, m([
                            Oy("We have disabled all " + $t(r) + " known repos in " + e.co.ax + ".")
                        ]))
                    ]))
                ]));
            default:
                var a = t.a;
                return A2(Iy, m([
                    Cy("ui icon negative message")
                ]), m([
                    A2(zy, m([
                        Cy("notched exclamation icon")
                    ]), g),
                    A2(Iy, m([
                        Cy("content")
                    ]), m([
                        A2(Iy, m([
                            Cy("header")
                        ]), m([
                            Oy("Error")
                        ])),
                        A2(Ww, g, A3(ik, Jw(n), a, g))
                    ]))
                ]));
        }
    }), Pj = F3(function(n, e, t) {
        return m([
            A2(Ww, g, m([
                Oy("Enabling a repository only has an effect when it contains a "),
                A2(Ek, g, m([
                    Oy("flake.nix")
                ])),
                Oy(", "),
                A2(Ek, g, m([
                    Oy("nix/ci.nix")
                ])),
                Oy(", "),
                A2(Ek, g, m([
                    Oy("ci.nix")
                ])),
                Oy(" or "),
                A2(Ek, g, m([
                    Oy("default.nix")
                ])),
                Oy(" file. Repositories without any of these files are ignored. "),
                A2(Ek, g, m([
                    Oy("flake.nix")
                ])),
                Oy("is ignored when all "),
                A2(Ek, g, m([
                    Oy("x86_64-linux")
                ])),
                Oy(" agents are older than "),
                A2(Ek, g, m([
                    Oy("0.9")
                ])),
                Oy(".")
            ])),
            A2(Ww, g, hj({
                ib: Bj,
                iz: "enableNewRepos",
                iT: {
                    eN: e.b_,
                    jm: t.ai.cS
                },
                jS: m([
                    Oy("Enable new repositories when they are added.")
                ])
            })),
            A2(Iy, m([
                Cy("ui segment")
            ]), m([
                A2(Ww, g, m([
                    Oy("This disables building of all repositories in " + t.co.ax + ". This action can not be reversed by itself; repositories must be re-enabled one by one.")
                ])),
                A2(vx, m([
                    Cy("ui button negative basic"),
                    ww(Lj)
                ]), m([
                    Oy("Disable all repositories")
                ])),
                A3(Oj, n, t, e.bW)
            ]))
        ]);
    }), Gj = A2(zy, m([
        Cy("ui small icon external link"),
        A2(Ly, "vertical-align", "text-bottom"),
        A2(Ly, "margin", "2pt"),
        A2(Ly, "text-decoration", "none")
    ]), g), Rj = F3(function(n, e, t) {
        var r, a = t.co.da, i = a ? "Uninstall" : "Install", u = pk(e.c4), c = u.a, o = u.b;
        return m([
            A2(yk, g, m([
                Oy("GitLab integration settings")
            ])),
            A2(Ww, g, m([
                Oy("You must be a Group Owner on GitLab to enable / disable the integration.")
            ])),
            A2(Ww, g, m([
                A2(Iy, g, A2(Lr, uk(Jw(n)), Dl(c))),
                A2(jj, {
                    ct: m([
                        Uy(m([
                            l("primary", !a),
                            l("red", a)
                        ]))
                    ]),
                    eM: (r = !a, {
                        $: 13,
                        a: r
                    }),
                    eN: o
                }, m([
                    Oy(i)
                ]))
            ]))
        ]);
    }), zj = F3(function(n, e, t) {
        return "gitlab" !== t.fr.W ? g : A3(Rj, n, e, t);
    }), qj = F3(function(n, e, t) {
        var r = t.co.fT;
        if (1 === r.$) return A3(zj, n, e, t);
        var a = r.a;
        return A2(Ze, A2(yk, g, m([
            Oy("Installation on " + t.co.hf)
        ])), a ? h(m([
            A2(Ww, g, m([
                Oy("The integration only has access to a limited number of repositories via " + t.co.hf + ". This means only admins can add new repositories.")
            ])),
            A2(Ww, g, m([
                Oy("If you install github on all repositories, non-admins can enable and disable Hercules CI on repositories where they have write permission.")
            ]))
        ]), A2(Lr, function(n) {
            return A2(Ww, g, m([
                A2(Py, m([
                    Cy("ui button primary"),
                    jw(n)
                ]), m([
                    Oy("Configure access or add repositories")
                ]))
            ]));
        }, Dl(t.co.gc))) : A2(Ze, A2(Ww, g, m([
            Oy("The integration is enabled for all repositories. Non-admins can enable and disable Hercules CI on repositories where they have write permission.")
        ])), A2(Lr, function(n) {
            return A2(Ww, g, m([
                A2(Py, m([
                    Cy("ui button primary"),
                    jw(n)
                ]), m([
                    Oy("Configure repository access"),
                    Gj
                ]))
            ]));
        }, Dl(t.co.gc))));
    }), _j = F3(function(n, e, t) {
        return A2(Iy, g, h(A3(qj, n, e, t), A2(Ze, A2(yk, g, m([
            Oy("Newly added repositories")
        ])), h(A3(Pj, n, e, t), A2(Ze, A2(yk, g, m([
            Oy("Billing")
        ])), function(n) {
            var e = A2(Py, m([
                Cy("ui primary button"),
                Sj(n)
            ]), m([
                Oy("Configure")
            ])), t = n.gB;
            if (t.$) return m([
                A2(Ww, g, m([
                    Oy("Start a trial or add this account to an existing organization.")
                ])),
                e
            ]);
            var r = t.a;
            return m([
                A2(Ww, g, m([
                    Oy("This account is billed as part of "),
                    A2(zy, g, m([
                        Oy(r.k)
                    ]))
                ])),
                Ej(r),
                e
            ]);
        }(t.co))))));
    }), Hj = {
        u: A2(Iy, g, m([
            A2(Iy, m([
                Cy("ui placeholder")
            ]), m([
                A2(Iy, m([
                    Cy("line")
                ]), g),
                A2(Iy, m([
                    Cy("line")
                ]), g),
                A2(Iy, m([
                    Cy("line")
                ]), g)
            ]))
        ])),
        e: "Account settings"
    }, Fj = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Uj = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Vj = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Wj = function(n) {
        return {
            $: 11,
            a: n
        };
    }, Yj = F4(function(n, e, t, r) {
        if (1 === r.$) return A3(e, Iy, g, m(n ? [
            A2(zy, g, m([
                Oy("please select")
            ]))
        ] : [
            A2(zy, g, m([
                Oy("default")
            ]))
        ]));
        var a = r.a;
        return A3(e, Iy, m([
            ck(a)
        ]), m([
            Oy(a)
        ]));
    }), Mj = F3(function(n, e, t) {
        return A3(n, Iy, g, m(1 === t.$ ? [
            A2(zy, g, m([
                Oy("default")
            ]))
        ] : t.a ? [
            Oy("All")
        ] : [
            Oy("Ignore")
        ]));
    }), Kj = m([
        0,
        1
    ]), Jj = function(n) {
        return A2(Xl, g, A2(kf, function(n) {
            return n.es;
        }, n.Z));
    }, Qj = function(n) {
        switch(n.$){
            case 1:
                return A2(zy, m([
                    Cy("ui icon circle notch loading")
                ]), g);
            case 3:
                return A2(zy, m([
                    Cy("ui icon check")
                ]), g);
            case 2:
                return A2(zy, m([
                    Cy("ui icon times")
                ]), g);
            default:
                return A2(zy, m([
                    Cy("ui icon")
                ]), g);
        }
    }, Zj = F3(function(n, e, t) {
        return A2(Iy, m([
            Cy("ui segment")
        ]), m([
            A2(yk, g, m([
                Oy("Personal notification settings")
            ])),
            A2(Ww, g, m([
                Oy("These settings only apply to you. They override your "),
                A2(Py, m([
                    Aw(Mu)
                ]), m([
                    Oy("default notification settings")
                ])),
                Oy(".")
            ])),
            A2(Iy, m([
                Cy("ui stackable grid")
            ]), m([
                A2(Iy, m([
                    Cy("row")
                ]), m([
                    A2(Iy, m([
                        Cy("ten wide column")
                    ]), m([
                        A2(Iy, m([
                            Cy("ui labeled input fluid")
                        ]), m([
                            A2(Iy, m([
                                Cy("ui label primary"),
                                A2(Ly, "width", "11em")
                            ]), m([
                                Oy("Email "),
                                Qj(e.b7)
                            ])),
                            A5(xw, qy({
                                h8: A2(Ze, gt, A2(Lr, A2(Zc, ht, function(n) {
                                    return n.ej;
                                }), Jj(e))),
                                iC: "default-email",
                                i8: Fj,
                                jb: Uj
                            }), {
                                im: e.dk,
                                jw: A2(nc, function(n) {
                                    return n.gu;
                                }, A2(Wb, e, t))
                            }, Iy, m([
                                Cy("fluid"),
                                Uy(m([
                                    l("loading", Km(e.Z))
                                ]))
                            ]), Yj(!1))
                        ]))
                    ]))
                ])),
                A2(Iy, m([
                    Cy("ten wide column")
                ]), m([
                    A2(Iy, m([
                        Cy("ui labeled input fluid")
                    ]), m([
                        A2(Iy, m([
                            Cy("ui label primary"),
                            A2(Ly, "width", "11em")
                        ]), m([
                            Oy("Events "),
                            Qj(e.b8)
                        ])),
                        A5(xw, qy({
                            h8: A2(Ze, gt, A2(Lr, ht, Kj)),
                            iC: "default-level",
                            i8: Vj,
                            jb: Wj
                        }), {
                            im: e.dm,
                            jw: A2(nc, function(n) {
                                return n.gv;
                            }, A2(Wb, e, t))
                        }, Iy, m([
                            Cy("fluid"),
                            Uy(m([
                                l("loading", Km(e.Z))
                            ]))
                        ]), Mj)
                    ]))
                ]))
            ]))
        ]));
    }), Xj = F2(function(n, e) {
        var t = e.co;
        switch(t.$){
            case 3:
                var r = t.a;
                return {
                    u: A2(Iy, g, m([
                        A3(Zj, n, e, r),
                        function() {
                            var t = A2(Kb, n, e);
                            switch(t.$){
                                case 2:
                                    if (3 === t.a.$ && 403 === t.a.a) return A2(Iy, g, g);
                                    var r = t.a;
                                    return A2(uk, Jw(n), r);
                                case 3:
                                    var a = t.a;
                                    return A2(Iy, m([
                                        Cy("ui segment")
                                    ]), m([
                                        A3(_j, n, e, a)
                                    ]));
                                default:
                                    return Hj.u;
                            }
                        }()
                    ])),
                    e: r.ax + " account settings"
                };
            case 2:
                var a = t.a;
                return {
                    u: A2(uk, Jw(n), a),
                    e: "Error"
                };
            default:
                return Hj;
        }
    }), nA = {
        $: 1
    }, eA = {
        $: 0
    }, tA = 18e4, rA = F2(function(n, e) {
        var t = e.g7;
        if (t.$) {
            var r = e.f5;
            if (1 === r.$) return eA;
            var a = r.a;
            return e.et ? s(n.eS - a, tA) > 0 ? {
                $: 3,
                a: a
            } : nA : function(n) {
                return {
                    $: 2,
                    a: n
                };
            }(a);
        }
        return {
            $: 4,
            a: a = t.a
        };
    }), aA = F2(function(n, e) {
        return 1 === A2(rA, n, e).$;
    }), iA = w, uA = iA(function(n) {
        return -n.eR;
    }), cA = F2(function(n, e) {
        return b(e, {
            cC: n
        });
    }), oA = F2(function(n, e) {
        return b(e, {
            cM: n
        });
    }), sA = {
        cv: !1,
        cz: !1,
        cC: gt,
        cM: gt,
        c0: !1,
        iB: gt,
        b1: gt,
        ds: gt,
        dC: 3,
        dK: !1
    }, fA = F3(function(n, e, t) {
        var r, a, i, c = m([
            Oy(t)
        ]);
        return A2(n, yc(m([
            m([
                Cy("ui label"),
                Uy(m([
                    l("image", !u(e.b1, gt)),
                    l("basic", e.cv),
                    l("tag", e.dK),
                    l("horizontal", e.c0),
                    l("circular", e.cz)
                ])),
                Ow(e.dC)
            ]),
            function() {
                var n = e.ds;
                if (n.$) return g;
                switch(n.a){
                    case 0:
                        return m([
                            Cy("pointing")
                        ]);
                    case 1:
                        return m([
                            Cy("pointing below")
                        ]);
                    case 2:
                        return m([
                            Cy("left pointing")
                        ]);
                    default:
                        return m([
                            Cy("right pointing")
                        ]);
                }
            }(),
            (i = e.cC, i.$ ? g : m([
                Zw(i.a)
            ]))
        ])), yc(m([
            (a = e.b1, a.$ ? g : m([
                A2(Iw, m([
                    Tw(a.a)
                ]), g)
            ])),
            (r = e.iB, r.$ ? g : m([
                A2(nk, ek, r.a)
            ])),
            c,
            function() {
                var n = e.cM;
                if (n.$) return g;
                var t = n.a;
                return m([
                    A2(Iy, m([
                        Cy("detail")
                    ]), m([
                        Oy(t)
                    ]))
                ]);
            }()
        ])));
    }), lA = fA(Iy), dA = function(n) {
        return 0 > n ? -n : n;
    }, bA = F2(function(n, e) {
        var t = dA(n - e) / 1e3 | 0, r = t / 60 | 0, a = t / 3600 | 0, i = t / 86400 | 0;
        return 2 > i ? 2 > a ? 2 > r ? 1 > r ? 2 > t ? "a second" : "seconds" : "a minute" : $t(r) + " minutes" : $t(a) + " hours" : $t(i) + " days";
    }), hA = F2(function(n, e) {
        var t = function(e) {
            return ht("for " + A2(bA, n.eS, e));
        }, r = A2(rA, n, e);
        switch(r.$){
            case 0:
                return A2(lA, sA, "Waiting to connect");
            case 1:
                return A2(lA, A2(cA, ht(4), sA), "Online");
            case 3:
                var a = r.a;
                return A2(lA, A2(cA, ht(2), A2(oA, t(a), sA)), "No connection");
            case 2:
                return a = r.a, A2(lA, A2(cA, ht(0), A2(oA, t(a), sA)), "Shut down");
            default:
                return a = r.a, A2(lA, A2(cA, ht(6), A2(oA, t(a), sA)), "Revoked");
        }
    }), gA = Fn("dd"), vA = Fn("dl"), pA = Fn("dt"), mA = function(n) {
        return m([
            A2(vA, g, A2(wc, function(n) {
                var e = n.a, t = n.b;
                return m([
                    A2(pA, m([
                        A2(Ly, "font-weight", "bold")
                    ]), m([
                        A2(Ek, m([
                            A2(Ly, "color", "#007")
                        ]), m([
                            Oy(e)
                        ]))
                    ])),
                    A2(gA, g, $A(t))
                ]);
            }, tt(n)))
        ]);
    }, $A = function(n) {
        var e, t = A2(wa, Zr, n);
        if (t.$) {
            var r = A2(wa, Oo, n);
            if (r.$) {
                var a = A2(wa, na, n);
                if (a.$) {
                    var i = A2(wa, $a(xa), n);
                    if (i.$) {
                        var u = A2(wa, {
                            $: 4,
                            b: xa
                        }, n);
                        return m(u.$ ? [
                            A2(Ek, g, m([
                                Oy(A2(mt, 2, n))
                            ]))
                        ] : (e = u.a, o = A3(nt, Ze, g, e)).b ? [
                            A2(qk, g, A2(Lr, function(n) {
                                return A2(zk, g, $A(n));
                            }, o))
                        ] : [
                            A2(zy, g, m([
                                Oy("(empty list)")
                            ]))
                        ]);
                    }
                    return mA(i.a);
                }
                return m(a.a ? [
                    A2(Ek, m([
                        A2(Ly, "color", "#00a")
                    ]), m([
                        Oy("true")
                    ]))
                ] : [
                    A2(Ek, m([
                        A2(Ly, "color", "#00a")
                    ]), m([
                        Oy("false")
                    ]))
                ]);
            }
            var c = r.a;
            return m([
                A2(Ek, m([
                    A2(Ly, "color", "#077")
                ]), m([
                    Oy($t(c))
                ]))
            ]);
        }
        var o, s = t.a;
        return m([
            A2(Ek, m([
                A2(Ly, "color", "#700")
            ]), m([
                Oy(s)
            ]))
        ]);
    }, yA = F2(function(n, e) {
        return A2(Iy, m([
            Cy("ui segment")
        ]), m([
            A2(Mw, g, m([
                Oy("Agent")
            ])),
            A2(wk, m([
                Cy("ui very basic stackable table")
            ]), m([
                A2(kk, g, m([
                    A2(Ck, g, m([
                        A2(jk, g, m([
                            Oy("Hostname")
                        ])),
                        A2(xk, g, m([
                            A2(Ek, g, m([
                                Oy(e.fK)
                            ]))
                        ]))
                    ])),
                    A2(Ck, g, m([
                        A2(jk, g, m([
                            Oy("Status")
                        ])),
                        A2(xk, g, m([
                            A2(hA, n, e)
                        ]))
                    ])),
                    A2(Ck, g, m([
                        A2(jk, g, m([
                            Oy("Id")
                        ])),
                        A2(xk, g, m([
                            A2(Ek, g, m([
                                Oy(e.c)
                            ]))
                        ]))
                    ])),
                    A2(Ck, g, m([
                        A2(jk, g, m([
                            Oy("Platforms")
                        ])),
                        A2(xk, g, m([
                            A2(qk, g, A2(Lr, function(n) {
                                return A2(zk, g, m([
                                    A2(Ek, g, m([
                                        Oy(n)
                                    ]))
                                ]));
                            }, e.gL))
                        ]))
                    ])),
                    A2(Ck, g, m([
                        A2(jk, g, m([
                            Oy("System features")
                        ])),
                        A2(xk, g, m([
                            A2(qk, g, A2(Lr, function(n) {
                                return A2(zk, g, m([
                                    A2(Ek, g, m([
                                        Oy(n)
                                    ]))
                                ]));
                            }, e.hs))
                        ]))
                    ])),
                    A2(Ck, g, m([
                        A2(jk, g, m([
                            Oy("Substituters")
                        ])),
                        A2(xk, g, m([
                            A2(qk, g, A2(Lr, function(n) {
                                return A2(zk, g, m([
                                    A2(Ek, g, m([
                                        Oy(n)
                                    ]))
                                ]));
                            }, e.hr))
                        ]))
                    ])),
                    A2(Ck, g, m([
                        A2(jk, g, m([
                            Oy("Push+pull caches")
                        ])),
                        A2(xk, g, m([
                            A2(qk, g, A2(Lr, function(n) {
                                return A2(zk, g, m([
                                    A2(Ek, g, m([
                                        Oy(n)
                                    ]))
                                ]));
                            }, e.gV))
                        ]))
                    ])),
                    A2(Ck, g, m([
                        A2(jk, g, m([
                            Oy("Concurrency")
                        ])),
                        A2(xk, g, m([
                            A2(Ek, g, m([
                                Oy($t(e.eP))
                            ]))
                        ]))
                    ])),
                    A2(Ck, g, m([
                        A2(jk, g, m([
                            Oy("Agent version")
                        ])),
                        A2(xk, g, m([
                            A2(Ek, g, m([
                                Oy(e.a0)
                            ]))
                        ]))
                    ])),
                    A2(Ck, g, m([
                        A2(jk, g, m([
                            Oy("Nix version")
                        ])),
                        A2(xk, g, m([
                            A2(Ek, g, m([
                                Oy(e.gr)
                            ]))
                        ]))
                    ])),
                    A2(Ck, g, m([
                        A2(jk, g, m([
                            Oy("Labels")
                        ])),
                        A2(xk, g, mA(e.f4))
                    ]))
                ]))
            ]))
        ]));
    }), wA = F2(function(n, e) {
        var t = e.aB;
        if (3 === t.$) {
            if (t.a.b) {
                var r = t.a;
                return A2(Iy, g, A2(Lr, yA(n), uA(A2(Uf, aA(n), r))));
            }
            return A2(Iy, g, g);
        }
        return A2(Iy, g, g);
    }), kA = F2(function(n, e) {
        var t = l(e, n);
        n: for(;;){
            e: for(;;){
                t: for(;;){
                    r: for(;;)switch(t.a.$){
                        case 3:
                            switch(t.b.$){
                                case 3:
                                    return Es((0, t.a.a)(t.b.a));
                                case 2:
                                    break n;
                                case 1:
                                    break t;
                                default:
                                    return Bs;
                            }
                        case 2:
                            return Ls(t.a.a);
                        case 1:
                            if (2 === t.b.$) break n;
                            break e;
                        default:
                            switch(t.b.$){
                                case 2:
                                    break n;
                                case 1:
                                    break t;
                                default:
                                    break r;
                            }
                    }
                    return Bs;
                }
                return Mr;
            }
            return Mr;
        }
        return Ls(t.b.a);
    }), xA = F2(function(n, e) {
        return A2(kA, e, A2(kf, F2(function(n, e) {
            return l(n, e);
        }), n));
    }), jA = F2(function(n, e) {
        var t = function(e) {
            return A2(Ck, g, m([
                A2(xk, g, m([
                    Oy(A2(bA, n.eS, e.eR))
                ])),
                A2(xk, g, A2(Lr, function(n) {
                    return A2(Pw, m([
                        Cy("ui label black")
                    ]), m([
                        Oy(n)
                    ]));
                }, e.gL)),
                A2(xk, g, A2(Lr, function(n) {
                    return A2(Pw, m([
                        Cy("ui label black")
                    ]), m([
                        Oy(n)
                    ]));
                }, e.hs)),
                A2(xk, g, m([
                    Oy(e.a0)
                ])),
                A2(xk, g, m([
                    Oy(e.gr)
                ])),
                A2(xk, g, g)
            ]));
        }, r = function() {
            var n = A2(kf, function(n) {
                return n.b;
            }, A2(xA, e.co, e.aB));
            switch(n.$){
                case 2:
                    return Oy("Oops, we could not load the agent this time.");
                case 3:
                    if (n.a.b) {
                        var r = n.a;
                        return A2(Iy, g, m([
                            A2(Mw, g, m([
                                Oy("Installation history")
                            ])),
                            A2(Ww, g, m([
                                Oy("Your agent derives a unique token from the cluster join token, which is saved in the "),
                                A2(Ek, g, m([
                                    Oy("session.key")
                                ])),
                                Oy(" file. When you re-create this token, an entry appears here.")
                            ])),
                            A2(wk, m([
                                Cy("ui unstackable very basic table")
                            ]), m([
                                A2(Ak, g, m([
                                    A2(jk, g, m([
                                        Oy("Registered since")
                                    ])),
                                    A2(jk, g, m([
                                        Oy("Platforms")
                                    ])),
                                    A2(jk, g, m([
                                        Oy("Features")
                                    ])),
                                    A2(jk, g, m([
                                        Oy("Agent version")
                                    ])),
                                    A2(jk, g, m([
                                        Oy("Nix version")
                                    ]))
                                ])),
                                A2(kk, g, A2(Lr, t, uA(r)))
                            ]))
                        ]));
                    }
                    return A2(Iy, g, m([
                        A2(Mw, g, m([
                            Oy("No data")
                        ])),
                        A2(Ww, g, m([
                            Oy("No agent has reported in with the hostname " + e.ch.fK + ". You may want to look at some system logs if you expected an agent to show up with that name.")
                        ]))
                    ]));
                case 1:
                    return A2(Iy, m([
                        Cy("ui loader active massive text")
                    ]), m([
                        Oy("Loading agent sessions")
                    ]));
                default:
                    return A2(Pw, g, g);
            }
        }();
        return A2(Iy, m([
            Cy("ui segment")
        ]), m([
            r
        ]));
    }), AA = F2(function(n, e) {
        return {
            u: A2(Iy, g, m([
                A2(wA, n, e),
                A2(jA, n, e)
            ])),
            e: "Agent " + e.ch.fK
        };
    }), CA = function(n) {
        if (3 === n.$) {
            var e = n.a;
            return m([
                A2(yk, g, m([
                    Oy("Active Users")
                ])),
                A2(Ww, g, m([
                    Oy((a = e.gq, a.$ ? "Based on the past month's usage." : "So far, until the end of the payment term on " + Dj(a.a) + "."))
                ])),
                (t = e.eh, r = A2(Lr, function(n) {
                    return A2(Ck, g, m([
                        A2(xk, g, m([
                            A2(Dw, n, 30),
                            Oy(n.k)
                        ])),
                        A2(xk, g, m([
                            Oy(n.hf + "/" + n.ax)
                        ]))
                    ]));
                }, t), A2(wk, m([
                    Cy("ui unstackable table")
                ]), m([
                    A2(Ak, g, m([
                        A2(Ck, m([
                            Cy("left aligned")
                        ]), m([
                            A2(jk, g, m([
                                Oy("Name")
                            ])),
                            A2(jk, g, m([
                                Oy("Handle")
                            ]))
                        ]))
                    ])),
                    A2(kk, g, r)
                ])))
            ]);
        }
        var t, r, a;
        return g;
    }, IA = function(n) {
        switch(n.$){
            case 1:
                return "Timeout exceeded";
            case 2:
                return "Network error";
            case 3:
                return "HTTP Error " + $t(n.a) + " ";
            case 4:
                return "Unexpected response from api: " + n.a;
            default:
                return "Malformed url: " + n.a;
        }
    }, TA = function(n) {
        return 2 === n.$ ? A2(rk, ak, m([
            Oy("HTTP request failed: " + IA(n.a))
        ])) : Oy("");
    }, SA = F2(function(n, e) {
        return A2(Kn, function(n) {
            return /^(on|formAction$)/i.test(n) ? "data-" + n : n;
        }(n), Jn(e));
    }), DA = SA, NA = function(n) {
        return {
            $: 8,
            a: n
        };
    }, EA = Fn("form"), LA = F2(function(n, e) {
        return A2(EA, yc(m([
            n.ct,
            m([
                Cy("ui form"),
                Uy(m([
                    l("error", n.e9)
                ]))
            ])
        ])), e);
    }), BA = {
        ct: g,
        e9: !1
    }, OA = {
        ct: g,
        e9: !1,
        c_: !1,
        dZ: !1,
        b2: !1,
        de: !1,
        dC: 3,
        eb: !1
    }, PA = function(n) {
        var e = n.dZ, t = n.ct, r = n.de, a = n.e9, i = n.eb, u = n.c_, c = n.dC, o = n.b2;
        return A2(Iy, m([
            Cy("ui input"),
            Uy(m([
                l("focus", e),
                l("loading", r),
                l("error", a),
                l("transparent", i),
                l("inverted", o),
                l("fluid", u)
            ])),
            Ow(c)
        ]), m([
            A2(yw, t, g)
        ]));
    }, GA = function(n) {
        return l(n, !0);
    }, RA = F2(function(n, e) {
        return A2(Ky, n, {
            $: 1,
            a: e
        });
    }), zA = A2(dj, m([
        "target",
        "value"
    ]), Zr), qA = function(n) {
        return A2(RA, "input", A2(cr, GA, A2(cr, n, zA)));
    }, _A = F2(function(n, e) {
        return b(e, {
            ct: n
        });
    }), HA = {
        hW: !1,
        h$: gt,
        ct: g,
        cv: !1,
        ih: !1,
        bd: gt,
        cZ: gt,
        c_: !1,
        aK: gt,
        iB: gt,
        c2: 0,
        b2: !1,
        de: !1,
        dC: 3
    }, FA = function(n) {
        return Cy(function() {
            switch(n){
                case 0:
                    return "top attached";
                case 1:
                    return "middle attached";
                default:
                    return "bottom attached";
            }
        }());
    }, UA = function(n) {
        return !n.b;
    }, VA = F3(function(n, e, t) {
        var r, a, i = !u(e.iB, gt) && !UA(t), c = yc(m([
            (r = e.iB, r.$ ? g : m([
                A2(nk, ek, r.a)
            ])),
            t
        ]));
        return A2(n, yc(m([
            e.ct,
            m([
                Cy("ui button"),
                Uy(m([
                    l("basic", e.cv),
                    l("inverted", e.b2),
                    l("loading", e.de),
                    l("fluid", e.c_),
                    l("inverted", e.b2),
                    l("right", i && 1 === e.c2),
                    l("labeled", i),
                    l("icon", !u(e.iB, gt)),
                    l("active", e.hW),
                    l("disabled", e.ih)
                ])),
                Ow(e.dC)
            ]),
            (a = e.h$, 1 === a.$ ? g : m([
                FA(a.a)
            ])),
            function() {
                var n = e.bd;
                if (1 === n.$) return g;
                switch(n.a){
                    case 0:
                        return m([
                            Cy("primary")
                        ]);
                    case 1:
                        return m([
                            Cy("secondary")
                        ]);
                    default:
                        return m([
                            Cy("negative")
                        ]);
                }
            }(),
            1 === e.cZ.$ ? g : m([
                Cy("right floated")
            ]),
            function() {
                var n = e.aK;
                if (1 === n.$) return g;
                var t = n.a.en;
                return yc(m([
                    m([
                        Cy("animated")
                    ]),
                    function() {
                        switch(t){
                            case 0:
                                return g;
                            case 1:
                                return m([
                                    Cy("vertical")
                                ]);
                            default:
                                return m([
                                    Cy("fade")
                                ]);
                        }
                    }()
                ]));
            }(),
            m([
                sj(e.ih)
            ])
        ])), function() {
            var n = e.aK;
            if (1 === n.$) return c;
            var t = n.a;
            return m([
                A2(Iy, m([
                    Cy("visible content")
                ]), c),
                A2(Iy, m([
                    Cy("hidden content")
                ]), t.aK)
            ]);
        }());
    }), WA = VA(Py), YA = F2(function(n, e) {
        return A2(WA, A2(_A, m([
            ww(e)
        ]), b(HA, {
            bd: ht(0)
        })), m([
            Oy("Start a month of free trial"),
            A2(zy, m([
                Cy("ui arrow alternate circle right icon")
            ]), g)
        ]));
    }), MA = F2(function(n, e) {
        var t, r = OA;
        return A2(Iy, m([
            A2(Ly, "margin-top", "40px")
        ]), m([
            A2(Iy, m([
                Cy("ui large top attached header")
            ]), m([
                Oy("Add new billing entity")
            ])),
            A2(Iy, m([
                Cy("ui attached segment")
            ]), m([
                A2(LA, BA, m([
                    A2(Iy, m([
                        Cy("inline field")
                    ]), m([
                        A2(lj, g, m([
                            Oy("Name (organization or company)")
                        ])),
                        PA(b(r, {
                            ct: m([
                                qA(NA)
                            ])
                        }))
                    ])),
                    A2(YA, n, (t = {
                        k: e.n,
                        gN: e.co.c
                    }, {
                        $: 1,
                        a: t
                    }))
                ]))
            ]))
        ]));
    }), KA = F2(function(n, e) {
        return {
            $: 3,
            a: n,
            b: e
        };
    }), JA = F3(function(n, e, t) {
        return A2(Iy, g, m([
            Oy(t.k),
            A2(Pw, m([
                A2(Ly, "margin", "10px")
            ]), g),
            A2(YA, n, A2(KA, t.c, e.co.c))
        ]));
    }), QA = F2(function(n, e) {
        var t, r = e.ca;
        switch(r.$){
            case 1:
                return A2(Iy, m([
                    Cy("ui loader active text inline centered")
                ]), m([
                    Oy("Loading organizations")
                ]));
            case 0:
                return A2(Iy, g, g);
            case 2:
                return Oy(IA(r.a));
            default:
                return r.a.b ? (t = r.a, A2(Iy, m([
                    A2(Ly, "margin-top", "40px")
                ]), m([
                    A2(Iy, m([
                        Cy("ui large top attached header")
                    ]), m([
                        Oy("Add to an existing billing entity")
                    ])),
                    A2(Iy, m([
                        Cy("ui attached segment")
                    ]), A2(Lr, A2(JA, n, e), t))
                ]))) : Oy("");
        }
    }), ZA = A2(Ww, g, m([
        Oy("Your subscription has been activated.")
    ])), XA = {
        eX: gt,
        iv: ht({
            h2: !1,
            jI: !1
        }),
        ju: !0,
        jA: !1
    }, nC = Ve, eC = nC(XA), tC = A2(eC, m([
        A2(Ly, "margin-bottom", "20px")
    ]), "\n  Free trial lasts **for a month** and requires **no credit card**.\n\n  After you subscribe you will be charged **29 EUR / active user / month**.\n\n  An active user is a collaborator of a billed account who is a committer or pusher on a job.\n  "), rC = F2(function(n, e) {
        var t = function(n) {
            var t = function(e) {
                var t;
                return A2(Py, m([
                    Cy("ui button primary " + e),
                    ww((t = n, {
                        $: 5,
                        a: t
                    })),
                    A2(DA, "data-theme", "none")
                ]), m([
                    Oy("Subscribe")
                ]));
            }, r = e.gH;
            switch(r.$){
                case 0:
                    return t("");
                case 1:
                    return t("loading");
                case 3:
                    return t("disabled");
                default:
                    var a = r.a;
                    return A2(Iy, g, m([
                        t(""),
                        A2(Bk, g, m([
                            Oy(IA(a))
                        ]))
                    ]));
            }
        }, r = A2(Iy, g, m([
            tC,
            A2(QA, n, e),
            A2(MA, n, e)
        ]));
        if (e.dH) return ZA;
        var a = e.co.gB;
        if (1 === a.$) return r;
        var i = a.a;
        switch(i.ew){
            case 0:
                return r;
            case 1:
                return A2(Iy, g, m([
                    tC,
                    Ej(i),
                    t(i)
                ]));
            case 2:
                return A2(Iy, g, m([
                    Ej(i),
                    function(n) {
                        var e = n.hn;
                        if (1 === e.$) return Oy("");
                        var t = e.a;
                        return A2(Py, m([
                            Cy("ui button red"),
                            jw(t)
                        ]), m([
                            Oy("Cancel")
                        ]));
                    }(i),
                    function(n) {
                        var e = n.hq;
                        if (1 === e.$) return Oy("");
                        var t = e.a;
                        return A2(Py, m([
                            Cy("ui button primary"),
                            jw(t)
                        ]), m([
                            Oy("Update")
                        ]));
                    }(i)
                ]));
            case 3:
                return A2(Iy, g, m([
                    Ej(i),
                    t(i)
                ]));
            default:
                return A2(Iy, g, m([
                    Ej(i)
                ]));
        }
    }), aC = F2(function(n, e) {
        return {
            u: A2(Iy, g, h(m([
                TA(A2(xA, e.ca, A2(xA, e.bP, e.cD))),
                A2(rC, n, e)
            ]), CA(e.cx))),
            e: "Billing"
        };
    }), iC = {
        $: 2
    }, uC = {
        $: 1
    }, cC = {
        $: 0
    }, oC = F2(function(n, e) {
        var t = e.bO;
        return A2(Iy, m([
            Cy("ui checkbox"),
            Uy(m([
                l("checked", t)
            ])),
            ww(n.i5)
        ]), m([
            A2(yw, m([
                kw("checkbox"),
                oj(t),
                Cy("hidden")
            ]), g),
            A2(lj, g, Dl(A2(Fi, Oy, n.N)))
        ]));
    }), sC = function(n) {
        return {
            N: gt,
            i5: n.i5
        };
    }, fC = F2(function(n, e) {
        return b(e, {
            N: ht(n)
        });
    }), lC = tk(g), dC = function(n) {
        switch(n.$){
            case 1:
                return A2(Iy, m([
                    Cy("ui placeholder")
                ]), m([
                    A2(Iy, m([
                        Cy("line")
                    ]), g)
                ]));
            case 2:
                return A2(uk, !0, n.a);
            case 3:
                var e = n.a;
                return A2(Ww, g, m([
                    Oy("The referrer claims to be described as "),
                    A2(Ek, g, m([
                        Oy(e.v)
                    ])),
                    Oy(".")
                ]));
            default:
                return A2(Iy, g, g);
        }
    }, bC = F2(function(n, e) {
        return {
            u: A2(Iy, m([
                Cy("ui raised yellow segment")
            ]), m([
                A2(Ww, g, m([
                    Oy("You've followed a link from some referrer to authorize access to your account.")
                ])),
                dC(e.cu),
                A2(oC, A2(fC, "I trust the referrer to perform operations on Hercules CI on my behalf.", sC({
                    i5: cC
                })), e),
                A2(Iy, m([
                    Cy("ui segment basic")
                ]), m([
                    A2(vx, m([
                        Cy("ui button positive"),
                        sj(!(e.bO && u(e.a6, Bs))),
                        ww(iC)
                    ]), m([
                        Oy("Authorize")
                    ])),
                    A2(vx, m([
                        Cy("ui button"),
                        ww(uC)
                    ]), m([
                        Oy("Cancel")
                    ]))
                ])),
                function() {
                    var n = e.a6;
                    switch(n.$){
                        case 2:
                            return A2(uk, !0, n.a);
                        case 3:
                            return A2(lC, ak, m([
                                Oy("Done! You may close this tab or "),
                                A2(Py, m([
                                    Aw(Ku)
                                ]), m([
                                    Oy("review your CLI token list.")
                                ]))
                            ]));
                        default:
                            return A2(Iy, g, g);
                    }
                }()
            ])),
            e: "CLI Authorization"
        };
    }), hC = function(n) {
        switch(n.$){
            case 0:
                return 1;
            case 1:
            case 2:
                return 2;
            default:
                return 3;
        }
    }, gC = function(n) {
        switch(n.$){
            case 0:
                return A2(Pw, g, g);
            case 1:
                return A2(zy, m([
                    Cy("icon circle notch loading")
                ]), g);
            case 3:
                return A2(zy, m(n.a.b ? [
                    Cy("icon blue server")
                ] : [
                    Cy("icon yellow exclamation circle"),
                    ck("No agents running yet")
                ]), g);
            default:
                return A2(zy, m([
                    Cy("ui icon sad")
                ]), g);
        }
    }, vC = F2(function(n, e) {
        return {
            $: 5,
            a: n,
            b: e
        };
    }), pC = F2(function(n, e) {
        return m([
            A2(Ly, "cursor", "pointer"),
            ww(A2(vC, n, e))
        ]);
    }), mC = F2(function(n, e) {
        return A2(Py, m([
            Aw(rm(e))
        ]), m([
            A2(Dw, e, n),
            Oy(e.k)
        ]));
    }), $C = function(n) {
        var e, t = (e = Ou({
            co: n.co.ax,
            dA: n.co.hf
        }), m([
            A2(Iy, m([
                Cy("ui item header")
            ]), m([
                A2(Py, m([
                    Aw(e)
                ]), m([
                    A2(zy, m([
                        Cy("ui icon wrench")
                    ]), g),
                    Oy("Settings")
                ]))
            ]))
        ])), r = function(e) {
            return u(hC(n.d9), hC(e)) ? "ui item active header" : "ui item header";
        }, a = 1 === n.ed ? A2(Iy, m([
            Cy("ui item header")
        ]), m([
            A2(mC, 40, n.co)
        ])) : A2(Pw, g, g);
        return A2(Iy, m([
            Cy("ui top attached stackable tabular small menu")
        ]), m([
            a,
            A2(Iy, m([
                Cy("right menu")
            ]), h(t, m([
                A2(Iy, A2(Ze, Cy(r(Jf)), A2(pC, Jf, Eu({
                    co: n.co.ax,
                    dA: n.dA
                }))), m([
                    A2(zy, m([
                        Cy("icon book")
                    ]), g),
                    Oy("Repositories")
                ])),
                A2(Iy, A2(Ze, Cy(r(Zf)), A2(pC, Yf, Lu({
                    co: n.co.ax,
                    ia: 0,
                    dA: n.dA
                }))), m([
                    A2(zy, m([
                        Cy("icon tasks")
                    ]), g),
                    Oy("Tasks")
                ])),
                A2(Iy, A2(Ze, Cy(r(Yf)), A2(pC, Yf, zu({
                    co: n.co.ax,
                    dA: n.dA
                }))), m([
                    gC(n.a1),
                    Oy("Agents")
                ]))
            ])))
        ]));
    }, yC = function(n) {
        return {
            $: 2,
            a: n
        };
    }, wC = F2(function(n, e) {
        return m([
            A2(Ly, "cursor", "pointer"),
            ww(n(e))
        ]);
    }), kC = function(n) {
        var e = F2(function(n, e) {
            return A2(Iy, m([
                Cy("ui label basic black")
            ]), m([
                A2(zy, m([
                    Cy("icon " + n)
                ]), g),
                Oy(e)
            ]));
        }), t = function(n) {
            var e = A2(wt, "/", n);
            n: for(; e.b && e.b.b;)switch(e.b.a){
                case "heads":
                    return ht({
                        $: 0,
                        a: A2(yt, "/", e.b.b)
                    });
                case "tags":
                    return ht({
                        $: 1,
                        a: A2(yt, "/", e.b.b)
                    });
                default:
                    break n;
            }
            return gt;
        }(n.dD.du);
        return t.$ ? A2(Pw, g, g) : A2(e, t.a.$ ? "icon tag" : "code branch", t.a.a);
    }, xC = m([
        Cy("ui image middle aligned rounded"),
        A2(Ly, "margin-right", "10px")
    ]), jC = Kn("d"), AC = F3(function(n, e, t) {
        return 1 > s(gr(t), n) ? t : h(A2(yr, n - gr(e), t), e);
    }), CC = Kn("fill"), IC = Hn("http://www.w3.org/2000/svg"), TC = IC("path"), SC = IC("svg"), DC = Kn("viewBox"), NC = F2(function(n, e) {
        var t, r = jw(e.dD.f9), a = (t = e.dD.eO).$ ? A2(Pw, A2(Ze, A2(Ly, "display", "inline-block"), xC), m([
            A2(SC, m([
                DC("0 0 640 512"),
                A2(DA, "focusable", "false"),
                A2(DA, "aria-hidden", "true"),
                Sw(25)
            ]), m([
                A2(TC, m([
                    CC("currentColor"),
                    jC("M320 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm156.8-48C462 361 397.4 416 320 416s-142-55-156.8-128H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H163.2C178 151 242.6 96 320 96s142 55 156.8 128H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H476.8z")
                ]), g)
            ]))
        ])) : A2(Dw, t.a, 25), i = m([
            a,
            Oy(" "),
            Oy(A3(AC, 72, "...", e.dD.bl))
        ]), u = m([
            ck(e.dD.fx)
        ]);
        return n ? A2(Pw, u, i) : A2(Py, A2(Ze, r, u), h(i, m([
            Oy(" "),
            Gj
        ])));
    }), EC = F2(function(n, e) {
        var t = F2(function(n, e) {
            return n > 0 ? $t(n) + (e + " ") : "";
        }), r = dA(n - e) / 1e3 | 0, a = r % 86400 / 3600 | 0, i = r % 3600 / 60 | 0, u = r % 60;
        return A2(t, r / 86400 | 0, "d") + (A2(t, a, "h") + (A2(t, i, "m") + ($t(u) + "s")));
    }), LC = function(n) {
        var e = n.e8;
        if (1 === e.$) return A2(Pw, g, g);
        var t = e.a;
        return A2(Pw, g, m([
            A2(zy, m([
                Cy("icon clock")
            ]), g),
            Oy(A2(EC, n.dF, t))
        ]));
    }, BC = F2(function(n, e) {
        return A2(Py, m([
            jw(n)
        ]), h(e, m([
            Gj
        ])));
    }), OC = F2(function(n, e) {
        return A2(zy, A2(Ze, Cy("ui icon"), A2(Ze, Cy(n), e)), g);
    }), PC = l(OC("sun outline loading"), "building"), GC = l(fk, "cancelled"), RC = l(OC("blue rocket"), "running effects"), zC = l(OC("snowflake blue loading"), "evaluating"), qC = l(OC("red times circle"), "failed"), _C = function(n) {
        return A2(Xl, !1, A2(kf, UA, n));
    }, HC = l(OC("spinner loading"), "queued"), FC = l(OC("green check circle"), "succeeded"), UC = F2(function(n, e) {
        if (_C(n)) return l(OC("yellow exclamation circle"), "Agent is not running yet");
        if (e.fV) return GC;
        switch(e.f$){
            case 0:
                return HC;
            case 1:
                return zC;
            case 2:
                return PC;
            case 3:
                return RC;
            default:
                switch(e.f0){
                    case 0:
                        return PC;
                    case 1:
                        return qC;
                    default:
                        return FC;
                }
        }
    }), VC = F2(function(n, e) {
        var t = A2(UC, n, e), r = t.b;
        return (0, t.a)(m([
            Cy("big"),
            ck(r)
        ]));
    }), WC = F2(function(n, e) {
        var t = e.hy;
        if (1 === t.$) return 0;
        var r = (n - t.a) / 864e5 | 0;
        return s(r, 30) > 0 ? 0 : 30 - r;
    }), YC = F2(function(n, e) {
        return !A2(WC, n, e);
    }), MC = tk(m([
        Cy("warning")
    ])), KC = function(n) {
        return A2(MC, ak, m([
            A2(Py, m([
                n
            ]), m([
                Oy("Enable a month of free trial")
            ])),
            Oy(" to start building your private repositories.")
        ]));
    }, JC = F3(function(n, e, t) {
        if (t.ar) return gt;
        var r = Sj(e), a = e.gB;
        if (1 === a.$) return ht(KC(r));
        var i = a.a;
        switch(i.ew){
            case 0:
                return ht(KC(r));
            case 3:
                return ht(function(n) {
                    return A2(MC, ak, m([
                        A2(Py, m([
                            n
                        ]), m([
                            Oy("Re-activate your subscription")
                        ])),
                        Oy(" to build your private repositories.")
                    ]));
                }(r));
            case 1:
                return A2(YC, n.eS, i) ? ht(function(n) {
                    return A2(MC, ak, m([
                        Oy("Your free trial expired. "),
                        A2(Py, m([
                            n
                        ]), m([
                            Oy("Activate your subscription")
                        ])),
                        Oy(" to build your private repositories.")
                    ]));
                }(r)) : gt;
            default:
                return gt;
        }
    }), QC = F2(function(n, e) {
        return A2(Ti, 1e3, e);
    }), ZC = F2(function(n, e) {
        return A3(Mk, n, "0", $t(e));
    }), XC = F2(function(n, e) {
        var t;
        return A2(Pw, m([
            ck("Created at " + (t = n.dF, A2(ZC, 4, A2(ix, cx, t)) + "-" + A2(ZC, 2, function(n) {
                switch(n){
                    case 0:
                        return 1;
                    case 1:
                        return 2;
                    case 2:
                        return 3;
                    case 3:
                        return 4;
                    case 4:
                        return 5;
                    case 5:
                        return 6;
                    case 6:
                        return 7;
                    case 7:
                        return 8;
                    case 8:
                        return 9;
                    case 9:
                        return 10;
                    case 10:
                        return 11;
                    default:
                        return 12;
                }
            }(A2(rx, cx, t))) + "-" + A2(ZC, 2, A2(nx, cx, t)) + "T" + A2(ZC, 2, A2(ex, cx, t)) + ":" + A2(ZC, 2, A2(tx, cx, t)) + ":" + A2(ZC, 2, A2(ax, cx, t)) + "." + A2(ZC, 3, A2(QC, cx, t)) + "Z"))
        ]), m([
            A2(zy, m([
                Cy("icon calendar alternate outline")
            ]), g),
            Oy(A2(bA, e.eS, n.dF)),
            Oy(" ago")
        ]));
    }), nI = A2(Pw, m([
        A2(Ly, "border-radius", "100%"),
        A2(Ly, "text-align", "center"),
        A2(Ly, "vertical-align", "middle"),
        A2(Ly, "display", "inline-block"),
        A2(Ly, "border", ".12em solid currentColor"),
        A2(Ly, "font-size", "90%"),
        A2(Ly, "width", "1.3em"),
        A2(Ly, "height", "1.3em"),
        A2(Ly, "margin", "0 .75em -0.12em -0.12em")
    ]), m([
        Oy(":=")
    ])), eI = A2(zy, m([
        Cy("ui icon calendar alternate outline")
    ]), g), tI = function(n) {
        switch(n.f1){
            case 0:
                return A2(Iy, m([
                    Cy("ui basic grey label"),
                    ck("herculesCI.*"),
                    A2(Ly, "white-space", "nowrap")
                ]), m([
                    A2(zy, m([
                        Cy("ui icon snowflake")
                    ]), g),
                    Oy("config")
                ]));
            case 1:
                return Oy("");
            case 2:
                var e = n.f_;
                if (1 === e.$) return Oy("");
                var t = e.a;
                return A2(Iy, m([
                    Cy("ui label blue"),
                    ck("herculesCI.onPush." + t),
                    A2(Ly, "white-space", "nowrap")
                ]), m([
                    nI,
                    Oy(t)
                ]));
            default:
                var r = n.f_;
                return 1 === r.$ ? Oy("") : (t = r.a, A2(Iy, m([
                    Cy("ui label purple"),
                    ck("herculesCI.onSchedule." + t),
                    A2(Ly, "white-space", "nowrap")
                ]), m([
                    eI,
                    Oy(t)
                ])));
        }
    }, rI = F5(function(n, e, t, r, a) {
        var i = r.a, u = r.b, c = r.c, o = 7 - jt(a), s = function() {
            if (1 === c.$) return m([
                A2(xk, m([
                    Lk(o)
                ]), m([
                    Oy("Push a commit "),
                    A2(BC, "https://docs.hercules-ci.com/hercules-ci/getting-started/repository", m([
                        Oy("with a Nix file")
                    ])),
                    Oy(" to start the first job.")
                ]))
            ]);
            var r = c.a, a = function(e) {
                return A2(Py, m([
                    Aw(Uu({
                        co: i.ax,
                        ab: e,
                        br: u.ax,
                        dA: n.dA
                    }))
                ]), m([
                    Oy("#" + $t(e))
                ]));
            }, s = function() {
                var n = r.g2;
                if (1 === n.$) return m([
                    A2(NC, 1, r)
                ]);
                var e = n.a;
                return m([
                    Oy("Retry of "),
                    a(e)
                ]);
            }(), f = A2(wC, yC, Uu({
                co: i.ax,
                ab: r.ab,
                br: u.ax,
                dA: n.dA
            }));
            return m([
                A2(xk, f, m([
                    A2(VC, t, r)
                ])),
                A2(xk, f, m([
                    A2(Iy, g, m([
                        a(r.ab)
                    ])),
                    A2(Iy, g, m([
                        tI(r)
                    ]))
                ])),
                A2(xk, f, m([
                    LC(r)
                ])),
                A2(xk, f, m([
                    A2(XC, r, e)
                ])),
                A2(xk, f, m([
                    kC(r)
                ])),
                A2(xk, f, s)
            ]);
        }(), f = function() {
            var n = A3(JC, e, i, u);
            if (n.$) return s;
            var t = n.a;
            return m([
                A2(xk, m([
                    Lk(o)
                ]), m([
                    t
                ]))
            ]);
        }();
        return A2(Ck, g, h(a, f));
    }), aI = F3(function(n, e, t) {
        var r, a = t.br, i = Ju({
            co: e.co.ax,
            gD: gt,
            br: a.ax,
            dA: e.dA
        }), u = A2(xk, A2(wC, yC, i), m([
            A2(Py, m([
                Aw(i)
            ]), m([
                A2(Pw, m([
                    Cy("ui large text")
                ]), m([
                    Oy(a.k)
                ]))
            ]))
        ])), c = (r = t.dc).b ? ht(r.a) : gt;
        return A5(rI, e, n, e.a1, d(e.co, a, c), m([
            u
        ]));
    }), iI = F3(function(n, e, t) {
        var r = t.b ? A2(Lr, A2(aI, n, e), t) : m([
            A2(Ww, g, m([
                Oy("We could not find any installed repositories in this account. You may need to add more repositories, and we can only show repositories you have access to.")
            ]))
        ]);
        return A2(Iy, m([
            Cy("ui bottom attached segment")
        ]), m([
            A2(wk, m([
                Cy("ui very basic selectable table")
            ]), m([
                A2(kk, g, r)
            ]))
        ]));
    }), uI = {
        $: 3
    }, cI = F3(function(n, e, t) {
        switch(e.$){
            case 2:
                return Oy("Oops, we could not load the " + n + ". " + IA(e.a));
            case 3:
                return t(e.a);
            case 1:
                return A2(Iy, m([
                    Cy("ui loader active inline text")
                ]), m([
                    Oy("Loading the " + n)
                ]));
            default:
                return Oy("");
        }
    }), oI = Fn("textarea"), sI = function(n) {
        var e = function(n) {
            return A2(Iy, g, m([
                A2(oI, m([
                    Cy("ui message ignored"),
                    A2(Kn, "rows", $t(5)),
                    A2(Ly, "width", "100%")
                ]), m([
                    Oy(n.by)
                ])),
                A2(Bk, g, m([
                    Oy("Save this token in a cluster-join-token.key file.")
                ]))
            ]));
        };
        return A2(Iy, g, m([
            Oy("A cluster join token is a secret key required for agent to be granted access to start building."),
            A2(Iy, g, m([
                A2(vx, m([
                    Cy("ui primary button huge"),
                    ww(uI),
                    A2(Ly, "margin", "30px")
                ]), m([
                    Oy("Generate join token")
                ]))
            ])),
            A3(cI, "token", n.cs, e)
        ]));
    }, fI = Fn("b"), lI = Fn("ol"), dI = Fn("pre"), bI = A2(Iy, g, m([
        A2(Iy, m([
            Cy("admonitionblock warning")
        ]), m([
            A2(wk, g, m([
                A2(Ck, g, m([
                    A2(xk, m([
                        Cy("icon")
                    ]), m([
                        A2(Iy, m([
                            Cy("title")
                        ]), m([
                            Oy("Warning")
                        ]))
                    ])),
                    A2(xk, m([
                        Cy("content")
                    ]), m([
                        Oy("\nAlthough a single agent works with empty "),
                        A2(Ek, g, m([
                            Oy("{}")
                        ])),
                        Oy(" binary cache configuration,\nwe highly recommend setting up a cache from the start.\nRunning without a cache will break some features and will cause unexpectedly long build times\ndue to eventual garbage collection.\n")
                    ]))
                ]))
            ]))
        ])),
        A2(Iy, m([
            Cy("paragraph")
        ]), m([
            A2(Ww, g, m([
                Oy("On "),
                A2(Py, m([
                    jw("https://cachix.org")
                ]), m([
                    Oy("Cachix")
                ])),
                Oy(" you can create a binary cache. After you complete the process, gather the keys into a "),
                A2(Ek, g, m([
                    Oy("binary-caches.json")
                ])),
                Oy(" file, replacing all placeholders:")
            ]))
        ])),
        A2(Iy, m([
            Cy("listingblock")
        ]), m([
            A2(Iy, m([
                Cy("title")
            ]), m([
                Oy("binary-caches.json")
            ])),
            A2(Iy, m([
                Cy("content")
            ]), m([
                A2(dI, m([
                    Cy("highlight")
                ]), m([
                    A2(Ek, m([
                        Cy("language-json"),
                        A2(DA, "data-lang", "json")
                    ]), m([
                        Oy('{ "mycache": '),
                        A2(fI, m([
                            Cy("conum")
                        ]), m([
                            Oy("(1)")
                        ])),
                        Oy('\n    { "kind": "CachixCache"\n    , "authToken": "eyJhaf23GH53a.bc23BUSI.9q3048hWHh" '),
                        A2(fI, m([
                            Cy("conum")
                        ]), m([
                            Oy("(2)")
                        ])),
                        Oy('\n    , "publicKeys": ["mycache.cachix.org-1:EjBSHzF6VmDnzqlldGXbi0RM3HdjfTU3yDRi9Pd0jTY="] '),
                        A2(fI, m([
                            Cy("conum")
                        ]), m([
                            Oy("(3)")
                        ])),
                        Oy('\n    , "signingKeys": ["uAhqM3jG..."] '),
                        A2(fI, m([
                            Cy("conum")
                        ]), m([
                            Oy("(4)")
                        ])),
                        Oy("\n    }\n}")
                    ]))
                ]))
            ]))
        ])),
        A2(Iy, m([
            Cy("colist arabic")
        ]), m([
            A2(lI, g, m([
                A2(zk, g, m([
                    A2(Ww, g, m([
                        Oy("The name of the Cachix cache; for example the "),
                        A2(Ek, g, m([
                            Oy("mycache")
                        ])),
                        Oy(" part from "),
                        A2(Ek, g, m([
                            Oy("mycache.cachix.org")
                        ])),
                        Oy(".")
                    ]))
                ])),
                A2(zk, g, m([
                    A2(Ww, g, m([
                        Oy("Optional; only required for private binary caches. You may retrieve this from the "),
                        A2(Py, m([
                            jw("https://cachix.org/")
                        ]), m([
                            Oy("Cachix Getting started instructions, step 3")
                        ])),
                        Oy(".")
                    ]))
                ])),
                A2(zk, g, m([
                    A2(Ww, g, m([
                        Oy('The public part of the signing key. Look for "Public Key" on your cache page (example page: '),
                        A2(Ek, g, m([
                            Oy("https://mycache.cachix.org")
                        ])),
                        Oy(").")
                    ]))
                ])),
                A2(zk, g, m([
                    A2(Ww, g, m([
                        Oy("A cache-specific secret key to sign store paths. You can find it in "),
                        A2(Ek, g, m([
                            Oy("~/.config/cachix/cachix.dhall")
                        ])),
                        Oy(" or your key backup after following the setup instructions on cachix.org. Make sure you copy the right key if you have multiple in your "),
                        A2(Ek, g, m([
                            Oy("cachix.dhall")
                        ])),
                        Oy(".")
                    ]))
                ]))
            ]))
        ])),
        A2(Iy, m([
            Cy("admonitionblock note")
        ]), m([
            A2(wk, g, m([
                A2(Ck, g, m([
                    A2(xk, m([
                        Cy("icon")
                    ]), m([
                        A2(Iy, m([
                            Cy("title")
                        ]), m([
                            Oy("Note")
                        ]))
                    ])),
                    A2(xk, m([
                        Cy("content")
                    ]), m([
                        Oy("\nFor more detail, see "),
                        A2(Py, m([
                            jw("https://docs.hercules-ci.com/hercules-ci/reference/binary-caches-json/")
                        ]), m([
                            Oy("The "),
                            A2(Ek, g, m([
                                Oy("binary-caches.json")
                            ])),
                            Oy(" format")
                        ])),
                        Oy(" in the Reference.\n")
                    ]))
                ]))
            ]))
        ]))
    ])), hI = function(n) {
        return m([
            A2(Ww, g, m([
                Oy("We start by gathering the required credentials and configuration into a fresh working directory.")
            ])),
            A2(yk, g, m([
                Oy("Cluster join token")
            ])),
            sI(n),
            A2(Ww, g, m([
                Oy("Copy the token into a plain text file "),
                A2(Ek, g, m([
                    Oy("cluster-join-token.key")
                ])),
                Oy(". We recommend to protect this file like a password.")
            ])),
            A2(yk, g, m([
                Oy("Binary cache configuration")
            ])),
            bI
        ]);
    }, gI = F2(function(n, e) {
        return n ? m([
            e
        ]) : g;
    }), vI = A2(Iy, g, m([
        A2(Iy, m([
            Cy("paragraph")
        ]), m([
            A2(Ww, g, m([
                Oy("Create a folder called mycompany-agents with a file:")
            ]))
        ])),
        A2(Iy, m([
            Cy("listingblock")
        ]), m([
            A2(Iy, m([
                Cy("title")
            ]), m([
                Oy("network.nix")
            ])),
            A2(Iy, m([
                Cy("content")
            ]), m([
                A2(dI, m([
                    Cy("highlight")
                ]), m([
                    A2(Ek, m([
                        Cy("language-nix"),
                        A2(DA, "data-lang", "nix")
                    ]), m([
                        Oy('let\n  hercules-ci-agent =\n      builtins.fetchTarball "https://github.com/hercules-ci/hercules-ci-agent/archive/stable.tar.gz";\nin\n{\n  network.description = "Hercules CI agents";\n\n  agent = {\n    imports = [\n      (hercules-ci-agent + "/module.nix")\n    ];\n\n    services.hercules-ci-agent.enable = true;\n    services.hercules-ci-agent.concurrentTasks = 4; # Number of jobs to run\n    deployment.keys."cluster-join-token.key".keyFile = ./cluster-join-token.key;\n    deployment.keys."binary-caches.json".keyFile = ./binary-caches.json;\n  };\n}')
                    ]))
                ]))
            ]))
        ]))
    ])), pI = A2(Iy, g, m([
        A2(Iy, m([
            Cy("paragraph")
        ]), m([
            A2(Ww, g, m([
                Oy("Save "),
                A2(Ek, g, m([
                    Oy("binary-caches.json")
                ])),
                Oy(" on the target machine and install it by running:")
            ]))
        ])),
        A2(Iy, m([
            Cy("listingblock")
        ]), m([
            A2(Iy, m([
                Cy("content")
            ]), m([
                A2(dI, m([
                    Cy("highlight")
                ]), m([
                    A2(Ek, m([
                        Cy("language-shell"),
                        A2(DA, "data-lang", "shell")
                    ]), m([
                        Oy("$ sudo install \\\n    -o hercules-ci-agent  \\\n    -m 0600 \\\n    binary-caches.json \\\n    /var/lib/hercules-ci-agent/secrets/binary-caches.json")
                    ]))
                ]))
            ]))
        ])),
        A2(Iy, m([
            Cy("paragraph")
        ]), m([
            A2(Ww, g, m([
                Oy("And activate via:")
            ]))
        ])),
        A2(Iy, m([
            Cy("listingblock")
        ]), m([
            A2(Iy, m([
                Cy("content")
            ]), m([
                A2(dI, m([
                    Cy("highlight")
                ]), m([
                    A2(Ek, m([
                        Cy("language-shell"),
                        A2(DA, "data-lang", "shell")
                    ]), m([
                        Oy("$ sudo ./result/bin/darwin-installer")
                    ]))
                ]))
            ]))
        ]))
    ])), mI = A2(Iy, g, m([
        A2(Iy, m([
            Cy("admonitionblock warning")
        ]), m([
            A2(wk, g, m([
                A2(Ck, g, m([
                    A2(xk, m([
                        Cy("icon")
                    ]), m([
                        A2(Iy, m([
                            Cy("title")
                        ]), m([
                            Oy("Warning")
                        ]))
                    ])),
                    A2(xk, m([
                        Cy("content")
                    ]), m([
                        Oy("\nAlthough a single agent works with empty "),
                        A2(Ek, g, m([
                            Oy("{}")
                        ])),
                        Oy(" binary cache configuration,\nwe highly recommend setting up a cache from the start.\nRunning without a cache will break some features and will cause unexpectedly long build times\ndue to eventual garbage collection.\n")
                    ]))
                ]))
            ]))
        ])),
        A2(Iy, m([
            Cy("paragraph")
        ]), m([
            A2(Ww, g, m([
                Oy("On "),
                A2(Py, m([
                    jw("https://cachix.org")
                ]), m([
                    Oy("Cachix")
                ])),
                Oy(" you can create a binary cache. After you complete the process, gather the keys into a "),
                A2(Ek, g, m([
                    Oy("binary-caches.json")
                ])),
                Oy(" file, replacing all placeholders:")
            ]))
        ])),
        A2(Iy, m([
            Cy("listingblock")
        ]), m([
            A2(Iy, m([
                Cy("title")
            ]), m([
                Oy("binary-caches.json")
            ])),
            A2(Iy, m([
                Cy("content")
            ]), m([
                A2(dI, m([
                    Cy("highlight")
                ]), m([
                    A2(Ek, m([
                        Cy("language-json"),
                        A2(DA, "data-lang", "json")
                    ]), m([
                        Oy('{ "mycache": '),
                        A2(fI, m([
                            Cy("conum")
                        ]), m([
                            Oy("(1)")
                        ])),
                        Oy('\n    { "kind": "CachixCache"\n    , "authToken": "eyJhaf23GH53a.bc23BUSI.9q3048hWHh" '),
                        A2(fI, m([
                            Cy("conum")
                        ]), m([
                            Oy("(2)")
                        ])),
                        Oy('\n    , "publicKeys": ["mycache.cachix.org-1:EjBSHzF6VmDnzqlldGXbi0RM3HdjfTU3yDRi9Pd0jTY="] '),
                        A2(fI, m([
                            Cy("conum")
                        ]), m([
                            Oy("(3)")
                        ])),
                        Oy('\n    , "signingKeys": ["uAhqM3jG..."] '),
                        A2(fI, m([
                            Cy("conum")
                        ]), m([
                            Oy("(4)")
                        ])),
                        Oy("\n    }\n}")
                    ]))
                ]))
            ]))
        ])),
        A2(Iy, m([
            Cy("colist arabic")
        ]), m([
            A2(lI, g, m([
                A2(zk, g, m([
                    A2(Ww, g, m([
                        Oy("The name of the Cachix cache; for example the "),
                        A2(Ek, g, m([
                            Oy("mycache")
                        ])),
                        Oy(" part from "),
                        A2(Ek, g, m([
                            Oy("mycache.cachix.org")
                        ])),
                        Oy(".")
                    ]))
                ])),
                A2(zk, g, m([
                    A2(Ww, g, m([
                        Oy("Optional; only required for private binary caches. You may retrieve this from the "),
                        A2(Py, m([
                            jw("https://cachix.org/")
                        ]), m([
                            Oy("Cachix Getting started instructions, step 3")
                        ])),
                        Oy(".")
                    ]))
                ])),
                A2(zk, g, m([
                    A2(Ww, g, m([
                        Oy('The public part of the signing key. Look for "Public Key" on your cache page (example page: '),
                        A2(Ek, g, m([
                            Oy("https://mycache.cachix.org")
                        ])),
                        Oy(").")
                    ]))
                ])),
                A2(zk, g, m([
                    A2(Ww, g, m([
                        Oy("A cache-specific secret key to sign store paths. You can find it in "),
                        A2(Ek, g, m([
                            Oy("~/.config/cachix/cachix.dhall")
                        ])),
                        Oy(" or your key backup after following the setup instructions on cachix.org. Make sure you copy the right key if you have multiple in your "),
                        A2(Ek, g, m([
                            Oy("cachix.dhall")
                        ])),
                        Oy(".")
                    ]))
                ]))
            ]))
        ])),
        A2(Iy, m([
            Cy("admonitionblock note")
        ]), m([
            A2(wk, g, m([
                A2(Ck, g, m([
                    A2(xk, m([
                        Cy("icon")
                    ]), m([
                        A2(Iy, m([
                            Cy("title")
                        ]), m([
                            Oy("Note")
                        ]))
                    ])),
                    A2(xk, m([
                        Cy("content")
                    ]), m([
                        Oy("\nFor more detail, see "),
                        A2(Py, m([
                            jw("https://docs.hercules-ci.com/hercules-ci/reference/binary-caches-json/")
                        ]), m([
                            Oy("The "),
                            A2(Ek, g, m([
                                Oy("binary-caches.json")
                            ])),
                            Oy(" format")
                        ])),
                        Oy(" in the Reference.\n")
                    ]))
                ]))
            ]))
        ])),
        A2(Iy, m([
            Cy("paragraph")
        ]), m([
            A2(Ww, g, m([
                Oy("To specify "),
                A2(Ek, g, m([
                    Oy("binary-caches.json")
                ])),
                Oy(" via NixOps:")
            ]))
        ])),
        A2(Iy, m([
            Cy("listingblock")
        ]), m([
            A2(Iy, m([
                Cy("content")
            ]), m([
                A2(dI, m([
                    Cy("highlight")
                ]), m([
                    A2(Ek, m([
                        Cy("language-nix"),
                        A2(DA, "data-lang", "nix")
                    ]), m([
                        Oy('services.hercules-ci-agent.enable = true;\ndeployment.keys."binary-caches.json".keyFile = ./binary-caches.json;')
                    ]))
                ]))
            ]))
        ])),
        A2(Iy, m([
            Cy("admonitionblock note")
        ]), m([
            A2(wk, g, m([
                A2(Ck, g, m([
                    A2(xk, m([
                        Cy("icon")
                    ]), m([
                        A2(Iy, m([
                            Cy("title")
                        ]), m([
                            Oy("Note")
                        ]))
                    ])),
                    A2(xk, m([
                        Cy("content")
                    ]), m([
                        Oy("\nWe're working on "),
                        A2(Py, m([
                            jw("https://cachix.org")
                        ]), m([
                            Oy("Cachix")
                        ])),
                        Oy(" to be able to restrict "),
                        A2(Ek, g, m([
                            Oy("authToken")
                        ])),
                        Oy("\nto only reading one private cache. "),
                        A2(Py, m([
                            jw("https://github.com/cachix/feedback/issues/7")
                        ]), m([
                            Oy("Subscribe to the issue to get notified")
                        ])),
                        Oy("\nwhen the token should be replaced.\n")
                    ]))
                ]))
            ]))
        ]))
    ])), $I = A2(Iy, g, m([
        A2(Iy, m([
            Cy("admonitionblock warning")
        ]), m([
            A2(wk, g, m([
                A2(Ck, g, m([
                    A2(xk, m([
                        Cy("icon")
                    ]), m([
                        A2(Iy, m([
                            Cy("title")
                        ]), m([
                            Oy("Warning")
                        ]))
                    ])),
                    A2(xk, m([
                        Cy("content")
                    ]), m([
                        Oy("\nEvaluation "),
                        A2(Py, m([
                            jw("https://github.com/hercules-ci/support/issues/24")
                        ]), m([
                            Oy("currently")
                        ])),
                        Oy(" requires an "),
                        A2(Ek, g, m([
                            Oy("x86_64-linux")
                        ])),
                        Oy(" machine to be in your build cluster!\n")
                    ]))
                ]))
            ]))
        ])),
        A2(Iy, m([
            Cy("admonitionblock note")
        ]), m([
            A2(wk, g, m([
                A2(Ck, g, m([
                    A2(xk, m([
                        Cy("icon")
                    ]), m([
                        A2(Iy, m([
                            Cy("title")
                        ]), m([
                            Oy("Note")
                        ]))
                    ])),
                    A2(xk, m([
                        Cy("content")
                    ]), m([
                        A2(Iy, m([
                            Cy("paragraph")
                        ]), m([
                            A2(Ww, g, m([
                                Oy("To avoid compiling the agent for hours you can use our binary cache to speed it up:")
                            ]))
                        ])),
                        A2(Iy, m([
                            Cy("listingblock")
                        ]), m([
                            A2(Iy, m([
                                Cy("content")
                            ]), m([
                                A2(dI, m([
                                    Cy("highlight")
                                ]), m([
                                    A2(Ek, m([
                                        Cy("language-shell"),
                                        A2(DA, "data-lang", "shell")
                                    ]), m([
                                        Oy("$ nix-env -iA cachix -f https://cachix.org/api/v1/install\n$ cachix use hercules-ci")
                                    ]))
                                ]))
                            ]))
                        ]))
                    ]))
                ]))
            ]))
        ])),
        A2(Iy, m([
            Cy("paragraph")
        ]), m([
            A2(Ww, g, m([
                Oy("On macOS run:")
            ]))
        ])),
        A2(Iy, m([
            Cy("listingblock")
        ]), m([
            A2(Iy, m([
                Cy("content")
            ]), m([
                A2(dI, m([
                    Cy("highlight")
                ]), m([
                    A2(Ek, m([
                        Cy("language-shell"),
                        A2(DA, "data-lang", "shell")
                    ]), m([
                        Oy("[root@mac]# sh <(curl https://nixos.org/nix/install) --daemon\n[root@mac]# source /nix/var/nix/profiles/default/etc/profile.d/nix-daemon.sh\n\n[root@mac]# nix-build https://github.com/hercules-ci/nix-darwin/archive/hercules-ci-agent.tar.gz -A installer\n[root@mac]# ./result/bin/darwin-installer")
                    ]))
                ]))
            ]))
        ])),
        A2(Iy, m([
            Cy("paragraph")
        ]), m([
            A2(Ww, g, m([
                Oy("When asked for editing the "),
                A2(Ek, g, m([
                    Oy("darwin-configuration.nix")
                ])),
                Oy(" add:")
            ]))
        ])),
        A2(Iy, m([
            Cy("listingblock")
        ]), m([
            A2(Iy, m([
                Cy("content")
            ]), m([
                A2(dI, m([
                    Cy("highlight")
                ]), m([
                    A2(Ek, m([
                        Cy("language-nix"),
                        A2(DA, "data-lang", "nix")
                    ]), m([
                        Oy("services.nix-daemon.enable = true;\nservices.hercules-ci-agent.enable = true;")
                    ]))
                ]))
            ]))
        ]))
    ])), yI = A2(Iy, g, m([
        A2(Iy, m([
            Cy("paragraph")
        ]), m([
            A2(Ww, g, m([
                Oy("Save the token to a new file "),
                A2(Ek, g, m([
                    Oy("cluster-join-token.key")
                ])),
                Oy(" on the target machine and run:")
            ]))
        ])),
        A2(Iy, m([
            Cy("listingblock")
        ]), m([
            A2(Iy, m([
                Cy("content")
            ]), m([
                A2(dI, m([
                    Cy("highlight")
                ]), m([
                    A2(Ek, m([
                        Cy("language-shell"),
                        A2(DA, "data-lang", "shell")
                    ]), m([
                        Oy("$ sudo install \\\n    -o hercules-ci-agent  \\\n    -m 0600 \\\n    cluster-join-token.key \\\n    /var/lib/hercules-ci-agent/secrets/cluster-join-token.key\n$ rm cluster-join-token.key")
                    ]))
                ]))
            ]))
        ])),
        A2(Iy, m([
            Cy("paragraph")
        ]), m([
            A2(Ww, g, m([
                A2(Ek, g, m([
                    Oy("tail -f /var/log/hercules-ci-agent.log")
                ])),
                Oy(" to see what is going on with your agent.")
            ]))
        ]))
    ])), wI = A2(Iy, g, m([
        A2(Iy, m([
            Cy("admonitionblock note")
        ]), m([
            A2(wk, g, m([
                A2(Ck, g, m([
                    A2(xk, m([
                        Cy("icon")
                    ]), m([
                        A2(Iy, m([
                            Cy("title")
                        ]), m([
                            Oy("Note")
                        ]))
                    ])),
                    A2(xk, m([
                        Cy("content")
                    ]), m([
                        A2(Iy, m([
                            Cy("paragraph")
                        ]), m([
                            A2(Ww, g, m([
                                Oy("To avoid compiling the agent for hours you can use our binary cache to speed it up:")
                            ]))
                        ])),
                        A2(Iy, m([
                            Cy("listingblock")
                        ]), m([
                            A2(Iy, m([
                                Cy("content")
                            ]), m([
                                A2(dI, m([
                                    Cy("highlight")
                                ]), m([
                                    A2(Ek, m([
                                        Cy("language-shell"),
                                        A2(DA, "data-lang", "shell")
                                    ]), m([
                                        Oy("$ nix-env -iA cachix -f https://cachix.org/api/v1/install\n$ cachix use hercules-ci")
                                    ]))
                                ]))
                            ]))
                        ]))
                    ]))
                ]))
            ]))
        ])),
        A2(Iy, m([
            Cy("paragraph")
        ]), m([
            A2(Ww, g, m([
                Oy("Deploy using:")
            ]))
        ])),
        A2(Iy, m([
            Cy("listingblock")
        ]), m([
            A2(Iy, m([
                Cy("content")
            ]), m([
                A2(dI, m([
                    Cy("highlight")
                ]), m([
                    A2(Ek, m([
                        Cy("language-shell"),
                        A2(DA, "data-lang", "shell")
                    ]), m([
                        Oy("$ nix-shell -p nixops -I nixpkgs=http://nixos.org/channels/nixos-19.09/nixexprs.tar.xz\n$ nixops create -d my-agent ./hercules-ci-agents.nix ./hercules-ci-agents-target.nix\n$ nixops deploy -d my-agent")
                    ]))
                ]))
            ]))
        ])),
        A2(Iy, m([
            Cy("paragraph")
        ]), m([
            A2(Ww, g, m([
                Oy("The agent will start working as soon as the deployment has succeeded and builds are queued.")
            ]))
        ]))
    ])), kI = A2(Iy, g, m([
        A2(Iy, m([
            Cy("paragraph")
        ]), m([
            A2(Ww, g, m([
                Oy("Active your configuration with")
            ]))
        ])),
        A2(Iy, m([
            Cy("listingblock")
        ]), m([
            A2(Iy, m([
                Cy("content")
            ]), m([
                A2(dI, m([
                    Cy("highlight")
                ]), m([
                    A2(Ek, m([
                        Cy("language-shell"),
                        A2(DA, "data-lang", "shell")
                    ]), m([
                        Oy("[root@my-agent-host]# nixos-rebuild switch")
                    ]))
                ]))
            ]))
        ])),
        A2(Iy, m([
            Cy("paragraph")
        ]), m([
            A2(Ww, g, m([
                Oy("This creates the "),
                A2(Ek, g, m([
                    Oy("hercules-ci-agent")
                ])),
                Oy(" user. If you haven't set the file permissions yet:")
            ]))
        ])),
        A2(Iy, m([
            Cy("listingblock")
        ]), m([
            A2(Iy, m([
                Cy("content")
            ]), m([
                A2(dI, m([
                    Cy("highlight")
                ]), m([
                    A2(Ek, m([
                        Cy("language-shell"),
                        A2(DA, "data-lang", "shell")
                    ]), m([
                        Oy("[root@my-agent-host]# chown -R hercules-ci-agent /var/lib/hercules-ci-agent\n[root@my-agent-host]# chmod o-rwx /var/lib/hercules-ci-agent/secrets")
                    ]))
                ]))
            ]))
        ])),
        A2(Iy, m([
            Cy("paragraph")
        ]), m([
            A2(Ww, g, m([
                Oy("The log should indicate "),
                A2(Ek, g, m([
                    Oy("Agent online")
                ])),
                Oy(".")
            ]))
        ])),
        A2(Iy, m([
            Cy("listingblock")
        ]), m([
            A2(Iy, m([
                Cy("content")
            ]), m([
                A2(dI, m([
                    Cy("highlight")
                ]), m([
                    A2(Ek, m([
                        Cy("language-shell"),
                        A2(DA, "data-lang", "shell")
                    ]), m([
                        Oy("[root@my-agent-host]# journalctl -u hercules-ci-agent.service\n[...]\nNov 06 22:35:36 my-agent-host hercules-ci-agent[1305]: [2019-11-06 22:35:36][][Info][agent-machine-1][PID 1305][ThreadId 22][agent-version:0.6.1][main:Hercules.Agent hercules-ci-agent/Hercules/Agent.hs:73:8] Agent online.")
                    ]))
                ]))
            ]))
        ]))
    ])), xI = A2(Iy, g, m([
        A2(Iy, m([
            Cy("admonitionblock warning")
        ]), m([
            A2(wk, g, m([
                A2(Ck, g, m([
                    A2(xk, m([
                        Cy("icon")
                    ]), m([
                        A2(Iy, m([
                            Cy("title")
                        ]), m([
                            Oy("Warning")
                        ]))
                    ])),
                    A2(xk, m([
                        Cy("content")
                    ]), m([
                        Oy("\nAlthough a single agent works with empty "),
                        A2(Ek, g, m([
                            Oy("{}")
                        ])),
                        Oy(" binary cache configuration,\nwe highly recommend setting up a cache from the start.\nRunning without a cache will break some features and will cause unexpectedly long build times\ndue to eventual garbage collection.\n")
                    ]))
                ]))
            ]))
        ])),
        A2(Iy, m([
            Cy("paragraph")
        ]), m([
            A2(Ww, g, m([
                Oy("On "),
                A2(Py, m([
                    jw("https://cachix.org")
                ]), m([
                    Oy("Cachix")
                ])),
                Oy(" you can create a binary cache. After you complete the process, gather the keys into a "),
                A2(Ek, g, m([
                    Oy("binary-caches.json")
                ])),
                Oy(" file, replacing all placeholders:")
            ]))
        ])),
        A2(Iy, m([
            Cy("listingblock")
        ]), m([
            A2(Iy, m([
                Cy("title")
            ]), m([
                Oy("binary-caches.json")
            ])),
            A2(Iy, m([
                Cy("content")
            ]), m([
                A2(dI, m([
                    Cy("highlight")
                ]), m([
                    A2(Ek, m([
                        Cy("language-json"),
                        A2(DA, "data-lang", "json")
                    ]), m([
                        Oy('{ "mycache": '),
                        A2(fI, m([
                            Cy("conum")
                        ]), m([
                            Oy("(1)")
                        ])),
                        Oy('\n    { "kind": "CachixCache"\n    , "authToken": "eyJhaf23GH53a.bc23BUSI.9q3048hWHh" '),
                        A2(fI, m([
                            Cy("conum")
                        ]), m([
                            Oy("(2)")
                        ])),
                        Oy('\n    , "publicKeys": ["mycache.cachix.org-1:EjBSHzF6VmDnzqlldGXbi0RM3HdjfTU3yDRi9Pd0jTY="] '),
                        A2(fI, m([
                            Cy("conum")
                        ]), m([
                            Oy("(3)")
                        ])),
                        Oy('\n    , "signingKeys": ["uAhqM3jG..."] '),
                        A2(fI, m([
                            Cy("conum")
                        ]), m([
                            Oy("(4)")
                        ])),
                        Oy("\n    }\n}")
                    ]))
                ]))
            ]))
        ])),
        A2(Iy, m([
            Cy("colist arabic")
        ]), m([
            A2(lI, g, m([
                A2(zk, g, m([
                    A2(Ww, g, m([
                        Oy("The name of the Cachix cache; for example the "),
                        A2(Ek, g, m([
                            Oy("mycache")
                        ])),
                        Oy(" part from "),
                        A2(Ek, g, m([
                            Oy("mycache.cachix.org")
                        ])),
                        Oy(".")
                    ]))
                ])),
                A2(zk, g, m([
                    A2(Ww, g, m([
                        Oy("Optional; only required for private binary caches. You may retrieve this from the "),
                        A2(Py, m([
                            jw("https://cachix.org/")
                        ]), m([
                            Oy("Cachix Getting started instructions, step 3")
                        ])),
                        Oy(".")
                    ]))
                ])),
                A2(zk, g, m([
                    A2(Ww, g, m([
                        Oy('The public part of the signing key. Look for "Public Key" on your cache page (example page: '),
                        A2(Ek, g, m([
                            Oy("https://mycache.cachix.org")
                        ])),
                        Oy(").")
                    ]))
                ])),
                A2(zk, g, m([
                    A2(Ww, g, m([
                        Oy("A cache-specific secret key to sign store paths. You can find it in "),
                        A2(Ek, g, m([
                            Oy("~/.config/cachix/cachix.dhall")
                        ])),
                        Oy(" or your key backup after following the setup instructions on cachix.org. Make sure you copy the right key if you have multiple in your "),
                        A2(Ek, g, m([
                            Oy("cachix.dhall")
                        ])),
                        Oy(".")
                    ]))
                ]))
            ]))
        ])),
        A2(Iy, m([
            Cy("admonitionblock note")
        ]), m([
            A2(wk, g, m([
                A2(Ck, g, m([
                    A2(xk, m([
                        Cy("icon")
                    ]), m([
                        A2(Iy, m([
                            Cy("title")
                        ]), m([
                            Oy("Note")
                        ]))
                    ])),
                    A2(xk, m([
                        Cy("content")
                    ]), m([
                        Oy("\nFor more detail, see "),
                        A2(Py, m([
                            jw("https://docs.hercules-ci.com/hercules-ci/reference/binary-caches-json/")
                        ]), m([
                            Oy("The "),
                            A2(Ek, g, m([
                                Oy("binary-caches.json")
                            ])),
                            Oy(" format")
                        ])),
                        Oy(" in the Reference.\n")
                    ]))
                ]))
            ]))
        ])),
        A2(Iy, m([
            Cy("paragraph")
        ]), m([
            A2(Ww, g, m([
                Oy("Copy or move the "),
                A2(Ek, g, m([
                    Oy("binary-caches.json")
                ])),
                Oy(" file into "),
                A2(Ek, g, m([
                    Oy("/var/lib/hercules-ci-agent/secrets/")
                ])),
                Oy(".")
            ]))
        ])),
        A2(Iy, m([
            Cy("paragraph")
        ]), m([
            A2(Ww, g, m([
                Oy("Make sure that "),
                A2(Ek, g, m([
                    Oy("/var/lib/hercules-ci-agent/secrets")
                ])),
                Oy(" and its contents can only be read by "),
                A2(Ek, g, m([
                    Oy("hercules-ci-agent")
                ])),
                Oy(".")
            ]))
        ]))
    ])), jI = A2(Iy, g, m([
        A2(Iy, m([
            Cy("paragraph")
        ]), m([
            A2(Ww, g, m([
                Oy("Add this configuration to "),
                A2(Ek, g, m([
                    Oy("/etc/nixos/configuration.nix")
                ])),
                Oy(":")
            ]))
        ])),
        A2(Iy, m([
            Cy("listingblock")
        ]), m([
            A2(Iy, m([
                Cy("content")
            ]), m([
                A2(dI, m([
                    Cy("highlight")
                ]), m([
                    A2(Ek, m([
                        Cy("language-nix"),
                        A2(DA, "data-lang", "nix")
                    ]), m([
                        Oy('{\n  imports = [\n    ( builtins.fetchTarball "https://github.com/hercules-ci/hercules-ci-agent/archive/stable.tar.gz"\n      + "/module.nix"\n    )\n  ];\n\n  services.hercules-ci-agent.enable = true;\n  services.hercules-ci-agent.concurrentTasks = 4; # Number of jobs to run\n}')
                    ]))
                ]))
            ]))
        ]))
    ])), AI = A2(Iy, g, m([
        A2(Iy, m([
            Cy("paragraph")
        ]), m([
            A2(Ww, g, m([
                Oy("The goal of this step is to make sure everything is set up correctly.")
            ]))
        ])),
        A2(Iy, m([
            Cy("olist loweralpha")
        ]), m([
            A2(lI, m([
                Cy("loweralpha")
            ]), m([
                A2(zk, g, m([
                    A2(Ww, g, m([
                        Oy("If you are familiar with Nix, "),
                        A2(Py, m([
                            jw("https://docs.hercules-ci.com/hercules-ci/getting-started/repository/")
                        ]), m([
                            Oy("set up your own git repository")
                        ]))
                    ]))
                ])),
                A2(zk, g, m([
                    A2(Ww, g, m([
                        Oy("Otherwise "),
                        A2(Py, m([
                            jw("https://docs.hercules-ci.com/hercules-ci/getting-started/minimal-repository/")
                        ]), m([
                            Oy("verify your agent setup with a minimal git repository")
                        ]))
                    ]))
                ]))
            ]))
        ]))
    ])), CI = A2(Iy, g, m([
        A2(Iy, m([
            Cy("paragraph")
        ]), m([
            A2(Ww, g, m([
                Oy("Choose between backends. NixOps can deploy to:")
            ]))
        ])),
        A2(Iy, m([
            Cy("ulist")
        ]), m([
            A2(qk, g, m([
                A2(zk, g, m([
                    A2(Ww, g, m([
                        A2(Py, m([
                            jw("https://nixos.org/nixops/manual/#sec-deploying-to-physical-nixos")
                        ]), m([
                            Oy("Any existing NixOS machine")
                        ]))
                    ]))
                ])),
                A2(zk, g, m([
                    A2(Ww, g, m([
                        A2(Py, m([
                            jw("https://nixos.org/nixops/manual/#sec-deploying-to-ec2")
                        ]), m([
                            Oy("Amazon EC2")
                        ]))
                    ]))
                ])),
                A2(zk, g, m([
                    A2(Ww, g, m([
                        A2(Py, m([
                            jw("https://nixos.org/nixops/manual/#sec-deploying-to-gce")
                        ]), m([
                            Oy("Google Cloud Engine")
                        ]))
                    ]))
                ])),
                A2(zk, g, m([
                    A2(Ww, g, m([
                        A2(Py, m([
                            jw("https://nixos.org/nixops/manual/#sec-deploying-to-azure")
                        ]), m([
                            Oy("Microsoft Azure")
                        ]))
                    ]))
                ])),
                A2(zk, g, m([
                    A2(Ww, g, m([
                        A2(Py, m([
                            jw("https://nixos.org/nixops/manual/#idm140737318355376")
                        ]), m([
                            Oy("Hetzner")
                        ]))
                    ]))
                ])),
                A2(zk, g, m([
                    A2(Ww, g, m([
                        A2(Py, m([
                            jw("https://nixos.org/nixops/manual/#sec-deploying-to-digital-ocean")
                        ]), m([
                            Oy("Digital Ocean")
                        ]))
                    ]))
                ]))
            ]))
        ])),
        A2(Iy, m([
            Cy("paragraph")
        ]), m([
            A2(Ww, g, m([
                Oy("An example physical specification:")
            ]))
        ])),
        A2(Iy, m([
            Cy("listingblock")
        ]), m([
            A2(Iy, m([
                Cy("title")
            ]), m([
                Oy("hercules-ci-agents-target.nix")
            ])),
            A2(Iy, m([
                Cy("content")
            ]), m([
                A2(dI, m([
                    Cy("highlight")
                ]), m([
                    A2(Ek, m([
                        Cy("language-nix"),
                        A2(DA, "data-lang", "nix")
                    ]), m([
                        Oy('{\n  agent = {\n    deployment.targetHost = "10.0.0.42"; # Your agent\'s IP address running NixOS\n  };\n}')
                    ]))
                ]))
            ]))
        ]))
    ])), II = A2(Iy, g, m([
        A2(Iy, m([
            Cy("paragraph")
        ]), m([
            A2(Ww, g, m([
                Oy("Terraform supports a wide range of cloud providers.\nTo facilitate deployment with this tool, we provide terraform modules.")
            ]))
        ])),
        A2(Iy, m([
            Cy("olist loweralpha")
        ]), m([
            A2(lI, m([
                Cy("loweralpha")
            ]), m([
                A2(zk, g, m([
                    A2(Ww, g, m([
                        Oy("If you already have a workflow for terraform deployments, the "),
                        A2(Py, m([
                            jw("https://github.com/hercules-ci/terraform-hercules-ci#readme")
                        ]), m([
                            Oy("terraform modules")
                        ])),
                        Oy(" are your starting point.")
                    ]))
                ])),
                A2(zk, g, m([
                    A2(Ww, g, m([
                        Oy("If you are using AWS and/or this is your first terraform deployment, we provide an "),
                        A2(Py, m([
                            jw("https://github.com/hercules-ci/example-deploy-agent-terraform-aws#readme")
                        ]), m([
                            Oy("AWS example deployment project")
                        ])),
                        Oy(" that you can adapt.")
                    ]))
                ]))
            ]))
        ]))
    ])), TI = F2(function(n, e) {
        return A2(pC, Wf(e), Ru({
            co: n.co.ax,
            dA: n.dA,
            bw: e
        }));
    }), SI = F2(function(n, e) {
        for(;;){
            var t = l(e.G, e.C);
            n: for(;;)switch(t.a){
                case 0:
                    var r = b(e, {
                        C: ht(2),
                        G: 4
                    }), a = b(e, {
                        C: ht(4),
                        G: 4
                    }), i = b(e, {
                        C: ht(1),
                        G: 4
                    }), c = b(e, {
                        C: ht(3),
                        G: 1
                    }), o = r, s = b(e, {
                        C: ht(0),
                        G: 1
                    });
                    return m([
                        A2(Ww, g, m([
                            Oy("Pick a recommended deployment method:")
                        ])),
                        A2(Iy, m([
                            Cy("ui borderless stackable two item menu fluid"),
                            A2(Ly, "position", "relative")
                        ]), m([
                            A2(Iy, A2(Ze, Cy("link item"), h(A2(gI, u(e.C, s.C), Cy("active")), A2(TI, n, s))), m([
                                A2(zy, m([
                                    Cy("ui icon massive apple"),
                                    A2(Ly, "margin", "0.214em !important")
                                ]), g),
                                A2(Iy, m([
                                    Cy("ui blue"),
                                    A2(Ly, "display", "inline-block"),
                                    A2(Ly, "vertical-align", "middle")
                                ]), m([
                                    A2(Pw, m([
                                        Cy("ui text big")
                                    ]), m([
                                        Oy("macOS")
                                    ])),
                                    A2(Ww, m([
                                        Cy("ui text")
                                    ]), m([
                                        Oy("via nix-darwin")
                                    ]))
                                ]))
                            ])),
                            A2(Iy, m([
                                Cy("ui vertical divider")
                            ]), m([
                                Oy("or")
                            ])),
                            A2(Iy, A2(Ze, Cy("link item"), h(A2(gI, u(e.C, o.C), Cy("active")), A2(TI, n, o))), m([
                                A2(zy, m([
                                    Cy("ui icon massive linux")
                                ]), g),
                                A2(Iy, m([
                                    Cy("ui blue"),
                                    A2(Ly, "display", "inline-block"),
                                    A2(Ly, "vertical-align", "middle")
                                ]), m([
                                    A2(Pw, m([
                                        Cy("ui text big")
                                    ]), m([
                                        Oy("Linux")
                                    ])),
                                    A2(Ww, m([
                                        Cy("ui text")
                                    ]), m([
                                        Oy("via Terraform")
                                    ]))
                                ]))
                            ]))
                        ])),
                        A2(Ww, g, m([
                            Oy("or choose from all methods:")
                        ])),
                        A2(qk, g, m([
                            A2(zk, g, m([
                                Oy("Deploy with "),
                                A2(Py, A2(TI, n, r), m([
                                    Oy("Terraform")
                                ]))
                            ])),
                            A2(zk, g, m([
                                Oy("Deploy with "),
                                A2(Py, A2(TI, n, i), m([
                                    Oy("NixOps")
                                ]))
                            ])),
                            A2(zk, g, m([
                                Oy("Install with "),
                                A2(Py, A2(pC, Wf(s), Ru({
                                    co: n.co.ax,
                                    dA: n.dA,
                                    bw: s
                                })), m([
                                    Oy("nix-darwin")
                                ]))
                            ])),
                            A2(zk, g, m([
                                Oy("Install with "),
                                A2(Py, A2(pC, Wf(a), Ru({
                                    co: n.co.ax,
                                    dA: n.dA,
                                    bw: a
                                })), m([
                                    Oy("NixOS")
                                ]))
                            ])),
                            A2(zk, g, m([
                                Oy("Install manually with "),
                                A2(Py, A2(pC, Wf(c), Ru({
                                    co: n.co.ax,
                                    dA: n.dA,
                                    bw: c
                                })), m([
                                    Oy("configuration file")
                                ]))
                            ]))
                        ]))
                    ]);
                case 2:
                    if (t.b.$) break n;
                    switch(t.b.a){
                        case 0:
                            return m([
                                mI,
                                pI
                            ]);
                        case 1:
                            return m([
                                mI
                            ]);
                        case 4:
                            return m([
                                xI
                            ]);
                        default:
                            break n;
                    }
                case 3:
                    if (t.b.$) break n;
                    switch(t.b.a){
                        case 1:
                            return m([
                                sI(n),
                                Oy("Copy the token into a plain text file "),
                                A2(Ek, g, m([
                                    Oy("cluster-join-token.key")
                                ])),
                                Oy(" in the same directory. Protect this file like a password.")
                            ]);
                        case 4:
                            return m([
                                sI(n),
                                Oy("Move the token into "),
                                A2(Ek, g, m([
                                    Oy("/var/lib/hercules-ci-agent/secrets/cluster-join-token.key")
                                ])),
                                Oy(". Protect this file like a password.")
                            ]);
                        default:
                            break n;
                    }
                case 5:
                    if (t.b.$ || 1 !== t.b.a) break n;
                    return m([
                        CI
                    ]);
                case 4:
                    if (t.b.$) break n;
                    switch(t.b.a){
                        case 1:
                            return m([
                                vI
                            ]);
                        case 4:
                            return m([
                                jI
                            ]);
                        case 2:
                            return hI(n);
                        default:
                            break n;
                    }
                case 1:
                    if (t.b.$) break n;
                    switch(t.b.a){
                        case 0:
                            return m([
                                $I,
                                sI(n),
                                yI
                            ]);
                        case 1:
                            return m([
                                wI
                            ]);
                        case 2:
                            return m([
                                II
                            ]);
                        case 3:
                            return h(hI(n), m([
                                A2(yk, g, m([
                                    Oy("Config file")
                                ])),
                                A2(Ww, g, m([
                                    Oy("Install and configure the agent as documented in "),
                                    A2(BC, "https://docs.hercules-ci.com/hercules-ci/getting-started/deploy/manual/", m([
                                        Oy("the manual")
                                    ])),
                                    Oy(".")
                                ]))
                            ]));
                        default:
                            return m([
                                kI
                            ]);
                    }
                default:
                    return m([
                        AI
                    ]);
            }
            e = b(e, {
                G: 0
            });
        }
    }), DI = F3(function(n, e, t) {
        var r = e.iB, a = e.e, i = e.ic, u = e.hW, c = e.ct;
        return A2(n, h(m([
            Cy("step"),
            Uy(m([
                l("completed", i),
                l("active", u)
            ]))
        ]), c), yc(m([
            1 === r.$ ? g : m([
                A2(nk, ek, r.a)
            ]),
            m([
                A2(Iy, m([
                    Cy("content")
                ]), function() {
                    if (1 === a.$) return t;
                    var n = a.a;
                    return m([
                        A2(Iy, m([
                            Cy("title")
                        ]), m([
                            Oy(n)
                        ])),
                        A2(Iy, m([
                            Cy("description")
                        ]), t)
                    ]);
                }())
            ])
        ])));
    }), NI = F2(function(n, e) {
        return A3(DI, Py, n, e);
    }), EI = F2(function(n, e) {
        var t;
        return A2(Iy, yc(m([
            m([
                Cy("ui steps"),
                Uy(m([
                    l("ordered", n.ji),
                    l("vertical", n.jP)
                ]))
            ]),
            (t = n.h$, 1 === t.$ ? g : m([
                FA(t.a)
            ])),
            function() {
                var e = n.jF;
                if (1 === e.$) return g;
                var t = e.a;
                return m([
                    Cy(function() {
                        switch(t){
                            case 0:
                                return "one";
                            case 1:
                                return "two";
                            case 2:
                                return "three";
                            case 3:
                                return "four";
                            case 4:
                                return "five";
                            case 5:
                                return "six";
                            case 6:
                                return "seven";
                            default:
                                return "eight";
                        }
                    }())
                ]);
            }()
        ])), A2(Lr, function(n) {
            return n;
        }, e));
    }), LI = F2(function(n, e) {
        var t = F4(function(t, r, a, i) {
            return A2(NI, {
                hW: u(e.G, i.G),
                ct: h(A2(pC, Wf(i), Ru({
                    co: n.co.ax,
                    dA: n.dA,
                    bw: i
                })), t),
                ic: !1,
                iB: gt,
                e: ht(r)
            }, m([
                Oy(a)
            ]));
        }), r = t(g), a = A3(r, "Deploy", "Using NixOps", b(e, {
            G: 1
        })), i = A3(r, "Install", "Using NixOS", b(e, {
            G: 1
        })), c = A3(r, "Choose Deployment", "", b(e, {
            G: 0
        })), o = A3(r, "Choose target", "Pick between AWS, Azure, GCE, ...", b(e, {
            G: 5
        })), s = A3(r, "Configure", "Gather credentials", b(e, {
            G: 4
        })), f = A3(r, "Deploy", "Using Terraform", b(e, {
            G: 1
        })), d = A3(r, "Build a Project", "", b(e, {
            G: 6
        })), v = F2(function(n, r) {
            return A4(t, m([
                Cy("disabled")
            ]), n, r, e);
        }), p = A3(r, "Install", "Using a config file", b(e, {
            G: 1
        })), $ = A3(r, "Generate a token", "Secret to join your account", b(e, {
            G: 3
        })), y = A2(v, "Build a Project", ""), w = A2(v, "Deploy", ""), k = A2(v, "Configure", ""), x = A3(r, "Deploy", "Using nix-darwin", b(e, {
            G: 1
        })), j = {
            h$: ht(0),
            ji: !0,
            jF: ht(6),
            jP: !1
        }, A = A3(r, "Binary Caches", "Share binaries between machines", b(e, {
            G: 2
        })), C = A3(r, "Bootstrap", "Configure your agent", b(e, {
            G: 4
        })), I = l(e.G, e.C);
        if (I.b.$) return m([
            A2(Mw, g, m([
                Oy("Agent Setup: Pick an Operating System")
            ])),
            A2(EI, j, m([
                c,
                k,
                w,
                y
            ]))
        ]);
        switch(I.b.a){
            case 0:
                return m([
                    A2(Mw, g, m([
                        Oy("Deploying an agent on macOS")
                    ])),
                    A2(EI, j, m([
                        c,
                        x,
                        A,
                        d
                    ]))
                ]);
            case 2:
                return m([
                    A2(Mw, g, m([
                        Oy("Deploying an agent using Terraform")
                    ])),
                    A2(EI, j, m([
                        c,
                        s,
                        f,
                        d
                    ]))
                ]);
            case 1:
                return m([
                    A2(Mw, g, m([
                        Oy("Deploying an agent using NixOps")
                    ])),
                    A2(EI, j, m([
                        c,
                        C,
                        A,
                        o,
                        $,
                        a,
                        d
                    ]))
                ]);
            case 4:
                return m([
                    A2(Mw, g, m([
                        Oy("Install an agent on NixOS")
                    ])),
                    A2(EI, j, m([
                        c,
                        C,
                        A,
                        $,
                        i,
                        d
                    ]))
                ]);
            default:
                return m([
                    A2(Mw, g, m([
                        Oy("Install an agent manually")
                    ])),
                    A2(EI, j, m([
                        c,
                        p,
                        d
                    ]))
                ]);
        }
    }), BI = F3(function(n, e, t) {
        return A2(Iy, g, m([
            A2(Iy, m([
                Cy("ui attached raised segment")
            ]), h(A2(LI, e, t), m([
                A2(Iy, m([
                    Cy("ui adoc"),
                    A2(Ly, "margin", "30px 0")
                ]), A2(SI, e, t))
            ]))),
            A2(Iy, m([
                Cy("ui buttom secondary attached raised segment")
            ]), m([
                A2(zy, m([
                    Cy("icon envelope")
                ]), g),
                Oy("Contact "),
                A2(Py, m([
                    jw("mailto:help@hercules-ci.com")
                ]), m([
                    Oy("help@hercules-ci.com")
                ])),
                Oy(" if you need help setting up an agent.")
            ]))
        ]));
    }), OI = F4(function(n, e, t, r) {
        return A3(cu, e, function(e) {
            return ht(e.$ ? t : A2(n, e.a, t));
        }, r);
    }), PI = F3(function(n, e, t) {
        return A3(xt, F2(function(t, r) {
            return A4(OI, n, e(t), t, r);
        }), da, t);
    }), GI = k, RI = Fn("tfoot"), zI = function(n) {
        return A2(Pw, m([
            Cy("ui label black")
        ]), m([
            Oy(n)
        ]));
    }, qI = function(n) {
        return A2(Pw, m([
            Cy("ui label blue")
        ]), m([
            Oy(n)
        ]));
    }, _I = F3(function(n, e, t) {
        var r = function(t) {
            var r, a = Pu({
                co: e.co.ax,
                fK: t.fK,
                dA: e.dA
            });
            return A2(Ck, m([
                ww((r = a, {
                    $: 6,
                    a: r
                }))
            ]), m([
                A2(xk, g, m([
                    A2(Py, m([
                        Aw(a)
                    ]), m([
                        Oy(t.fK)
                    ]))
                ])),
                A2(xk, g, m([
                    A2(hA, n, t)
                ])),
                A2(xk, g, m([
                    Oy(A2(bA, n.eS, t.eR))
                ])),
                A2(xk, g, A2(Lr, zI, t.gL)),
                A2(xk, g, A2(Lr, qI, t.hs)),
                A2(xk, g, m([
                    Oy(t.a0)
                ])),
                A2(xk, g, m([
                    Oy(t.gr)
                ]))
            ]));
        }, a = m([
            A2(jk, g, m([
                Oy("Hostname")
            ])),
            A2(jk, g, m([
                Oy("Status")
            ])),
            A2(jk, g, m([
                Oy("Registered since")
            ])),
            A2(jk, g, m([
                Oy("Platforms")
            ])),
            A2(jk, g, m([
                Oy("Features")
            ])),
            A2(jk, g, m([
                Oy("Agent version")
            ])),
            A2(jk, g, m([
                Oy("Nix version")
            ]))
        ]), i = F2(function(n, e) {
            var t = n.f5;
            if (1 === t.$) return 2;
            var r = t.a, a = e.f5;
            if (1 === a.$) return 0;
            var i = a.a;
            return s(dA(r - i), tA) > 0 ? A2(ga, i, r) : 1;
        });
        return A2(wk, m([
            Cy("ui unstackable table bottom attached")
        ]), m([
            A2(Ak, g, m([
                A2(Ck, m([
                    Cy("center aligned")
                ]), a)
            ])),
            A2(kk, g, A2(Lr, r, A2(GI, i, t))),
            A2(RI, g, m([
                A2(Ck, g, m([
                    A2(jk, m([
                        Lk(jt(a))
                    ]), m([
                        A2(Py, A2(Ze, Cy("ui right floated primary labeled icon button"), A2(pC, el, Gu({
                            co: e.co.ax,
                            dA: e.dA
                        }))), m([
                            A2(zy, m([
                                Cy("ui icon plus")
                            ]), g),
                            Oy("Set up an agent")
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), HI = F2(function(n, e) {
        var t = e.a1;
        switch(t.$){
            case 2:
                var r = t.a;
                return A2(uk, Jw(n), r);
            case 3:
                var a = t.a;
                return a.b ? A3(_I, n, e, Ql(A3(PI, F2(function(n, e) {
                    return s(A2(ca, 0, A2(Fi, Jk, n.f5)), A2(ca, 0, A2(Fi, Jk, e.f5))) > 0 ? n : e;
                }), function(n) {
                    return l(n.fK, n.eK);
                }, a))) : A3(BI, n, e, nl);
            case 1:
                return A2(Iy, m([
                    Cy("ui loader active massive text")
                ]), m([
                    Oy("Loading agents")
                ]));
            default:
                return A2(Pw, g, g);
        }
    }), FI = m([
        A2(jk, m([
            Cy("two wide")
        ]), m([
            Oy("Type")
        ])),
        A2(jk, m([
            Cy("four wide")
        ]), m([
            Oy("Task")
        ])),
        A2(jk, m([
            Cy("two wide")
        ]), m([
            Oy("Status")
        ])),
        A2(jk, m([
            Cy("three wide")
        ]), m([
            Oy("Planned")
        ])),
        A2(jk, m([
            Cy("two wide")
        ]), m([
            Oy("System")
        ])),
        A2(jk, m([
            Cy("three wide")
        ]), m([
            Oy("Agent")
        ]))
    ]), UI = Lk(jt(FI)), VI = function(n) {
        return n ? 1 : 0;
    }, WI = F3(function(n, e, t) {
        return Bu({
            co: n.co.ax,
            eY: !1,
            a8: e,
            dA: n.dA,
            d9: VI(t),
            dQ: gt
        });
    }), YI = q, MI = function(n) {
        var e = Bt(A2(wt, "/", n));
        if (e.b) {
            if (e.b.b) {
                var t = e.a, r = A2(YI, "-", t);
                if (r.b) {
                    var a = r.a;
                    return A2(Pw, m([
                        ck(n)
                    ]), m([
                        A2(Ek, g, m([
                            A2(Pw, m([
                                A2(Ly, "display", "inline-flex"),
                                A2(Ly, "width", "3.7em"),
                                A2(Ly, "margin-right", "-0.1em"),
                                A2(Ly, "text-overflow", "ellipsis"),
                                A2(Ly, "overflow", "hidden")
                            ]), m([
                                A2(Iy, m([
                                    A2(Ly, "overflow", "hidden"),
                                    A2(Ly, "text-overflow", "ellipsis")
                                ]), m([
                                    Oy(A3(vr, 0, a, t))
                                ]))
                            ]))
                        ])),
                        A2(Pw, g, m([
                            Oy(A3(vr, a, gr(t), t))
                        ]))
                    ]));
                }
                return Oy(n);
            }
            return Oy(e.a);
        }
        return Oy("");
    }, KI = F3(function(n, e, t) {
        return A2(Py, m([
            Aw(A3(WI, n, e, t))
        ]), m([
            MI(e)
        ]));
    }), JI = F2(function(n, e) {
        var t = e.a$;
        if (1 === t.$) return e.bw ? Oy("(Redacted)") : A2(Pw, m([
            Cy("ui disabled text")
        ]), m([
            Oy("Unassigned")
        ]));
        var r = t.a;
        return A2(Py, m([
            Aw(Pu({
                co: n.co.ax,
                fK: r,
                dA: n.dA
            }))
        ]), m([
            Oy(r)
        ]));
    }), QI = function(n) {
        switch(n){
            case 0:
                return Oy("Ready");
            case 1:
                return Oy("Dispatched");
            case 2:
                return Oy("Cancelling");
            default:
                return Oy("Resetting");
        }
    }, ZI = F6(function(n, e, t, r, a, i) {
        return A2(Ck, g, m([
            A2(xk, g, m([
                Oy(r)
            ])),
            A2(xk, g, a),
            A2(xk, g, m([
                QI(t.bw)
            ])),
            A2(xk, g, m([
                A2(ox, n.jK, t.I)
            ])),
            A2(xk, g, i),
            A2(xk, g, m([
                A2(JI, e, t)
            ]))
        ]));
    }), XI = F3(function(n, e, t) {
        var r;
        return A6(ZI, n, e, t, "Build", m(1 === (r = t.a8).$ ? [
            Oy("(Private)")
        ] : [
            A3(KI, e, r.a, t.bw)
        ]), m([
            zI(t.dJ)
        ]));
    }), nT = F2(function(n, e) {
        return Wu({
            co: n.br.bn.n,
            a2: e,
            ab: n.ab,
            br: n.br.n,
            dA: n.br.bn.dA.n,
            d9: 1
        });
    }), eT = function(n) {
        var e = n.as, t = n.er;
        return A2(Py, m([
            Aw(A2(nT, e, t))
        ]), m([
            Oy(e.br.n + "#" + $t(e.ab) + " / " + Tl(t))
        ]));
    }, tT = F3(function(n, e, t) {
        var r;
        return A6(ZI, n, e, t, "Effect", m(1 === (r = t.cQ).$ ? [
            Oy("(Private)")
        ] : [
            eT(r.a)
        ]), m([
            zI(t.dJ)
        ]));
    }), rT = function(n) {
        return Uu({
            co: n.br.bn.n,
            ab: n.ab,
            br: n.br.n,
            dA: n.br.bn.dA.n
        });
    }, aT = F3(function(n, e, t) {
        var r, a;
        return A6(ZI, n, e, t, "Evaluation", m(1 === (a = t.as).$ ? [
            Oy("(Private)")
        ] : [
            (r = a.a, A2(Py, m([
                Aw(rT(r))
            ]), m([
                Oy(r.br.n + "#" + $t(r.ab))
            ])))
        ]), g);
    }), iT = F3(function(n, e, t) {
        var r = t.ff;
        if (r.$) {
            var a = t.eC;
            if (a.$) {
                var i = t.cQ;
                return i.$ ? A2(Ck, g, m([
                    A2(xk, g, m([
                        Oy("Unknown")
                    ]))
                ])) : A3(tT, n, e, i.a);
            }
            return A3(XI, n, e, a.a);
        }
        return A3(aT, n, e, r.a);
    }), uT = F2(function(n, e) {
        var t = e.dL;
        switch(t.$){
            case 3:
                var r = t.a;
                return UA(r.bh) ? m([
                    A2(Ck, g, m([
                        A2(xk, m([
                            UI,
                            Cy("center aligned disabled"),
                            A2(Ly, "user-select", "none"),
                            A2(Ly, "padding-top", "8.5ex")
                        ]), m([
                            A2(Pw, m([
                                Cy("ui text large")
                            ]), m([
                                A2(zy, m([
                                    Cy("ui icon check"),
                                    A2(Ly, "margin-right", ".5em")
                                ]), g),
                                Oy("idle")
                            ]))
                        ]))
                    ]))
                ]) : h(A2(Lr, A2(iT, n, e), r.bh), r.dj ? m([
                    A2(xk, m([
                        UI,
                        Cy("center aligned"),
                        A2(Ly, "padding-top", "10ex"),
                        A2(Ly, "padding-bottom", "10ex")
                    ]), m([
                        A2(Iy, m([
                            Cy("ui info message")
                        ]), m([
                            Oy("List truncated; further tasks not shown.")
                        ]))
                    ]))
                ]) : g);
            case 1:
                return m([
                    A2(Ck, g, m([
                        A2(xk, m([
                            UI
                        ]), m([
                            A2(Iy, m([
                                Cy("ui loader active inline text centered")
                            ]), m([
                                Oy("Loading tasks")
                            ]))
                        ]))
                    ]))
                ]);
            case 2:
                var a = t.a;
                return m([
                    A2(Ck, g, m([
                        A2(xk, m([
                            UI
                        ]), m([
                            Oy("Failed to load tasks: " + IA(a))
                        ]))
                    ]))
                ]);
            default:
                return g;
        }
    }), cT = F2(function(n, e) {
        return A2(Iy, m([
            Cy("ui bottom attached segment"),
            A2(Ly, "min-height", "100ex")
        ]), m([
            A2(wk, m([
                Cy("ui very basic table")
            ]), m([
                A2(Ak, m([
                    A2(Ly, "height", "4ex")
                ]), m([
                    A2(Ck, g, FI)
                ])),
                A2(kk, g, A2(uT, n, e))
            ]))
        ]));
    }), oT = F3(function(n, e, t) {
        var r = function() {
            switch(e.d9.$){
                case 1:
                case 2:
                    return "Agents";
                case 0:
                    return "Projects";
                default:
                    return "Tasks";
            }
        }(), a = function() {
            var r = e.d9;
            switch(r.$){
                case 1:
                    return A2(HI, n, e);
                case 2:
                    return A3(BI, n, e, r.a);
                case 0:
                    return A3(iI, n, e, t);
                default:
                    return A2(cT, n, e);
            }
        }();
        return {
            u: A2(Iy, g, m([
                A2(Iy, m([
                    Cy("ui container"),
                    A2(Ly, "margin-top", "60px")
                ]), m([
                    $C(e),
                    a
                ]))
            ])),
            e: r + " for " + e.co.k
        };
    }), sT = F3(function(n, e, t) {
        var r = t.a, a = t.b, i = A2(Xi, r, n.hV);
        return 1 === i.$ ? A2(Pw, g, g) : A2(Dy, function(n) {
            return Fs({
                bE: r,
                bF: n
            });
        }, A3(oT, e, i.a, a).u);
    }), fT = F2(function(n, e) {
        return {
            u: function() {
                var t = e.aR;
                switch(t.$){
                    case 1:
                        return A2(zy, m([
                            Cy("ui loader active massive text")
                        ]), m([
                            Oy("Loading your projects")
                        ]));
                    case 3:
                        var r = t.a, a = e.bC;
                        if (a.$) {
                            var i = a.a, u = A2(Xi, i.c, r);
                            return A2(Iy, g, m(1 === u.$ ? [
                                A3(sT, e, n, l(i.c, g))
                            ] : [
                                A3(sT, e, n, l(i.c, u.a))
                            ]));
                        }
                        return A2(Iy, g, A2(Ze, uy(r) ? A2(Iy, g, m([
                            A2(Mw, g, m([
                                Oy("Welcome to Hercules CI.")
                            ])),
                            A2(Ww, g, m([
                                Oy("We did not find any projects for you. Perhaps you could install Hercules CI on your repository accounts?")
                            ]))
                        ])) : A2(Iy, g, A2(Lr, A2(sT, e, n), Ys(r))), function(n) {
                            return 1 === n.hD.$ ? A2(wc, function(n) {
                                return A2(Lr, function(n) {
                                    return A2(Iy, m([
                                        Cy("ui placeholder segment"),
                                        A2(Ly, "margin-top", "5em"),
                                        A2(Ly, "margin-bottom", "5em")
                                    ]), m([
                                        A2(Iy, g, m([
                                            A2(Ww, m([
                                                A2(Ly, "text-align", "center")
                                            ]), m([
                                                Oy("Add more GitHub accounts")
                                            ])),
                                            A2(Py, m([
                                                jw(n),
                                                Cy("ui big labeled icon primary button")
                                            ]), m([
                                                A2(zy, m([
                                                    Cy("plus icon")
                                                ]), g),
                                                Oy("Install")
                                            ]))
                                        ]))
                                    ]));
                                }, Dl(n.gm));
                            }, n.h9.fu) : g;
                        }(n)));
                    case 0:
                        return A2(Pw, g, g);
                    default:
                        var c = t.a;
                        return A2(Iy, m([
                            Cy("ui container")
                        ]), m([
                            A2(uk, Jw(n), c)
                        ]));
                }
            }(),
            e: "Dashboard"
        };
    }), lT = {
        $: 2
    }, dT = {
        $: 5
    }, bT = Fn("h2"), hT = F3(function(n, e, t) {
        return A2(Iy, m([
            Cy("ui sixteen column centered stackable grid")
        ]), m([
            A2(Iy, m([
                Cy("four wide column")
            ]), n),
            A2(Iy, m([
                Cy("eight wide column centered")
            ]), m([
                A2(Iy, m([
                    Cy("column")
                ]), m([
                    A2(Iy, m([
                        Cy("ui padded basic segment")
                    ]), e)
                ]))
            ])),
            A2(Iy, m([
                Cy("four wide column")
            ]), t)
        ]));
    }), gT = function(n) {
        return A2(Iy, m([
            Cy("ui two column centered stackable grid")
        ]), m([
            A2(Iy, m([
                Cy("two column centered row")
            ]), m([
                A2(Iy, m([
                    Cy("column")
                ]), m([
                    A2(Iy, m([
                        Cy("ui padded basic segment")
                    ]), n)
                ]))
            ]))
        ]));
    }, vT = function(n) {
        return !A2(Pk, function(n) {
            return "webhook_noTestMessageReceived" === n;
        }, n.fc);
    }, pT = function(n) {
        var e = n.ac;
        return 3 === e.$ ? A2(Uf, vT, e.a.fe) : g;
    }, mT = F2(function(n, e) {
        return {
            $: 4,
            a: n,
            b: e
        };
    }), $T = BA, yT = OA, wT = F2(function(n, e) {
        var t = n.c, r = n.f3, a = n.ct, i = n.fe, u = n.fF;
        return A2(Iy, h(m([
            Cy("field"),
            Uy(m([
                l("error", u)
            ])),
            A2(Ly, "position", "relative")
        ]), a), h(m([
            A2(lj, m([
                fj(t)
            ]), m([
                Oy(r)
            ])),
            A2(Iy, g, A2(Lr, function(n) {
                return A2(Iy, m([
                    Cy("ui right aligned floating pointing below label")
                ]), m([
                    Oy(n)
                ]));
            }, i))
        ]), e));
    }), kT = F2(function(n, e) {
        return A2(Pk, function(e) {
            return u(e, n);
        }, e);
    }), xT = Ay("value"), jT = F2(function(n) {
        var e = pT(n), t = function(n) {
            return A2(Lr, function(n) {
                return n.bl;
            }, A2(Uf, function(e) {
                return A2(kT, n, e.fc);
            }, e));
        };
        return A2(LA, $T, m([
            A2(Ww, g, m([
                Oy("Please set the forge name as desired. These names can not be changed afterwards.")
            ])),
            A2(wT, {
                ct: m([
                    Cy("required field")
                ]),
                fe: t("input_name"),
                fF: !u(t("input_name"), g),
                c: "forge_name",
                f3: "Name (URLs, API, command line)"
            }, m([
                PA(b(yT, {
                    ct: m([
                        Ty("forge_name"),
                        xT(n.n),
                        qA(mT(0))
                    ])
                }))
            ])),
            A2(wT, {
                ct: m([
                    Cy("required field")
                ]),
                fe: t("input_displayName"),
                fF: !u(t("input_displayName"), g),
                c: "forge_display_name",
                f3: "Display Name (Dashboard)"
            }, m([
                PA(b(yT, {
                    ct: m([
                        Ty("forge_display_name"),
                        xT(n.k),
                        qA(mT(1))
                    ])
                }))
            ]))
        ]));
    }), AT = F3(function(n, e, t) {
        return A2(rk, ak, A3(ik, n, e, t));
    }), CT = F2(function(n, e) {
        var t, r, a = function(n) {
            var e = n.ac;
            if (3 === e.$) {
                var t = e.a;
                return A2(Uf, A2(cc, vT, xi), t.fe);
            }
            return g;
        }(e), i = 3 === (t = e.ac).$ && A2(wp, e, t.a) && u(pT(e), g), c = !i, o = pk(e.aq).a, s = pk(e.bU), f = s.a, d = s.b, b = h(A2(Lr, uk(Jw(n)), $k(m([
            f
        ]))), h(A2(Lr, function(e) {
            return A3(AT, Jw(n), e, m([
                Oy(" "),
                A2(Py, m([
                    ww(dT)
                ]), m([
                    Oy("Retry")
                ]))
            ]));
        }, $k(m([
            o
        ]))), h(Qb(d) ? m([
            A2(Iy, m([
                Cy("ui message info")
            ]), m([
                Oy("Installation deleted. "),
                A2(Py, m([
                    Aw(Fu({}))
                ]), m([
                    Oy("Go back")
                ]))
            ]))
        ]) : g, A2(Lr, function(n) {
            return A2(Iy, m([
                Cy("ui message warning")
            ]), m([
                Oy(n.bl)
            ]));
        }, a))));
        return A2(Iy, m([
            Cy("ui stacked segments")
        ]), m([
            A2(Iy, m([
                Uy(m([
                    l("ui padded basic segment", !u(b, g))
                ]))
            ]), b),
            A3(hT, g, m([
                A2(bT, g, m([
                    Oy("Connect GitLab and Hercules CI")
                ])),
                (r = e.ac, 3 === r.$ ? A2(jT, e, r.a) : A2(Iy, m([
                    Cy("ui placeholder")
                ]), m([
                    A2(Iy, m([
                        Cy("line")
                    ]), g)
                ])))
            ]), m([
                A2(Iy, m([
                    Cy("ui basic padded segment"),
                    A2(Ly, "position", "relative"),
                    A2(Ly, "float", "right")
                ]), m([
                    A2(jj, {
                        ct: m([
                            Cy("ui button yellow"),
                            sj(Km(d) || Qb(d))
                        ]),
                        eM: lT,
                        eN: d
                    }, m([
                        Oy("Cancel")
                    ]))
                ]))
            ])),
            gT(m([
                A2(Ww, g, m([
                    Oy("Next, finalize the installation by logging in and becoming the initial forge administrator.")
                ])),
                A2(Py, h(m([
                    Cy("ui orange button"),
                    Uy(m([
                        l("orange", i),
                        l("disabled", c)
                    ])),
                    sj(c)
                ]), i ? m([
                    jw("/api/auth/gitlab/start/" + e.ch.c6 + "?redirect=/install/gitlab/continue/" + e.ch.c6)
                ]) : g), m([
                    A2(zy, m([
                        Cy("ui icon gitlab")
                    ]), g),
                    Oy("Sign in")
                ]))
            ]))
        ]));
    }), IT = F2(function() {
        return A2(Iy, m([
            Cy("ui stacked segments")
        ]), m([
            A3(hT, g, m([
                A2(bT, g, m([
                    Oy("OAuth Setup Done")
                ])),
                A2(Ww, g, m([
                    Oy("Go to "),
                    A2(Py, m([
                        Aw(_u)
                    ]), m([
                        Oy("dashboard")
                    ]))
                ]))
            ]), g)
        ]));
    }), TT = F2(function(n, e) {
        return A2(A2(Pk, function(n) {
            return u(n.c, e.ch.c6);
        }, n.h9.fu) ? IT : CT, n, e);
    }), ST = F2(function(n, e) {
        return {
            u: A2(TT, n, e),
            e: "Installing GitLab"
        };
    }), DT = F2(function(n, e) {
        var t = e.c5;
        return 3 === t.$ ? A2(Lr, function(n) {
            return function(n) {
                return A2(Iy, m([
                    Cy("ui message warning")
                ]), m([
                    A2(Iy, m([
                        Cy("header")
                    ]), m([
                        Oy("Another GitLab installation is in progress")
                    ])),
                    A2(Iy, g, m([
                        Oy("You may choosey to "),
                        A2(Py, m([
                            Aw(Hu({
                                c6: n.c
                            }))
                        ]), m([
                            Oy("Resume installation")
                        ])),
                        Oy(' of the in progress installation of "'),
                        A2(Py, m([
                            Aw(Hu({
                                c6: n.c
                            }))
                        ]), m([
                            Oy(n.k)
                        ])),
                        Oy('" instead.')
                    ]))
                ]));
            }(n);
        }, t.a.bh) : g;
    }), NT = {
        $: 2
    }, ET = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), LT = function(n) {
        return l(n, !0);
    }, BT = VA(vx), OT = HA, PT = BA, GT = OA, RT = function(n) {
        var e = n.c4;
        switch(e.$){
            case 0:
            case 2:
                return !0;
            case 1:
                return !1;
            default:
                return 1 === e.a.$;
        }
    }, zT = F2(function(n, e) {
        return A2(Ky, n, {
            $: 2,
            a: e
        });
    }), qT = F2(function(n, e) {
        var t, r = function(n) {
            return m([
                qA(ET(n))
            ]);
        }, a = 1 === (t = Zp(e)).$ ? qp(t.a) : g, i = F4(function(n, t, r, i) {
            var c;
            return A2(Iy, h(m([
                Cy("field"),
                Uy(m([
                    l("error", (c = t, e.aA && A2(Pk, function(n) {
                        return u(n.a, c);
                    }, a)))
                ])),
                A2(Ly, "position", "relative")
            ]), r), h(m([
                A2(lj, m([
                    fj(n)
                ]), m([
                    Oy(t)
                ])),
                A2(Iy, g, e.aA ? A2(Lr, function(n) {
                    var e = n.b;
                    return A2(Iy, m([
                        Cy("ui right aligned floating pointing below label")
                    ]), m([
                        Oy(e)
                    ]));
                }, A2(Uf, function(n) {
                    return u(n.a, t);
                }, a)) : g)
            ]), i));
        }), c = A2(Zc, sj, xi), o = c(RT(e) && (!e.aA || u(a, g))), s = c(RT(e)), f = e.aA && !u(a, g);
        return A2(LA, PT, h(m([
            A4(i, "gitlab_url", "GitLab URL", m([
                Cy("required field")
            ]), m([
                PA(b(GT, {
                    ct: h(m([
                        Ty("gitlab_url"),
                        xT(e.c$),
                        s
                    ]), r(0))
                }))
            ])),
            A4(i, "gitlab_admin_username", "GitLab Admin Username", m([
                Cy("required field")
            ]), m([
                PA(b(GT, {
                    ct: h(m([
                        Ty("gitlab_admin_username"),
                        xT(e.aW),
                        s
                    ]), r(1))
                }))
            ])),
            A4(i, "gitlab_admin_password", "GitLab Admin Password", m([
                Cy("required field")
            ]), m([
                PA(b(GT, {
                    ct: h(m([
                        Ty("gitlab_admin_password"),
                        kw("password"),
                        xT(e.aQ),
                        s
                    ]), r(2))
                }))
            ])),
            A2(BT, b(OT, {
                ct: m([
                    Uy(m([
                        l("primary", !f),
                        l("red", f)
                    ])),
                    o,
                    A2(zT, "submit", A2(cr, LT, sr(NT))),
                    A2(zT, "click", A2(cr, LT, sr(NT)))
                ]),
                ih: f
            }), m([
                Oy("Submit")
            ]))
        ]), u(a, g) ? m([
            A2(Iy, g, g)
        ]) : m([
            A2(Iy, m([
                Cy("ui padded basic segment")
            ]), A2(Lr, function(n) {
                var e = n.a;
                return A2(Iy, m([
                    Cy("ui message error")
                ]), m([
                    Oy("Please correct: "),
                    Oy(e)
                ]));
            }, a))
        ])));
    }), _T = ak, HT = function(n) {
        n: for(;;)switch(n.$){
            case 2:
                return A2(uk, !0, n.a);
            case 3:
                if (1 === n.a.$) {
                    var e = n.a.a;
                    return A2(rk, b(_T, {
                        iw: ht("Hercules CI could not connect to GitLab")
                    }), m([
                        A2(Pw, m([
                            A2(Ly, "white-space", "pre-line")
                        ]), m([
                            Oy(e)
                        ]))
                    ]));
                }
                break n;
            default:
                break n;
        }
        return A2(Iy, g, g);
    }, FT = F2(function(n, e) {
        return A2(Iy, m([
            Cy("ui stacked segments")
        ]), m([
            gT(m([
                A2(bT, g, m([
                    Oy("Connect GitLab and Hercules CI")
                ])),
                A2(Iy, m([
                    Cy("ui padded basic segment")
                ]), A2(DT, n, e)),
                A2(Ww, g, m([
                    Oy("For this process, you need an Administrator account on the GitLab instance. By submitting the form, Hercules CI will:")
                ])),
                A2(lI, g, m([
                    A2(zk, g, m([
                        Oy("Log in to GitLab,")
                    ])),
                    A2(zk, g, m([
                        Oy("Create an instance-wide GitLab OAuth application for Hercules CI,")
                    ])),
                    A2(zk, g, m([
                        Oy("Configure itself to connect to the GitLab instance,")
                    ])),
                    A2(zk, g, m([
                        Oy("Forget the credentials you submitted.")
                    ]))
                ]))
            ])),
            A2(Iy, m([
                Cy("ui segment")
            ]), m([
                gT(m([
                    A2(qT, n, e),
                    HT(e.c4)
                ]))
            ])),
            A2(Iy, m([
                Cy("ui segment"),
                A2(Ly, "background-color", "#f0f0f0")
            ]), m([
                gT(m([
                    A2(bT, g, m([
                        A2(zy, m([
                            Cy("info circle icon primary")
                        ]), g),
                        Oy("Why do I need to enter my GitLab password?")
                    ])),
                    A2(Ww, g, m([
                        Oy("Many online services allow you to authenticate via other services securely, without sharing a password. This is achieved with a special authorization page and a communication protocol between such services called OAuth.")
                    ])),
                    A2(Ww, g, m([
                        Oy("However, your GitLab and your Hercules CI have not been configured to talk to each other yet.")
                    ])),
                    A2(Ww, g, m([
                        Oy("After this initial setup, GitLab will be able to authorize logins into Hercules CI using OAuth, and Hercules CI will not ask to share a password again.")
                    ]))
                ]))
            ]))
        ]));
    }), UT = F2(function(n, e) {
        return {
            u: A2(FT, n, e),
            e: "Install on GitLab"
        };
    }), VT = A2(Ww, g, m([
        A2(zy, m([
            Cy("ui huge grey icon circle notch loading")
        ]), g)
    ])), WT = F2(function(n, e) {
        return {
            u: A2(Iy, m([
                Cy("ui placeholder segment"),
                A2(Ly, "text-align", "center"),
                A2(Ly, "height", "70%")
            ]), m([
                A2(Ww, g, function() {
                    var n = function(n) {
                        var e = n.aU.ie;
                        return 3 === e.$ ? e.a.co : gt;
                    }(e);
                    if (n.$) return m([
                        Oy("Waiting for the changes to your account installation to be processed...")
                    ]);
                    var t = n.a;
                    return m([
                        Oy("Waiting for the changes to "),
                        A2(Dw, t, 30),
                        Oy(t.ax + " to be processed...")
                    ]);
                }()),
                function() {
                    var n = e.aU.ie;
                    switch(n.$){
                        case 2:
                            return 3 === n.a.$ && 404 === n.a.a ? VT : A2(uk, !0, n.a);
                        case 3:
                            return nm(n.a) ? VT : A2(Pw, g, g);
                        default:
                            return VT;
                    }
                }()
            ])),
            e: "Account update progress"
        };
    }), YT = F2(function(n, e) {
        var t = l(n, e);
        n: for(;;)if (1 === t.b) switch(t.a.$){
            case 13:
            case 15:
                return Vu({
                    co: (r = t.a.a).co,
                    eu: gt,
                    ab: r.ab,
                    br: r.br,
                    dA: r.dA
                });
            default:
                break n;
        }
        else switch(t.a.$){
            case 13:
                return Uu(r = t.a.a);
            case 15:
                var r;
                return Uu({
                    co: (r = t.a.a).co,
                    ab: r.ab,
                    br: r.br,
                    dA: r.dA
                });
            default:
                break n;
        }
        return n;
    }), MT = F3(function(n, e, t) {
        var r = function(e) {
            return Aw(A2(YT, n, e));
        }, a = function(n) {
            switch(n.$){
                case 13:
                    return ht(0);
                case 15:
                    return ht(1);
                default:
                    return gt;
            }
        }(n), i = function(n) {
            return m([
                Cy("item"),
                r(n),
                Uy(m([
                    l("active", u(a, ht(n)))
                ]))
            ]);
        };
        return A2(Ze, A2(Iy, m([
            Cy("ui big top attached tabular menu")
        ]), m([
            A2(Iy, m([
                Cy("right menu")
            ]), m([
                A2(Py, i(0), m([
                    Oy("Job")
                ])),
                A2(Py, i(1), m([
                    Oy("Compare")
                ]))
            ]))
        ])), e ? t : m([
            A2(Iy, m([
                Cy("ui bottom basic segment horizontally fitted")
            ]), t)
        ]));
    }), KT = Fn("br"), JT = function(n) {
        return Uk({
            co: ht(n.co),
            br: ht(n.br),
            dA: n.dA
        });
    }, QT = function(n) {
        switch(n){
            case 0:
            case 1:
                return "disabled";
            case 2:
                return "active";
            default:
                return "";
        }
    }, ZT = F4(function(n, e, t, r) {
        return A2(Iy, m([
            Cy("step"),
            Cy(n)
        ]), m([
            A2(zy, m([
                Cy(e)
            ]), g),
            A2(Iy, m([
                Cy("content")
            ]), m([
                A2(Iy, m([
                    Cy("title")
                ]), t),
                A2(Iy, m([
                    Cy("description")
                ]), r)
            ]))
        ]));
    }), XT = function(n) {
        if (n.fV) return A4(ZT, "disabled", "icon sun outline", m([
            Oy("Build")
        ]), m([
            Oy("cancelled")
        ]));
        var e = n.f$;
        switch(e){
            case 0:
            case 1:
                return A4(ZT, "disabled", "icon sun outline", m([
                    Oy("Build")
                ]), g);
            default:
                var t = e;
                switch(n.cL){
                    case 0:
                        return A4(ZT, QT(t), "icon sun outline loading", m([
                            Oy("Build")
                        ]), m([
                            Oy("building derivations")
                        ]));
                    case 1:
                        return A4(ZT, QT(t), "icon sun outline red", m([
                            Oy("Build")
                        ]), m([
                            Oy("build failed")
                        ]));
                    default:
                        return A4(ZT, QT(t), "icon sun outline green", m([
                            Oy("Build")
                        ]), m([
                            Oy("successful")
                        ]));
                }
        }
    }, nS = function(n) {
        switch(n){
            case 0:
            case 1:
            case 2:
                return "disabled";
            case 3:
                return "active";
            default:
                return "";
        }
    }, eS = m([
        Oy("Effects"),
        A2(Iy, m([
            Cy("floating ui small yellow label")
        ]), m([
            Oy("BETA")
        ]))
    ]), tS = F2(function(n, e) {
        if (e.fV) return A4(ZT, "disabled", "icon rocket", eS, m([
            Oy("cancelled")
        ]));
        var t = e.f$;
        switch(t){
            case 0:
            case 1:
                return A4(ZT, "disabled", "icon rocket", eS, g);
            case 2:
                return A4(ZT, "disabled", "icon rocket", eS, m([
                    Oy("awaiting build")
                ]));
            default:
                var r = t;
                switch(e.e7){
                    case 0:
                        return 3 === r ? A4(ZT, nS(r), "icon rocket blue", eS, m([
                            Oy("running effects")
                        ])) : A4(ZT, nS(r), "icon rocket grey", eS, m([
                            Oy("none")
                        ]));
                    case 1:
                        return A4(ZT, nS(r), "icon rocket red", eS, m([
                            Oy("failed")
                        ]));
                    default:
                        var a = n.as.ie;
                        return 3 === a.$ && jt(A2(Uf, function(n) {
                            return 4 === n.W;
                        }, a.a.c.ct)) > 0 ? A4(ZT, nS(r), "icon rocket green", eS, m([
                            Oy("successful")
                        ])) : A4(ZT, nS(r), "icon rocket grey", eS, m([
                            Oy("none")
                        ]));
                }
        }
    }), rS = function(n) {
        switch(n){
            case 0:
                return "disabled";
            case 1:
                return "active";
            default:
                return "";
        }
    }, aS = function(n) {
        if (n.fV) return A4(ZT, "disabled", "icon snowflake", m([
            Oy("Evaluation")
        ]), m([
            Oy("cancelled")
        ]));
        var e = n.f$;
        if (!e) return A4(ZT, "disabled", "icon snowflake", m([
            Oy("Evaluation")
        ]), m([
            Oy("needs agent")
        ]));
        var t = e;
        switch(n.fj){
            case 0:
                return A4(ZT, rS(t), "icon snowflake blue loading", m([
                    Oy("Evaluation")
                ]), m([
                    Oy("evaluating expressions")
                ]));
            case 1:
                return A4(ZT, rS(t), "icon snowflake red", m([
                    Oy("Evaluation")
                ]), m([
                    Oy("error in expressions")
                ]));
            default:
                return A4(ZT, rS(t), "icon snowflake green", m([
                    Oy("Evaluation")
                ]), m([
                    Oy("successful")
                ]));
        }
    }, iS = F3(function(n, e, t) {
        return A2(Iy, m([
            Cy("ui steps")
        ]), m([
            aS(t),
            XT(t),
            A2(tS, e, t)
        ]));
    }), uS = F2(function(n, e) {
        var t = e.as.ie;
        switch(t.$){
            case 2:
                return A2(Mw, g, m([
                    Oy(IA(t.a))
                ]));
            case 3:
                var r = t.a, a = r.b, i = r.c, u = A2(Ck, g, m([
                    A2(jk, m([
                        Cy("ui three wide")
                    ]), m([
                        Oy("Source")
                    ])),
                    A2(xk, m([
                        Lk(2)
                    ]), m([
                        kC(a),
                        A2(Pw, m([
                            A2(Ly, "margin-right", "1em")
                        ]), g),
                        A2(NC, 0, a)
                    ]))
                ])), c = A2(Ck, g, m([
                    A2(jk, m([
                        Cy("ui three wide")
                    ]), m([
                        Oy("Git rev")
                    ])),
                    A2(xk, m([
                        Lk(2)
                    ]), m([
                        A2(Ek, g, m([
                            Oy(a.dD.g6)
                        ]))
                    ]))
                ])), o = function() {
                    var n = a.g2;
                    if (1 === n.$) return g;
                    var t = n.a, r = e.ch;
                    return m([
                        A2(Ck, g, m([
                            A2(jk, g, m([
                                Oy("Rerun of job")
                            ])),
                            A2(xk, m([
                                Lk(2)
                            ]), m([
                                A2(JT, r, b(r, {
                                    ab: t
                                }))
                            ]))
                        ]))
                    ]);
                }(), s = function() {
                    switch(a.f1){
                        case 1:
                            return g;
                        case 0:
                            return m([
                                A2(Ck, g, m([
                                    A2(jk, g, m([
                                        Oy("Job type")
                                    ])),
                                    A2(xk, m([
                                        Lk(2)
                                    ]), m([
                                        Oy("Config")
                                    ]))
                                ]))
                            ]);
                        case 2:
                            return m([
                                A2(Ck, g, m([
                                    A2(jk, g, m([
                                        Oy("Event handler")
                                    ])),
                                    A2(xk, m([
                                        Lk(2)
                                    ]), m([
                                        A2(Ek, g, m([
                                            Oy("onPush."),
                                            Oy(A2(ca, "", a.f_))
                                        ]))
                                    ]))
                                ]))
                            ]);
                        default:
                            return m([
                                A2(Ck, g, m([
                                    A2(jk, g, m([
                                        Oy("Event handler")
                                    ])),
                                    A2(xk, m([
                                        Lk(2)
                                    ]), m([
                                        A2(Ek, g, m([
                                            Oy("onSchedule."),
                                            Oy(A2(ca, "", a.f_))
                                        ]))
                                    ]))
                                ]))
                            ]);
                    }
                }(), f = function(n) {
                    return A2(Ek, g, function() {
                        var e = n.fy;
                        if (1 === e.$) return g;
                        var t, r, a = e.a;
                        return h(1 === (t = a.gZ).$ ? g : m([
                            Oy(t.a.n),
                            Oy(" / ")
                        ]), m([
                            Oy(a.du),
                            Oy(" @ "),
                            (function() {
                                var n = a.fI;
                                if (1 === n.$) return Oy;
                                var e = n.a;
                                return function(n) {
                                    return A2(BC, e, m([
                                        Oy(n)
                                    ]));
                                };
                            })()((r = A2(ay, 7, sc(a.g5)), $(r).join("")))
                        ]));
                    }());
                }, l = A2(Tt, F2(function(n, e) {
                    var t = e.a, r = e.b;
                    return A2(Ck, g, m([
                        A2(jk, g, n ? g : m([
                            Oy("Extra inputs")
                        ])),
                        A2(xk, m([
                            Cy("ui two wide")
                        ]), m([
                            A2(Bk, g, m([
                                A2(Ek, g, m([
                                    Oy(t)
                                ]))
                            ]))
                        ])),
                        A2(xk, g, m([
                            f(r)
                        ]))
                    ]));
                }), tt(a.fn)), d = function() {
                    var n = i.a_;
                    if ("" === n) return g;
                    var e = n;
                    return m([
                        A2(Ck, g, m([
                            A2(jk, g, m([
                                Oy("Evaluating agent")
                            ])),
                            A2(xk, m([
                                Lk(2)
                            ]), m([
                                A2(Ek, g, m([
                                    Oy(e)
                                ]))
                            ]))
                        ]))
                    ]);
                }();
                return A2(Iy, g, m([
                    A3(iS, n, e, a),
                    A2(Iy, m([
                        Cy("ui segment"),
                        A2(Ly, "box-shadow", "none")
                    ]), m([
                        A2(wk, m([
                            Cy("ui very basic table")
                        ]), m([
                            A2(kk, g, A2(Ze, u, A2(Ze, c, h(s, h(l, h(o, h(m([
                                A2(Ck, g, m([
                                    A2(jk, g, m([
                                        Oy("Duration (incl. queue)")
                                    ])),
                                    A2(xk, m([
                                        Lk(2)
                                    ]), m([
                                        LC(a)
                                    ]))
                                ])),
                                A2(Ck, g, m([
                                    A2(jk, g, m([
                                        Oy("Created")
                                    ])),
                                    A2(xk, m([
                                        Lk(2)
                                    ]), m([
                                        A2(XC, a, n)
                                    ]))
                                ]))
                            ]), d)))))))
                        ]))
                    ]))
                ]));
            case 1:
                return A2(Mw, g, m([
                    A2(zy, m([
                        Cy("ui icon circle notch loading")
                    ]), g)
                ]));
            default:
                return A2(Mw, g, g);
        }
    }), cS = F2(function(n, e) {
        var t = e.gB;
        if (1 === t.$) return Oy("");
        var r = t.a;
        return 1 === r.ew ? A2(MC, ak, m([
            Oy("Your free trial expires in " + $t(A2(WC, n.eS, r)) + " days. "),
            A2(Py, m([
                Sj(e)
            ]), m([
                Oy("Subscribe")
            ])),
            Oy(".")
        ])) : Oy("");
    }), oS = F2(function(n, e) {
        return A3(Fo, pa, e, n);
    }), sS = function(n) {
        return {
            $: 0,
            a: n
        };
    }, fS = function(n) {
        return {
            $: 7,
            a: n
        };
    }, lS = function(n) {
        return {
            $: 6,
            a: n
        };
    }, dS = F2(function(n, e) {
        return !A2(Xi, n, e).$;
    }), bS = F2(function(n, e) {
        return A2(dS, n, e);
    }), hS = F2(function(n, e) {
        var t = A2(bS, e.bp, n.aa) ? l("down", fS(e)) : l("right", lS(e)), r = t.a, a = t.b;
        return A2(vx, m([
            Cy("ui basic button"),
            ww(a)
        ]), m([
            A2(zy, m([
                Cy("ui icon black chevron " + r),
                A2(Ly, "margin", "0 3px 0 0")
            ]), g),
            Oy("Cause")
        ]));
    }), gS = F2(function(n, e) {
        var t = A2(bS, e.bp, n.aa) ? l("down", fS(e)) : l("right", lS(e)), r = t.a, a = t.b;
        return A2(vx, m([
            Cy("ui basic button"),
            ww(a)
        ]), m([
            A2(zy, m([
                Cy("ui icon black chevron " + r),
                A2(Ly, "margin", "0 3px 0 0")
            ]), g),
            Oy("Show trace")
        ]));
    }), vS = Fn("em"), pS = function(n) {
        return A2(Ck, g, m([
            A2(xk, m([
                Cy("center aligned")
            ]), m([
                n.V
            ])),
            A2(xk, g, m([
                n.a2
            ])),
            A2(xk, n.ec, m([
                n.bB
            ])),
            A2(xk, m([
                Cy("right aligned"),
                A2(Ly, "vertical-align", "top")
            ]), m([
                n.cq
            ]))
        ]));
    }, mS = F2(function(n, e) {
        switch(n){
            case 0:
                return dk(e);
            case 1:
                return function(n) {
                    var e = 5 === n ? "Build succeeded but was expected to fail. If build success is desirable, remove the mustFail attribute to avoid regressions." : lk(n);
                    switch(n){
                        case 0:
                        case 1:
                        case 2:
                        case 4:
                        default:
                            return dk(n);
                        case 5:
                            return A2(Iy, m([
                                A2(Ly, "width", "6em")
                            ]), m([
                                A2(ok, "check red circle", e),
                                A2(ok, "red times", e)
                            ]));
                        case 3:
                            return A2(ok, "times green circle", e);
                    }
                }(e);
            case 2:
                return function(n) {
                    switch(n){
                        case 0:
                        case 1:
                        case 2:
                        case 4:
                        default:
                            return dk(n);
                        case 5:
                            return A2(Iy, m([
                                A2(Ly, "width", "6em")
                            ]), m([
                                A2(ok, "check yellow circle", "Successful but ignored"),
                                A2(ok, "yellow exclamation triangle", "This attribute does not contribute towards regression avoidance.")
                            ]));
                        case 3:
                            return A2(ok, "times yellow circle", "Failed but ignored");
                    }
                }(e);
            default:
                return function(n) {
                    switch(n){
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        default:
                            return dk(n);
                        case 5:
                            return A2(ok, "check green circle outline", "Dependencies successful. The derivation itself is not meant to be built.");
                    }
                }(e);
        }
    }), $S = F2(function(n, e) {
        var t = function(n) {
            switch(n.dS){
                case 4:
                    return Wu({
                        co: n.co,
                        a2: n.er,
                        ab: n.ab,
                        br: n.br,
                        dA: n.dA,
                        d9: 1
                    });
                case 3:
                    return Bu({
                        co: n.co,
                        eY: !0,
                        a8: n.a7.a8,
                        dA: n.dA,
                        d9: 0,
                        dQ: n.dQ
                    });
                default:
                    return Bu({
                        co: n.co,
                        eY: !1,
                        a8: n.a7.a8,
                        dA: n.dA,
                        d9: Ik(n.a7.V),
                        dQ: n.dQ
                    });
            }
        }(n);
        return pS({
            cq: e,
            a2: n.a2,
            V: A2(mS, n.dS, n.a7.V),
            bB: 4 === n.dS ? Oy("Effect specification") : A2(Py, m([
                Aw(t)
            ]), m([
                MI(n.a7.a8)
            ])),
            ec: m([
                ww(n.iW(t)),
                A2(Ly, "cursor", "pointer")
            ])
        });
    }), yS = F2(function(n, e) {
        return A2(tl, function(n) {
            return u(ht(n.a7.a8), e.fa);
        }, n.fg);
    }), wS = A2(zy, m([
        Cy("icon large rotated clockwise level up alt"),
        A2(Ly, "display", "block")
    ]), g), kS = F2(function(n, e) {
        var t = Wu({
            co: n.H,
            a2: e.bp,
            ab: n.au,
            br: n.br,
            dA: n.dB,
            d9: 1
        });
        return A2(Py, m([
            Aw(t),
            Cy("ui icon button basic"),
            ww(sS(t))
        ]), m([
            A2(zy, m([
                Cy("icon info blue")
            ]), g)
        ]));
    }), xS = F2(function(n, e) {
        var t;
        return Bu({
            co: n.H,
            eY: !0,
            a8: e,
            dA: n.dB,
            d9: 0,
            dQ: (t = n.as.ie, 3 === t.$ ? ht(t.a.b.c) : gt)
        });
    }), jS = F2(function(n, e) {
        var t = A2(xS, n, e.a8);
        return A2(Py, m([
            Aw(t),
            Cy("ui icon button basic"),
            ww(sS(t))
        ]), m([
            A2(zy, m([
                Cy("icon info blue")
            ]), g)
        ]));
    }), AS = F3(function(n, e, t) {
        var r;
        return Bu({
            co: n.H,
            eY: !1,
            a8: e,
            dA: n.dB,
            d9: Ik(t),
            dQ: (r = n.as.ie, 3 === r.$ ? ht(r.a.b.c) : gt)
        });
    }), CS = F2(function(n, e) {
        var t = A3(AS, n, e.a8, e.V);
        return A2(Py, m([
            Aw(t),
            Cy("ui icon button basic"),
            ww(sS(t))
        ]), m([
            A2(zy, m([
                Cy("icon info blue")
            ]), g)
        ]));
    }), IS = F2(function(n, e) {
        return A2(ca, A2(Pw, g, g), A2(Fi, e, n.a5));
    }), TS = F3(function(n, e, t) {
        return A2(IS, e, function(e) {
            var r;
            return A2(vx, h(m([
                Cy("ui button primary"),
                ww((r = {
                    bE: e.c,
                    a8: t.a8
                }, {
                    $: 8,
                    a: r
                }))
            ]), h(A2(gI, n, Cy("icon")), A2(gI, n, ck("Rebuild")))), A2(Ze, A2(zy, A2(Ze, Cy("icon redo alternative"), A2(gI, !n, Cy("ui"))), g), A2(gI, !n, Oy("Rebuild"))));
        });
    }), SS = F3(function(n, e, t) {
        switch(t.V){
            case 0:
            case 1:
            case 2:
            case 5:
                return g;
            default:
                return m([
                    A3(TS, n, e, t)
                ]);
        }
    }), DS = F3(function(n, e, t) {
        switch(e.W){
            case 4:
                return m([
                    A2(kS, n, e)
                ]);
            case 3:
                return m([
                    A2(jS, n, t)
                ]);
            default:
                switch(t.V){
                    case 0:
                    case 1:
                    case 2:
                    case 5:
                    case 3:
                    case 6:
                        return h(A3(SS, !1, n, t), m([
                            A2(CS, n, t)
                        ]));
                    default:
                        return A2(Ze, A2(hS, n, e), h(A3(SS, !0, n, t), m([
                            A2(CS, n, t)
                        ])));
                }
        }
    }), NS = function(n) {
        return n.b ? Oy(Tl(n)) : A2(zy, g, m([
            Oy("expression root")
        ]));
    }, ES = function(n) {
        var e = n.bB.gx;
        return 1 === e.$ ? A2(ok, "attention red circle", "Evaluation failed") : A2(mS, n.W, e.a.V);
    }, LS = Iy(m([
        Cy("ui buttons small")
    ])), BS = A2(Ck, g, m([
        A2(xk, m([
            Lk(4)
        ]), m([
            Oy("No dependencies are in a failed state now. Use [Rebuild] or [Re-run effects and failures] to resume the job.")
        ]))
    ])), OS = F2(function(n, e) {
        var t = F2(function(e, t) {
            var r = t.a, a = t.b;
            return n(e) ? l(A2(Ze, e, r), a) : l(r, A2(Ze, e, a));
        });
        return A3(Er, t, l(g, g), e);
    }), PS = F4(function(n, e, t, r) {
        var a = function() {
            var r = n.aH.ie;
            switch(r.$){
                case 2:
                    return m([
                        Oy("Failure loading derivations. Try again?")
                    ]);
                case 0:
                    return m([
                        Oy("Failed derivations weren't asked for yet")
                    ]);
                case 1:
                    return m([
                        A2(Iy, m([
                            Cy("ui loader active text inline centered")
                        ]), m([
                            Oy("Loading derivations")
                        ]))
                    ]);
                default:
                    var a = r.a, i = function(n) {
                        var e = A2(Xi, n, a);
                        if (1 === e.$) return g;
                        var t = e.a, r = t.a, u = A2(OS, function(n) {
                            return 3 === n.a.V;
                        }, A2(fu, function(n) {
                            return A2(Xi, n, a);
                        }, t.b)), c = u.a, o = u.b;
                        return 3 === r.V ? m([
                            l(r, g)
                        ]) : h(c, A2(wc, function(n) {
                            return i(n.a.a8);
                        }, o));
                    };
                    return A2(Lr, function(t) {
                        var r = t.a;
                        return A2($S, {
                            co: n.H,
                            a2: wS,
                            er: g,
                            dS: 0,
                            a7: r,
                            ab: n.au,
                            iW: sS,
                            br: n.br,
                            dA: n.dB,
                            dQ: A2(Fi, function(n) {
                                return n.c;
                            }, Mm(n))
                        }, LS(A3(DS, n, e, r)));
                    }, i(t.a8));
            }
        }();
        return A2(bS, e.bp, n.aa) ? UA(a) ? m([
            r
        ]) : a : g;
    }), GS = F3(function(n, e, t) {
        var r = function(n) {
            var e = n.a, r = n.b;
            return A2(Ze, pS({
                cq: n.c,
                a2: NS(t.bp),
                V: ES(t),
                bB: e,
                ec: g
            }), r);
        }, a = l(t.bB.e9, t.bB.gx);
        if (a.a.$) {
            if (a.b.$) return g;
            var i = a.b.a;
            return A2(Ze, A2($S, {
                co: n.H,
                a2: NS(t.bp),
                er: t.bp,
                dS: t.W,
                a7: i,
                ab: n.au,
                iW: sS,
                br: n.br,
                dA: n.dB,
                dQ: A2(Fi, function(n) {
                    return n.c;
                }, Mm(n))
            }, LS(A3(DS, n, t, i))), A4(PS, n, t, i, BS));
        }
        var u = a.a.a, c = function(n) {
            return gv(n.fi);
        }(e), o = F2(function(e, r) {
            return A2(Ek, m([
                A2(Ly, "white-space", "pre-wrap")
            ]), A2(Ze, A2(zy, m([
                Cy("attention red icon")
            ]), g), h(A2(Zx, wx, e).eI, h(function(n) {
                return c && A2(hr, "nix::ExecError", n) && A2(hr, "failed with exit code", n) ? m([
                    A2(KT, g, g),
                    A2(zy, m([
                        Cy("info circle icon")
                    ]), g),
                    Oy("Diagnostic output from the failed program is captured in the "),
                    Oy("evaluation log below"),
                    Oy(".")
                ]) : g;
            }(e), function() {
                if (r.$) return g;
                var e = r.a;
                return A2(bS, t.bp, n.aa) && "" !== e ? A2(Ze, A2(Iy, g, m([
                    A2(vS, g, m([
                        Oy("\nEvaluation trace:\n")
                    ]))
                ])), A2(Zx, wx, e).eI) : g;
            }()))));
        }), s = u.fd;
        if (s.$ || "BuildException" !== s.a) return (!u.hx.$ && A2(bS, t.bp, n.aa) ? function(n) {
            var e, r = n.a, a = n.b;
            return A2(Ze, (e = {
                cq: n.c,
                a2: NS(t.bp),
                V: ES(t),
                bB: r,
                ec: g
            }, A2(Ck, g, m([
                A2(xk, m([
                    Cy("center aligned")
                ]), m([
                    e.V
                ])),
                A2(xk, m([
                    Lk(2)
                ]), m([
                    A2(Iy, m([
                        Cy("ui basic horizontally fitted segment")
                    ]), m([
                        e.a2
                    ])),
                    A2(Iy, m([
                        Cy("ui basic horizontally fitted segment")
                    ]), m([
                        e.bB
                    ]))
                ])),
                A2(xk, m([
                    Cy("right aligned"),
                    A2(Ly, "vertical-align", "top")
                ]), m([
                    e.cq
                ]))
            ]))), a);
        } : r)(d(A2(o, u.fb, u.hx), g, (b = u.hx).$ || "" === b.a ? A2(Pw, g, g) : A2(gS, n, t)));
        var f = A2(yS, e, u);
        if (f.$) return r(d(A2(o, "Build failure reported without derivation path.", gt), g, A2(Pw, g, g)));
        var b, v = f.a, p = {
            co: n.H,
            a2: wS,
            er: g,
            dS: 0,
            a7: v.a7,
            ab: n.au,
            iW: sS,
            br: n.br,
            dA: n.dB,
            dQ: A2(Fi, function(n) {
                return n.c;
            }, Mm(n))
        }, $ = A2($S, p, LS(A3(DS, n, t, v.a7)));
        return r(d(A2(o, "Evaluation-time build failure. Message: " + u.fb, u.hx), A4(PS, n, t, v.a7, $), A2(hS, n, t)));
    }), RS = A2(yk, g, m([
        Oy("Attributes")
    ])), zS = {
        $: 13
    }, qS = sk(g), _S = F2(function(n, e) {
        return A2(gI, u(A2(Fi, function(n) {
            return n.bk;
        }, Mm(n)), ht(!0)), A2(jj, {
            ct: m([
                Cy("fluid yellow")
            ]),
            eM: zS,
            eN: e
        }, m([
            qS(g),
            Oy("Cancel")
        ])));
    }), HS = A2(cc, tt, Lr(function(n) {
        return {
            a8: n.a,
            V: n.b
        };
    })), FS = F3(function(n, e, t) {
        return A2(Py, m([
            Aw(A3(AS, n, e, t))
        ]), m([
            Oy(e)
        ]));
    }), US = F2(function(n, e) {
        var t = A2(Lr, function(e) {
            return A2(Ck, g, m([
                A2(xk, m([
                    Cy("center aligned")
                ]), m([
                    dk(e.V)
                ])),
                A2(xk, g, m([
                    A3(FS, n, e.a8, e.V)
                ])),
                A2(xk, m([
                    Cy("center aligned")
                ]), m([
                    LS(h(A3(SS, !1, n, e), m([
                        A2(CS, n, e)
                    ])))
                ]))
            ]));
        }, e);
        return m([
            A2(wk, m([
                Cy("ui unstackable table")
            ]), m([
                A2(Ak, g, m([
                    A2(Ck, m([
                        Cy("center aligned")
                    ]), m([
                        A2(jk, m([
                            Cy("one wide")
                        ]), m([
                            Oy("Status")
                        ])),
                        A2(jk, m([
                            Cy("eleven wide")
                        ]), m([
                            Oy("Derivation")
                        ])),
                        A2(jk, m([
                            Cy("three wide")
                        ]), m([
                            Oy("Actions")
                        ]))
                    ]))
                ])),
                A2(kk, g, t)
            ]))
        ]);
    }), VS = F2(function(n, e) {
        var t = F2(function(n, e) {
            return n ? e : g;
        }), r = e.e3, a = e.e2, i = function(n) {
            switch(n.V){
                case 0:
                case 1:
                case 3:
                case 4:
                case 5:
                default:
                    return !1;
                case 2:
                    return !0;
            }
        }, u = function(n) {
            switch(n.V){
                case 0:
                case 1:
                case 2:
                case 4:
                case 5:
                default:
                    return !1;
                case 3:
                    return !0;
            }
        }, c = HS(e.eZ), o = A2(Uf, i, c), s = A2(Uf, u, c);
        return h(A2(t, r > 0 || !UA(o), A2(Ze, A2(yk, g, m([
            Oy("Build progress")
        ])), h(A2(t, !UA(e.hz), m([
            A2(Iy, m([
                Cy("ui icon warning message")
            ]), m([
                A2(zy, m([
                    Cy("notched exclamation icon")
                ]), g),
                A2(Iy, m([
                    Cy("content")
                ]), m([
                    A2(Iy, m([
                        Cy("header")
                    ]), m([
                        Oy("No agent available for some derivations")
                    ])),
                    A2(qk, g, A2(Lr, function(n) {
                        return A2(zk, g, function(n) {
                            var e = n.bs;
                            if (e.b) {
                                var t = e.a, r = e.b;
                                return h(m([
                                    Oy("No agent for platform "),
                                    A2(Ek, g, m([
                                        Oy(n.bq)
                                    ])),
                                    Oy(" and system features ")
                                ]), A2(Ze, A2(Ek, g, m([
                                    Oy(t)
                                ])), A2(wc, function(n) {
                                    return m([
                                        Oy(", "),
                                        A2(Ek, g, m([
                                            Oy(n)
                                        ]))
                                    ]);
                                }, r)));
                            }
                            return m([
                                Oy("No agent for platform "),
                                A2(Ek, g, m([
                                    Oy(n.bq)
                                ]))
                            ]);
                        }(n));
                    }, e.hz)),
                    A2(Ww, g, m([
                        Oy("Please make sure your agent configurations are correct, deployed and started. Alternatively, you may cancel this job to save computation.")
                    ]))
                ]))
            ]))
        ])), h(A2(t, r > 0, m([
            A2(Ww, g, m([
                Oy($t(r) + " derivations waiting for dependency or agent to become available.")
            ]))
        ])), UA(o) ? m([
            A2(Ww, g, m([
                Oy("Not currently building any derivations for this job.")
            ]))
        ]) : A2(US, n, o))))), A2(t, !UA(s) || a > 0, A2(Ze, A2(yk, g, m([
            Oy("Build failures")
        ])), h(A2(t, !UA(s), A2(US, n, s)), A2(t, a > 0, m([
            A2(Ww, g, m([
                Oy($t(a) + " derivations were not built due to failed dependencies")
            ]))
        ]))))));
    }), WS = function(n) {
        return {
            $: 17,
            a: n
        };
    }, YS = function(n) {
        return {
            $: 21,
            a: n
        };
    }, MS = function(n) {
        return {
            $: 18,
            a: n
        };
    }, KS = F4(function(n, e, t, r) {
        return A7(yu, "GET", "/api/v1/jobs/{jobId}/evaluation/log/raw", m([
            l("jobId", n)
        ]), m([
            l("logId", ht(e)),
            l("iMin", A2(Fi, $t, t)),
            l("verbosity", A2(Fi, Xm, r))
        ]), g, gt, Zr);
    }), JS = F4(function(n, e, t, r) {
        var a = r.fi;
        if (a.$) return g;
        var i = a.a, u = 0 !== t.fj;
        return A2(Ze, A2(yk, g, m([
            Oy("Evaluation Log")
        ])), A2(pj, n, {
            ik: function(n) {
                return A4(KS, t.c, i, gt, ht(n));
            },
            iG: e.aF,
            iT: A2(kf, function(n) {
                return b(n, {
                    e5: n.e5 || u
                });
            }, e.ak),
            i4: YS,
            i6: MS,
            jc: WS,
            jg: e.b$,
            aT: e.b0,
            jO: ht(e.aG),
            jR: "evaluation_log"
        }));
    }), QS = function(n) {
        return n.W ? A2(Iy, m([
            Cy("ui warning message")
        ]), m([
            A2(Ww, g, m([
                A2(zy, m([
                    Cy("attention icon")
                ]), g),
                Oy(n.bl)
            ]))
        ])) : A2(Iy, m([
            Cy("ui error message")
        ]), m([
            A2(Ww, g, m([
                A2(zy, m([
                    Cy("attention red circle icon")
                ]), g),
                Oy(n.bl)
            ]))
        ]));
    }, ZS = F2(function(n, e) {
        return A2(zy, m([
            Cy("ui icon big " + n),
            ck(e)
        ]), g);
    }), XS = F3(function(n, e, t) {
        return m([
            pS({
                cq: LS(m([
                    A2(CS, n, t.bB)
                ])),
                a2: NS(t.bp),
                V: function() {
                    if (e.fV) return fk(m([
                        Cy("big"),
                        ck("Evaluation cancelled")
                    ]));
                    switch(t.bB.V){
                        case 2:
                            return A2(ZS, "sun outline loading", "Building");
                        case 1:
                            return A2(ZS, "spinner loading", "Waiting");
                        case 0:
                            return A2(ZS, "", "Not planned");
                        default:
                            return A2(Pw, g, g);
                    }
                }(),
                bB: A2(zy, g, m([
                    Oy("import from derivation")
                ])),
                ec: g
            })
        ]);
    }), nD = function(n) {
        return A2(Uf, function() {
            switch(n.a7.V){
                case 0:
                case 1:
                case 2:
                    return !0;
                default:
                    return !1;
            }
        }, m([
            pS({
                cq: A2(Pw, g, g),
                a2: A2(zy, g, m([
                    Oy("import from derivation")
                ])),
                V: dk(n.a7.V),
                bB: Oy(n.a7.a8),
                ec: g
            })
        ]));
    }, eD = A2(Zc, A2(Mk, 2, "0"), $t), tD = function(n) {
        return A2(yt, ", ", A2(Lr, function(e) {
            return eD(e) + ":" + eD(n.gj);
        }, n.fL)) + " UTC " + function(n) {
            var e = function(n) {
                switch(n){
                    case 0:
                        return "Monday";
                    case 1:
                        return "Tuesday";
                    case 2:
                        return "Wednesday";
                    case 3:
                        return "Thursday";
                    case 4:
                        return "Friday";
                    case 5:
                        return "Saturday";
                    default:
                        return "Sunday";
                }
            }, t = function(n) {
                return A2(yt, ", ", A2(Lr, e, n));
            }, r = function(n) {
                return A2(yt, ", ", A2(Lr, $t, n));
            }, a = l(n.eV, n.eU);
            if (1 === a.a.$) return 1 === a.b.$ ? "every day" : "on each " + r(a.b.a) + " of the month";
            if (a.b.$) return "on each " + t(i = a.a.a);
            if (a.a.a.b && !a.a.a.b.b && a.b.a.b && 1 === a.b.a.a && a.b.a.b.b && 2 === a.b.a.b.a && a.b.a.b.b.b && 3 === a.b.a.b.b.a && a.b.a.b.b.b.b && 4 === a.b.a.b.b.b.a && a.b.a.b.b.b.b.b && 5 === a.b.a.b.b.b.b.a && a.b.a.b.b.b.b.b.b && 6 === a.b.a.b.b.b.b.b.a && a.b.a.b.b.b.b.b.b.b && 7 === a.b.a.b.b.b.b.b.b.a && !a.b.a.b.b.b.b.b.b.b.b) return "on the first " + e(a.a.a.a) + " of the month";
            var i = a.a.a;
            return "on each " + r(a.b.a) + " of the month that is also a " + t(i);
        }(n);
    }, rD = function(n) {
        var e = n.N, t = n.n, r = n.dT, a = n.dY;
        return A2(Iy, m([
            Cy("ui segment")
        ]), m([
            A2(Iy, m([
                Cy("ui stackable sixteen column grid")
            ]), A2(Ze, A2(Iy, m([
                Cy("row")
            ]), m([
                A2(Iy, m([
                    Cy("three wide column"),
                    A2(Ly, "height", "5ex"),
                    A2(Ly, "vertical-align", "middle")
                ]), m([
                    A2(Ww, g, e)
                ])),
                A2(Iy, m([
                    Cy("five wide column")
                ]), m([
                    A2(Ww, m([
                        Cy("ui large text")
                    ]), m([
                        A2(Ek, g, t)
                    ]))
                ])),
                A2(Iy, m([
                    Cy("eight wide column")
                ]), m([
                    A2(Ww, g, r)
                ]))
            ])), A2(Lr, Iy(m([
                Cy("row")
            ])), a)))
        ]));
    }, aD = F2(function(n, e) {
        return n ? e : g;
    }), iD = F3(function(n, e, t) {
        var r;
        return A2(aD, u(A2(Fi, function(n) {
            return n.gd;
        }, Mm(n)), ht(!0)), m([
            A2(jj, {
                ct: m([
                    Cy("primary")
                ]),
                eM: (r = e, {
                    $: 15,
                    a: r
                }),
                eN: t
            }, m([
                A2(zy, m([
                    Cy("ui icon play small")
                ]), g),
                Oy("Run this")
            ])),
            A2(zy, m([
                Cy("ui icon grey info circle"),
                ck("This will run the job on the current commit, so that you can test it without merging it into the default branch.\nIt does not run with extra privileges that may have been granted to jobs on the default branch.\nThe branch metadata passed to the Nix expression is accurate, but many effects may ignore this contextual information and run the same regardless of the branch.")
            ]), g)
        ]));
    }), uD = F3(function(n, e, t) {
        var r = A2(wc, function(e) {
            var r = e.a, a = e.b;
            return m([
                rD({
                    dT: A3(iD, n, r, t),
                    dY: m([
                        m([
                            A2(Iy, m([
                                Cy("ui basic segment")
                            ]), m(a.gb ? [
                                A2(Ww, g, m([
                                    Oy("Runs at " + tD(a.hP))
                                ]))
                            ] : [
                                A2(Ww, g, m([
                                    Oy("This is a new scheduled job. To enable it, merge it into the default branch.")
                                ])),
                                A2(Ww, g, m([
                                    Oy("When merged, will run at " + tD(a.hP))
                                ]))
                            ]))
                        ])
                    ]),
                    N: m([
                        A2(Pw, m([
                            Cy("ui ribbon label purple"),
                            ck("herculesCI.onSchedule." + r),
                            A2(Ly, "white-space", "nowrap")
                        ]), m([
                            eI,
                            Oy(" onSchedule")
                        ]))
                    ]),
                    n: m([
                        Oy(r)
                    ])
                })
            ]);
        }, tt(e.gz)), a = A2(wc, function(n) {
            var e = n.a;
            return m([
                rD({
                    dT: g,
                    dY: g,
                    N: m([
                        A2(Pw, m([
                            Cy("ui ribbon label blue"),
                            ck("herculesCI.onPush." + e),
                            A2(Ly, "white-space", "nowrap")
                        ]), m([
                            nI,
                            Oy(" onPush")
                        ]))
                    ]),
                    n: m([
                        Oy(e)
                    ])
                })
            ]);
        }, tt(e.gy));
        return A2(Ze, A2(yk, g, m([
            Oy("Declared Jobs")
        ])), h(a, r));
    }), cD = F3(function(n, e, t) {
        var r = e.at;
        switch(r.$){
            case 3:
                var a = r.a;
                return function(n) {
                    return uy(n.gy) && uy(n.gz);
                }(a) && function(n) {
                    var e = n.as.ie;
                    return 3 === e.$ && !!e.a.b.fj;
                }(e) ? m([
                    A2(Iy, m([
                        Cy("ui info message")
                    ]), m([
                        A2(Iy, m([
                            Cy("header")
                        ]), m([
                            Oy("Empty configuration")
                        ])),
                        A2(Ww, g, m([
                            Oy("The repository does not declare any onPush or onSchedule jobs. Nothing will be done.")
                        ]))
                    ]))
                ]) : A3(uD, e, a, t);
            case 2:
                var i = r.a;
                return m([
                    A2(uk, Jw(n), i)
                ]);
            case 0:
                return g;
            default:
                return m([
                    A2(Iy, m([
                        Cy("ui placeholder")
                    ]), m([
                        A2(Iy, m([
                            Cy("line")
                        ]), g)
                    ]))
                ]);
        }
    }), oD = pS({
        cq: A2(Pw, g, g),
        a2: A2(Pw, g, g),
        V: A2(zy, m([
            Cy("ui icon big spinner loading"),
            ck("Evaluating")
        ]), g),
        bB: A2(Pw, g, g),
        ec: g
    }), sD = F2(function(n, e) {
        return A2(cl, n, {
            co: e.H,
            dA: e.dB
        }).$ ? Oy("You don't have permission to view or create agents. Contact your organization administrator if more agents are needed.") : A2(Py, m([
            Aw(zu({
                co: e.H,
                dA: e.dB
            }))
        ]), m([
            Oy("View or create agents")
        ]));
    }), fD = F2(function(n, e) {
        var t = e.as.ie;
        return 3 === t.$ ? t.a.b.f$ ? g : m([
            A2(Iy, m([
                Cy("ui positive message")
            ]), m([
                A2(Iy, m([
                    Cy("header")
                ]), m([
                    Oy("Job is queued")
                ])),
                Oy("This job is queued and will be evaluated when either"),
                A2(qk, g, m([
                    A2(zk, g, m([
                        Oy("an x86_64-linux agent is added,")
                    ])),
                    A2(zk, g, m([
                        Oy("or an existing agent finishes its tasks.")
                    ]))
                ])),
                A2(sD, n, e)
            ]))
        ]) : g;
    }), lD = {
        $: 11
    }, dD = F2(function(n, e) {
        return A2(gI, u(A2(Fi, function(n) {
            return n.gd;
        }, Mm(n)), ht(!0)), A2(jj, {
            ct: m([
                Cy("primary fluid")
            ]),
            eM: lD,
            eN: e
        }, m([
            A2(zy, m([
                Cy("ui icon redo alternative")
            ]), g),
            Oy("Re-run effects and failures")
        ])));
    }), bD = F2(function(n, e) {
        var t = A2(wc, function(n) {
            return A2(ay, 1, h(A2(wc, nD, Bt(n.c.fg)), m([
                oD
            ])));
        }, A2(Uf, function(n) {
            var e = n.b;
            return !e.fj && !e.fV;
        }, Dl(nd(e.as.ie)))), r = pk(e.bu), a = r.a, i = r.b, u = pk(e.bt), c = u.a, o = u.b, s = pk(e.as.ie), f = s.a, d = s.b, b = pk(e.bM), v = b.a, p = b.b, $ = h(A2(Lr, uk(Jw(n)), $k(m([
            c,
            a,
            v,
            f
        ]))), h(A2(ca, g, A2(Fi, function(e) {
            return m([
                A2(cS, n, e)
            ]);
        }, e.a5)), A2(Ze, A2(Iy, m([
            A2(Ly, "float", "right"),
            A2(Ly, "width", "14em"),
            A2(Ly, "position", "relative"),
            A2(Ly, "z-index", "1")
        ]), h(A2(dD, e, o), A2(Ze, A2(KT, g, g), A2(_S, e, p)))), A2(Ze, A2(uS, n, e), function(n) {
            switch(n.$){
                case 2:
                case 1:
                case 0:
                    return g;
                default:
                    return A2(Lr, QS, n.a.c.gh);
            }
        }(d))))), y = function() {
            switch(d.$){
                case 2:
                default:
                    return g;
                case 3:
                    var r = d.a, a = r.a, u = r.b, c = r.c, o = function() {
                        var n, r = ma(A2(Lr, function(n) {
                            return l(n.bp, A3(GS, e, c, n));
                        }, c.ct)), a = ma(A2(Lr, function(n) {
                            return l(n.bp, A3(XS, e, u, n));
                        }, c.fO));
                        return n = yc(Ql(A2(oS, r, a))), m([
                            RS,
                            A2(wk, m([
                                Cy("ui unstackable table")
                            ]), m([
                                A2(Ak, g, m([
                                    A2(Ck, m([
                                        Cy("center aligned")
                                    ]), m([
                                        A2(jk, m([
                                            Cy("one wide")
                                        ]), m([
                                            Oy("Status")
                                        ])),
                                        A2(jk, m([
                                            Cy("six wide")
                                        ]), m([
                                            Oy("Attribute")
                                        ])),
                                        A2(jk, m([
                                            Cy("five wide")
                                        ]), m([
                                            Oy("Derivation")
                                        ])),
                                        A2(jk, m([
                                            Cy("three wide")
                                        ]), m([
                                            Oy("Actions")
                                        ]))
                                    ]))
                                ])),
                                A2(kk, g, h(n, t))
                            ]))
                        ]);
                    }, s = l(A2(nc, function(e) {
                        return A3(JC, n, e, a);
                    }, e.a5), c.ct);
                    return s.a.$ ? h($, h(A2(VS, e, c), s.b.b ? h(o(), A4(JS, n, e, u, c)) : h(A3(cD, n, e, i), h(A2(fD, n, e), h(function() {
                        var n = l(u.fj, u.f$);
                        switch(n.a){
                            case 0:
                                return n.b ? o() : g;
                            case 1:
                                return c.gh.b ? g : m([
                                    A2(Iy, m([
                                        Cy("ui warning message")
                                    ]), m([
                                        A2(Iy, m([
                                            Cy("header")
                                        ]), m([
                                            Oy("Evaluation failed")
                                        ])),
                                        Oy("Please make sure your job has at least one derivation. See also "),
                                        A2(Py, m([
                                            jw("https://docs.hercules-ci.com/hercules-ci/troubleshooting/#why-is-my-attribute-not-in-eval")
                                        ]), m([
                                            Oy("Why doesn\u2019t my attribute show up in the evaluation?")
                                        ]))
                                    ]))
                                ]);
                            default:
                                switch(u.f1){
                                    case 0:
                                        return g;
                                    case 1:
                                        return m([
                                            A2(yk, g, m([
                                                A2(Py, m([
                                                    jw("https://docs.hercules-ci.com/hercules-ci/troubleshooting/#why-is-my-attribute-not-in-eval")
                                                ]), m([
                                                    Oy("Evaluation succeeded and yet produced no attributes.")
                                                ]))
                                            ]))
                                        ]);
                                    default:
                                        return m([
                                            A2(Iy, m([
                                                Cy("ui warning message")
                                            ]), m([
                                                A2(Iy, m([
                                                    Cy("header")
                                                ]), m([
                                                    Oy("This job does not contain any builds or effects.")
                                                ]))
                                            ]))
                                        ]);
                                }
                        }
                    }(), A4(JS, n, e, u, c)))))) : m([
                        s.a.a
                    ]);
                case 1:
                    return m([
                        A2(Iy, m([
                            Cy("ui loader active massive text")
                        ]), m([
                            Oy("Loading evaluation")
                        ]))
                    ]);
            }
        }();
        return A2(Iy, g, y);
    }), hD = F2(function(n, e) {
        return A2(Iy, g, m([
            A2(uS, n, e),
            A2(MC, ak, m([
                Oy("Please follow the instructions to"),
                A2(Py, m([
                    Aw(Gu({
                        co: e.H,
                        dA: e.dB
                    }))
                ]), m([
                    Oy(" set up an Agent.")
                ]))
            ]))
        ]));
    }), gD = F2(function(n, e) {
        return {
            u: _C(e.a1) ? A2(hD, n, e) : A2(Iy, g, A3(MT, n.ch, !1, m([
                A2(bD, n, e)
            ]))),
            e: "Job #" + $t(e.au)
        };
    }), vD = function(n) {
        var e = l(n.bB.gx, n.bB.e9);
        if (e.b.$) {
            if (e.a.$) return A2(Pw, g, g);
            var t = e.a.a;
            return A2(Pw, g, m([
                A2(Pw, m([
                    Cy("ui text small")
                ]), m([
                    ES(n)
                ])),
                A2(Pw, m([
                    A2(Ly, "user-select", "contain")
                ]), m([
                    Oy(t.a8)
                ]))
            ]));
        }
        var r = e.b.a;
        return A2(Pw, g, m([
            A2(Pw, m([
                Cy("ui text small")
            ]), m([
                ES(n)
            ])),
            A2(Pw, m([
                A2(Ly, "user-select", "contain")
            ]), m([
                Oy(r.fb)
            ]))
        ]));
    }, pD = function(n) {
        var e = l(n.cw, n.cr);
        if (1 === e.a.$) {
            if (1 === e.b.$) return A2(Pw, g, g);
            var t = e.b.a;
            return A2(Pw, g, m([
                A2(Pw, m([
                    A2(Ly, "user-select", "none")
                ]), m([
                    Oy("Added: ")
                ])),
                vD(t)
            ]));
        }
        if (1 === e.b.$) return t = e.a.a, A2(Pw, g, m([
            A2(Pw, m([
                A2(Ly, "user-select", "none")
            ]), m([
                Oy("Removed: ")
            ])),
            vD(t)
        ]));
        t = e.a.a;
        var r = e.b.a;
        return A2(Pw, g, m([
            A2(Pw, m([
                A2(Ly, "user-select", "none")
            ]), m([
                Oy("Before: ")
            ])),
            vD(t),
            A2(KT, g, g),
            A2(Pw, m([
                A2(Ly, "user-select", "none")
            ]), m([
                Oy("After: ")
            ])),
            vD(r)
        ]));
    }, mD = function(n) {
        var e = l(n.cw, n.cr);
        if (1 === e.a.$) return 1 !== e.b.$;
        if (1 === e.b.$) return !0;
        var t = e.a.a, r = e.b.a;
        return !u(t.W, r.W) || !u(A2(Fi, function(n) {
            return n.V;
        }, t.bB.gx), A2(Fi, function(n) {
            return n.V;
        }, r.bB.gx)) || !u(A2(Fi, function(n) {
            return n.fd;
        }, t.bB.e9), A2(Fi, function(n) {
            return n.fd;
        }, r.bB.e9));
    }, $D = function(n) {
        return 1 === n.$ ? A2(ok, "", "") : ES(n.a);
    }, yD = function(n) {
        var e = n.cw, t = n.cr;
        return A2(Iy, m([
            A2(Ly, "display", "block"),
            A2(Ly, "height", "4ex"),
            A2(Ly, "position", "relative")
        ]), m([
            A2(Iy, m([
                A2(Ly, "position", "absolute"),
                A2(Ly, "bottom", "0px"),
                A2(Ly, "right", "0px")
            ]), m([
                A2(Pw, m([
                    Cy("ui text tiny")
                ]), m([
                    e
                ]))
            ])),
            t
        ]));
    }, wD = function(n) {
        return yD({
            cr: $D(n.cr),
            cw: mD(n) ? $D(n.cw) : A2(Pw, g, g)
        });
    }, kD = function(n) {
        var e = l(n.cw, n.cr);
        return 1 === e.a.$ ? Cy(1 === e.b.$ ? "" : "green") : 1 === e.b.$ ? Cy("red") : u(e.a.a, e.b.a) ? Cy("") : Cy("yellow");
    }, xD = F2(function(n, e) {
        var t, r = F2(function(n, e) {
            return A2(zy, m([
                Cy("ui icon"),
                Cy(n),
                ck(e)
            ]), g);
        }), a = 1 === (t = l(n.cw, n.cr)).a.$ ? 1 === t.b.$ ? A2(r, "question", "No value") : A2(r, "plus", "Added") : 1 === t.b.$ ? A2(r, "minus", "Removed") : u(t.a.a, t.b.a) ? A2(r, "", "Unchanged") : A2(r, "pen", "Changed");
        return A2(Iy, m([
            Cy("ui segment"),
            kD(n),
            A2(Ly, "border-top-left-radius", "0")
        ]), A2(Ze, A2(Pw, m([
            Cy("ui left corner label"),
            A2(Ly, "top", "-0.1rem"),
            kD(n)
        ]), m([
            a
        ])), e));
    }), jD = function(n) {
        return A2(xD, n.bB, m([
            A2(Iy, m([
                Cy("ui grid"),
                A2(Ly, "padding-left", "2em")
            ]), m([
                A2(Iy, m([
                    Cy("one wide column")
                ]), m([
                    wD(n.bB)
                ])),
                A2(Iy, m([
                    Cy("four wide column")
                ]), m([
                    A2(Bk, g, m([
                        NS(n.bp)
                    ]))
                ])),
                A2(Iy, m([
                    Cy("ten wide column")
                ]), m([
                    A2(Iy, m([
                        Cy("ui basic segment")
                    ]), m([
                        pD(n.bB)
                    ]))
                ]))
            ]))
        ]));
    }, AD = function(n) {
        return n.$ ? A2(ok, "", "") : dk(n.a);
    }, CD = function(n) {
        return yD({
            cr: AD(A2(Fi, function(n) {
                return n.a7.V;
            }, n.cr)),
            cw: AD(A2(Fi, function(n) {
                return n.a7.V;
            }, n.cw))
        });
    }, ID = function(n) {
        return A2(Pw, g, m([
            dk(n.a7.V),
            A2(Pw, m([
                A2(Ly, "user-select", "contain")
            ]), m([
                Oy(n.a7.a8)
            ]))
        ]));
    }, TD = function(n) {
        return A2(Pw, g, m([
            A2(Pw, m([
                A2(Ly, "user-select", "contain")
            ]), m([
                Oy(n.a7.a8)
            ]))
        ]));
    }, SD = function(n) {
        var e = l(n.cw, n.cr);
        if (1 === e.a.$) {
            if (1 === e.b.$) return A2(Pw, g, g);
            var t = e.b.a;
            return A2(Pw, g, m([
                A2(Pw, m([
                    A2(Ly, "user-select", "none")
                ]), m([
                    Oy("Added: ")
                ])),
                TD(t)
            ]));
        }
        if (1 === e.b.$) return t = e.a.a, A2(Pw, g, m([
            A2(Pw, m([
                A2(Ly, "user-select", "none")
            ]), m([
                Oy("Removed: ")
            ])),
            TD(t)
        ]));
        var r = e.b.a, a = u((t = e.a.a).a7.V, r.a7.V) ? TD : ID;
        return A2(Pw, g, m([
            A2(Pw, m([
                A2(Ly, "user-select", "none")
            ]), m([
                Oy("Before: ")
            ])),
            a(t),
            A2(KT, g, g),
            A2(Pw, m([
                A2(Ly, "user-select", "none")
            ]), m([
                Oy("After: ")
            ])),
            a(r)
        ]));
    }, DD = function(n) {
        return A2(xD, n, m([
            A2(Iy, m([
                Cy("ui grid"),
                A2(Ly, "padding-left", "2em")
            ]), m([
                A2(Iy, m([
                    Cy("one wide column")
                ]), m([
                    CD(n)
                ])),
                A2(Iy, m([
                    Cy("fourteen wide column")
                ]), m([
                    A2(Iy, m([
                        Cy("ui basic segment")
                    ]), m([
                        SD(n)
                    ]))
                ]))
            ]))
        ]));
    }, ND = A2(yk, g, m([
        Oy("Import From Derivation")
    ])), ED = F2(function(n, e) {
        return u(e.ev, e.el) ? A2(Iy, m([
            Cy("ui basic segment")
        ]), m([
            Oy("Comparing the same job; select a different one by clicking the Compare tab.")
        ])) : A2(Iy, m([
            Cy("ui basic segment")
        ]), A2(Ze, RS, h(function(n) {
            return UA(n.ct) ? m([
                A2(Iy, m([
                    Cy("ui basic segment")
                ]), m([
                    Oy("No changes")
                ]))
            ]) : A2(Lr, jD, n.ct);
        }(e), A2(Ze, ND, function(n) {
            return UA(n.fP) ? m([
                A2(Iy, m([
                    Cy("ui basic segment")
                ]), m([
                    Oy("No changes")
                ]))
            ]) : A2(Lr, DD, n.fP);
        }(e)))));
    }), LD = function(n) {
        var e = n.bV;
        if (3 === e.$) {
            var t = e.a;
            return A2(Iy, g, m([
                A2(Iy, m([
                    Cy("ui basic segment")
                ]), m([
                    RS
                ])),
                A2(ED, n, t)
            ]));
        }
        return TA(e);
    }, BD = function(n) {
        var e = function(n) {
            var e = l(n.am, n.aj);
            if (3 === e.a.$ && 3 === e.b.$) {
                var t = e.b.a;
                return ht(Vu({
                    co: t.dp,
                    eu: ht(e.a.a.c),
                    ab: t.ab,
                    br: t.dw,
                    dA: t.ft
                }));
            }
            return gt;
        }(n);
        return e.$ ? g : m([
            Aw(e.a)
        ]);
    }, OD = F3(function(n, e, t) {
        var r;
        return A2(Iy, m([
            Cy("column")
        ]), m([
            A2(Iy, m([
                Cy("ui segment")
            ]), m([
                A2(Iy, m([
                    A2(Ly, "position", "relative")
                ]), m([
                    (r = n, r ? A2(Pw, m([
                        Cy("ui ribbon label green")
                    ]), m([
                        A2(zy, m([
                            Cy("ui icon white plus")
                        ]), g),
                        Oy("")
                    ])) : A2(Pw, m([
                        Cy("ui right ribbon label red"),
                        A2(Ly, "position", "absolute")
                    ]), m([
                        A2(zy, m([
                            Cy("ui icon white minus")
                        ]), g),
                        Oy("")
                    ]))),
                    A2(Iy, m([
                        Cy("ui header"),
                        A2(Ly, "display", "inline")
                    ]), m([
                        Oy(e)
                    ])),
                    A2(KT, g, g),
                    A2(KT, g, g),
                    A2(Ww, g, m([
                        Oy("Commit: "),
                        A2(Ek, g, m([
                            Oy(t.dD.g6)
                        ]))
                    ])),
                    A2(KT, g, g),
                    A2(KT, g, g),
                    A2(Ww, g, m([
                        A2(Ek, m([
                            A2(Ly, "white-space", "pre-wrap")
                        ]), m([
                            Oy(t.dD.bl)
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), PD = F3(function(n, e, t) {
        return A2(Iy, m([
            Cy("ui two column stackable grid")
        ]), m([
            A2(Iy, m([
                Cy("ui vertical divider")
            ]), m([
                A2(Py, BD(n), m([
                    A2(zy, m([
                        Cy("ui icon exchange alternate"),
                        A2(Ly, "margin", "0"),
                        A2(Ly, "margin-top", "-1ex")
                    ]), g)
                ]))
            ])),
            A2(Iy, m([
                Cy("row")
            ]), m([
                A3(OD, !0, "Current Job, #" + $t(e.ab), e),
                A3(OD, !1, "Baseline Job, #" + $t(t.ab), t)
            ]))
        ]));
    }), GD = {
        $: 7
    }, RD = function(n) {
        return {
            $: 5,
            a: n
        };
    }, zD = function(n) {
        return {
            $: 4,
            a: n
        };
    }, qD = function(n) {
        return l(n, !0);
    }, _D = function(n) {
        var e, t, r, a = pk(n.a4), i = a.a, u = a.b;
        return A2(Iy, m([
            Cy("ui segment bottom attached")
        ]), m([
            A2(EA, m([
                (r = n.bg, t = r.$ ? GD : RD(r.a), A2(zT, "submit", A2(cr, qD, sr(t))))
            ]), m([
                A2(Iy, g, m([
                    i.$ ? Oy("") : A2(uk, !0, i.a)
                ])),
                A2(yk, m([
                    Cy("ui header")
                ]), m([
                    Oy("Baseline Job")
                ])),
                A2(Ww, g, m([
                    Oy("Enter a job index to compare against.")
                ])),
                A2(Ww, g, m([
                    A2(yw, m([
                        Cy("ui input"),
                        A2(Jy, "input", A2(cr, A2(Zc, zD, wr), zA))
                    ]), g)
                ])),
                A2(Ww, g, m([
                    A2(jj, {
                        ct: n.bg.$ ? m([
                            sj(!0)
                        ]) : g,
                        eM: (e = n.bg, e.$ ? GD : RD(e.a)),
                        eN: u
                    }, m([
                        Oy("Compare")
                    ]))
                ]))
            ]))
        ]));
    }, HD = function(n) {
        return A2(Iy, m([
            Cy("ui basic segment")
        ]), m([
            A3(gj, !0, "Could not load jobs", n)
        ]));
    }, FD = A2(Iy, m([
        Cy("ui basic segment")
    ]), m([
        A2(Iy, m([
            Cy("ui active inverted dimmer")
        ]), m([
            A2(Iy, m([
                Cy("ui text loader")
            ]), m([
                Oy("Loading")
            ]))
        ]))
    ])), UD = function(n) {
        var e = l(n.am, n.aj);
        n: for(;;){
            e: for(;;){
                t: for(;;){
                    r: for(;;)switch(e.a.$){
                        case 3:
                            switch(e.b.$){
                                case 3:
                                    var t = e.a.a, r = e.b.a;
                                    return A2(Iy, m([
                                        Cy("ui basic segment")
                                    ]), m([
                                        A3(PD, n, t, r)
                                    ]));
                                case 1:
                                    break n;
                                case 2:
                                    break t;
                                default:
                                    break r;
                            }
                        case 1:
                            return FD;
                        case 2:
                            if (1 === e.b.$) break n;
                            break e;
                        default:
                            switch(e.b.$){
                                case 1:
                                    break n;
                                case 2:
                                    break t;
                                default:
                                    break r;
                            }
                    }
                    return _D(n);
                }
                return HD(e.b.a);
            }
            return HD(e.a.a);
        }
        return FD;
    }, VD = F2(function(n, e) {
        return {
            u: A2(Iy, g, A3(MT, n.ch, !0, m([
                UD(e),
                LD(e)
            ]))),
            e: "Comparing " + e.ch.br + "#" + $t(e.ch.ab)
        };
    }), WD = function(n) {
        switch(n){
            case 0:
                return "Waiting";
            case 1:
                return "Running";
            case 4:
                return "Success";
            case 2:
                return "Failed";
            case 3:
                return "Dependency failed";
            default:
                return "Cancelled";
        }
    }, YD = {
        $: 6
    }, MD = F2(function(n, e) {
        return A2(Lr, function(n) {
            return A2(jj, {
                ct: m([
                    Cy("yellow fluid")
                ]),
                eM: YD,
                eN: e
            }, m([
                qS(g),
                Oy(n)
            ]));
        }, function(n) {
            if (!n.j.bk) return g;
            switch(n.j.V){
                case 0:
                case 1:
                    return m([
                        "Cancel"
                    ]);
                default:
                    return g;
            }
        }(n));
    }), KD = F2(function(n, e) {
        return A2(zy, m([
            Cy("ui icon big " + n),
            ck(e)
        ]), g);
    }), JD = function(n) {
        switch(n){
            case 0:
                return A2(KD, "spinner loading", WD(n));
            case 1:
                return A2(KD, "sun outline loading", WD(n));
            case 4:
                return A2(KD, "check green circle", WD(n));
            case 2:
                return A2(KD, "times red circle", WD(n));
            case 3:
                return A2(KD, "times red circle outline", WD(n));
            default:
                return fk(m([
                    Cy("big"),
                    ck(WD(n))
                ]));
        }
    }, QD = F3(function(n, e, t) {
        return Bu({
            co: n.dR,
            eY: !1,
            a8: e,
            dA: n.ch.dA,
            d9: A2(ca, 0, A2(Fi, Ik, t)),
            dQ: A2(Fi, function(n) {
                return n.b.c;
            }, nd(n.aN))
        });
    }), ZD = F3(function(n, e, t) {
        return A2(Py, m([
            Aw(A3(QD, n, e, t))
        ]), m([
            Oy(e)
        ]));
    }), XD = function(n) {
        return "out" === n ? A2(Pw, m([
            Cy("ui text grey")
        ]), m([
            Oy(n)
        ])) : Oy(n);
    }, nN = F2(function(n, e) {
        var t = A2(Lr, function(e) {
            return A2(Ck, g, m([
                A2(xk, m([
                    Cy("center aligned")
                ]), m([
                    dk(e.cL)
                ])),
                A2(xk, g, m([
                    A3(ZD, n, e.a8, ht(e.cL))
                ])),
                A2(xk, g, m([
                    XD(e.af)
                ])),
                A2(xk, g, m([
                    Oy(e.bm)
                ]))
            ]));
        }, e.j.c3);
        return A2(wk, m([
            Cy("ui unstackable table")
        ]), m([
            A2(Ak, g, m([
                A2(Ck, m([
                    Cy("center aligned")
                ]), m([
                    A2(jk, m([
                        Cy("one wide")
                    ]), m([
                        Oy("Status")
                    ])),
                    A2(jk, m([
                        Cy("six wide")
                    ]), m([
                        Oy("Derivation")
                    ])),
                    A2(jk, m([
                        Cy("one wide")
                    ]), m([
                        Oy("Output")
                    ])),
                    A2(jk, m([
                        Cy("six wide")
                    ]), m([
                        Oy("Output path")
                    ]))
                ]))
            ])),
            A2(kk, g, t)
        ]));
    }), eN = F2(function(n, e) {
        var t;
        return A2(wk, m([
            Cy("ui structured collapsing table")
        ]), m([
            A2(kk, g, m([
                A2(Ck, g, m([
                    A2(xk, m([
                        Lk(2)
                    ]), m([
                        A2(Bk, g, m([
                            Oy("Platform")
                        ]))
                    ])),
                    A2(xk, g, m([
                        A2(Ek, g, m([
                            Oy(e.j.bq)
                        ]))
                    ]))
                ])),
                A2(Ck, g, m([
                    A2(xk, m([
                        Lk(2)
                    ]), m([
                        A2(Bk, g, m([
                            Oy("Required system features")
                        ]))
                    ])),
                    A2(xk, g, (t = e.j.bs, t.b ? A2(Bw, Oy(", "), A2(Lr, function(n) {
                        return A2(Ek, g, m([
                            Oy(n)
                        ]));
                    }, t)) : m([
                        A2(zy, g, m([
                            Oy("(none)")
                        ]))
                    ])))
                ]))
            ]))
        ]));
    }), tN = F2(function(n, e) {
        return m([
            A2(eN, n, e),
            A2(yk, g, m([
                Oy("Inputs")
            ])),
            A2(nN, n, e)
        ]);
    }), rN = function(n) {
        return A2(Iy, m([
            Cy("event")
        ]), m([
            A2(Iy, m([
                Cy("label")
            ]), n.N),
            A2(Iy, m([
                Cy("content")
            ]), A2(Ze, A2(Iy, m([
                Cy("summary")
            ]), n.Q), A2(Ze, A2(Iy, m([
                Cy("meta")
            ]), n.O), Dl(A2(Fi, Iy(m([
                Cy("extra")
            ])), n.K)))))
        ]));
    }, aN = F2(function(n, e) {
        var t = e.dM;
        if (1 === t.$) return rN({
            K: gt,
            N: m([
                A2(zy, m([
                    Cy("ui icon red circle times")
                ]), g)
            ]),
            O: m([
                A2(ox, n.jK, e.f)
            ]),
            Q: m([
                Oy("Failed")
            ])
        });
        var r = t.a;
        return rN({
            K: ht(m([
                A2(Iy, m([
                    Cy("ui message error")
                ]), m([
                    A2(Ww, g, m([
                        Oy(r)
                    ]))
                ]))
            ])),
            N: m([
                A2(zy, m([
                    Cy("ui icon red circle bolt")
                ]), g)
            ]),
            O: m([
                A2(ox, n.jK, e.f)
            ]),
            Q: m([
                Oy("Technical error")
            ])
        });
    }), iN = F2(function(n, e) {
        return {
            $: 12,
            a: n,
            b: e
        };
    }), uN = F2(function(n, e) {
        return {
            $: 11,
            a: n,
            b: e
        };
    }), cN = F5(function(n, e, t, r, a) {
        return A7(yu, "GET", "/api/v1/jobs/{jobId}/effects/{attribute}/log/raw", m([
            l("jobId", n),
            l("attribute", e)
        ]), m([
            l("logId", ht(t)),
            l("iMin", A2(Fi, $t, r)),
            l("verbosity", A2(Fi, gg, a))
        ]), g, gt, Zr);
    }), oN = F4(function(n, e, t, r) {
        return A2(pj, n, {
            ik: function() {
                return A5(cN, t.as.c, pu(Tl(e.ch.a2)), r.dg, gt, gt);
            },
            iG: !0,
            iT: A2(ca, Mr, A2(Rl, r.dg, e.al)),
            i4: function() {
                return mg;
            },
            i6: iN(r.dg),
            jc: uN(r.dg),
            jg: A2(Xi, r.dg, e.b9),
            aT: A2(ca, !0, A2(Xi, r.dg, e.aT)),
            jO: gt,
            jR: r.dg
        });
    }), sN = F4(function(n, e, t, r) {
        return h(A2(Lr, function(e) {
            return rN({
                K: gt,
                N: m([
                    A2(zy, m([
                        Cy("ui icon green circle check")
                    ]), g)
                ]),
                O: m([
                    A2(ox, n.jK, e.f)
                ]),
                Q: m([
                    Oy("Succeeded")
                ])
            });
        }, Dl(r.dI)), h(A2(Lr, function(e) {
            return rN({
                K: u(t.j.hL, g) && u(t.j.hM, g) ? gt : ht(A2(Ze, Oy("Waiting for: "), h(A2(Bw, Oy(", "), A2(Lr, function(n) {
                    return A2(Py, m([
                        Aw(Wu({
                            co: n.as.br.bn.n,
                            a2: n.er,
                            ab: n.as.ab,
                            br: n.as.br.n,
                            dA: n.as.br.bn.dA.n,
                            d9: 1
                        }))
                    ]), m([
                        Oy(n.as.br.n + "#" + $t(n.as.ab) + "/" + Tl(n.er))
                    ]));
                }, t.j.hL)), h(u(t.j.hM, g) || u(t.j.hL, g) ? g : m([
                    Oy(", and jobs: ")
                ]), A2(Bw, Oy(", "), A2(Lr, function(n) {
                    return A2(Py, m([
                        Aw(Uu({
                            co: n.br.bn.n,
                            ab: n.ab,
                            br: n.br.n,
                            dA: n.br.bn.dA.n
                        }))
                    ]), m([
                        Oy(n.br.n + "#" + $t(n.ab))
                    ]));
                }, A2(iA, function(n) {
                    return n.ab;
                }, t.j.hM))))))),
                N: m([
                    A2(zy, m([
                        Cy("ui icon ellipsis horizontal")
                    ]), g)
                ]),
                O: m([
                    A2(ox, n.jK, e.f)
                ]),
                Q: m([
                    Oy("Queued")
                ])
            });
        }, Dl(r.dt)), h(A2(Lr, function(r) {
            return rN({
                K: ht(A2(Ze, A2(Ww, g, m([
                    Oy("Agent: "),
                    A2(Ek, g, m([
                        Oy(r.a_)
                    ]))
                ])), A4(oN, n, e, t, r))),
                N: m([
                    A2(zy, m([
                        Cy("ui icon sun outline")
                    ]), g)
                ]),
                O: m([
                    A2(ox, n.jK, r.f)
                ]),
                Q: m([
                    Oy("Created")
                ])
            });
        }, Dl(r.dG)), h(A2(Lr, function(e) {
            return A2(aN, n, e);
        }, Dl(r.cX)), h(A2(Lr, function(e) {
            return rN({
                K: gt,
                N: m([
                    A2(zy, m([
                        Cy("ui icon times red circle outline")
                    ]), g)
                ]),
                O: m([
                    A2(ox, n.jK, e.f)
                ]),
                Q: m([
                    Oy("Dependency failed")
                ])
            });
        }, Dl(r.cK)), A2(Lr, function(e) {
            return rN({
                K: gt,
                N: m([
                    fk(m([
                        A2(Ly, "margin-left", "0.4rem")
                    ]))
                ]),
                O: m([
                    A2(ox, n.jK, e.f)
                ]),
                Q: m([
                    Oy("Cancelled")
                ])
            });
        }, Dl(r.cy)))))));
    }), fN = F4(function(n, e, t, r) {
        return A2(Iy, m([
            Cy("ui feed")
        ]), A2(wc, A3(sN, n, e, t), r));
    }), lN = F3(function(n, e, t) {
        var r = Bt(t.j.cT);
        if (r.b) {
            if (r.b.b) {
                var a = r.a, i = r.b;
                return A2(Ze, A2(Iy, m([
                    Cy("ui vertical segment")
                ]), m([
                    A4(fN, n, e, t, a)
                ])), A2(Lr, function(r) {
                    return A2(Iy, m([
                        Cy("ui vertical segment")
                    ]), m([
                        A2(yk, g, m([
                            Oy("Previous attempt")
                        ])),
                        A4(fN, n, e, t, r)
                    ]));
                }, i));
            }
            return m([
                A4(fN, n, e, t, r.a)
            ]);
        }
        return m([
            Oy("No events / No events yet")
        ]);
    }), dN = {
        $: 4
    }, bN = F2(function(n, e) {
        return A2(Lr, function(n) {
            return A2(jj, {
                ct: m([
                    Cy("primary fluid")
                ]),
                eM: dN,
                eN: e
            }, m([
                A2(zy, m([
                    Cy("ui icon redo alternative")
                ]), g),
                Oy(n)
            ]));
        }, g);
    }), hN = F4(function(n, e, t, r) {
        var a, i = Wu(b(n.ch, {
            d9: e
        }));
        return A2(Iy, A2(Ze, ww({
            $: 3,
            a: e
        }), h((a = u(n.ch.d9, e), A2(Uf, function() {
            return a;
        }, m([
            Cy("active")
        ]))), t)), m([
            A2(Py, m([
                Aw(i)
            ]), r)
        ]));
    }), gN = F3(function(n, e, t) {
        var r = pk(e.cg), a = r.a, i = r.b, u = A2(Lr, uk(Jw(n)), $k(m([
            a
        ]))), c = pk(e.bN).b;
        return A2(Iy, g, m([
            A2(Iy, m([
                A2(Ly, "float", "right"),
                A2(Ly, "width", "14em")
            ]), h(A2(bN, t, i), A2(MD, t, c))),
            A2(Mw, m([
                Cy("ui large header")
            ]), m([
                JD(t.j.V),
                Oy(WD(t.j.V))
            ])),
            A2(Iy, g, u),
            A2(Iy, m([
                Cy("ui big top attached tabular small menu")
            ]), m([
                A4(hN, e, 0, m([
                    Cy("item right")
                ]), m([
                    A2(zy, m([
                        Cy("ui icon info circle black")
                    ]), g),
                    Oy("Info")
                ])),
                A4(hN, e, 1, m([
                    Cy("item ")
                ]), m([
                    A2(zy, m([
                        Cy("ui icon clipboard list black")
                    ]), g),
                    Oy("Log")
                ]))
            ])),
            A2(Iy, m([
                Cy("ui bottom attached active tab segment")
            ]), e.ch.d9 ? A3(lN, n, e, t) : A2(tN, e, t))
        ]));
    }), vN = F2(function(n, e) {
        return {
            u: function() {
                var t = A2(rf, n, e);
                switch(t.$){
                    case 3:
                        return A3(gN, n, e, t.a);
                    case 2:
                        var r = t.a;
                        return A2(uk, Jw(n), r);
                    default:
                        return Oy("Loading...");
                }
            }(),
            e: e.ch.br + "#" + $t(e.ch.ab) + " " + Tl(e.ch.a2)
        };
    }), pN = F2(function() {
        return {
            u: A2(Iy, g, m([
                Oy("Redirecting...")
            ])),
            e: "Redirecting..."
        };
    }), mN = F2(function(n, e) {
        return {
            $: 3,
            a: n,
            b: e
        };
    }), $N = F2(function(n, e) {
        return {
            $: 4,
            a: n,
            b: e
        };
    }), yN = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), wN = F2(function(n, e) {
        return {
            $: 2,
            a: n,
            b: e
        };
    }), kN = function(n) {
        return A2(Xl, g, A2(kf, function(n) {
            return n.es;
        }, n.Z));
    }, xN = F2(function(n, e) {
        switch(e.$){
            case 1:
            default:
                return A2(zy, A2(Ze, Cy("ui icon"), n), g);
            case 3:
                return A2(zy, A2(Ze, Cy("ui icon primary check"), n), g);
            case 2:
                return A2(zy, A2(Ze, Cy("ui icon red times"), n), g);
        }
    })(m([
        A2(Ly, "position", "absolute"),
        A2(Ly, "margin-left", "-0.7em"),
        A2(Ly, "margin-top", "-0.4em"),
        A2(Ly, "pointer-events", "none")
    ])), jN = F2(function(n, e) {
        var t = function(n) {
            return m([
                A2(Ck, g, m([
                    A2(xk, m([
                        Lk(4),
                        A2(Ly, "vertical-align", "top")
                    ]), n)
                ]))
            ]);
        }, r = m([
            A2(jk, m([
                Cy("four wide")
            ]), m([
                Oy("Subject")
            ])),
            A2(jk, m([
                Cy("six wide")
            ]), m([
                Oy("Send to")
            ])),
            A2(jk, m([
                Cy("three wide")
            ]), m([
                Oy("Events")
            ]))
        ]), a = function(n) {
            switch(n.$){
                case 1:
                    return m([
                        Cy("loading")
                    ]);
                case 3:
                default:
                    return g;
                case 2:
                    return m([
                        Cy("error")
                    ]);
            }
        }, i = function(n) {
            var t = A2(T$, e, n.co.c), r = {
                bE: n.co.c
            };
            return m([
                A2(xk, g, m([
                    A2(Dw, n.co, 25),
                    Oy(n.co.k)
                ])),
                A2(xk, g, m([
                    A5(xw, qy({
                        h8: A2(Ze, gt, A2(Lr, A2(Zc, ht, function(n) {
                            return n.ej;
                        }), kN(e))),
                        iC: "account-email-" + n.co.c,
                        i8: mN(r),
                        jb: yN(r)
                    }), {
                        im: t.cR,
                        jw: n.hb.gu
                    }, Iy, a(t.bc), Yj(!1)),
                    Oy(" "),
                    xN(t.bc)
                ])),
                A2(xk, g, m([
                    A5(xw, qy({
                        h8: A2(Ze, gt, A2(Lr, ht, Kj)),
                        iC: "account-level-" + n.co.c,
                        i8: $N(r),
                        jb: wN(r)
                    }), {
                        im: t.dd,
                        jw: n.hb.gv
                    }, Iy, a(t.bj), Mj),
                    Oy(" "),
                    xN(t.bj)
                ]))
            ]);
        }, c = function() {
            var n = e.Z;
            switch(n.$){
                case 1:
                    return t(m([
                        A2(Iy, m([
                            Cy("ui placeholder")
                        ]), m([
                            A2(Iy, m([
                                Cy("line")
                            ]), g),
                            A2(Iy, m([
                                Cy("line")
                            ]), g),
                            A2(Iy, m([
                                Cy("line")
                            ]), g)
                        ]))
                    ]));
                case 3:
                    var r = n.a;
                    return u(r.cp, g) ? t(m([
                        A2(Iy, m([
                            A2(Ly, "text-align", "center"),
                            A2(Ly, "margin", "2.5em")
                        ]), m([
                            A2(Ww, g, m([
                                Oy("You don't have any notification overrides.")
                            ])),
                            A2(Ww, g, m([
                                Oy("You can create one by visiting the account settings.")
                            ]))
                        ]))
                    ])) : A2(Lr, A2(Zc, Ck(g), i), r.cp);
                default:
                    return t(m([
                        A2(Iy, m([
                            A2(Ly, "text-align", "center"),
                            A2(Ly, "margin", "2.5em")
                        ]), m([
                            A2(Ww, g, m([
                                Oy("An error ocurred while retrieving your overrides.")
                            ]))
                        ]))
                    ]));
            }
        }();
        return m([
            A2(wk, m([
                Cy("ui table")
            ]), m([
                A2(Ak, g, m([
                    A2(Ck, g, r)
                ])),
                A2(kk, g, c)
            ]))
        ]);
    }), AN = function(n) {
        return {
            $: 7,
            a: n
        };
    }, CN = function(n) {
        return {
            $: 8,
            a: n
        };
    }, IN = function(n) {
        return {
            $: 10,
            a: n
        };
    }, TN = function(n) {
        return {
            $: 11,
            a: n
        };
    }, SN = F3(function(n, e, t) {
        return A3(n, Iy, g, m(1 === t.$ ? [
            A2(zy, g, m([
                Oy("please select")
            ]))
        ] : t.a ? [
            Oy("All")
        ] : [
            Oy("Ignore")
        ]));
    }), DN = F2(function(n, e) {
        return m([
            A2(Iy, m([
                Cy("ui stackable grid")
            ]), m([
                A2(Iy, m([
                    Cy("row")
                ]), m([
                    A2(Iy, m([
                        Cy("ten wide column")
                    ]), m([
                        A2(Iy, m([
                            Cy("ui labeled input fluid")
                        ]), m([
                            A2(Iy, m([
                                Cy("ui label primary"),
                                A2(Ly, "width", "11em")
                            ]), m([
                                Oy("Default email "),
                                Qj(e.bS)
                            ])),
                            A5(xw, qy({
                                h8: A2(Lr, A2(Zc, ht, function(n) {
                                    return n.ej;
                                }), kN(e)),
                                iC: "default-email",
                                i8: AN,
                                jb: CN
                            }), {
                                im: e.cF,
                                jw: A2(nc, function(n) {
                                    return n.gu;
                                }, A2(nc, function(n) {
                                    return n.cJ;
                                }, nd(e.Z)))
                            }, Iy, m([
                                Cy("fluid")
                            ]), Yj(!0))
                        ]))
                    ]))
                ])),
                A2(Iy, m([
                    Cy("ten wide column")
                ]), m([
                    A2(Iy, m([
                        Cy("ui labeled input fluid")
                    ]), m([
                        A2(Iy, m([
                            Cy("ui label primary"),
                            A2(Ly, "width", "11em")
                        ]), m([
                            Oy("Default events "),
                            Qj(e.bT)
                        ])),
                        A5(xw, qy({
                            h8: A2(Lr, ht, Kj),
                            iC: "default-level",
                            i8: IN,
                            jb: TN
                        }), {
                            im: e.cH,
                            jw: A2(nc, function(n) {
                                return n.gv;
                            }, A2(nc, function(n) {
                                return n.cJ;
                            }, nd(e.Z)))
                        }, Iy, m([
                            Cy("fluid")
                        ]), SN)
                    ]))
                ]))
            ]))
        ]);
    }), NN = F2(function(n, e) {
        switch(e.Z.$){
            case 1:
                return m([
                    A2(Iy, m([
                        Cy("ui placeholder")
                    ]), m([
                        A2(Iy, m([
                            Cy("line")
                        ]), g),
                        A2(Iy, m([
                            Cy("line")
                        ]), g),
                        A2(Iy, m([
                            Cy("line")
                        ]), g)
                    ]))
                ]);
            case 2:
                return m([
                    Oy("Failed to load")
                ]);
            default:
                return A2(DN, n, e);
        }
    }), EN = function(n) {
        var e = n.e, t = n.u, r = n.ch, a = F2(function(n, e) {
            return A2(Py, m([
                Uy(m([
                    l("item", !0),
                    l("active", u(r, n))
                ])),
                Aw(n)
            ]), m([
                Oy(e)
            ]));
        });
        return function(n) {
            var e = n.e, t = n.gg, r = n.u;
            return {
                u: A2(Iy, m([
                    Cy("ui grid")
                ]), m([
                    A2(Iy, m([
                        Cy("four wide column")
                    ]), m([
                        A2(Iy, m([
                            Cy("ui vertical menu")
                        ]), t)
                    ])),
                    A2(Iy, m([
                        Cy("twelve wide column")
                    ]), A2(Ze, A2(bT, g, m([
                        Oy(e)
                    ])), r))
                ])),
                e: e
            };
        }({
            u: t,
            gg: m([
                A2(Iy, m([
                    Cy("header item")
                ]), m([
                    Oy("Personal Settings")
                ])),
                A2(a, Ku, "CLI Tokens"),
                A2(a, Mu, "Notifications")
            ]),
            e: e
        });
    }, LN = F2(function(n, e) {
        return EN({
            u: A2(Ze, A2(yk, g, m([
                Oy("Defaults")
            ])), A2(Ze, A2(Ww, g, m([
                Oy("This email will be used for your notifications, except when a rule in the section below overrides it.")
            ])), A2(Ze, A2(Ww, g, m([
                Oy('You can add more email addresses through the GitHub "secondary" email settings.')
            ])), h(A2(NN, n, e), A2(Ze, A2(yk, g, m([
                Oy("Per-account overrides")
            ])), A2(Ze, A2(Ww, g, m([
                Oy("These rules apply when you interact with the listed accounts.")
            ])), A2(Ze, A2(Ww, g, m([
                Oy("You can configure a new override by navigating to an account's settings page.")
            ])), A2(jN, n, e)))))))),
            ch: n.ch,
            e: "Notification Settings"
        });
    }), BN = F2(function(n, e) {
        var t = function(n) {
            return m([
                A2(Ck, g, m([
                    A2(xk, m([
                        Lk(3),
                        A2(Ly, "vertical-align", "top")
                    ]), n)
                ]))
            ]);
        }, r = m([
            A2(jk, m([
                Cy("four wide")
            ]), m([
                Oy("Description")
            ])),
            A2(jk, m([
                Cy("four wide")
            ]), m([
                Oy("Created")
            ])),
            A2(jk, m([
                Cy("four wide")
            ]), g)
        ]), a = function(t) {
            var r, a = A2(ca, Bs, A2(Xi, t.c, e.aE));
            return m([
                A2(xk, g, m([
                    Oy(t.v)
                ])),
                A2(xk, g, m([
                    A2(ox, n.jK, t.I)
                ])),
                A2(xk, g, m([
                    A2(vx, m([
                        Cy("ui button negative basic"),
                        Uy(m([
                            l("loading", Km(a)),
                            l("disabled", Qb(a)),
                            l("negative", !Qb(a))
                        ])),
                        ww((r = t.c, {
                            $: 1,
                            a: r
                        }))
                    ]), m([
                        Oy("Revoke")
                    ]))
                ]))
            ]);
        }, i = function() {
            var n = e.cA;
            switch(n.$){
                case 1:
                    return t(m([
                        A2(Iy, m([
                            Cy("ui placeholder")
                        ]), m([
                            A2(Iy, m([
                                Cy("line")
                            ]), g),
                            A2(Iy, m([
                                Cy("line")
                            ]), g),
                            A2(Iy, m([
                                Cy("line")
                            ]), g)
                        ]))
                    ]));
                case 3:
                    var r = n.a;
                    return u(r.eJ, g) ? t(m([
                        A2(Iy, m([
                            A2(Ly, "text-align", "center"),
                            A2(Ly, "margin", "2.5em")
                        ]), m([
                            A2(Ww, g, m([
                                Oy("You don't have any CLI tokens currently.")
                            ])),
                            A2(Ww, g, m([
                                Oy("To grant command line access, "),
                                A2(Py, m([
                                    jw("https://docs.hercules-ci.com/hercules-ci-effects/guide/install-the-hci-command/")
                                ]), m([
                                    Oy("install "),
                                    A2(Ek, g, m([
                                        Oy("hci")
                                    ]))
                                ])),
                                Oy(" and use the "),
                                A2(Ek, g, m([
                                    Oy("hci login")
                                ])),
                                Oy(" command.")
                            ]))
                        ]))
                    ])) : A2(Lr, A2(Zc, Ck(g), a), r.eJ);
                default:
                    return t(m([
                        A2(Iy, m([
                            A2(Ly, "text-align", "center"),
                            A2(Ly, "margin", "2.5em")
                        ]), m([
                            A2(Ww, g, m([
                                Oy("An error ocurred while retrieving your CLI token list.")
                            ]))
                        ]))
                    ]));
            }
        }();
        return m([
            A2(Ww, g, m([
                Oy("CLI tokens give API access to command line applications.")
            ])),
            A2(wk, m([
                Cy("ui table")
            ]), m([
                A2(Ak, g, m([
                    A2(Ck, g, r)
                ])),
                A2(kk, g, i)
            ]))
        ]);
    }), ON = F2(function(n, e) {
        return EN({
            u: A2(BN, n, e),
            ch: n.ch,
            e: "My CLI tokens"
        });
    }), PN = F3(function(n, e, t) {
        return {
            dc: t,
            bn: n,
            br: e
        };
    }), GN = function(n) {
        return {
            $: 7,
            a: n
        };
    }, RN = {
        $: 8
    }, zN = Ay("alt"), qN = F2(function(n, e) {
        return n.cY.hZ + "/api/v1/site/" + e.dB + "/account/" + e.gC + "/project/" + e.ax + "/badge";
    }), _N = F3(function(n, e) {
        return A2(Iw, m([
            Tw(A2(qN, n, e)),
            zN("Hercules CI")
        ]), g);
    }), HN = A2(cc, A2(hu, "&", "&amp;"), A2(cc, A2(hu, '"', "&quot;"), function(n) {
        return '"' + n + '"';
    })), FN = F2(function(n, e) {
        return n.cY.iA + "/" + e.dB + "/" + e.gC + "/" + e.ax + "/status";
    }), UN = F2(function(n, e) {
        return "<a href=" + HN(A2(FN, n, e)) + "><img src=" + HN(A2(qN, n, e)) + ' alt="Hercules CI"></a>';
    }), VN = F2(function(n, e) {
        return "![Hercules CI](" + A2(qN, n, e) + ")";
    }), WN = F2(function(n, e) {
        return "[" + A2(VN, n, e) + "](" + A2(FN, n, e) + ")";
    }), YN = F3(function(n, e, t) {
        return m([
            A2(Ww, g, m([
                A2(Py, m([
                    jw(A2(FN, n, e))
                ]), m([
                    A3(_N, n, e, t)
                ]))
            ]))
        ]);
    }), MN = function(n) {
        return A2(Iy, m([
            Cy("ui segment secondary")
        ]), m([
            A2(dI, m([
                A2(Ly, "white-space", "pre-wrap"),
                A2(Ly, "word-break", "break-word")
            ]), n)
        ]));
    }, KN = F3(function(n, e, t) {
        return m([
            e.ar ? A2(Ww, g, m([
                Oy("Add a convenient CI status badge to your "),
                A2(Bk, g, m([
                    A2(Ek, g, m([
                        Oy("README.md")
                    ]))
                ])),
                Oy(":")
            ])) : A2(Iy, m([
                Cy("ui info message")
            ]), m([
                A2(Iy, m([
                    Cy("header")
                ]), m([
                    Oy("This project is private")
                ])),
                Oy("Authentication is not possible for images on GitHub, so a badge can only be placed off the GitHub platform and "),
                A2(Ek, g, m([
                    Oy("README.md")
                ])),
                Oy(".")
            ])),
            MN(m([
                Oy(A2(WN, n, e)),
                Oy("\n")
            ])),
            A2(Ww, g, m([
                Oy("Alternatively, on a web page, you could use an "),
                A2(Bk, g, m([
                    Oy("HTML")
                ])),
                Oy(" badge: ")
            ])),
            MN(m([
                Oy(A2(UN, n, e)),
                Oy("\n")
            ])),
            A2(Ww, g, A2(Ze, Oy("Preview including link:"), A3(YN, n, e, t)))
        ]);
    }), JN = F3(function(n, e, t) {
        return m([
            A2(Iy, m([
                Cy("ui accordion")
            ]), m([
                A2(Iy, m([
                    Cy("title"),
                    Uy(m([
                        l("active", t.bA)
                    ])),
                    ww(RN)
                ]), m([
                    A2(zy, m([
                        Cy("dropdown icon")
                    ]), g),
                    A3(_N, n, e, t)
                ])),
                A2(Iy, m([
                    Cy("content"),
                    Uy(m([
                        l("active", t.bA)
                    ]))
                ]), A3(KN, n, e, t))
            ]))
        ]);
    }), QN = F2(function(n, e) {
        return A2(oS, n, e);
    }), ZN = F2(function(n, e) {
        var t, r, a, i = e.ch, c = 1 === (r = e.bi).$ ? 0 : A2(ca, 0, (t = A2(Lr, function(n) {
            return n.ab;
        }, r.a.bh)).b ? ht(A3(xt, Qt, t.a, t.b)) : gt), o = (c - 1) / 25 | 0, f = s(c, 25) > 0 || !u(e.ch.gD, gt), d = A2(Uf, function() {
            return !f;
        }, m([
            A2(Ly, "display", "none")
        ])), h = function(n) {
            return m([
                Cy("item"),
                Uy(m([
                    l("active", u(n, e.ch))
                ])),
                Aw(Ju(n))
            ]);
        }, v = function(n) {
            return function(n) {
                return A3(xt, Ym, Mh, n);
            }(m([
                n - 3,
                n - 2,
                n - 1,
                n,
                n + 1,
                n + 2,
                n + 3
            ]));
        }, p = A2(QN, v(A2(ca, 1, e.ch.gD)), A2(QN, v(o), v(1))), $ = Bt((a = A2(Uf, function(n) {
            return 1 > s(n, o) && n >= 1;
        }, function(n) {
            return rt(n);
        }(p)), A2(iA, lr, a))), y = A2(Ze, A2(Py, h(b(i, {
            gD: gt
        })), m([
            Oy("Latest")
        ])), A2(wc, function(n) {
            return A2(Ze, A2(Py, h(b(i, {
                gD: ht(n)
            })), m([
                Oy($t(n))
            ])), n > 1 && !A2(bS, n - 1, p) ? m([
                A2(Iy, m([
                    Cy("disabled item")
                ]), m([
                    Oy("...")
                ]))
            ]) : g);
        }, $));
        return A2(Iy, A2(Ze, Cy("ui pagination menu"), d), y);
    }), XN = F3(function(n, e, t) {
        var r = {
            dc: t.dc.bh,
            br: t.br
        }, a = r.br, i = u(r.dc, g) ? m([
            A2(Ck, m([
                Cy("disabled")
            ]), m([
                A2(xk, m([
                    Lk(6),
                    Cy("center aligned"),
                    A2(Ly, "padding-top", "2.5em"),
                    A2(Ly, "padding-bottom", "2.5em"),
                    A2(Ly, "color", "rgba(0,0,0,.5)")
                ]), A2(Ze, A2(Ww, g, m([
                    A2(zy, m([
                        Cy("ui icon kiwi bird")
                    ]), g)
                ])), m(r.br.be ? [
                    A2(Ww, g, m([
                        Oy("This project has not been built yet. Push a commit with a flake.nix, ci.nix, nix/ci.nix or default.nix.")
                    ]))
                ] : [
                    A2(Ww, g, m([
                        Oy("This project has not been built yet.")
                    ])),
                    A2(Ww, g, m([
                        Oy("Enable building this repository in Settings, then push a commit with a flake.nix, ci.nix, nix/ci.nix or default.nix.")
                    ]))
                ])))
            ]))
        ]) : g, c = t.bn, o = function(t) {
            return A2(Dy, function(n) {
                return cf({
                    bE: c.c,
                    bF: n
                });
            }, A5(rI, e.ch, n, Bs, d(c, a, ht(t)), g));
        };
        return A2(Iy, m([
            Cy("ui container")
        ]), m([
            A2(yk, g, m([
                Oy("Latest jobs")
            ])),
            A2(wk, m([
                Cy("ui selectable padded table")
            ]), m([
                A2(Ak, g, m([
                    A2(Ck, g, m([
                        A2(jk, g, m([
                            Oy("Status")
                        ])),
                        A2(jk, g, m([
                            Oy("Job")
                        ])),
                        A2(jk, g, m([
                            Oy("Duration")
                        ])),
                        A2(jk, g, m([
                            Oy("Created")
                        ])),
                        A2(jk, g, m([
                            Oy("Branch/Tag")
                        ])),
                        A2(jk, g, m([
                            Oy("Version")
                        ]))
                    ]))
                ])),
                A2(kk, g, h(i, A2(Lr, o, r.dc)))
            ])),
            A2(ZN, n, e)
        ]));
    }), nE = {
        be: gt
    }, eE = F2(function(n, e) {
        return hj({
            ib: function(e) {
                return {
                    $: 5,
                    a: {
                        c: n.c,
                        gG: b(nE, {
                            be: ht(e)
                        })
                    }
                };
            },
            iz: "enableProject",
            iT: {
                eN: e.cb,
                jm: n.be
            },
            jS: m([
                Oy("Build this repository")
            ])
        });
    }), tE = F3(function(n, e, t) {
        var r = t.$8, a = t.iX, i = function(n) {
            return m([
                A2(Ly, "cursor", "pointer"),
                Aw(n),
                ww(a(n))
            ]);
        }, c = g, o = function(n) {
            return u(r, n) ? "ui item active header" : "ui item header";
        };
        return A2(Iy, m([
            Cy("ui top attached stackable tabular small menu")
        ]), m([
            A2(Iy, m([
                Cy("right menu")
            ]), h(c, m([
                A2(Iy, A2(Ze, Cy(o(0)), i(Ju({
                    co: e.co,
                    gD: gt,
                    br: e.br,
                    dA: e.dA
                }))), m([
                    A2(zy, m([
                        Cy("icon list")
                    ]), g),
                    Oy("Jobs")
                ])),
                A2(Iy, A2(Ze, Cy(o(1)), i(Qu({
                    co: e.co,
                    br: e.br,
                    dA: e.dA
                }))), m([
                    A2(zy, m([
                        Cy("icon outline file")
                    ]), g),
                    Oy("State")
                ]))
            ])))
        ]));
    }), rE = F3(function(n, e, t) {
        return A2(Iy, g, m([
            A3(tE, n, e.ch, {
                $8: 0,
                iX: GN
            }),
            A2(Iy, m([
                Cy("bottom attached ui segment")
            ]), m([
                A2(Iy, m([
                    Cy("ui basic segment")
                ]), A2(Ze, A2(yk, g, m([
                    Oy("Settings")
                ])), A2(eE, t.br, e))),
                A2(Iy, m([
                    Cy("ui basic segment")
                ]), A2(Ze, A2(yk, g, m([
                    Oy("Badge")
                ])), A3(JN, n, t.br, e))),
                A2(Iy, m([
                    Cy("ui basic segment")
                ]), m([
                    A3(XN, n, e, t)
                ]))
            ]))
        ]));
    }), aE = F2(function(n, e) {
        return {
            u: function() {
                var t = function(n) {
                    return A2(kA, n.dc, A2(kA, n.br, A2(kf, PN, n.bn)));
                }(e);
                switch(t.$){
                    case 3:
                        return A3(rE, n, e, t.a);
                    case 2:
                        if (3 === t.a.$ && 404 === t.a.a) return Jw(n) ? A2(Iy, m([
                            Cy("ui container")
                        ]), m([
                            A2(uk, Jw(n), Xc(404))
                        ])) : A2(Iy, m([
                            Cy("ui container")
                        ]), m([
                            A2(rk, ak, m([
                                Oy("If this project exists, it isn't public, so you may want to sign in.")
                            ]))
                        ]));
                        var r = t.a;
                        return A2(Iy, m([
                            Cy("ui container")
                        ]), m([
                            A2(uk, Jw(n), r)
                        ]));
                    default:
                        return A2(zy, m([
                            Cy("ui loader active massive text")
                        ]), m([
                            Oy("Loading...")
                        ]));
                }
            }(),
            e: "Dashboard"
        };
    }), iE = function(n) {
        return {
            $: 0,
            a: n
        };
    }, uE = mC(25), cE = F2(function(n, e) {
        var t = F2(function(n, e) {
            return e.$ ? g : n(e.a);
        }), r = function(n) {
            return A2(cc, function(n) {
                return n.hH;
            }, A2(cc, Bt, A2(cc, Ac, t(n))));
        }, a = r(function(e) {
            return m([
                A2(ox, n.jK, e.I)
            ]);
        }), i = r(A2(cc, function(n) {
            return n.dC;
        }, t(function(n) {
            return m([
                Oy($t(n))
            ]);
        }))), u = function(n) {
            return m([
                A2(Ck, g, m([
                    A2(xk, m([
                        Lk(6),
                        A2(Ly, "vertical-align", "top")
                    ]), n)
                ]))
            ]);
        }, c = function(n) {
            return m([
                A2(zy, m([
                    Cy("ui icon file outline"),
                    A2(Ly, "margin-left", "2ex"),
                    A2(Ly, "margin-right", "2ex")
                ]), g),
                A2(Ek, g, m([
                    Oy(n.n)
                ]))
            ]);
        }, o = r(function(n) {
            var t, r = n.hA;
            if (r.$) {
                var a = n.as;
                return a.$ ? g : m([
                    A2(Py, m([
                        Aw(Uu({
                            co: e.ch.co,
                            ab: (t = a.a).ab,
                            br: e.ch.br,
                            dA: e.ch.dA
                        }))
                    ]), m([
                        A2(Pw, m([
                            A2(Ly, "width", "7ex"),
                            A2(Ly, "display", "inline-block")
                        ]), m([
                            Oy("#" + $t(t.ab) + " ")
                        ])),
                        kC(t)
                    ]))
                ]);
            }
            return m([
                uE(r.a)
            ]);
        }), s = m([
            A2(jk, g, m([
                Oy("Name")
            ])),
            A2(jk, g, m([
                Oy("Job or Uploader")
            ])),
            A2(jk, g, m([
                Oy("Updated")
            ])),
            A2(jk, g, m([
                Oy("Bytes")
            ])),
            A2(jk, g, m([
                Oy("Hash")
            ])),
            A2(jk, g, m([
                Oy("Download")
            ]))
        ]), f = r(A2(cc, function(n) {
            return n.hd;
        }, t(A2(cc, yr(10), function(n) {
            return m([
                Oy(n)
            ]);
        })))), l = function() {
            var t = e.cd;
            if (3 === t.$ && t.a.b && !t.a.b.b) {
                var r = t.a.a;
                return function(e) {
                    var t;
                    return m([
                        A2(Py, m([
                            jw((t = {
                                a3: n.cY.hZ,
                                U: r.c,
                                ci: e.n
                            }, A3(bo, t.a3, m([
                                "api",
                                "v1",
                                "projects",
                                t.U,
                                "state",
                                t.ci,
                                "data"
                            ]), A2(fu, lr, g))))
                        ]), m([
                            A2(zy, m([
                                Cy("ui icon download")
                            ]), g)
                        ]))
                    ]);
                };
            }
            return function() {
                return g;
            };
        }(), d = function(n) {
            return m([
                A2(xk, g, c(n)),
                A2(xk, g, o(n)),
                A2(xk, g, a(n)),
                A2(xk, g, i(n)),
                A2(xk, g, f(n)),
                A2(xk, m([
                    A2(Ly, "text-align", "center")
                ]), l(n))
            ]);
        }, b = function() {
            var n = e.bx.ie;
            switch(n.$){
                case 1:
                    return u(m([
                        A2(Iy, m([
                            Cy("ui placeholder")
                        ]), m([
                            A2(Iy, m([
                                Cy("line")
                            ]), g),
                            A2(Iy, m([
                                Cy("line")
                            ]), g),
                            A2(Iy, m([
                                Cy("line")
                            ]), g)
                        ]))
                    ]));
                case 3:
                    var t = n.a;
                    return uy(t.hi) ? u(m([
                        A2(Ww, m([
                            A2(Ly, "text-align", "center"),
                            A2(Ly, "margin", "10%")
                        ]), m([
                            Oy("This project does not have any state files yet. State may be created by Effects or uploaded manually with the button above.")
                        ]))
                    ])) : A2(Lr, A2(Zc, Ck(g), d), Ql(t.hi));
                default:
                    return g;
            }
        }();
        return A2(wk, m([
            Cy("ui celled table")
        ]), m([
            A2(Ak, g, m([
                A2(Ck, g, s)
            ])),
            A2(kk, g, b)
        ]));
    }), oE = {
        $: 5
    }, sE = {
        $: 11
    }, fE = {
        $: 4
    }, lE = function(n) {
        return {
            $: 6,
            a: n
        };
    }, dE = F2(function(n, e) {
        return {
            $: 9,
            a: n,
            b: e
        };
    }), bE = Ue, hE = A2(dj, m([
        "target",
        "files"
    ]), Hi(bE)), gE = A2(cc, Ql, F2(function(n, e) {
        return !A2(Pk, A2(Zc, xi, n), e);
    })(function(n) {
        return 0 !== n.$;
    })), vE = cj("multiple"), pE = function(n) {
        return Fn(function(n) {
            return "script" == n ? "p" : n;
        }(n));
    }, mE = Ay("placeholder"), $E = F2(function(n, e) {
        var t = e.z;
        switch(t.$){
            case 0:
                return A2(Iy, g, m([
                    A2(vx, m([
                        Cy("ui button"),
                        A2(Ly, "visibility", "hidden")
                    ]), g),
                    A2(lj, m([
                        Cy("ui green button right floated")
                    ]), m([
                        A2(zy, m([
                            Cy("ui plus icon")
                        ]), g),
                        Oy("Add files"),
                        A2(yw, m([
                            kw("file"),
                            A2(Ly, "display", "none"),
                            vE(!0),
                            A2(Jy, "change", A2(cr, lE, hE))
                        ]), g)
                    ]))
                ]));
            case 1:
                var r = t.a, a = oy(r), i = r.Y, u = r.aI, c = 1 === a.$ ? l(!0, a.a) : l(!1, da), o = c.a, s = c.b;
                return A2(Iy, m([
                    Cy("ui segment form")
                ]), A2(Ze, A2(Ww, g, m([
                    Oy("Name your files to match what is expected by your Effects.")
                ])), h(A2(Tt, F2(function(n, t) {
                    var r, a, i = (r = Ac(A2(bu, n, u))).$ ? "" : ny(r.a), c = "name-" + $t(n);
                    return A2(Iy, m([
                        Cy("field")
                    ]), m([
                        A2(Iy, m([
                            Cy("ui labeled action input")
                        ]), m([
                            A2(lj, m([
                                Cy("ui right icon label"),
                                fj(c)
                            ]), m([
                                A2(Pw, m([
                                    A2(Ly, "display", "inline-block"),
                                    A2(Ly, "min-width", "20ex")
                                ]), m([
                                    Oy(i)
                                ])),
                                A3(pE, "i", m([
                                    Cy("angle right icon")
                                ]), g)
                            ])),
                            A2(Py, m([
                                Cy("item"),
                                A2(Ly, "position", "relative"),
                                A2(Ly, "bottom", "-0.5ex")
                            ]), function() {
                                var n = A2(Xi, t, s);
                                if (n.$) return A2(nc, A2(cc, function(n) {
                                    return n.hi;
                                }, Xi(t)), nd(e.bx.ie)).$ ? g : m([
                                    A2(Iy, m([
                                        Cy("ui left bottom floating basic pointing label")
                                    ]), m([
                                        Oy("Updates existing file")
                                    ]))
                                ]);
                                var r = n.a;
                                return m([
                                    A2(Iy, m([
                                        Cy("ui left bottom floating basic red pointing label")
                                    ]), m([
                                        Oy(r)
                                    ]))
                                ]);
                            }()),
                            A2(yw, m([
                                kw("text"),
                                Ty(c),
                                xT(t),
                                mE(i),
                                qA(dE(n))
                            ]), g),
                            A2(vx, m([
                                Cy("ui icon button"),
                                ww((a = n, {
                                    $: 10,
                                    a: a
                                }))
                            ]), m([
                                A3(pE, "i", m([
                                    Cy("times icon")
                                ]), g)
                            ]))
                        ]))
                    ]));
                }), i), m([
                    A2(vx, m([
                        Cy("ui primary button"),
                        ww(fE),
                        sj(o)
                    ]), m([
                        A2(zy, m([
                            Cy("ui icon upload")
                        ]), g),
                        Oy("Confirm")
                    ])),
                    A2(vx, m([
                        Cy("ui button right floated"),
                        ww(oE)
                    ]), m([
                        A2(zy, m([
                            Cy("ui icon times")
                        ]), g),
                        Oy("Cancel all")
                    ]))
                ]))));
            default:
                var f = t.a;
                return A2(Iy, m([
                    Cy("ui segment")
                ]), A2(Ze, A2(Mw, g, m([
                    Oy("Upload")
                ])), h(A2(Lr, function(n) {
                    var e = n.a, t = n.b;
                    switch(t.$){
                        case 0:
                            var r = $t(Wa(100 * t.a)), a = r + "%";
                            return A2(Iy, m([
                                Cy("ui active progress"),
                                A2(DA, "data-percent", r)
                            ]), m([
                                A2(Iy, m([
                                    Cy("bar"),
                                    A2(Ly, "transition-duration", "300ms"),
                                    A2(Ly, "display", "block"),
                                    A2(Ly, "width", a)
                                ]), m([
                                    A2(Iy, m([
                                        Cy("progress")
                                    ]), m([
                                        Oy(a)
                                    ]))
                                ])),
                                A2(Iy, m([
                                    Cy("label")
                                ]), m([
                                    A2(Ek, g, m([
                                        Oy(e)
                                    ]))
                                ]))
                            ]));
                        case 1:
                            return A2(Iy, m([
                                Cy("ui progress success"),
                                A2(DA, "data-percent", "100")
                            ]), m([
                                A2(Iy, m([
                                    Cy("bar"),
                                    A2(Ly, "transition-duration", "300ms"),
                                    A2(Ly, "display", "block"),
                                    A2(Ly, "width", "100%")
                                ]), m([
                                    A2(Iy, m([
                                        Cy("progress")
                                    ]), g)
                                ])),
                                A2(Iy, m([
                                    Cy("label")
                                ]), m([
                                    A2(Ek, g, m([
                                        Oy(e)
                                    ])),
                                    Oy(" successful")
                                ]))
                            ]));
                        default:
                            return A2(Iy, m([
                                Cy("ui progress error"),
                                A2(DA, "data-percent", "0")
                            ]), m([
                                A2(Iy, m([
                                    Cy("bar"),
                                    A2(Ly, "transition-duration", "300ms"),
                                    A2(Ly, "display", "block"),
                                    A2(Ly, "width", "100%")
                                ]), m([
                                    A2(Iy, m([
                                        Cy("progress")
                                    ]), g)
                                ])),
                                A2(Iy, m([
                                    Cy("label")
                                ]), m([
                                    A2(Ek, g, m([
                                        Oy(e)
                                    ])),
                                    Oy(" failed")
                                ]))
                            ]));
                    }
                }, tt(f)), gE(f) ? m([
                    A2(Iy, m([
                        Cy("ui basic segment")
                    ]), m([
                        A2(vx, m([
                            Cy("ui button"),
                            A2(Ly, "visibility", "hidden")
                        ]), g),
                        A2(vx, m([
                            Cy("ui button right floated"),
                            ww(sE)
                        ]), m([
                            Oy("Close")
                        ]))
                    ]))
                ]) : g)));
        }
    }), yE = F2(function(n, e) {
        return {
            u: A2(Iy, g, m([
                A3(tE, n, e.ch, {
                    $8: 1,
                    iX: iE
                }),
                A2(Iy, m([
                    Cy("ui bottom attached segment")
                ]), m([
                    A2(Ww, g, m([
                        Oy("State files allow your Effects to maintain information across executions, such as IP addresses of created hosts, or the NixOps state export. Effects can only access the latest version of each file.")
                    ])),
                    A2($E, n, e),
                    A2(cE, n, e)
                ]))
            ])),
            e: "States"
        };
    }), wE = F2(function(n, e) {
        var t = e.gD;
        switch(t.$){
            case 10:
                return {
                    aD: m([
                        A2(Dy, vs, (a = A2(Tj, n, t.a)).u)
                    ]),
                    e: a.e
                };
            case 9:
                return {
                    aD: m([
                        A2(Dy, Af, (a = A2(Xj, n, t.a)).u)
                    ]),
                    e: a.e
                };
            case 2:
                return {
                    aD: m([
                        A2(Dy, ps, (a = A2(AA, n, t.a)).u)
                    ]),
                    e: a.e
                };
            case 11:
                return {
                    aD: m([
                        A2(Dy, $s, (a = A2(bC, n, t.a)).u)
                    ]),
                    e: a.e
                };
            case 0:
                return {
                    aD: m([
                        A2(Dy, ys, (a = A2(fT, n, t.a)).u)
                    ]),
                    e: a.e
                };
            case 1:
                return {
                    aD: m([
                        A2(Dy, Ts, (a = A2(aE, n, t.a)).u)
                    ]),
                    e: a.e
                };
            case 3:
                return {
                    aD: m([
                        A2(Dy, Ss, (a = A2(yE, n, t.a)).u)
                    ]),
                    e: a.e
                };
            case 6:
                return {
                    aD: m([
                        A2(Dy, As, (a = A2(vN, n, t.a)).u)
                    ]),
                    e: a.e
                };
            case 4:
                return {
                    aD: m([
                        A2(Dy, Is, (a = A2(gD, n, t.a)).u)
                    ]),
                    e: a.e
                };
            case 5:
                return {
                    aD: m([
                        A2(Dy, js, (a = A2(VD, n, t.a)).u)
                    ]),
                    e: a.e
                };
            case 7:
                return {
                    aD: m([
                        A2(Dy, Cs, (a = A2(pN, n, t.a)).u)
                    ]),
                    e: a.e
                };
            case 8:
                return {
                    aD: m([
                        A2(Dy, ms, (a = A2(aC, n, t.a)).u)
                    ]),
                    e: a.e
                };
            case 13:
                return {
                    aD: m([
                        A2(Mw, g, m([
                            Oy("404 Not Found")
                        ]))
                    ]),
                    e: "404 Not Found"
                };
            case 14:
                var r = t.a;
                return {
                    aD: m([
                        A2(Mw, g, m([
                            Oy("Welcome to Hercules CI")
                        ])),
                        A2(Ww, g, m([
                            Oy("Please sign in to continue.")
                        ])),
                        A2(Yw, n.h9, r.gW)
                    ]),
                    e: "Please log in first"
                };
            case 15:
                return {
                    aD: m([
                        (a = {
                            u: A2(eC, g, '\nTerms and Conditions\n====================\n\nLast updated: April 17, 2021\n\nThese Terms and Conditions ("Terms", "Terms and Conditions") govern\nyour relationship with the Hercules CI web application (the "Service")\noperated by Ensius B.V. ("us", "we", or "our"). The Service\nincludes the https://hercules-ci.com website, including any subdomains\nthereof, the Hercules CI API, Continuous Integration services and\nrelated technologies, software, content and services.\n\nPlease read these Terms and Conditions carefully before using the\nService.\n\nYour access to and use of the Service is conditioned on your acceptance\nof and compliance with these Terms. These Terms apply to all visitors,\nusers and others who access or use the Service.\n\nBy accessing or using the Service you agree to be bound by these Terms.\nIf you disagree with any part of the terms then you may not access the\nService.\n\nIf you use the Service on behalf of a legal entity, you hereby\nwarrant, represent and guarantee that you personally have the\nauthority to represent and legally bind the legal entity and all its\nmembers.\n\nSubscriptions\n-------------\n\nSome parts of the Service are billed on a subscription basis\n("Subscription(s)"). You will be billed in advance on a recurring and\nperiodic basis ("Billing Cycle"). Billing cycles are set on a monthly\nbasis.\n\nAt the end of each Billing Cycle, your Subscription will automatically\nrenew under the exact same conditions unless you cancel it or Hercules\nLabs O\xdc cancels it. You may cancel your Subscription renewal either\nthrough your online account management page or by contacting Hercules\nLabs O\xdc customer support team.\n\nA valid payment method, is required to process the payment for your\nSubscription. You shall provide our reseller, FastSpring, with accurate\nand complete billing information including full\nname, address, state, zip code, telephone number, and a valid payment\nmethod information. By submitting such payment information, you\nautomatically authorize FastSpring to charge all Subscription fees\nincurred through your account to any such payment instruments.\n\nShould automatic billing fail to occur for any reason, FastSpring may\nreattempt the automatic billing and/or contact you to alter the payment\nmethod information. You must make a successful payment within 14 days of\nthe start of the Billing Cycle.\n\n\nFee Changes\n-----------\n\nEnsius B.V., in its sole discretion and at any time, may modify the\nSubscription fees for the Subscriptions. Any Subscription fee change\nwill become effective at the end of the then-current Billing Cycle.\n\nEnsius B.V. will provide you with a reasonable prior notice of any\nchange in Subscription fees to give you an opportunity to terminate your\nSubscription before such change becomes effective.\n\nYour continued use of the Service after the Subscription fee change\ncomes into effect constitutes your agreement to pay the modified\nSubscription fee amount.\n\nRefunds\n-------\n\nPaid Subscription fees are non-refundable, except when required by law or as follows.\n\nYou are only entitled to a refund of a Subscription so long as you\nrequest the refund within 30 days of your Subscription purchase and\nyou have not requested a refund prior to the Subscription purchase.\n\nPreview\n-------\n\nYou may be invited to try certain products or product features\n("Preview Services") before we make them generally available. Preview\nServices are designated by terms such as "early access", "preview",\n"beta", "trial" or similar.\nPreview Services are not intended for production use, and can at any time be\nterminated, altered, or require payment for continued use. We may never make\na Preview Service generally available.\n\nContent\n-------\n\nOur Service allows you to post, link, store, share and otherwise make\navailable certain information, text, graphics, videos, or other material\n("Content"). You are responsible for the Content that you post to the\nService, including its legality, reliability, and appropriateness.\n\nBy posting Content to the Service, you grant us the right and license to\nuse, modify, publicly perform, publicly display, reproduce, and\ndistribute such Content on and through the Service. You retain any and\nall of your rights to any Content you submit, post or display on or\nthrough the Service and you are responsible for protecting those rights.\nYou agree that this license includes the right for us to make your\nContent available to other users of the Service, who may also use your\nContent subject to these Terms.\n\nYou represent and warrant that: (i) the Content is yours (you own it) or\nyou have the right to use it and grant us the rights and license as\nprovided in these Terms, and (ii) the posting of your Content on or\nthrough the Service does not violate the privacy rights, publicity\nrights, copyrights, contract rights or any other rights of any person.\n\nAccounts\n--------\n\nWhen you create an account with us, you must provide us information that\nis accurate, complete, and current at all times. Failure to do so\nconstitutes a breach of the Terms, which may result in immediate\ntermination of your account on our Service.\n\nYou are responsible for safeguarding the password and other authentication methods that you use to access\nthe Service and for any activities or actions under your password,\nwhether your password is with our Service or a third-party service.\n\nYou agree not to disclose your password to any third party. You must\nnotify us immediately upon becoming aware of any breach of security or\nunauthorized use of your account.\n\nCopyright Policy\n----------------\n\nWe respect the intellectual property rights of others. It is our policy\nto respond to any claim that Content posted on the Service infringes the\ncopyright or other intellectual property infringement ("Infringement")\nof any person.\n\nIf you are a copyright owner, or authorized on behalf of one, and you\nbelieve that the copyrighted work has been copied in a way that\nconstitutes copyright infringement that is taking place through the\nService, you must submit your notice in writing to the attention of\n"Copyright Infringement" of dataprotection@hercules-ci.com and include\nin your notice a detailed description of the alleged Infringement.\n\nYou may be held accountable for damages (including costs and attorneys\'\nfees) for misrepresenting that any Content is infringing your copyright.\n\nIntellectual Property\n---------------------\n\nThe Service and its original content (excluding Content provided by\nusers), features and functionality are and will remain the exclusive\nproperty of Ensius B.V. and its licensors. The Service is protected\nby copyright, trademark, and other laws of both The Netherlands and foreign\ncountries. Our trademarks and trade dress may not be used in connection\nwith any product or service without the prior written consent of\nEnsius B.V..\n\nYou may not attempt to decompile, disassemble or reverse\nengineer the Service.\n\nLinks To Other Web Sites\n------------------------\n\nOur Service may contain links to third-party web sites or services that\nare not owned or controlled by Ensius B.V..\n\nEnsius B.V. has no control over, and assumes no responsibility for,\nthe content, privacy policies, or practices of any third party web sites\nor services. You further acknowledge and agree that Ensius B.V.\nshall not be responsible or liable, directly or indirectly, for any\ndamage or loss caused or alleged to be caused by or in connection with\nuse of or reliance on any such content, goods or services available on\nor through any such web sites or services.\n\nWe strongly advise you to read the terms and conditions and privacy\npolicies of any third-party web sites or services that you visit.\n\nTermination\n-----------\n\nWe may terminate or suspend your account immediately, without prior\nnotice or liability, for any reason whatsoever, including without\nlimitation if you breach the Terms.\n\nUpon termination, your right to use the Service will immediately cease.\n\nLimitation Of Liability\n-----------------------\n\nIn no event shall Ensius B.V., nor its directors, employees,\npartners, agents, suppliers, or affiliates, be liable for any indirect,\nincidental, special, consequential or punitive damages, including\nwithout limitation, loss of profits, data, use, goodwill, or other\nintangible losses, resulting from (i) your access to or use of or\ninability to access or use the Service; (ii) any conduct or content of\nany third party on the Service; (iii) any content obtained from the\nService; and (iv) unauthorized access, use or alteration of your\ntransmissions or content, whether based on warranty, contract, tort\n(including negligence) or any other legal theory, whether or not we have\nbeen informed of the possibility of such damage, and even if a remedy\nset forth herein is found to have failed of its essential purpose.\n\nDisclaimer\n----------\n\nYour use of the Service is at your sole risk. The Service is provided on\nan "AS IS" and "AS AVAILABLE" basis. The Service is provided without\nwarranties of any kind, whether express or implied, including, but not\nlimited to, implied warranties of merchantability, fitness for a\nparticular purpose, non-infringement or course of performance.\n\nEnsius B.V. its subsidiaries, affiliates, and its licensors do not\nwarrant that a) the Service will function uninterrupted, secure or\navailable at any particular time or location; b) any errors or defects\nwill be corrected; c) the Service is free of viruses or other harmful\ncomponents; or d) the results of using the Service will meet your\nrequirements.\n\nGoverning Law\n-------------\n\nThese Terms shall be governed and construed in accordance with the laws\nof The Netherlands, without regard to its conflict of law provisions.\n\nOur failure to enforce any right or provision of these Terms will not be\nconsidered a waiver of those rights. If any provision of these Terms is\nheld to be invalid or unenforceable by a court, the remaining provisions\nof these Terms will remain in effect. These Terms constitute the entire\nagreement between us regarding our Service, and supersede and replace\nany prior agreements we might have between us regarding the Service.\n\nChanges\n-------\n\nWe reserve the right, at our sole discretion, to modify or replace these\nTerms at any time. If a revision is material we will try to provide at\nleast 30 days notice prior to any new terms taking effect. What\nconstitutes a material change will be determined at our sole discretion.\n\nBy continuing to access or use our Service after those revisions become\neffective, you agree to be bound by the revised terms. If you do not\nagree to the new terms, please stop using the Service.\n\nContact Us\n----------\n\nIf you have any questions about these Terms, please contact us.\n'),
                            e: "Terms of Service"
                        }).u
                    ]),
                    e: a.e
                };
            case 12:
                return {
                    aD: g,
                    e: "Loading..."
                };
            case 16:
                return {
                    aD: m([
                        A2(Dy, qf, (a = A2(ON, n, t.a)).u)
                    ]),
                    e: a.e
                };
            case 17:
                return {
                    aD: m([
                        A2(Dy, Rf, (a = A2(LN, n, t.a)).u)
                    ]),
                    e: a.e
                };
            case 18:
                return {
                    aD: m([
                        A2(Dy, xs, (a = A2(WT, n, t.a)).u)
                    ]),
                    e: a.e
                };
            case 19:
                return {
                    aD: m([
                        A2(Dy, ks, (a = A2(UT, n, t.a)).u)
                    ]),
                    e: a.e
                };
            default:
                var a;
                return {
                    aD: m([
                        A2(Dy, ws, (a = A2(ST, n, t.a)).u)
                    ]),
                    e: a.e
                };
        }
    }), kE = Fn("footer"), xE = (rs = m([
        A2(Py, m([
            Cy("item"),
            jw("https://www.iubenda.com/privacy-policy/14101005")
        ]), m([
            Oy("Privacy Policy")
        ])),
        A2(Py, m([
            Aw(Xu),
            Cy("item")
        ]), m([
            Oy("Terms")
        ])),
        A2(Py, m([
            Cy("item"),
            jw("https://status.hercules-ci.com/")
        ]), m([
            Oy("Service Status")
        ])),
        A2(Py, m([
            Cy("item"),
            jw("mailto:help@hercules-ci.com")
        ]), m([
            Oy("Support")
        ]))
    ]), A2(kE, m([
        Cy("ui inverted vertical footer segment")
    ]), m([
        A2(Iy, m([
            Cy("ui center aligned container")
        ]), A2(Bw, Oy(" | "), rs))
    ]))), jE = {
        $: 9
    }, AE = function(n) {
        return {
            $: 11,
            a: n
        };
    }, CE = function(n) {
        var e = n.q;
        return 1 === e.$ && 14 === e.b.gD.$;
    }, IE = function(n) {
        var e, t, r, a, i;
        return A2(Py, m([
            Cy("ui inverted button"),
            Aw(Zu({
                gW: ht((e = n.hB, a = 1 === (t = e.jj).$ ? "" : "?" + t.a, i = 1 === (r = e.it).$ ? "" : "#" + r.a, h(e.bp, pu(h(a, i)))))
            }))
        ]), m([
            A2(zy, m([
                Cy("icon user")
            ]), g),
            Oy(" Sign in")
        ]));
    }, TE = function(n) {
        var e = n.q;
        switch(e.$){
            case 0:
                return m([
                    A2(Iy, m([
                        Cy("ui item")
                    ]), m([
                        A2(zy, m([
                            Cy("ui icon user large")
                        ]), g),
                        A2(Pw, m([
                            A2(DA, "style", "margin-left: 10px;")
                        ]), m([
                            A2(Iy, m([
                                Cy("ui inverted placeholder"),
                                A2(Ly, "width", "8em")
                            ]), m([
                                A2(Iy, m([
                                    Cy(" line")
                                ]), g)
                            ]))
                        ]))
                    ]))
                ]);
            case 2:
                return m([
                    A2(Iy, m([
                        Cy("ui item")
                    ]), m([
                        A2(Pw, m([
                            A2(Ly, "margin-right", "10px")
                        ]), m([
                            Oy("Sign-in status unknown")
                        ])),
                        IE(n)
                    ]))
                ]);
            default:
                var t = e.a.hD;
                if (1 === t.$) {
                    var r = t.a, a = n.aZ, i = function(n) {
                        return {
                            iC: n.iC,
                            jb: n.jb,
                            cf: !1,
                            dO: 0
                        };
                    }({
                        iC: "account",
                        jb: AE
                    });
                    return m([
                        A5(mw, i, a, Iy, m([
                            Cy("item")
                        ]), m([
                            A5(pw, i, a, Iy, m([
                                Cy("")
                            ]), m([
                                A5(pw, i, a, zy, m([
                                    Cy("dropdown icon")
                                ]), g),
                                A2(Dw, r, 35),
                                A2(Pw, m([
                                    A2(Ly, "margin-left", "10px")
                                ]), m([
                                    Oy(r.k)
                                ]))
                            ])),
                            A5(Zy, i, a, Iy, g, m([
                                A3(Xy, Py, m([
                                    Aw(Ku)
                                ]), m([
                                    A2(zy, m([
                                        Cy("wrench icon")
                                    ]), g),
                                    Oy("Settings")
                                ])),
                                A3(Xy, Py, Xx(jE), m([
                                    A2(zy, m([
                                        Cy("icon")
                                    ]), g),
                                    Oy("Sign out")
                                ]))
                            ]))
                        ]))
                    ]);
                }
                return m([
                    A2(Iy, m([
                        Cy("ui item")
                    ]), CE(n) ? g : m([
                        IE(n)
                    ]))
                ]);
        }
    }, SE = function(n) {
        var e, t = h(m([
            A2(Iw, m([
                Tw(n.cY.iL),
                A2(Ly, "margin-right", "10px"),
                A2(Ly, "height", "2.5em"),
                A2(Ly, "object-fit", "contain")
            ]), g),
            Oy(" Hercules CI")
        ]), function() {
            var e = n.q;
            if (1 === e.$) {
                var t = e.a;
                return "Hercules CI" === t.h9.f7 ? g : m([
                    A2(Iy, m([
                        A2(Ly, "position", "absolute"),
                        A2(Ly, "bottom", "0.5ex"),
                        A2(Ly, "left", "4.8em"),
                        A2(Ly, "font-weight", "normal"),
                        A2(Ly, "opacity", "0.75"),
                        A2(Ly, "font-size", "90%")
                    ]), m([
                        Oy("for " + t.h9.f7)
                    ]))
                ]);
            }
            return g;
        }()), r = El(_u), a = 1 === (e = n.q).$ ? e.a.hD.$ ? r : "/" : r;
        return A2(Iy, m([
            Cy("ui container")
        ]), m([
            A2(Py, m([
                jw(a),
                Cy("header item")
            ]), t),
            A2(Py, m([
                Cy("item"),
                jw("https://docs.hercules-ci.com")
            ]), m([
                Oy("Docs")
            ])),
            A2(Py, m([
                Cy("item"),
                jw("https://blog.hercules-ci.com")
            ]), m([
                Oy("Blog")
            ])),
            A2(Iy, m([
                Ty("user-menu"),
                Cy("menu right")
            ]), TE(n))
        ]));
    };
    !function(e) {
        n.Elm ? Rn(n.Elm, e) : n.Elm = e;
    }({
        Main: {
            init: (os = {
                iE: Bo,
                jd: function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                },
                je: function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                },
                jH: function(n) {
                    var e, t = 1 === (e = n.q).$ ? A2(hs, Po, A2(bf, e.a, e.b)) : gs;
                    return Ro(m([
                        A2(bs, 3e3, Go),
                        t
                    ]));
                },
                jN: jy,
                jQ: function(n) {
                    var e = function() {
                        var e = n.q;
                        switch(e.$){
                            case 0:
                                return {
                                    aD: m([
                                        A2(Iy, m([
                                            Cy("ui loader active massive text")
                                        ]), m([
                                            Oy("Loading Hercules CI")
                                        ]))
                                    ]),
                                    e: "Loading"
                                };
                            case 1:
                                return A2(wE, e.a, e.b);
                            default:
                                return {
                                    aD: m([
                                        A2(uk, !0, e.a)
                                    ]),
                                    e: "Error"
                                };
                        }
                    }(), t = A2(Dy, Vr, A3(Fw, n.q, n.ch, n.bL));
                    return {
                        aD: m([
                            A2(Iy, m([
                                Ty("main")
                            ]), m([
                                A2(Ny, m([
                                    Cy("ui fixed inverted menu")
                                ]), m([
                                    SE(n)
                                ])),
                                A2(Iy, m([
                                    Ty("wrap")
                                ]), m([
                                    A2(Iy, m([
                                        Ty("ci-content"),
                                        Cy("ui main container")
                                    ]), A2(Ze, A2(Iy, m([
                                        A2(Ly, "margin", "20px 0")
                                    ]), m([
                                        t
                                    ])), A2(Lr, Dy(Po), e.aD))),
                                    xE
                                ]))
                            ]))
                        ]),
                        e: e.e + " - Hercules CI"
                    };
                }
            }, ss = os.jd, fs = os.je, ls = function() {
                ls.a(ss(xe()));
            }, we({
                d7: function(n) {
                    return ls.a = n, Ce.addEventListener("popstate", ls), 0 > Ce.navigator.userAgent.indexOf("Trident") || Ce.addEventListener("hashchange", ls), F2(function(e, t) {
                        if (!(t.ctrlKey || t.metaKey || t.shiftKey || t.button >= 1 || e.target || e.hasAttribute("download"))) {
                            t.preventDefault();
                            var r = e.href, a = xe(), i = Ir(r).a;
                            n(fs(i && a.gU === i.gU && a.fJ === i.fJ && a.gM.a === i.gM.a ? {
                                $: 0,
                                a: i
                            } : function(n) {
                                return {
                                    $: 1,
                                    a: n
                                };
                            }(r)));
                        }
                    });
                },
                iE: function(n) {
                    return A3(os.iE, n, xe(), ls);
                },
                jQ: os.jQ,
                jN: os.jN,
                jH: os.jH
            }))(A2(ur, function(n) {
                return A2(ur, function(e) {
                    return A2(ur, function(t) {
                        return A2(ur, function(r) {
                            return sr({
                                hZ: r,
                                eS: t,
                                iA: e,
                                iL: n
                            });
                        }, A2(Ur, "apiURL", Zr));
                    }, A2(Ur, "currentTime", Oo));
                }, A2(Ur, "htmlURL", Zr));
            }, A2(Ur, "logoURL", Zr)))(0)
        }
    });
}($a0b4f895e1596b3b$exports);


var $dad545c909cfec2d$var$app = (0, $a0b4f895e1596b3b$exports.Elm).Main.init({
    node: document.getElementById("main"),
    flags: {
        apiURL: window.location.origin,
        htmlURL: window.location.origin,
        logoURL: (0, (/*@__PURE__*/$parcel$interopDefault($3bcf9a3bdb62d21d$exports))),
        currentTime: Date.now()
    }
});
$dad545c909cfec2d$var$app.ports.paddleSubscribe.subscribe(function(data) {
    Paddle.Setup({
        vendor: 49326
    });
    Paddle.Checkout.open({
        product: data.product,
        passthrough: data.passthrough,
        successCallback: $dad545c909cfec2d$var$app.ports.paddleSubscriptionSucceeded.send,
        override: data.paymentLink
    });
});


//# sourceMappingURL=index.6701cb34.js.map
